
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lEVfb", function(module, exports) {
/**
 * @generated SignedSource<<d1b4a88900ad2784d17c9f56a71367b1>>
 * @relayHash 1966b33d5ef8f314895fbeede75bf700
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dfbd793342a2f6636b6b714e36b0ccb21eb0f9912a662b3a4eaa26e191107693
const $8e6373b4fed7a540$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEditorToolbarDockedAtTopEditorPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEditorToolbarDockedAtTopEditorPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1966b33d5ef8f314895fbeede75bf700",
            "id": "dfbd793342a2f6636b6b714e36b0ccb21eb0f9912a662b3a4eaa26e191107693",
            "metadata": {},
            "name": "useIsEditorToolbarDockedAtTopEditorPreferencesQuery",
            "operationKind": "query",
            "text": "query useIsEditorToolbarDockedAtTopEditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$8e6373b4fed7a540$var$node.hash = "dd0b909642c1511dd33cee50b754da27";
var $8e6373b4fed7a540$export$2e2bcd8739ae039 = $8e6373b4fed7a540$var$node;



var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery = (0, $8e6373b4fed7a540$export$2e2bcd8739ae039);
const $8a729a72887c33f8$export$39186427447356b2 = ({ defaultDockedAtTop: defaultDockedAtTop = false } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery, {
        fetchPolicy: 'cache-only',
        __callerPackage__: "content-types-header"
    });
    if (loading) // while loading use the default docking preference
    return defaultDockedAtTop;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        // couldn't query for user's docking preference, use the default docking preference
        return defaultDockedAtTop;
    }
    // get graphql user preference value
    const dockingPreference = data?.userPreferences?.confluenceEditorSettings?.toolbarDockingInitialPosition;
    if (dockingPreference === 'top') return true;
    if (dockingPreference === 'none') return false;
    return defaultDockedAtTop;
};
module.exports["useIsEditorToolbarDockedAtTop"] = $8a729a72887c33f8$export$39186427447356b2;

});

parcelRegister("3o3i5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $dOBRD = parcelRequire("dOBRD");

const $d83b6646de023a51$var$defaultRetrieveEditorTitleAndContent = ()=>Promise.resolve({
        title: '',
        adf: {
            type: ''
        }
    });
const $d83b6646de023a51$var$defaultEditorObjectHeaderContext = {
    saveDraft: ()=>Promise.resolve(),
    navigateOnClose: ()=>{},
    triggerAnalyticsEvent: ()=>{},
    version: 0,
    editorActions: {
        isDocumentEmpty: ()=>{}
    },
    title: '',
    retrieveEditorTitleAndContent: $d83b6646de023a51$var$defaultRetrieveEditorTitleAndContent,
    onPreviewClicked: ()=>{},
    isPublishingContent: false,
    userOffline: false,
    editorTitle: null,
    collabLimitReached: false,
    collabEditConnected: false,
    onClickPublish: ()=>{},
    shouldRenderPreview: false,
    isUnpublishedDraft: false,
    onHoverPublish: ()=>{}
};
const $d83b6646de023a51$var$EditorObjectHeaderContext = /*#__PURE__*/ (0, $cozmU.createContext)($d83b6646de023a51$var$defaultEditorObjectHeaderContext);
const $d83b6646de023a51$var$memoizeDeepEq = (0, $dOBRD.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d83b6646de023a51$export$7cf4636ad0f38e12 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, value: value } = t0;
    let t1;
    if ($[0] !== value) {
        t1 = $d83b6646de023a51$var$memoizeDeepEq(value);
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    const memoizedValue = t1;
    const t2 = memoizedValue;
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d83b6646de023a51$var$EditorObjectHeaderContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
const $d83b6646de023a51$export$54525653dcbc614a = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($d83b6646de023a51$var$EditorObjectHeaderContext);
    if (!context) throw new Error("useEditorObjectHeaderContext must be used within a EditorObjectHeaderContextProvider, and a `value` must be provided to EditorObjectHeaderContextProvider");
    return context;
};
module.exports["EditorObjectHeaderContextProvider"] = $d83b6646de023a51$export$7cf4636ad0f38e12;
module.exports["useEditorObjectHeaderContext"] = $d83b6646de023a51$export$54525653dcbc614a;

});

parcelRegister("1ch0f", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $6s78L = parcelRequire("6s78L");

/**
 * @generated SignedSource<<6091016860dacebc1cd8a69a71da7574>>
 * @relayHash 9c1433a098b8d67c1d47d21323cdafeb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99dc6e26456dc3cca27a70a32c753eeb82bec6079452a0d1db666a1f8956e864
const $39485bf2a989af16$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "action"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "action",
                    "variableName": "action"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "DeleteContentResponsePayload",
            "kind": "LinkedField",
            "name": "deleteContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "wasDeleted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "DeleteDraftMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "DeleteDraftMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9c1433a098b8d67c1d47d21323cdafeb",
            "id": "99dc6e26456dc3cca27a70a32c753eeb82bec6079452a0d1db666a1f8956e864",
            "metadata": {},
            "name": "DeleteDraftMutation",
            "operationKind": "mutation",
            "text": "mutation DeleteDraftMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId,wasDeleted}}"
        }
    };
}();
$39485bf2a989af16$var$node.hash = "d5524f7ebeca5db81e74baaef5bc18f4";
var $39485bf2a989af16$export$2e2bcd8739ae039 = $39485bf2a989af16$var$node;


const $70727fac6b2369a2$export$20904b77028459e9 = ({ isUnpublishedDraft: isUnpublishedDraft, isSingleUserSession: isSingleUserSession, hasTitle: hasTitle, hasBody: hasBody, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, hasRestrictions: hasRestrictions, hasLabels: hasLabels })=>{
    const isBlank = isSingleUserSession && isUnpublishedDraft && !hasTitle && !hasBody && !hasEmoji && !hasEmoji && !hasCoverPicture && !hasContentState && !hasRestrictions && !hasLabels;
    return {
        isBlank: isBlank,
        isUnpublishedDraft: isUnpublishedDraft,
        isSingleUserSession: isSingleUserSession,
        hasTitle: hasTitle,
        hasBody: hasBody,
        hasEmoji: hasEmoji,
        hasCoverPicture: hasCoverPicture,
        hasContentState: hasContentState,
        hasRestrictions: hasRestrictions,
        hasLabels: hasLabels
    };
};
const $70727fac6b2369a2$export$96599dcc2d34575a = ({ contentId: contentId, deleteOnlyIfBlank: deleteOnlyIfBlank })=>(0, $6s78L.mutateInterop)({
        mutation: (0, $39485bf2a989af16$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId,
            action: deleteOnlyIfBlank ? 'DELETE_DRAFT_IF_BLANK' : 'DELETE_DRAFT'
        },
        __callerPackage__: "editor-features"
    });
module.exports["blankDraftInfo"] = $70727fac6b2369a2$export$20904b77028459e9;
module.exports["deleteDraft"] = $70727fac6b2369a2$export$96599dcc2d34575a;

});

parcelRegister("2unW6", function(module, exports) {
/**
 * @generated SignedSource<<9b71d6d81a9b03d3c972309a3d75d3dc>>
 * @relayHash 848f1836e2238dbfdcc045c2ec137644
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f16220b95acf270f365810e4dc35125e23fa8938ab963384bae1e3f51467f3f3
const $e3a32f09a5f0d53b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": {
                                        "direction": "ASCENDING",
                                        "sortField": "LABELLING_CREATIONDATE"
                                    }
                                }
                            ],
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                }
                            ],
                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsLabelCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsLabelCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "848f1836e2238dbfdcc045c2ec137644",
            "id": "f16220b95acf270f365810e4dc35125e23fa8938ab963384bae1e3f51467f3f3",
            "metadata": {},
            "name": "useLabelsLabelCountQuery",
            "operationKind": "query",
            "text": "query useLabelsLabelCountQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count}}}}"
        }
    };
}();
$e3a32f09a5f0d53b$var$node.hash = "b0ad7041e68cadecf202efbc623c838f";
var $e3a32f09a5f0d53b$export$2e2bcd8739ae039 = $e3a32f09a5f0d53b$var$node;



var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");

const $0c936a0ccc8709d1$export$d6875122194c7b44 = (contentId)=>{
    const [hasLabels, setHasLabels] = (0, $cozmU.useState)(true);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $e3a32f09a5f0d53b$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "editor-features"
    });
    (0, $cozmU.useEffect)(()=>{
        setHasLabels((data?.content?.nodes?.[0]?.labels?.count ?? 0) > 0);
    }, [
        data
    ]);
    return hasLabels;
};
module.exports["useLabels"] = $0c936a0ccc8709d1$export$d6875122194c7b44;

});

parcelRegister("gDbO8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $efvKr = parcelRequire("efvKr");


var $82Ooj = parcelRequire("82Ooj");





var $kSwu1 = parcelRequire("kSwu1");


var $is1T6 = parcelRequire("is1T6");


var $4aRua = parcelRequire("4aRua");


var $1KLPb = parcelRequire("1KLPb");


var $gC2EJ = parcelRequire("gC2EJ");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $d0922dfcb7434c92$var$i18n = (0, $kSwu1.defineMessages)({
    modeToggleToEdit: {
        id: "live-pages-features.live-pages-mode-switcher.editing.edit-dropdown",
        defaultMessage: "Resume editing"
    },
    modeToggleToView: {
        id: "live-pages-features.live-pages-mode-switcher.editing.view-dropdown",
        defaultMessage: "Switch to viewing"
    }
});
const $d0922dfcb7434c92$export$7266636f729f5bc9 = ({ selectedMode: selectedMode, onChange: onChange, isDisabled: isDisabled, elemAfter: elemAfter })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const dropdownMenuContent = selectedMode === 'edit' ? $d0922dfcb7434c92$var$i18n.modeToggleToView : $d0922dfcb7434c92$var$i18n.modeToggleToEdit;
    const shortcut = selectedMode === 'edit' ? (0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW) : (0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT);
    const getShortcutComponent = ()=>{
        if (elemAfter) return elemAfter({
            shortcutKeys: [
                shortcut
            ],
            id: 'viewEditToggle'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: shortcut
        });
    };
    const Icon = selectedMode === 'edit' ? (0, (/*@__PURE__*/$parcel$interopDefault($1KLPb))) : (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: ""
        }),
        elemAfter: getShortcutComponent(),
        testId: "live-page-mode-toggle-label",
        onClick: ()=>onChange?.(selectedMode === 'view' ? 'edit' : 'view'),
        "aria-label": formatMessage(dropdownMenuContent),
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), dropdownMenuContent)));
};


const $074be0d28909724e$export$9674de41b3e1d3c1 = ({ contentId: contentId, isDisabled: isDisabled, flags: flags, analyticsSource: analyticsSource, elemAfter: elemAfter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [{ mode: livePageMode }, { setMode: setLivePageMode }] = (0, $efvKr.useLivePageMode)();
    const { showLivePageModeFlag: showLivePageModeFlag } = (0, $82Ooj.useLivePageModeFlag)(flags);
    const handleModeChange = (newMode)=>{
        showLivePageModeFlag(newMode);
        setLivePageMode(newMode);
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                source: analyticsSource,
                action: 'changed',
                actionSubject: 'mode',
                actionSubjectId: 'livePagesModeSwitcher',
                attributes: {
                    previousMode: livePageMode,
                    newMode: newMode
                },
                objectType: 'page',
                objectId: contentId
            }
        })?.fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d0922dfcb7434c92$export$7266636f729f5bc9), {
        selectedMode: livePageMode ?? 'view',
        onChange: handleModeChange,
        isDisabled: isDisabled,
        elemAfter: elemAfter
    });
};
module.exports["LivePagesModeChanger"] = $074be0d28909724e$export$9674de41b3e1d3c1;

});

parcelRegister("5rEAe", function(module, exports) {
/**
 * Gets the contentId of the specified draft content's parent by looking in the GraphQL cache.
 * If it's unable to find the parent, returns undefined.
 */ const $15544693a6bca546$export$15562ab063498253 = async (contentId, readFragmentInterop)=>{
    // Apollo's `readQuery` method will throw an error if ANY of the requested fields are missing.
    // We want to gracefully handle this and return `undefined`, so we use the try/catch block to swallow errors.
    let parentId = undefined;
    try {
        const draftData = readFragmentInterop({
            id: `Content:${contentId}`
        });
        parentId = draftData?.ancestors?.slice(-1)?.[0]?.id;
    } catch  {}
    return parentId;
};
module.exports["getParentOfDraft"] = $15544693a6bca546$export$15562ab063498253;

});

parcelRegister("3mmDo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hYoU4 = parcelRequire("hYoU4");


var $1ch0f = parcelRequire("1ch0f");

const $f928d6004096ea67$export$a0b893b7ce6fdcb3 = ({ isUnpublishedDraft: isUnpublishedDraft, isSingleUserSession: isSingleUserSession, hasTitle: hasTitle, hasBody: hasBody, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, hasRestrictions: hasRestrictions, hasLabels: hasLabels })=>{
    const [willDeleteBlankDraftOnClose, setWillDeleteBlankDraftOnClose] = (0, $cozmU.useState)(false);
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    (0, $cozmU.useEffect)(()=>{
        // necessary for showing correct tooltip on close button
        const { isBlank: isBlank } = (0, $1ch0f.blankDraftInfo)({
            isUnpublishedDraft: isUnpublishedDraft,
            isSingleUserSession: isSingleUserSession,
            hasTitle: hasTitle,
            hasBody: hasBody,
            hasEmoji: hasEmoji,
            hasCoverPicture: hasCoverPicture,
            hasContentState: hasContentState,
            hasRestrictions: hasRestrictions,
            hasLabels: hasLabels
        });
        setWillDeleteBlankDraftOnClose(collabEditConnected && isBlank);
    }, [
        isUnpublishedDraft,
        isSingleUserSession,
        hasTitle,
        hasBody,
        hasEmoji,
        hasCoverPicture,
        hasContentState,
        hasRestrictions,
        hasLabels,
        collabEditConnected
    ]);
    return willDeleteBlankDraftOnClose;
};
module.exports["useWillDeleteBlankDraftOnClose"] = $f928d6004096ea67$export$a0b893b7ce6fdcb3;

});

parcelRegister("lHzSp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $ktUCG = parcelRequire("ktUCG");


var $i5zxs = parcelRequire("i5zxs");


var $bJX6u = parcelRequire("bJX6u");

// Utility component to update state when subscription triggers.
// We can't call state setters in Subscribe's render prop because it's called in the render phase.
const $fb2260515fd87e61$var$StateSync = ({ value: value, setter: setter })=>{
    (0, $cozmU.useEffect)(()=>{
        setter(value);
    }, [
        value,
        setter
    ]);
    return null;
};
const $fb2260515fd87e61$export$5ebd549b1d465b39 = ()=>{
    const [hasEmoji, setHasEmoji] = (0, $cozmU.useState)(false);
    const [hasCoverPicture, setHasCoverPicture] = (0, $cozmU.useState)(false);
    const [hasContentState, setHasContentState] = (0, $cozmU.useState)(false);
    const emojiCoverPictureAndContentStateSubscription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $ktUCG.EmojiTitleStateContainer)
        ]
    }, (emojiTitleState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2260515fd87e61$var$StateSync, {
            value: !!emojiTitleState.state.selectedEmoji,
            setter: setHasEmoji
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2260515fd87e61$var$StateSync, {
            value: coverPictureState.state.hasCoverPicture,
            setter: setHasCoverPicture
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $bJX6u.ContentStateStateContainer)
        ]
    }, (contentStateState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb2260515fd87e61$var$StateSync, {
            value: !!contentStateState.state.contentState,
            setter: setHasContentState
        })));
    return {
        emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription,
        hasCoverPicture: hasCoverPicture,
        hasEmoji: hasEmoji,
        hasContentState: hasContentState
    };
};
module.exports["useEmojiTitleCoverPictureAndContentState"] = $fb2260515fd87e61$export$5ebd549b1d465b39;

});

parcelRegister("atF9V", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $xBGBA = parcelRequire("xBGBA");

const $5d4782fa577ebcb8$export$e6d5ad5483367d52 = ()=>{
    const [hasRestrictions, setHasRestrictions] = (0, $cozmU.useState)(false);
    const hasRestrictionsSubscription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $xBGBA.RestrictionsDataContainer)
        ]
    }, (restrictionsState)=>{
        setHasRestrictions(restrictionsState.state.hasRestrictions);
        return null;
    });
    return {
        hasRestrictionsSubscription: hasRestrictionsSubscription,
        hasRestrictions: hasRestrictions
    };
};
module.exports["useRestrictions"] = $5d4782fa577ebcb8$export$e6d5ad5483367d52;

});

parcelRegister("JJ6wk", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<02bdfabe7fda5196228e5c2504a01ca7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8ed80225f5935c72$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "contentTypeModified"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "kind": "ScalarField",
            "name": "friendlyWhen"
        },
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ContentTypesHeader_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "alias"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "subType"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "alias": "smartFolderProperties",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "smartFolderProperties"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"smartFolderProperties\"])"
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v2 /*: any*/ 
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": v2 /*: any*/ 
            }
        ],
        "type": "Content"
    };
}();
$8ed80225f5935c72$var$node.hash = "29b76ba651aabc8cc3a5b6ecb447a5f7";
var $8ed80225f5935c72$export$2e2bcd8739ae039 = $8ed80225f5935c72$var$node;



var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6SsN4 = parcelRequire("6SsN4");


var $kNIYN = parcelRequire("kNIYN");


var $kz1Yj = parcelRequire("kz1Yj");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");


var $8zMP3 = parcelRequire("8zMP3");


var $8dwdz = parcelRequire("8dwdz");


var $hzkzq = parcelRequire("hzkzq");


var $3u0dr = parcelRequire("3u0dr");








var $8MMdp = parcelRequire("8MMdp");

const $7c44703207686ef4$export$8bb26699ba16d6a3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MMdp.Breadcrumbs), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MMdp.Breadcrumbs), props);



var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $40pD8 = parcelRequire("40pD8");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $4Wxqa = parcelRequire("4Wxqa");


var $dnfJM = parcelRequire("dnfJM");


var $jjv3l = parcelRequire("jjv3l");


var $bvJwp = parcelRequire("bvJwp");


var $99t4P = parcelRequire("99t4P");


var $cuWTe = parcelRequire("cuWTe");


var $1ggpj = parcelRequire("1ggpj");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $bPoXA = parcelRequire("bPoXA");


var $18vK6 = parcelRequire("18vK6");


var $4aGJ9 = parcelRequire("4aGJ9");


var $laFNM = parcelRequire("laFNM");


var $1vpkQ = parcelRequire("1vpkQ");


var $jln20 = parcelRequire("jln20");


var $7xVCs = parcelRequire("7xVCs");


var $lyx2E = parcelRequire("lyx2E");


var $deZfn = parcelRequire("deZfn");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $8z0fF = parcelRequire("8z0fF");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jvYFk = parcelRequire("jvYFk");


var $aWwYt = parcelRequire("aWwYt");


var $dPJCf = parcelRequire("dPJCf");


var $bj5fB = parcelRequire("bj5fB");


var $l7iY7 = parcelRequire("l7iY7");


var $1NBp8 = parcelRequire("1NBp8");


var $1xpoY = parcelRequire("1xpoY");


var $hQBR9 = parcelRequire("hQBR9");


var $568fA = parcelRequire("568fA");


var $jMyy4 = parcelRequire("jMyy4");


var $LSims = parcelRequire("LSims");


var $5qUgM = parcelRequire("5qUgM");











var $kSwu1 = parcelRequire("kSwu1");








var $24dy7 = parcelRequire("24dy7");


var $1JERl = parcelRequire("1JERl");


var $4yg9g = parcelRequire("4yg9g");


var $lpNn5 = parcelRequire("lpNn5");


var $1B9Aq = parcelRequire("1B9Aq");


var $4n1IT = parcelRequire("4n1IT");


var $9DHhW = parcelRequire("9DHhW");








var $iOaib = parcelRequire("iOaib");








var $lt6Lx = parcelRequire("lt6Lx");


var $7Sm4c = parcelRequire("7Sm4c");


var $bT0se = parcelRequire("bT0se");


var $7QM6o = parcelRequire("7QM6o");


var $kSPGK = parcelRequire("kSPGK");











var $1B6Lx = parcelRequire("1B6Lx");


var $kXsBa = parcelRequire("kXsBa");





var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $dOlTT = parcelRequire("dOlTT");

const $778018eca844ead1$export$f6d8ac9231e1baff = 60;
const $778018eca844ead1$export$506c7795053eb4cd = 255;
const $778018eca844ead1$export$3e7822b6c7b36880 = (error)=>{
    // Mirror the duplicate-title check in editor-title's LivePagesTitle so both surfaces
    // classify the backend message consistently. The backend may return "...the same TITLE
    // in this space" (uppercase), so lower-case the message before matching. See EDITOR-7659.
    return error.message.toLowerCase().includes('exists with the same title in this space');
};
const $778018eca844ead1$var$i18n = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "content-types-header.content-types-title.placeholder",
        defaultMessage: "Untitled whiteboard"
    },
    slideTitlePlaceholder: {
        id: "content-types-header.content-types-title.slide-title-placeholder",
        defaultMessage: "Untitled slide"
    },
    databaseTitlePlaceholder: {
        id: "content-types-header.content-types-title.database-title-placeholder",
        defaultMessage: "Untitled database"
    },
    embedTitlePlaceholder: {
        id: "content-types-header.content-types-title.embed-title-placeholder",
        defaultMessage: "Untitled Smart Link"
    },
    markdownPageTitlePlaceholder: {
        id: "content-types-header.content-types-title.markdown-page-title-placeholder",
        defaultMessage: "Untitled markdown page"
    },
    renameTooltip: {
        id: "content-types-header.content-types-title.rename-tooltip",
        defaultMessage: "Rename"
    },
    permissionsTooltip: {
        id: "content-types-header.content-types-title.permissions-tooltip",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "You don't have permission to edit this whiteboard"
    },
    slidesPermissionsTooltip: {
        id: "content-types-header.content-types-title.slides-permissions-tooltip",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "You don't have permission to edit these slides"
    },
    databasePermissionsTooltip: {
        id: "content-types-header.content-types-title.database-permissions-tooltip",
        defaultMessage: "You don\u2019t have permission to edit this database"
    },
    embedPermissionsTooltip: {
        id: "content-types-header.content-types-title.embed-permissions-tooltip",
        defaultMessage: "You don\u2019t have permission to edit this Smart Link"
    },
    markdownPagePermissionsTooltip: {
        id: "content-types-header.content-types-title.markdown-page-permissions-tooltip",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "You don't have permission to edit this markdown page"
    },
    duplicateTitleError: {
        id: "content-types-header.content-types-title.duplicate-title-error",
        defaultMessage: "A whiteboard with this title already exists in this space"
    },
    emptyTitleError: {
        id: "content-types-header.content-types-title.empty-title-error",
        defaultMessage: "Title cannot be empty"
    },
    duplicateSlideTitleError: {
        id: "content-types-header.content-types-title.duplicate-slide-title-error",
        defaultMessage: "A slide with this title already exists in this space"
    },
    duplicateDatabaseTitleError: {
        id: "content-types-header.content-types-title.duplicate-database-title-error",
        defaultMessage: "A database with this title already exists in this space"
    },
    duplicateEmbedTitleError: {
        id: "content-types-header.content-types-title.duplicate-embed-title-error",
        defaultMessage: "A Smart Link with this title already exists in this space"
    },
    duplicateMarkdownPageTitleError: {
        id: "content-types-header.content-types-title.duplicate-markdown-page-title-error",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    },
    generalError: {
        id: "content-types-header.content-types-title.general-error",
        defaultMessage: "There was an error on our end. Refresh and try again."
    },
    titleLengthError: {
        id: "content-types-header.content-types-title.title-length-error",
        defaultMessage: "{maxLength, plural, one {Title has a maximum of {maxLength} character} other {Title has a maximum of {maxLength} characters}}"
    },
    onboardingSpotlightBody: {
        id: "content-types-header.content-types-title.onboarding-spotlight-body",
        defaultMessage: "Give your whiteboard a unique name"
    }
});
const $778018eca844ead1$var$i18nByContentType = {
    duplicateTitleError: {
        database: $778018eca844ead1$var$i18n.duplicateDatabaseTitleError,
        whiteboard: $778018eca844ead1$var$i18n.duplicateTitleError,
        slide: $778018eca844ead1$var$i18n.duplicateSlideTitleError,
        embed: $778018eca844ead1$var$i18n.duplicateEmbedTitleError
    },
    permissionsTooltip: {
        database: $778018eca844ead1$var$i18n.databasePermissionsTooltip,
        whiteboard: $778018eca844ead1$var$i18n.permissionsTooltip,
        slide: $778018eca844ead1$var$i18n.slidesPermissionsTooltip,
        embed: $778018eca844ead1$var$i18n.embedPermissionsTooltip
    },
    placeholder: {
        database: $778018eca844ead1$var$i18n.databaseTitlePlaceholder,
        whiteboard: $778018eca844ead1$var$i18n.placeholder,
        slide: $778018eca844ead1$var$i18n.slideTitlePlaceholder,
        embed: $778018eca844ead1$var$i18n.embedTitlePlaceholder
    }
};
const $778018eca844ead1$var$height = '20px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778018eca844ead1$var$Title = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _1kk5Tkf7mX _39xV02E6Kk _23H6YHdnbC _1avv7HdnbC _23YtAodnbC _09qab2dnbC _2koRJodnbC _2I4d1kdnbC _1GOaqfdnbC _4eIXMtdnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // This needs to be a tagged template expression because @compiled isn't applying the `attr(data-value)`
const $778018eca844ead1$var$EditViewContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1UDy7ImnOE _3UcnShk9Lk _2pGy7VnQyn _0KzMwNnQyn _3Ku51I5bSx _0OU75rQ4SZ _26YxmtN91d _4DqeriN3cS _3vgkB5SPN1 _0Ech7mZYee",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778018eca844ead1$var$TextViewContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { errorIcon: errorIcon, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _2uNWyHmnOE _3OzABDmb2E _05AF6uSPN1 _2JwW0D7j8z",
            __cmplp.errorIcon && "_0PxTj7dnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $778018eca844ead1$var$readOnlyContainerStyles = (0, $buxP3.xcss)({
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'space.250',
    maxWidth: '100%',
    paddingRight: 'space.075',
    paddingLeft: 'space.075',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'text',
    fontWeight: 'font.weight.bold',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $778018eca844ead1$var$readOnlyMobileAppStyles = (0, $buxP3.xcss)({
    pointerEvents: 'none',
    userSelect: 'none',
    touchAction: 'none'
});
const $778018eca844ead1$var$popupContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.200',
    color: 'color.text'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $778018eca844ead1$var$ErrorIconWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1mPzvKSPN1 _3mqZUnSPN1 _0IqiLwZqHV",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $778018eca844ead1$var$readOnlyTitleWrapperStyles = (0, $buxP3.xcss)({
    padding: 'space.025' //to match 2px transparent border on InlineEdit readView
});
const $778018eca844ead1$var$tooltipStyles = null; // same styles as a tooltip but with no width restriction to accommodate longer messages
const $778018eca844ead1$export$7574cd0e3a4be128 = /*#__PURE__*/ (0, $cozmU.forwardRef)(function ToolTipOverride(t0, ref) {
    const $ = (0, $bDgLe.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2uo31fgozt _0bjKvDzXzM _2sNsIg7NXe _0Of8r24Jdh _1ZnuxbZimw _1wydGW4Jdh _2Zuz6QZimw _1UtDYze5R3 _1EqgXlgs9g"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props || $[6] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
            ...props,
            ref: ref,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = ref;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
});
function $778018eca844ead1$var$onFocus(evt) {
    evt.target.select();
}
const $778018eca844ead1$export$42d61ec2afde455f = (t0)=>{
    const $ = (0, $bDgLe.c)(89);
    const { title: title, contentId: contentId, spaceName: spaceName, readOnly: readOnly, updateContentTree: updateContentTree, contentType: contentType, isMarkdownMode: t1, onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler } = t0;
    const isMarkdownMode = t1 === undefined ? false : t1;
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isMobileAppWhiteboard = isMobileApp && contentType === "whiteboard";
    const shouldUseMarkdownPageTitleRules = contentType === "page" && isMarkdownMode;
    const maxTitleLength = shouldUseMarkdownPageTitleRules ? $778018eca844ead1$export$506c7795053eb4cd : $778018eca844ead1$export$f6d8ac9231e1baff;
    const placeholderMessage = shouldUseMarkdownPageTitleRules ? $778018eca844ead1$var$i18n.markdownPageTitlePlaceholder : $778018eca844ead1$var$i18nByContentType.placeholder[contentType] || $778018eca844ead1$var$i18n.placeholder;
    const permissionsMessage = shouldUseMarkdownPageTitleRules ? $778018eca844ead1$var$i18n.markdownPagePermissionsTooltip : $778018eca844ead1$var$i18nByContentType.permissionsTooltip[contentType] || $778018eca844ead1$var$i18n.permissionsTooltip;
    const duplicateTitleErrorMessage = shouldUseMarkdownPageTitleRules ? $778018eca844ead1$var$i18n.duplicateMarkdownPageTitleError : $778018eca844ead1$var$i18nByContentType.duplicateTitleError[contentType] || $778018eca844ead1$var$i18n.duplicateTitleError;
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== intl || $[1] !== placeholderMessage) {
        t2 = intl.formatMessage(placeholderMessage);
        $[0] = intl;
        $[1] = placeholderMessage;
        $[2] = t2;
    } else t2 = $[2];
    const placeholderText = t2;
    const { isEditing: isEditing, setIsEditing: setIsEditing, setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub, updateLoading: updateLoading, updateError: updateError, updateTitle: updateTitle, updateCache: updateCache } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    let t3;
    if ($[3] !== isEditing || $[4] !== setUpdatedTitleFromPubsub || $[5] !== updateCache || $[6] !== updateContentTree) {
        t3 = async (_aris, pubsubRequestBody)=>{
            const title_0 = pubsubRequestBody?.contentTitleUpdateRequestBody.contentTitle;
            if (!(0, $9wGTI.fg)("cc_fps_migration_content-title") || ![
                "DUAL",
                "GRAPHQL"
            ].includes((0, $1xpoY.default).getString("confluence-migrate-fps-to-graphql-subscription", ""))) {
                if (!isEditing) {
                    updateCache(title_0);
                    updateContentTree();
                    setUpdatedTitleFromPubsub(undefined);
                } else setUpdatedTitleFromPubsub(title_0);
            }
        };
        $[3] = isEditing;
        $[4] = setUpdatedTitleFromPubsub;
        $[5] = updateCache;
        $[6] = updateContentTree;
        $[7] = t3;
    } else t3 = $[7];
    const onPubSubEvent = t3;
    const t4 = `titleUpdated:${contentType}`;
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $9wGTI.fg)("cc_fps_migration_content-title") && (0, $1xpoY.default).getString("confluence-migrate-fps-to-graphql-subscription", "") === "GRAPHQL";
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== contentId || $[10] !== contentType || $[11] !== onPubSubEvent || $[12] !== t4) {
        t6 = {
            contentId: contentId,
            contentType: contentType,
            eventName: t4,
            onEvent: onPubSubEvent,
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES,
            skip: t5
        };
        $[9] = contentId;
        $[10] = contentType;
        $[11] = onPubSubEvent;
        $[12] = t4;
        $[13] = t6;
    } else t6 = $[13];
    (0, $bT0se.usePubSubEvent)(t6);
    const [isTitleSpotlightActive, setIsTitleSpotlightActive] = (0, $cozmU.useState)(false);
    let t7;
    let t8;
    if ($[14] !== contentType || $[15] !== createAnalyticsEvent || $[16] !== isTitleSpotlightActive) {
        t7 = ()=>{
            if (isTitleSpotlightActive) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingSpotlightScreen",
                    attributes: {
                        contentType: contentType,
                        spotlight: "spotlight-content-type-title"
                    },
                    source: "contentTypesHeader"
                }
            }).fire();
        };
        t8 = [
            contentType,
            createAnalyticsEvent,
            isTitleSpotlightActive
        ];
        $[14] = contentType;
        $[15] = createAnalyticsEvent;
        $[16] = isTitleSpotlightActive;
        $[17] = t7;
        $[18] = t8;
    } else {
        t7 = $[17];
        t8 = $[18];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t10;
    let t9;
    if ($[19] !== registerShowTitleSpotlightHandler || $[20] !== setIsEditing) {
        t9 = ()=>{
            registerShowTitleSpotlightHandler?.(()=>{
                setIsEditing(true);
                setIsTitleSpotlightActive(true);
            });
        };
        t10 = [
            registerShowTitleSpotlightHandler,
            setIsEditing,
            setIsTitleSpotlightActive
        ];
        $[19] = registerShowTitleSpotlightHandler;
        $[20] = setIsEditing;
        $[21] = t10;
        $[22] = t9;
    } else {
        t10 = $[21];
        t9 = $[22];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[23] !== isTitleSpotlightActive || $[24] !== onCloseTitleSpotlight) {
        t11 = ()=>{
            if (isTitleSpotlightActive) {
                setIsTitleSpotlightActive(false);
                onCloseTitleSpotlight?.();
            }
        };
        $[23] = isTitleSpotlightActive;
        $[24] = onCloseTitleSpotlight;
        $[25] = t11;
    } else t11 = $[25];
    const showNextSpotlight = t11;
    let t12;
    let t13;
    if ($[26] !== updateError) {
        t12 = ()=>{
            if (updateError && $778018eca844ead1$export$3e7822b6c7b36880(updateError)) (0, $7Sm4c.markErrorAsHandled)(updateError);
        };
        t13 = [
            updateError
        ];
        $[26] = updateError;
        $[27] = t12;
        $[28] = t13;
    } else {
        t12 = $[27];
        t13 = $[28];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    if ($[29] !== duplicateTitleErrorMessage || $[30] !== intl || $[31] !== maxTitleLength || $[32] !== placeholderText || $[33] !== updateError || $[34] !== updateLoading) {
        t14 = (t15)=>{
            const { errorMessage: errorMessage, ...fieldProps } = t15;
            const error = !!(fieldProps.isInvalid || updateError);
            const renderElemAfterInput = ()=>{
                if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($778018eca844ead1$var$ErrorIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious",
                    label: "error"
                }));
                return null;
            };
            const renderErrorMessage = ()=>{
                if (fieldProps.isInvalid) return errorMessage;
                else {
                    if (updateError && $778018eca844ead1$export$3e7822b6c7b36880(updateError)) return intl.formatMessage(duplicateTitleErrorMessage, {
                        pageTitle: fieldProps.value
                    });
                    else return intl.formatMessage($778018eca844ead1$var$i18n.generalError);
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($778018eca844ead1$var$EditViewContainer, {
                "data-value": fieldProps.value
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($778018eca844ead1$var$TextViewContainer, {
                errorIcon: error
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
                autoFocus: false,
                isOpen: error,
                placement: "bottom-start",
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                        xcss: $778018eca844ead1$var$popupContainerStyles
                    }, renderErrorMessage()),
                trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                        ...triggerProps,
                        ...fieldProps,
                        testId: "content-types-title-input",
                        width: "auto",
                        isCompact: true,
                        className: "text-field-input",
                        placeholder: placeholderText,
                        autoComplete: "off",
                        onFocus: $778018eca844ead1$var$onFocus,
                        autoFocus: true,
                        isDisabled: updateLoading,
                        isInvalid: error,
                        maxLength: maxTitleLength + 1,
                        elemAfterInput: renderElemAfterInput()
                    })
            })));
        };
        $[29] = duplicateTitleErrorMessage;
        $[30] = intl;
        $[31] = maxTitleLength;
        $[32] = placeholderText;
        $[33] = updateError;
        $[34] = updateLoading;
        $[35] = t14;
    } else t14 = $[35];
    const renderEditView = t14;
    let t15;
    if ($[36] !== isMarkdownMode || $[37] !== isMobileAppWhiteboard || $[38] !== permissionsMessage || $[39] !== readOnly || $[40] !== title) {
        t15 = ()=>{
            const displayTitle = isMarkdownMode && title && !(0, $iOaib.endsWithMarkdownSuffix)(title) ? `${title}${0, $iOaib.MARKDOWN_SUFFIX}` : title;
            const message = readOnly ? permissionsMessage : $778018eca844ead1$var$i18n.renameTooltip;
            const TooltipComponent = isMobileAppWhiteboard ? (0, $cozmU.Fragment) : (0, $lpNn5.default);
            const tooltipProps = isMobileAppWhiteboard ? {
                content: undefined
            } : {
                component: $778018eca844ead1$export$7574cd0e3a4be128,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message)
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TooltipComponent, tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $778018eca844ead1$var$readOnlyContainerStyles
            }, displayTitle));
        };
        $[36] = isMarkdownMode;
        $[37] = isMobileAppWhiteboard;
        $[38] = permissionsMessage;
        $[39] = readOnly;
        $[40] = title;
        $[41] = t15;
    } else t15 = $[41];
    const renderReadView = t15;
    let t16;
    if ($[42] !== intl || $[43] !== maxTitleLength) {
        t16 = (value)=>{
            if (!value || value.length === 0) return intl.formatMessage($778018eca844ead1$var$i18n.emptyTitleError);
            if (value.length > maxTitleLength) return intl.formatMessage($778018eca844ead1$var$i18n.titleLengthError, {
                maxLength: maxTitleLength
            });
        };
        $[42] = intl;
        $[43] = maxTitleLength;
        $[44] = t16;
    } else t16 = $[44];
    const validateName = t16;
    let t17;
    if ($[45] !== contentId || $[46] !== createAnalyticsEvent || $[47] !== setIsEditing || $[48] !== spaceId) {
        t17 = ()=>{
            setIsEditing(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contentTypeHeaderTitle",
                    containerType: "space",
                    containerId: spaceId,
                    objectId: contentId,
                    source: "contentTypesHeader"
                }
            }).fire();
        };
        $[45] = contentId;
        $[46] = createAnalyticsEvent;
        $[47] = setIsEditing;
        $[48] = spaceId;
        $[49] = t17;
    } else t17 = $[49];
    const onTitleEdit = t17;
    const { setOptimisticTitle: setOptimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(contentId, title);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    let t18;
    if ($[50] !== contentId || $[51] !== createAnalyticsEvent || $[52] !== setOptimisticTitle || $[53] !== showNextSpotlight || $[54] !== spaceId || $[55] !== updateContentTree || $[56] !== updateTimestampCache || $[57] !== updateTitle) {
        t18 = async (value_0)=>{
            await updateTitle(value_0);
            setOptimisticTitle(value_0);
            updateContentTree();
            updateTimestampCache({
                contentId: contentId
            });
            showNextSpotlight();
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "updated",
                    actionSubject: "contentTypeHeaderTitle",
                    containerType: "space",
                    containerId: spaceId,
                    objectId: contentId,
                    source: "contentTypesHeader"
                }
            }).fire();
        };
        $[50] = contentId;
        $[51] = createAnalyticsEvent;
        $[52] = setOptimisticTitle;
        $[53] = showNextSpotlight;
        $[54] = spaceId;
        $[55] = updateContentTree;
        $[56] = updateTimestampCache;
        $[57] = updateTitle;
        $[58] = t18;
    } else t18 = $[58];
    const onTitleUpdate = t18;
    let t19;
    if ($[59] !== isEditing || $[60] !== onTitleEdit || $[61] !== onTitleUpdate || $[62] !== renderEditView || $[63] !== renderReadView || $[64] !== title || $[65] !== validateName) {
        t19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1JERl.default), {
                isEditing: isEditing,
                onEdit: onTitleEdit,
                validate: validateName,
                onConfirm: onTitleUpdate,
                defaultValue: title,
                editView: renderEditView,
                readView: renderReadView,
                hideActionButtons: true
            });
        $[59] = isEditing;
        $[60] = onTitleEdit;
        $[61] = onTitleUpdate;
        $[62] = renderEditView;
        $[63] = renderReadView;
        $[64] = title;
        $[65] = validateName;
        $[66] = t19;
    } else t19 = $[66];
    const renderInlineEdit = t19;
    let t20;
    if ($[67] !== isMobileAppWhiteboard || $[68] !== renderReadView) {
        t20 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                testId: "content-types-title-read-only-view",
                xcss: [
                    $778018eca844ead1$var$readOnlyTitleWrapperStyles,
                    isMobileAppWhiteboard && $778018eca844ead1$var$readOnlyMobileAppStyles
                ]
            }, renderReadView());
        $[67] = isMobileAppWhiteboard;
        $[68] = renderReadView;
        $[69] = t20;
    } else t20 = $[69];
    const renderReadOnlyTitle = t20;
    let t21;
    if ($[70] !== isTitleSpotlightActive || $[71] !== readOnly || $[72] !== renderInlineEdit || $[73] !== renderReadOnlyTitle || $[74] !== showNextSpotlight) {
        t21 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($778018eca844ead1$var$Title, null, readOnly ? renderReadOnlyTitle() : renderInlineEdit())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
                placement: "right-end",
                isVisible: isTitleSpotlightActive,
                dismiss: showNextSpotlight
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
                key: "whiteboard-onboarding-title-target"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $778018eca844ead1$var$i18n.onboardingSpotlightBody)))));
        $[70] = isTitleSpotlightActive;
        $[71] = readOnly;
        $[72] = renderInlineEdit;
        $[73] = renderReadOnlyTitle;
        $[74] = showNextSpotlight;
        $[75] = t21;
    } else t21 = $[75];
    const renderSpotlight = t21;
    let t22;
    if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $5qUgM.CONTENT_TYPES_HEADER_TITLE_SEGMENT)
        });
        $[76] = t22;
    } else t22 = $[76];
    let t23;
    if ($[77] !== updateError) {
        t23 = updateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: updateError
        });
        $[77] = updateError;
        $[78] = t23;
    } else t23 = $[78];
    let t24;
    if ($[79] !== spaceName || $[80] !== title) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
            contentTitle: title,
            contentSpace: spaceName
        });
        $[79] = spaceName;
        $[80] = title;
        $[81] = t24;
    } else t24 = $[81];
    let t25;
    if ($[82] !== renderSpotlight) {
        t25 = renderSpotlight();
        $[82] = renderSpotlight;
        $[83] = t25;
    } else t25 = $[83];
    let t26;
    if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $5qUgM.CONTENT_TYPES_HEADER_TITLE_SEGMENT)
        });
        $[84] = t26;
    } else t26 = $[84];
    let t27;
    if ($[85] !== t23 || $[86] !== t24 || $[87] !== t25) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t22, t23, t24, t25, t26);
        $[85] = t23;
        $[86] = t24;
        $[87] = t25;
        $[88] = t27;
    } else t27 = $[88];
    return t27;
};


const $4cb3eaaf01c9d693$export$dce52735e291d3da = {
    showMove: true,
    showArchive: true,
    showCopy: true,
    showBreadcrumbs: true,
    showReplacementAccessLinkTitle: true,
    showInlineRename: true,
    showFavourite: true,
    showShare: true,
    showMainActions: true,
    showMoreActions: true,
    showClassificationMenuAction: false,
    showContentRestrictions: true,
    showWatchDialog: true,
    showLastEdited: true,
    showPresence: true,
    showWhiteboardTeammate: true
};





const $52743c6077a5aa9d$export$994d93100c71c210 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { allowedFeatures: allowedFeatures, hasAccessLinkTitle: hasAccessLinkTitle, isAccessLinkViewer: isAccessLinkViewer } = t0;
    let features = allowedFeatures;
    if (hasAccessLinkTitle) {
        let t1;
        if ($[0] !== features) {
            t1 = {
                ...features,
                showBreadcrumbs: false
            };
            $[0] = features;
            $[1] = t1;
        } else t1 = $[1];
        features = t1;
    }
    if (isAccessLinkViewer) {
        let t1;
        if ($[2] !== features) {
            t1 = {
                ...features,
                showWatchDialog: false
            };
            $[2] = features;
            $[3] = t1;
        } else t1 = $[3];
        features = t1;
    }
    return features;
};


const $71c531080fb6afdc$export$753f77420b5437b9 = ({ isSpaceOverviewPage: isSpaceOverviewPage, contentMode: contentMode, editorTitle: editorTitle, contentTitle: contentTitle })=>{
    if (isSpaceOverviewPage) // Pass an undefined string to contentTitle to prevent the breadcrumbs from rendering
    // a title when this is a Space Overview page
    return undefined;
    // intentionally exclude live mode, we want to return published content title since live mode publishes their title on every change
    if (contentMode === 'edit' || contentMode === 'draft') // pass the editorTitle as-is, even if it is an empty string (empty strings will be transformed into "Untitled")
    // pass in contentTitle if editorTitle is not available to prevent any breadcrumbs layout shifting during load (especially for drafts)
    return typeof editorTitle === 'string' ? editorTitle : typeof contentTitle === 'string' ? contentTitle : undefined;
    return contentTitle ?? undefined;
};









var $4HbMh = parcelRequire("4HbMh");


var $1sCHt = parcelRequire("1sCHt");


var $gqqjz = parcelRequire("gqqjz");


var $iAOfI = parcelRequire("iAOfI");











var $jFm04 = parcelRequire("jFm04");





var $4wEOc = parcelRequire("4wEOc");

'use no memo';
const $66bd5ba8343e39f0$export$48cea123122bbc52 = (_contentType, _isLivePage = false, shouldSkipEnablementQuery = false)=>{
    const { isEnabled: isClassificationEnabledForOrg } = (0, $4wEOc.useIsDataClassificationEnabledForOrg)({
        skip: shouldSkipEnablementQuery
    });
    // Classification is enabled for all content types as long as it is enabled for the org.
    return isClassificationEnabledForOrg;
};









var $jeQ9x = parcelRequire("jeQ9x");














var $gDx2k = parcelRequire("gDx2k");


var $dAzRS = parcelRequire("dAzRS");


var $Gq5Ho = parcelRequire("Gq5Ho");


var $87whh = parcelRequire("87whh");




const $0f9c0b3d7e5360a3$export$7c95b5e4cc9d3256 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1xpoY.default).getString("confluence_page_preview_panel_testing", "");
        $[0] = t0;
    } else t0 = $[0];
    const previewPanelUrl = t0;
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel } = (0, $Gq5Ho.useConfluencePagePreviewPanel)((0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE);
    const isOpen = (0, $87whh.useIsPreviewPanelOpen)();
    if (!previewPanelUrl) return null;
    let t1;
    if ($[1] !== closeConfluencePagePreviewPanel || $[2] !== isOpen || $[3] !== openConfluencePagePreviewPanel) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))),
            label: "Preview Panel Test",
            onClick: ()=>isOpen ? closeConfluencePagePreviewPanel() : openConfluencePagePreviewPanel(previewPanelUrl)
        });
        $[1] = closeConfluencePagePreviewPanel;
        $[2] = isOpen;
        $[3] = openConfluencePagePreviewPanel;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const previewPanelUrl = (0, $1xpoY.default).getString('confluence_page_preview_panel_testing', '');
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel } = (0, $Gq5Ho.useConfluencePagePreviewPanel)((0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE);
    const isOpen = (0, $87whh.useIsPreviewPanelOpen)();
    if (!previewPanelUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))),
        label: "Preview Panel Test",
        onClick: ()=>isOpen ? closeConfluencePagePreviewPanel() : openConfluencePagePreviewPanel(previewPanelUrl)
    });
};



var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");


var $6ug2F = parcelRequire("6ug2F");


var $cxu5H = parcelRequire("cxu5H");


var $bjZbA = parcelRequire("bjZbA");


var $dA1Sn = parcelRequire("dA1Sn");








var $3o3i5 = parcelRequire("3o3i5");











var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48a5da156a2c7b78$var$StyledMainActions = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEhJSK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $48a5da156a2c7b78$var$ConditionalWrapper = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
const $48a5da156a2c7b78$var$TooltipWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { mainAction: mainAction, children: children } = t0;
    const t1 = `${mainAction.id}-tooltip`;
    let t2;
    if ($[0] !== children || $[1] !== mainAction.tooltip || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: mainAction.tooltip,
            testId: t1
        }, children);
        $[0] = children;
        $[1] = mainAction.tooltip;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $48a5da156a2c7b78$export$a37ba60443eae06e = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { mainActions: mainActions } = t0;
    let t1;
    if ($[0] !== mainActions) {
        t1 = mainActions?.map($48a5da156a2c7b78$var$_temp);
        $[0] = mainActions;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
function $48a5da156a2c7b78$var$_temp(mainAction) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($48a5da156a2c7b78$var$StyledMainActions, {
        key: mainAction.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($48a5da156a2c7b78$var$ConditionalWrapper, {
        condition: mainAction.tooltip !== undefined,
        wrapper: (children)=>$48a5da156a2c7b78$var$TooltipWrapper({
                mainAction: mainAction,
                children: children
            })
    }, mainAction.buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: mainAction.buttonLink,
        appearance: mainAction.appearance,
        isSelected: mainAction.isSelected,
        onClick: mainAction.onClick,
        iconBefore: ()=>mainAction.icon,
        testId: mainAction.id,
        target: mainAction.openInNewTab ? "_blank" : "_self"
    }, mainAction.text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: mainAction.appearance,
        isSelected: mainAction.isSelected,
        onClick: mainAction.onClick,
        iconBefore: ()=>mainAction.icon,
        testId: mainAction.id
    }, mainAction.text || mainAction.label)));
}


















var $4nIKB = parcelRequire("4nIKB");


var $gC2EJ = parcelRequire("gC2EJ");


var $bh4C9 = parcelRequire("bh4C9");





var $11OF7 = parcelRequire("11OF7");


var $f3HCt = parcelRequire("f3HCt");


var $eDtFr = parcelRequire("eDtFr");





var $6TaGl = parcelRequire("6TaGl");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");











var $2pQiO = parcelRequire("2pQiO");





var $aRvnq = parcelRequire("aRvnq");


var $iqeQP = parcelRequire("iqeQP");


var $lCTy3 = parcelRequire("lCTy3");


var $2jY8x = parcelRequire("2jY8x");


var $kLlYX = parcelRequire("kLlYX");


var $dPtk6 = parcelRequire("dPtk6");


var $kUFQ0 = parcelRequire("kUFQ0");


var $bAKDg = parcelRequire("bAKDg");


var $4efpo = parcelRequire("4efpo");


var $6omt0 = parcelRequire("6omt0");


var $kyJuy = parcelRequire("kyJuy");


var $5ZtfK = parcelRequire("5ZtfK");


var $8lt1a = parcelRequire("8lt1a");


var $2x0Nk = parcelRequire("2x0Nk");


var $a9aSv = parcelRequire("a9aSv");


var $6Fmj3 = parcelRequire("6Fmj3");


var $hAgam = parcelRequire("hAgam");


var $b8pma = parcelRequire("b8pma");


var $kdlgT = parcelRequire("kdlgT");


var $ivert = parcelRequire("ivert");











var $gMfOo = parcelRequire("gMfOo");











var $bQm3c = parcelRequire("bQm3c");

const $170867294debdb93$var$REPORT_ABUSE_BASE_URL = 'https://support.atlassian.com/contact/#/?inquiry_category=abuse&support_type=customer';
const $170867294debdb93$export$4c0463ac9878f99 = ({ ati: ati, ari: ari, fileUrl: fileUrl, reporteraaid: reporteraaid })=>{
    const params = new URLSearchParams();
    if (ati) params.append('ati', ati);
    if (ari) params.append('ari', ari);
    if (reporteraaid) params.append('reporteraaid', reporteraaid);
    if (fileUrl) params.append('fileUrl', fileUrl);
    const extraParams = params.toString();
    return extraParams ? `${$170867294debdb93$var$REPORT_ABUSE_BASE_URL}&${extraParams}` : $170867294debdb93$var$REPORT_ABUSE_BASE_URL;
};


const $dae6041f5080f63e$var$REPORT_ABUSE_ATI_PREFIX = 'ati:cloud:confluence';
const $dae6041f5080f63e$var$REPORT_ABUSE_ARI_PREFIX = 'ari:cloud:confluence::content';
const $dae6041f5080f63e$export$4df9889c4164d521 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { contentId: contentId, contentType: contentType } = t0;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    if (!(0, $9wGTI.fg)("cc_golden_path_report_abuse_extension")) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $170867294debdb93$export$4c0463ac9878f99)({});
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    const ati = contentType ? `${$dae6041f5080f63e$var$REPORT_ABUSE_ATI_PREFIX}:${contentType}` : undefined;
    const ari = cloudId && contentId ? `${$dae6041f5080f63e$var$REPORT_ABUSE_ARI_PREFIX}/${contentId}` : undefined;
    const fileUrl = typeof window.location !== "undefined" ? window.location.href : undefined;
    let t1;
    if ($[1] !== ari || $[2] !== ati || $[3] !== userId) {
        t1 = (0, $170867294debdb93$export$4c0463ac9878f99)({
            ati: ati,
            ari: ari,
            fileUrl: fileUrl,
            reporteraaid: userId
        });
        $[1] = ari;
        $[2] = ati;
        $[3] = userId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};


const $871972f40e17ae63$var$i18n = (0, $kSwu1.defineMessages)({
    reportAbuseLabel: {
        id: "report-abuse.menu-item.label",
        defaultMessage: "Report Abuse"
    }
});
const $871972f40e17ae63$export$fe18dbd7a0492bf0 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId, contentType: contentType, onClick: onClick } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== contentType) {
        t1 = {
            contentId: contentId,
            contentType: contentType
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = t1;
    } else t1 = $[2];
    const href = (0, $dae6041f5080f63e$export$4df9889c4164d521)(t1);
    let t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gMfOo))), {
            label: ""
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $871972f40e17ae63$var$i18n.reportAbuseLabel);
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    let t4;
    if ($[5] !== href || $[6] !== onClick) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: onClick,
            elemBefore: t2
        }, t3);
        $[5] = href;
        $[6] = onClick;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};



var $hjUDQ = parcelRequire("hjUDQ");


var $lJDEI = parcelRequire("lJDEI");


var $lvOsp = parcelRequire("lvOsp");


var $euL71 = parcelRequire("euL71");


var $gDbO8 = parcelRequire("gDbO8");





var $gEtAQ = parcelRequire("gEtAQ");





var $78wUU = parcelRequire("78wUU");


var $aYZaZ = parcelRequire("aYZaZ");


var $d8oE8 = parcelRequire("d8oE8");











var $kqv9Z = parcelRequire("kqv9Z");


var $6ykQV = parcelRequire("6ykQV");


var $eSLr0 = parcelRequire("eSLr0");


var $iEfsZ = parcelRequire("iEfsZ");


var $kxhju = parcelRequire("kxhju");


var $bHd1w = parcelRequire("bHd1w");


var $5FwhF = parcelRequire("5FwhF");


var $3J7TU = parcelRequire("3J7TU");

















var $1Zthr = parcelRequire("1Zthr");


var $k22lL = parcelRequire("k22lL");


var $2WH1B = parcelRequire("2WH1B");


var $kRW4Y = parcelRequire("kRW4Y");





var $8Lx5S = parcelRequire("8Lx5S");





var $ln0hx = parcelRequire("ln0hx");

var $hjygH = parcelRequire("hjygH");



var $1kHsc = parcelRequire("1kHsc");


var $dcvq8 = parcelRequire("dcvq8");


var $c54hr = parcelRequire("c54hr");


var $aCrkK = parcelRequire("aCrkK");


var $5thep = parcelRequire("5thep");










const $ff966189b275be15$export$78b7a39935e0bb86 = (contentType, contentMode, isSpaceOverviewPage)=>{
    if (contentType === 'page' && !isSpaceOverviewPage) return contentMode === 'view';
    return false;
};
const $ff966189b275be15$export$a130e0ea03d42b0b = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$32820bf57e654cf8 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'edit';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
};
const $ff966189b275be15$export$58a134bd2769b459 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'archived';
    else if (contentType === 'blogpost') return contentMode === 'view';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
const $ff966189b275be15$export$dec488a51a9b97f0 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'edit' || contentMode === 'draft';
    else if (contentType === 'blogpost') return contentMode === 'view' || contentMode === 'edit' || contentMode === 'draft';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$f7bde71715697ce0 = (contentType, contentMode, readOnly)=>{
    if (contentType === 'page') // Templates are always available on live/draft pages. For published (edit) pages we only expose
    // templates when `platform_editor_blocks_conf` is enabled.
    return contentMode === 'live' || contentMode === 'draft' || contentMode === 'edit' && (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false);
    if ((0, $1ggpj.isCanvasContentType)(contentType)) return !readOnly;
    return contentType === 'database' && contentMode !== 'archived' && !readOnly;
};
const $ff966189b275be15$export$a2eada40e8c9a2ed = (contentType, contentMode, isSpaceOverviewPage)=>{
    return (contentType === 'page' || contentType === 'blogpost') && (contentMode === 'view' || contentMode === 'live') && !isSpaceOverviewPage;
};
const $ff966189b275be15$export$d790dfbcfcf44b71 = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'edit' || contentMode === 'draft';
    return false;
};
const $ff966189b275be15$export$caca47bf68c8998 = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode === 'edit';
    return false;
};
const $ff966189b275be15$export$71ad62dbe8638043 = (contentType, contentMode, hasEditPermission, livePageMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        const isLiveView = contentType === 'page' && contentMode === 'live' && livePageMode === 'view';
        // In live view the editor find dialog is the only way to search content inside
        // collapsed heading sections, which the editor hides with `display: none`. Readers
        // without edit permission get it too, because the dialog offers find without replace.
        // This rides the collapsible headings experiment, because collapsed content is the
        // reason live view needs the editor find at all.
        if (isLiveView && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_collapsible_headings', 'isEnabled', false)) return true;
        if (!hasEditPermission) return false;
        if (isLiveView) return false;
        return contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft';
    }
    return false;
};
const $ff966189b275be15$export$d0c33a26470e0efe = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode === 'edit';
    return false;
};
const $ff966189b275be15$export$493ddb7a4c710fed = (contentType, contentMode, isDeleteDraftAllowed, isAutoConvertedDraftRevertEnabled)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (contentMode === 'edit' && isDeleteDraftAllowed) return true;
        else if (isAutoConvertedDraftRevertEnabled && contentType === 'page' && contentMode === 'draft') return true;
        else if (contentMode === 'view') return true;
    }
    return false;
};
const $ff966189b275be15$export$bb21210c1c36f22a = (contentType, contentMode, isSpaceOverviewPage)=>{
    if (contentType === 'page' && !isSpaceOverviewPage) return contentMode === 'view' || contentMode === 'live' || contentMode === 'archived';
    return false;
};
const $ff966189b275be15$export$49f8860e43af4419 = (contentType, contentMode)=>{
    return (contentType === 'page' || contentType === 'blogpost') && contentMode !== 'draft' && contentMode !== 'edit';
};
const $ff966189b275be15$export$8623af461a2f6a54 = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode === 'live' || contentMode === 'view';
    return false;
};
const $ff966189b275be15$export$46e46e0c15d57a1 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed';
};
const $ff966189b275be15$export$1711931c27adfab0 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
const $ff966189b275be15$export$11233ac17765daec = (contentType)=>{
    return contentType === 'embed';
};
const $ff966189b275be15$export$3d371a49efa2fa0a = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') return contentMode !== 'draft';
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'folder';
};
const $ff966189b275be15$export$4a2abd609e31ae47 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType);
};
const $ff966189b275be15$export$37d144a1b557c80d = (contentType, contentMode)=>{
    return contentType === 'page' && contentMode === 'live';
};
const $ff966189b275be15$export$d01b7f6c0ae49b6b = (contentType, contentMode, isMarkdownMode)=>{
    return contentType === 'page' && contentMode === 'live' && !isMarkdownMode && (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true);
};
const $ff966189b275be15$export$22cead55e1c779de = (contentType, contentMode, isMarkdownMode)=>{
    return contentType === 'page' && contentMode === 'live' && !!isMarkdownMode && (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true);
};
const $ff966189b275be15$export$74e87e549c7a0f96 = (contentType, contentMode)=>{
    return (contentType === 'page' || contentType === 'blogpost') && (contentMode === 'edit' || contentMode === 'draft');
};
const $ff966189b275be15$export$458bbd6d88041c9d = (contentType, contentMode)=>{
    if (contentType === 'page') return contentMode === 'live' || contentMode === 'view' || contentMode === 'archived';
    else if (contentType === 'blogpost') return contentMode === 'view';
    return false;
};








const $1b70db1d5649f5f3$export$5dc260e4e702b5d0 = (contentType)=>{
    return ((0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database') && !(0, $9wGTI.fg)('cc-whiteboards-consolidating-comments');
};



var $2cKGu = parcelRequire("2cKGu");







/* ConvertMarkdownModeDialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");











var $2VjJa = parcelRequire("2VjJa");


var $fxbF1 = parcelRequire("fxbF1");


var $3xwCI = parcelRequire("3xwCI");


var $6YkHb = parcelRequire("6YkHb");


var $9KSWX = parcelRequire("9KSWX");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $1VhsF = parcelRequire("1VhsF");

const $6b53555ece09eb9c$var$TEST_ID = 'convert-markdown-mode-dialog';
const $6b53555ece09eb9c$var$styles = {
    iconBox: "_0jFU0VoWWg _39xV02oWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _4xdlr07p2s",
    rowText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
    titleText: "_3iDTPbS8kF",
    lozengeWrap: "_3YEZNOdnbC",
    bodyStack: "_46hvQm1Y8M _0xmtko2ADO",
    footer: "_39xV02N91d"
};
const $6b53555ece09eb9c$var$resolveVariant = (direction, isLossy)=>{
    if (direction === 'toRichText') return 'toRichText';
    return isLossy ? 'toMarkdownLossy' : 'toMarkdown';
};
const $6b53555ece09eb9c$var$buildRows = (variant)=>{
    switch(variant){
        case 'toMarkdownLossy':
            return [
                {
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3xwCI))), {
                        label: ""
                    }),
                    label: (0, $2VjJa.markdownModeMessages).confirmDialogToMarkdownLossyRichContent,
                    testId: `${$6b53555ece09eb9c$var$TEST_ID}--row-lossy-rich-content`
                },
                {
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
                        label: ""
                    }),
                    label: (0, $2VjJa.markdownModeMessages).confirmDialogToMarkdownLossyVersionHistory,
                    testId: `${$6b53555ece09eb9c$var$TEST_ID}--row-lossy-version-history`
                }
            ];
        case 'toMarkdown':
            return [
                {
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3xwCI))), {
                        label: ""
                    }),
                    label: (0, $2VjJa.markdownModeMessages).confirmDialogToMarkdownToolsRemoved,
                    testId: `${$6b53555ece09eb9c$var$TEST_ID}--row-tools-removed`
                },
                {
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
                        label: ""
                    }),
                    label: (0, $2VjJa.markdownModeMessages).confirmDialogToMarkdownToggle,
                    testId: `${$6b53555ece09eb9c$var$TEST_ID}--row-toggle`
                },
                {
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
                        label: ""
                    }),
                    label: (0, $2VjJa.markdownModeMessages).confirmDialogToMarkdownVersionHistory,
                    testId: `${$6b53555ece09eb9c$var$TEST_ID}--row-version-history`
                }
            ];
        case 'toRichText':
        default:
            return [
                {
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3xwCI))), {
                        label: ""
                    }),
                    label: (0, $2VjJa.markdownModeMessages).confirmDialogToRichTextStandardTools,
                    testId: `${$6b53555ece09eb9c$var$TEST_ID}--row-standard-tools`
                },
                {
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
                        label: ""
                    }),
                    label: (0, $2VjJa.markdownModeMessages).confirmDialogToRichTextVersionHistory,
                    testId: `${$6b53555ece09eb9c$var$TEST_ID}--row-version-history`
                }
            ];
    }
};
const $6b53555ece09eb9c$var$InlineRow = ({ icon: icon, label: label, testId: testId })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $6b53555ece09eb9c$var$styles.iconBox,
                testId: testId,
                children: icon
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $6b53555ece09eb9c$var$styles.rowText,
                children: intl.formatMessage(label)
            })
        ]
    });
};
const $6b53555ece09eb9c$var$resolveTitle = (variant)=>{
    switch(variant){
        case 'toMarkdownLossy':
            return (0, $2VjJa.markdownModeMessages).confirmDialogTitleToMarkdownLossy;
        case 'toMarkdown':
            return (0, $2VjJa.markdownModeMessages).confirmDialogTitleToMarkdown;
        case 'toRichText':
        default:
            return (0, $2VjJa.markdownModeMessages).confirmDialogTitleToRichText;
    }
};
const $6b53555ece09eb9c$var$resolveConfirmLabel = (variant)=>variant === 'toMarkdownLossy' ? (0, $2VjJa.markdownModeMessages).confirmDialogToMarkdownLossyCta : (0, $2VjJa.markdownModeMessages).confirmDialogConfirm;
const $6b53555ece09eb9c$var$ConvertMarkdownModeDialogContents = ({ direction: direction, isLossy: isLossy, syncBlockCount: syncBlockCount = 0, onConfirm: onConfirm, onClose: onClose })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const handleConfirm = (0, $cozmU.useCallback)(async ()=>{
        setHasError(false);
        setIsSubmitting(true);
        try {
            const { success: success } = await onConfirm();
            if (success) onClose();
            else setHasError(true);
        } catch  {
            setHasError(true);
        } finally{
            setIsSubmitting(false);
        }
    }, [
        onConfirm,
        onClose
    ]);
    const variant = $6b53555ece09eb9c$var$resolveVariant(direction, isLossy);
    const isWarning = variant === 'toMarkdownLossy' || syncBlockCount > 0;
    const rows = $6b53555ece09eb9c$var$buildRows(variant);
    const titleMessage = $6b53555ece09eb9c$var$resolveTitle(variant);
    const confirmLabel = variant === 'toMarkdown' && syncBlockCount > 0 ? (0, $2VjJa.markdownModeMessages).confirmDialogToMarkdownLossyCta : $6b53555ece09eb9c$var$resolveConfirmLabel(variant);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                    appearance: isWarning ? 'warning' : undefined,
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        as: "span",
                        space: "space.100",
                        alignBlock: "start",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                as: "span",
                                xcss: $6b53555ece09eb9c$var$styles.titleText,
                                children: intl.formatMessage(titleMessage)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                as: "span",
                                xcss: $6b53555ece09eb9c$var$styles.lozengeWrap,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                                    appearance: "discovery",
                                    children: intl.formatMessage((0, $2VjJa.markdownModeMessages).labsLozenge)
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fEPJS.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                    space: "space.150",
                    xcss: $6b53555ece09eb9c$var$styles.bodyStack,
                    children: [
                        rows.map((row)=>/*#__PURE__*/ (0, $8aG6j.jsx)($6b53555ece09eb9c$var$InlineRow, {
                                icon: row.icon,
                                label: row.label,
                                testId: row.testId
                            }, row.testId)),
                        syncBlockCount > 0 ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1VhsF.default), {
                            appearance: "warning",
                            title: intl.formatMessage((0, $2VjJa.markdownModeMessages).unlinkSyncedBlocksTitle),
                            testId: `${$6b53555ece09eb9c$var$TEST_ID}--synced-content-warning`,
                            children: intl.formatMessage((0, $2VjJa.markdownModeMessages).unlinkSyncedBlocksBody)
                        }) : null,
                        hasError ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1VhsF.default), {
                            appearance: "error",
                            testId: `${$6b53555ece09eb9c$var$TEST_ID}--error`,
                            children: intl.formatMessage((0, $2VjJa.markdownModeMessages).confirmDialogError)
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eQiT1.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $6b53555ece09eb9c$var$styles.footer,
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        alignBlock: "center",
                        alignInline: "end",
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                appearance: "subtle",
                                onClick: onClose,
                                isDisabled: isSubmitting,
                                testId: `${$6b53555ece09eb9c$var$TEST_ID}--cancel`,
                                children: intl.formatMessage((0, $2VjJa.markdownModeMessages).confirmDialogCancel)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                autoFocus: true,
                                appearance: isWarning ? 'warning' : 'primary',
                                onClick: handleConfirm,
                                isDisabled: isSubmitting,
                                testId: `${$6b53555ece09eb9c$var$TEST_ID}--confirm`,
                                children: intl.formatMessage(confirmLabel)
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const $6b53555ece09eb9c$export$5dc4ca615d73e8f7 = ({ isOpen: isOpen, direction: direction, isLossy: isLossy, syncBlockCount: syncBlockCount = 0, onConfirm: onConfirm, onClose: onClose })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7aRdF.default), {
            onClose: onClose,
            width: "small",
            testId: $6b53555ece09eb9c$var$TEST_ID,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($6b53555ece09eb9c$var$ConvertMarkdownModeDialogContents, {
                direction: direction,
                isLossy: isLossy,
                syncBlockCount: syncBlockCount,
                onConfirm: onConfirm,
                onClose: onClose
            })
        }) : null
    });



var $bYfSa = parcelRequire("bYfSa");

const $b730a79dde962810$export$7a57ac10272e035f = ({ onConfirmToMarkdown: onConfirmToMarkdown, onConfirmToRichText: onConfirmToRichText })=>{
    const [{ dialog: dialog }] = (0, $bYfSa.useConvertDialogState)();
    const { closeConvertDialog: closeConvertDialog } = (0, $bYfSa.useConvertDialogActions)();
    const handleConfirm = (0, $cozmU.useCallback)(async ()=>{
        if (!dialog.isOpen) return {
            success: false
        };
        return dialog.direction === 'toMarkdown' ? onConfirmToMarkdown() : onConfirmToRichText();
    }, [
        dialog,
        onConfirmToMarkdown,
        onConfirmToRichText
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b53555ece09eb9c$export$5dc4ca615d73e8f7), {
        isOpen: dialog.isOpen,
        direction: dialog.isOpen ? dialog.direction : 'toMarkdown',
        isLossy: dialog.isOpen ? dialog.isLossy : false,
        syncBlockCount: dialog.isOpen ? dialog.syncBlockCount : 0,
        onConfirm: handleConfirm,
        onClose: closeConvertDialog
    });
};



var $bJrpn = parcelRequire("bJrpn");


var $6hmtW = parcelRequire("6hmtW");


var $9BVDK = parcelRequire("9BVDK");


var $6eFi0 = parcelRequire("6eFi0");


var $2E1L5 = parcelRequire("2E1L5");


var $ai7NK = parcelRequire("ai7NK");


var $5KL6w = parcelRequire("5KL6w");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $4GDP8 = parcelRequire("4GDP8");


var $7J5Uc = parcelRequire("7J5Uc");


var $5yVAS = parcelRequire("5yVAS");


var $bzwhi = parcelRequire("bzwhi");


var $3krUE = parcelRequire("3krUE");

/**
 * @generated SignedSource<<abad9c59a78f6c0e9d2a410652b80c25>>
 * @relayHash 5e62fa12477c31b6e34abc2474433a92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed99853890443271211bafc59fd8d139d00fbb8e481259cdc1cfe95cfaa1b947
const $f7631694bda7441a$var$node = function() {
    var v0 = [
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "WatchSettingsItemTrialDetailsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "WatchSettingsItemTrialDetailsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5e62fa12477c31b6e34abc2474433a92",
            "id": "ed99853890443271211bafc59fd8d139d00fbb8e481259cdc1cfe95cfaa1b947",
            "metadata": {},
            "name": "WatchSettingsItemTrialDetailsQuery",
            "operationKind": "query",
            "text": "query WatchSettingsItemTrialDetailsQuery{license{trialEndDate}}"
        }
    };
}();
$f7631694bda7441a$var$node.hash = "95d5a1d05fc052c62a0995545b6cedc8";
var $f7631694bda7441a$export$2e2bcd8739ae039 = $f7631694bda7441a$var$node;












var $aDSIl = parcelRequire("aDSIl");











var $a79Sy = parcelRequire("a79Sy");


var $XgBmC = parcelRequire("XgBmC");





var $2Zz3q = parcelRequire("2Zz3q");





var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $1uFM6 = parcelRequire("1uFM6");











var $f9HtC = parcelRequire("f9HtC");


var $5EoFB = parcelRequire("5EoFB");





var $7aRa9 = parcelRequire("7aRa9");

/**
 * @generated SignedSource<<0f922a194a263913a932b4c350af11ce>>
 * @relayHash 784eb81584ff60b20ad802add7a860b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 396cfb0e77d3f5d2d3be19c191884a1eb98d20638e1a1c0af526217e72cc9c41
const $d90ac48a7784de52$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeChildren"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "id"
                        },
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "includeChildren",
                            "variableName": "includeChildren"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchContentInput"
                }
            ],
            "concreteType": "WatchContentPayload",
            "kind": "LinkedField",
            "name": "watchContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "currentUserIsWatchingChildren"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "784eb81584ff60b20ad802add7a860b0",
            "id": "396cfb0e77d3f5d2d3be19c191884a1eb98d20638e1a1c0af526217e72cc9c41",
            "metadata": {},
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation",
            "operationKind": "mutation",
            "text": "mutation WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation($id:ID!,$includeChildren:Boolean){watchContent(watchContentInput:{contentId:$id,currentUser:true,includeChildren:$includeChildren}){content{id,currentUserIsWatchingChildren}}}"
        }
    };
}();
$d90ac48a7784de52$var$node.hash = "c9440fa8475983e8d6fcad9b24ce5d57";
var $d90ac48a7784de52$export$2e2bcd8739ae039 = $d90ac48a7784de52$var$node;


/**
 * @generated SignedSource<<92df421f36de36b72848778d4f5ee484>>
 * @relayHash 220c1dc9971af7620525069e05c4802e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 557e099621709e324ddfa12255e9381a2dda552618cc3fb198af91465d7f8192
const $532f71827d8eb303$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeChildren"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "id"
                        },
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "includeChildren",
                            "variableName": "includeChildren"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchContentInput"
                }
            ],
            "concreteType": "WatchContentPayload",
            "kind": "LinkedField",
            "name": "watchContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "currentUserIsWatchingChildren"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "220c1dc9971af7620525069e05c4802e",
            "id": "557e099621709e324ddfa12255e9381a2dda552618cc3fb198af91465d7f8192",
            "metadata": {},
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation",
            "operationKind": "mutation",
            "text": "mutation WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation($id:ID!,$includeChildren:Boolean){watchContent(watchContentInput:{contentId:$id,currentUser:true,includeChildren:$includeChildren}){content{id,currentUserIsWatchingChildren}}}"
        }
    };
}();
$532f71827d8eb303$var$node.hash = "e5b69a223926d9564180a06fcb387aaf";
var $532f71827d8eb303$export$2e2bcd8739ae039 = $532f71827d8eb303$var$node;


/**
 * @generated SignedSource<<4b6dfdae9c48950f6e90068e7e893cde>>
 * @relayHash d77704449727a4fba85ef3393fa73580
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5bd0701ceaa0fe9c8c090a00b4ac1dd90cf504110fc3b0e5741c489a8400b2d2
const $5aea7caf34cb0595$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceId",
                            "variableName": "spaceId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchSpaceInput"
                }
            ],
            "concreteType": "WatchSpacePayload",
            "kind": "LinkedField",
            "name": "unwatchSpace",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d77704449727a4fba85ef3393fa73580",
            "id": "5bd0701ceaa0fe9c8c090a00b4ac1dd90cf504110fc3b0e5741c489a8400b2d2",
            "metadata": {},
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation($spaceId:ID!){unwatchSpace(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatched}}}}"
        }
    };
}();
$5aea7caf34cb0595$var$node.hash = "8c5e29a2e28ada8e000ea45eac9b0b5d";
var $5aea7caf34cb0595$export$2e2bcd8739ae039 = $5aea7caf34cb0595$var$node;


/**
 * @generated SignedSource<<6207dc59d1d20e528f855c79db4fa056>>
 * @relayHash 2a24468c466d8e9a73d581e3768dbb35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d01016327c806a0379196745d32fade48e4ff11a5890e82a8056269243acbe7d
const $23f3269f5efb45f2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceId",
                            "variableName": "spaceId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchSpaceInput"
                }
            ],
            "concreteType": "WatchSpacePayload",
            "kind": "LinkedField",
            "name": "watchSpace",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2a24468c466d8e9a73d581e3768dbb35",
            "id": "d01016327c806a0379196745d32fade48e4ff11a5890e82a8056269243acbe7d",
            "metadata": {},
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation WatchSettingsCheckboxItemsWatchDialogWatchSpaceMutation($spaceId:ID!){watchSpace(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatched}}}}"
        }
    };
}();
$23f3269f5efb45f2$var$node.hash = "66118bea4ceac3b38ba446d22355a1c9";
var $23f3269f5efb45f2$export$2e2bcd8739ae039 = $23f3269f5efb45f2$var$node;


/**
 * @generated SignedSource<<758c135d7fd906794385d00fe9ef5cef>>
 * @relayHash 65eaeffc7d49cbfbdabaa3df12f1ca03
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cec9945748f8de03d3172e831e29a0dbbb45ce8c376e1c6485a0e61d646edcd0
const $9fa208f239c55b38$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceId",
                            "variableName": "spaceId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchSpaceInput"
                }
            ],
            "concreteType": "WatchSpacePayload",
            "kind": "LinkedField",
            "name": "unwatchBlogs",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatchingBlogs"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "65eaeffc7d49cbfbdabaa3df12f1ca03",
            "id": "cec9945748f8de03d3172e831e29a0dbbb45ce8c376e1c6485a0e61d646edcd0",
            "metadata": {},
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation",
            "operationKind": "mutation",
            "text": "mutation WatchSettingsCheckboxItemsWatchDialogUnwatchBlogsMutation($spaceId:ID!){unwatchBlogs(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatchingBlogs}}}}"
        }
    };
}();
$9fa208f239c55b38$var$node.hash = "3fc1a3ec86be09c73864b27362d2f1a6";
var $9fa208f239c55b38$export$2e2bcd8739ae039 = $9fa208f239c55b38$var$node;


/**
 * @generated SignedSource<<c867ecbf2e92cdd2fc6f3624eee0c9ba>>
 * @relayHash 620df065b7431ceffafcc0bd6a2477a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6f95b1f8b37927e14435ca4228c482bb4cdadc4c126c2be318566284e9a1395
const $7583e5b0ae12d9ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceId",
                            "variableName": "spaceId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchSpaceInput"
                }
            ],
            "concreteType": "WatchSpacePayload",
            "kind": "LinkedField",
            "name": "watchBlogs",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatchingBlogs"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "620df065b7431ceffafcc0bd6a2477a8",
            "id": "e6f95b1f8b37927e14435ca4228c482bb4cdadc4c126c2be318566284e9a1395",
            "metadata": {},
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation",
            "operationKind": "mutation",
            "text": "mutation WatchSettingsCheckboxItemsWatchDialogWatchBlogsMutation($spaceId:ID!){watchBlogs(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatchingBlogs}}}}"
        }
    };
}();
$7583e5b0ae12d9ec$var$node.hash = "55ef642597667d6c9b68e438922daf62";
var $7583e5b0ae12d9ec$export$2e2bcd8739ae039 = $7583e5b0ae12d9ec$var$node;


/**
 * @generated SignedSource<<b205ef2730c48d02e569b30a99a541ef>>
 * @relayHash 1a883375b2a6a14337dc51105c07f050
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 30d7d5e1ae9ef6998d6c80f39437903f638fc5d6d55dc38c4d3b20fb20d6acbe
const $2ae404a0a30ec50b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "id"
                        },
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchContentInput"
                }
            ],
            "concreteType": "WatchContentPayload",
            "kind": "LinkedField",
            "name": "unwatchContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "currentUserIsWatching"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1a883375b2a6a14337dc51105c07f050",
            "id": "30d7d5e1ae9ef6998d6c80f39437903f638fc5d6d55dc38c4d3b20fb20d6acbe",
            "metadata": {},
            "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation",
            "operationKind": "mutation",
            "text": "mutation WatchSettingsCheckboxItemsWatchDialogUnwatchContentMutation($id:ID!){unwatchContent(watchContentInput:{contentId:$id,currentUser:true}){content{id,currentUserIsWatching}}}"
        }
    };
}();
$2ae404a0a30ec50b$var$node.hash = "9f4a882f6a9a2ad388c10ff7750841a5";
var $2ae404a0a30ec50b$export$2e2bcd8739ae039 = $2ae404a0a30ec50b$var$node;


/**
 * @generated SignedSource<<bb48b210bab3fad47b27e66ecda13229>>
 * @relayHash 101b1a8ae7e0bf33f1337fc2b781ca83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID baffd355fcdf4cec4bf546e89f209f61ee3445d680d7539739d1b212cb56fd99
const $6f3fff661936387e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeChildren"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "id"
                        },
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "includeChildren",
                            "variableName": "includeChildren"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchContentInput"
                }
            ],
            "concreteType": "WatchContentPayload",
            "kind": "LinkedField",
            "name": "watchContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "currentUserIsWatching"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchContentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchContentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "101b1a8ae7e0bf33f1337fc2b781ca83",
            "id": "baffd355fcdf4cec4bf546e89f209f61ee3445d680d7539739d1b212cb56fd99",
            "metadata": {},
            "name": "WatchSettingsCheckboxItemsWatchDialogWatchContentMutation",
            "operationKind": "mutation",
            "text": "mutation WatchSettingsCheckboxItemsWatchDialogWatchContentMutation($id:ID!,$includeChildren:Boolean){watchContent(watchContentInput:{contentId:$id,currentUser:true,includeChildren:$includeChildren}){content{id,currentUserIsWatching}}}"
        }
    };
}();
$6f3fff661936387e$var$node.hash = "f0531cc08c5665f791387efd9fdd5a2c";
var $6f3fff661936387e$export$2e2bcd8739ae039 = $6f3fff661936387e$var$node;









var $lU4RT = parcelRequire("lU4RT");


var $7DqNt = parcelRequire("7DqNt");























var $308Wd = parcelRequire("308Wd");


var $jle6C = parcelRequire("jle6C");

const $d49593a2f9070b10$var$i18n = (0, $kSwu1.defineMessages)({
    watchThisContent: {
        id: "watch-dialog.overflow-menu.watch-this-content",
        defaultMessage: "Watch this content"
    },
    watchChildItems: {
        id: "watch-dialog.overflow-menu.watch-child-items",
        defaultMessage: "Watch child items"
    },
    watchThisFolder: {
        id: "watch-dialog.overflow-menu.watch-this-folder",
        defaultMessage: "Watch all content in this folder"
    },
    watchNewBlogposts: {
        id: "watch-dialog.overflow-menu.watch-new-blog-posts",
        defaultMessage: "Watch new blog posts"
    },
    watchAllContent: {
        id: "watch-dialog.overflow-menu.watch-all-content",
        defaultMessage: "Watch all content in this space"
    },
    watchingContentTitle: {
        id: "watch-dialog.overflow-menu.watching-content-flag-title",
        defaultMessage: "You\u2019re watching this content"
    },
    watchingContentDescription: {
        id: "watch-dialog.overflow-menu.watching-content-flag-description",
        defaultMessage: "You\u2019ll receive email updates about changes to it."
    },
    watchingWhiteboardTitle: {
        id: "watch-dialog.overflow-menu.watching-whiteboard-flag-title",
        defaultMessage: "You\u2019re watching this whiteboard"
    },
    watchingWhiteboardDescription: {
        id: "watch-dialog.overflow-menu.watching-whiteboard-flag-description",
        defaultMessage: "You\u2019ll receive email updates about mentions and comment replies."
    },
    watchingDatabaseTitle: {
        id: "watch-dialog.overflow-menu.watching-database-flag-title",
        defaultMessage: "You\u2019re watching this database"
    },
    watchingDatabaseDescription: {
        id: "watch-dialog.overflow-menu.watching-database-flag-description",
        defaultMessage: "You\u2019ll receive email updates about mentions and comment replies."
    },
    stoppedWatchingContentTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-content-flag-title",
        defaultMessage: "You stopped watching this content"
    },
    stoppedWatchingContentDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-content-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about changes to it."
    },
    stoppedWatchingWhiteboardTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-whiteboard-flag-title",
        defaultMessage: "You stopped watching this whiteboard"
    },
    stoppedWatchingWhiteboardDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-whiteboard-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about mentions and comment replies."
    },
    stoppedWatchingDatabaseTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-database-flag-title",
        defaultMessage: "You stopped watching this database"
    },
    stoppedWatchingDatabaseDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-database-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about mentions and comment replies."
    },
    watchingSlideTitle: {
        id: "watch-dialog.overflow-menu.watching-slide-flag-title",
        defaultMessage: "You\u2019re watching this slide"
    },
    watchingSlideDescription: {
        id: "watch-dialog.overflow-menu.watching-slide-flag-description",
        defaultMessage: "You\u2019ll receive email updates about mentions and comment replies."
    },
    stoppedWatchingSlideTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-slide-flag-title",
        defaultMessage: "You stopped watching this slide"
    },
    stoppedWatchingSlideDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-slide-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about mentions and comment replies."
    },
    watchingNewBlogpostsTitle: {
        id: "watch-dialog.overflow-menu.watching-blogs-flag-title",
        defaultMessage: "You\u2019re watching for new blog posts"
    },
    watchingNewBlogpostsDescription: {
        id: "watch-dialog.overflow-menu.watching-blogs-flag-description",
        defaultMessage: "You\u2019ll receive email updates about new blog posts in this space."
    },
    stoppedWatchingBlogpostsTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-blogs-flag-title",
        defaultMessage: "You stopped watching for new blog posts"
    },
    stoppedWatchingBlogpostsDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-blogs-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about new blog posts in this space."
    },
    watchSpaceTitle: {
        id: "watch-dialog.overflow-menu.watching-space-flag-title",
        defaultMessage: "You\u2019re watching content in this space"
    },
    watchSpaceDescription: {
        id: "watch-dialog.overflow-menu.watching-space-flag-description",
        defaultMessage: "You\u2019ll receive email updates about changes to content in this space."
    },
    stoppedWatchingSpaceTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-space-flag-title",
        defaultMessage: "You stopped watching content in this space"
    },
    stoppedWatchingSpaceDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-space-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about changes to content in this space."
    },
    watchChildrenTitle: {
        id: "watch-dialog.overflow-menu.watching-children-flag-title",
        defaultMessage: "You\u2019re watching child items"
    },
    watchChildrenDescription: {
        id: "watch-dialog.overflow-menu.watching-children-flag-description",
        defaultMessage: "You\u2019ll receive email updates about changes to this content\u2019s child items."
    },
    stoppedWatchingChildrenTitle: {
        id: "watch-dialog.overflow-menu.stopped-watching-children-flag-title",
        defaultMessage: "You stopped watching child items"
    },
    stoppedWatchingChildrenDescription: {
        id: "watch-dialog.overflow-menu.stopped-watching-children-flag-description",
        defaultMessage: "You\u2019ll no longer receive email updates about changes to this content\u2019s child items."
    },
    ancestorWatchStatus: {
        id: "watch-dialog.overflow-menu.ancestor-watch-status",
        defaultMessage: "You watch all items under a parent of this content. Adjust its settings anytime."
    }
});
const $d49593a2f9070b10$var$styles = {
    ancestorWatchStatusContainer: "_2sNsIg7NXe _0Of8r22ADO _1wydGW2ADO _1Znuxb5zaO _2Zuz6Q5zaO _1EqgXls38O"
};
const $d49593a2f9070b10$var$AncestorWatchStatus = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d49593a2f9070b10$var$styles.ancestorWatchStatusContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d49593a2f9070b10$var$i18n.ancestorWatchStatus));
};
const $d49593a2f9070b10$export$aa1e7bb13f611ba0 = ({ isCurrentUserWatching: isCurrentUserWatching, isWatchingSpace: isWatchingSpace, isWatchingBlogs: isWatchingBlogs, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, contentType: contentType, contentId: contentId, spaceId: spaceId, updateQueryHandler: updateQueryHandler, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isCurrentUserWatchingContent, setIsCurrentUserWatchingContent] = (0, $cozmU.useState)(isCurrentUserWatching);
    const [isCurrentUserWatchingBlogs, setIsCurrentUserWatchingBlogs] = (0, $cozmU.useState)(isWatchingBlogs);
    const [isCurrentUserWatchingSpace, setIsCurrentUserWatchingSpace] = (0, $cozmU.useState)(isWatchingSpace);
    const [isCurrentUserWatchingChildren, setIsCurrentUserWatchingChildren] = (0, $cozmU.useState)(isWatchingChildren);
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isWatchChildrenRendered = contentType !== 'blogpost' && !isSpaceOverviewPage;
    const isFolder = contentType === (0, $1ggpj.ContentType).FOLDER;
    const watchContentTitleI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.watchingWhiteboardTitle,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.watchingDatabaseTitle,
        [(0, $1ggpj.ContentType).SLIDE]: $d49593a2f9070b10$var$i18n.watchingSlideTitle,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.watchingContentTitle,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.watchingContentTitle,
        [(0, $1ggpj.ContentType).FOLDER]: $d49593a2f9070b10$var$i18n.watchingContentTitle
    };
    const watchContentDescriptionI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.watchingWhiteboardDescription,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.watchingDatabaseDescription,
        [(0, $1ggpj.ContentType).SLIDE]: $d49593a2f9070b10$var$i18n.watchingSlideDescription,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.watchingContentDescription,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.watchingContentDescription,
        [(0, $1ggpj.ContentType).FOLDER]: $d49593a2f9070b10$var$i18n.watchingContentDescription
    };
    const stoppedWatchingContentTitleI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.stoppedWatchingWhiteboardTitle,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.stoppedWatchingDatabaseTitle,
        [(0, $1ggpj.ContentType).SLIDE]: $d49593a2f9070b10$var$i18n.stoppedWatchingSlideTitle,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentTitle,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentTitle,
        [(0, $1ggpj.ContentType).FOLDER]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentTitle
    };
    const stoppedWatchingContentDescriptionI18nMap = {
        [(0, $1ggpj.ContentType).WHITEBOARD]: $d49593a2f9070b10$var$i18n.stoppedWatchingWhiteboardDescription,
        [(0, $1ggpj.ContentType).DATABASE]: $d49593a2f9070b10$var$i18n.stoppedWatchingDatabaseDescription,
        [(0, $1ggpj.ContentType).SLIDE]: $d49593a2f9070b10$var$i18n.stoppedWatchingSlideDescription,
        [(0, $1ggpj.ContentType).PAGE]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentDescription,
        [(0, $1ggpj.ContentType).BLOGPOST]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentDescription,
        [(0, $1ggpj.ContentType).FOLDER]: $d49593a2f9070b10$var$i18n.stoppedWatchingContentDescription
    };
    const fireWatchAnalyticsEvent = (action, actionSubject, error)=>{
        const isActionSubjectSpace = actionSubject === (0, $jle6C.UpdateContentType).SPACE;
        const contentObjectMetadata = {
            objectId: isActionSubjectSpace ? spaceId : contentId,
            objectType: isActionSubjectSpace ? 'space' : contentType
        };
        const analyticsData = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: contentId,
            source: 'overflowMenu',
            attributes: {
                componentVersion: 'v2',
                ...error && {
                    errorMessage: error.message,
                    contentType: contentType
                }
            },
            ...contentObjectMetadata
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: analyticsData
        }).fire();
    };
    const fireCheckboxClickAnalyticsEvent = (0, $cozmU.useCallback)((actionSubjectId)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'checkbox',
                actionSubjectId: actionSubjectId,
                source: 'overflowMenu',
                attributes: {
                    contentType: contentType
                }
            }
        }).fire();
    }, [
        contentType,
        createAnalyticsEvent
    ]);
    const [watchContentMutation] = (0, $308Wd.useMutationInterop)((0, $6f3fff661936387e$export$2e2bcd8739ae039), {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CONTENT, data?.watchContent?.content?.currentUserIsWatching);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CONTENT);
            const titleI18n = watchContentTitleI18nMap[contentType];
            const descriptionI18n = watchContentDescriptionI18nMap[contentType];
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-content-success',
                title: formatMessage(titleI18n),
                description: formatMessage(descriptionI18n),
                isAutoDismiss: true
            });
        },
        onError: (error)=>{
            fireWatchAnalyticsEvent('failed', (0, $jle6C.UpdateContentType).CONTENT, error);
        },
        __callerPackage__: "watch-dialog"
    });
    const [unwatchContentMutation] = (0, $308Wd.useMutationInterop)((0, $2ae404a0a30ec50b$export$2e2bcd8739ae039), {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CONTENT, data?.unwatchContent?.content?.currentUserIsWatching);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).CONTENT);
            const titleI18n = stoppedWatchingContentTitleI18nMap[contentType];
            const descriptionI18n = stoppedWatchingContentDescriptionI18nMap[contentType];
            flags.showSuccessCircleFlag({
                id: `overflow-menu.watch-settings.stopped-watching-content-success`,
                title: formatMessage(titleI18n),
                description: formatMessage(descriptionI18n),
                isAutoDismiss: true
            });
        },
        onError: (error)=>{
            fireWatchAnalyticsEvent('failed', (0, $jle6C.UpdateContentType).CONTENT, error);
        },
        __callerPackage__: "watch-dialog"
    });
    const [watchBlogsMutation] = (0, $308Wd.useMutationInterop)((0, $7583e5b0ae12d9ec$export$2e2bcd8739ae039), {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).BLOGS_IN_SPACE, data?.watchBlogs?.space?.currentUser?.isWatchingBlogs);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-blogs-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.watchingNewBlogpostsTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.watchingNewBlogpostsDescription),
                isAutoDismiss: true
            });
        },
        onError: (error)=>{
            fireWatchAnalyticsEvent('failed', (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE, error);
        },
        __callerPackage__: "watch-dialog"
    });
    const [unwatchBlogsMutation] = (0, $308Wd.useMutationInterop)((0, $9fa208f239c55b38$export$2e2bcd8739ae039), {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).BLOGS_IN_SPACE, data?.unwatchBlogs?.space?.currentUser?.isWatchingBlogs);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.unwatch-blogs-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingBlogpostsTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingBlogpostsDescription),
                isAutoDismiss: true
            });
        },
        onError: (error)=>{
            fireWatchAnalyticsEvent('failed', (0, $jle6C.UpdateContentType).BLOGS_IN_SPACE, error);
        },
        __callerPackage__: "watch-dialog"
    });
    const [watchSpaceMutation] = (0, $308Wd.useMutationInterop)((0, $23f3269f5efb45f2$export$2e2bcd8739ae039), {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).SPACE, data?.watchSpace?.space?.currentUser?.isWatched);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-space-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.watchSpaceTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.watchSpaceDescription),
                isAutoDismiss: true
            });
        },
        onError: (error)=>{
            fireWatchAnalyticsEvent('failed', (0, $jle6C.UpdateContentType).SPACE, error);
        },
        __callerPackage__: "watch-dialog"
    });
    const [unwatchSpaceMutation] = (0, $308Wd.useMutationInterop)((0, $5aea7caf34cb0595$export$2e2bcd8739ae039), {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).SPACE, data?.unwatchSpace?.space?.currentUser?.isWatched);
        },
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).SPACE);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.unwatch-space-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingSpaceTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingSpaceDescription),
                isAutoDismiss: true
            });
        },
        onError: (error)=>{
            fireWatchAnalyticsEvent('failed', (0, $jle6C.UpdateContentType).SPACE, error);
        },
        __callerPackage__: "watch-dialog"
    });
    const [watchChildrenMutation] = (0, $308Wd.useMutationInterop)((0, $532f71827d8eb303$export$2e2bcd8739ae039), {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CHILDREN, data?.watchContent?.content.currentUserIsWatchingChildren);
        },
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
                attributes: {
                    startWatchingChildren: true,
                    contentType: contentType
                }
            });
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CHILDREN);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.watch-children-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.watchChildrenTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.watchChildrenDescription),
                isAutoDismiss: true
            });
        },
        onError: (mutationError)=>{
            handleWatchChildrenError(mutationError, true);
        },
        __callerPackage__: "watch-dialog"
    });
    const [unwatchChildrenMutation] = (0, $308Wd.useMutationInterop)((0, $d90ac48a7784de52$export$2e2bcd8739ae039), {
        update: (_, { data: data })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CHILDREN, data?.watchContent?.content.currentUserIsWatchingChildren);
        },
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
                attributes: {
                    startWatchingChildren: false,
                    contentType: contentType
                }
            });
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).UNWATCH, (0, $jle6C.UpdateContentType).CHILDREN);
            flags.showSuccessCircleFlag({
                id: 'overflow-menu.watch-settings.stopped-watching-children-success',
                title: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingChildrenTitle),
                description: formatMessage($d49593a2f9070b10$var$i18n.stoppedWatchingChildrenDescription),
                isAutoDismiss: true
            });
        },
        onError: (mutationError)=>{
            handleWatchChildrenError(mutationError, false);
        },
        __callerPackage__: "watch-dialog"
    });
    const handleWatchChildrenError = (mutationError, startWatchingChildren)=>{
        if ((0, $1uFM6.isUnauthorizedError)(mutationError)) experienceTracker.abort({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
            reason: mutationError.message,
            attributes: {
                startWatchingChildren: startWatchingChildren,
                contentType: contentType,
                isUnauthorized: true
            }
        });
        else experienceTracker.fail({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
            error: mutationError.message,
            attributes: {
                startWatchingChildren: startWatchingChildren,
                contentType: contentType
            }
        });
    };
    const onWatchContentChange = (0, $cozmU.useCallback)(async ()=>{
        fireCheckboxClickAnalyticsEvent('watchContentCheckbox');
        if (isCurrentUserWatchingContent || isFolder && isCurrentUserWatchingChildren) {
            await unwatchContentMutation({
                variables: {
                    id: contentId
                },
                optimisticResponse: {
                    unwatchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatching: false
                        }
                    }
                }
            });
            setIsCurrentUserWatchingContent(false);
            if (isFolder && isCurrentUserWatchingChildren) setIsCurrentUserWatchingChildren(false);
        } else {
            await watchContentMutation({
                variables: {
                    id: contentId,
                    ...isFolder && {
                        includeChildren: true
                    }
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            // @ts-expect-error - Relay artifacts do not contain __typename
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatching: true
                        }
                    }
                }
            });
            setIsCurrentUserWatchingContent(true);
        }
    }, [
        isCurrentUserWatchingContent,
        isCurrentUserWatchingChildren,
        contentId,
        isFolder,
        unwatchContentMutation,
        watchContentMutation,
        fireCheckboxClickAnalyticsEvent
    ]);
    const onWatchBlogpostsChange = (0, $cozmU.useCallback)(async ()=>{
        fireCheckboxClickAnalyticsEvent('watchBlogsCheckbox');
        if (isCurrentUserWatchingBlogs) {
            await unwatchBlogsMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    unwatchBlogs: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                // @ts-expect-error - Relay artifacts do not contain __typename
                                __typename: 'SpaceUserMetadata',
                                isWatchingBlogs: false
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingBlogs(false);
        } else {
            await watchBlogsMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchBlogs: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                // @ts-expect-error - Relay artifacts do not contain __typename
                                __typename: 'SpaceUserMetadata',
                                isWatchingBlogs: true
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingBlogs(true);
        }
    }, [
        isCurrentUserWatchingBlogs,
        spaceId,
        unwatchBlogsMutation,
        watchBlogsMutation,
        fireCheckboxClickAnalyticsEvent
    ]);
    const onWatchSpaceChange = (0, $cozmU.useCallback)(async ()=>{
        fireCheckboxClickAnalyticsEvent('watchSpaceCheckbox');
        if (isCurrentUserWatchingSpace) {
            await unwatchSpaceMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    unwatchSpace: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                // @ts-expect-error - Relay artifacts do not contain __typename
                                __typename: 'SpaceUserMetadata',
                                isWatched: false
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingSpace(false);
        } else {
            await watchSpaceMutation({
                variables: {
                    spaceId: spaceId
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchSpace: {
                        __typename: 'WatchSpacePayload',
                        space: {
                            __typename: 'Space',
                            id: spaceId,
                            currentUser: {
                                // @ts-expect-error - Relay artifacts do not contain __typename
                                __typename: 'SpaceUserMetadata',
                                isWatched: true
                            }
                        }
                    }
                }
            });
            setIsCurrentUserWatchingSpace(true);
        }
    }, [
        isCurrentUserWatchingSpace,
        spaceId,
        unwatchSpaceMutation,
        watchSpaceMutation,
        fireCheckboxClickAnalyticsEvent
    ]);
    const onWatchChildrenChange = (0, $cozmU.useCallback)(async ()=>{
        fireCheckboxClickAnalyticsEvent('watchChildrenCheckbox');
        experienceTracker.start({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_CHILDREN_EXPERIENCE),
            attributes: {
                startWatchingChildren: !isCurrentUserWatchingChildren,
                contentType: contentType
            }
        });
        if (isCurrentUserWatchingChildren) {
            await unwatchChildrenMutation({
                variables: {
                    id: contentId,
                    includeChildren: false
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            // @ts-expect-error - Relay artifacts do not contain __typename
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatchingChildren: false
                        }
                    }
                }
            });
            setIsCurrentUserWatchingChildren(false);
        } else {
            await watchChildrenMutation({
                variables: {
                    id: contentId,
                    includeChildren: true
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    watchContent: {
                        __typename: 'WatchContentPayload',
                        content: {
                            // @ts-expect-error - Relay artifacts do not contain __typename
                            __typename: 'Content',
                            id: contentId,
                            currentUserIsWatchingChildren: true
                        }
                    }
                }
            });
            setIsCurrentUserWatchingChildren(true);
        }
    }, [
        isCurrentUserWatchingChildren,
        contentId,
        unwatchChildrenMutation,
        watchChildrenMutation,
        contentType,
        experienceTracker,
        fireCheckboxClickAnalyticsEvent
    ]);
    const watchContentCheckbox = ()=>{
        const isImplicitlyWatching = isWatchingSpace || hasAncestorWatchingChildren || isWatchingChildren;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lU4RT.default), {
            id: "watch-this-content-option",
            testId: "watch-this-content-option",
            isSelected: isCurrentUserWatching || isImplicitlyWatching,
            isDisabled: isImplicitlyWatching,
            onClick: onWatchContentChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d49593a2f9070b10$var$i18n.watchThisContent));
    };
    const watchFolderCheckbox = ()=>{
        const isImplicitlyWatching = isWatchingSpace || hasAncestorWatchingChildren;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lU4RT.default), {
            id: "watch-this-folder-option",
            testId: "watch-this-folder-option",
            isSelected: isCurrentUserWatchingContent || isCurrentUserWatchingChildren || isImplicitlyWatching,
            isDisabled: isImplicitlyWatching,
            onClick: onWatchContentChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d49593a2f9070b10$var$i18n.watchThisFolder));
    };
    const watchBlogpostsCheckbox = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lU4RT.default), {
            id: "watch-blogs-option",
            testId: "watch-blogs-option",
            isSelected: isWatchingBlogs || isWatchingSpace,
            isDisabled: isWatchingSpace,
            onClick: onWatchBlogpostsChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d49593a2f9070b10$var$i18n.watchNewBlogposts));
    };
    const watchChildrenCheckbox = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lU4RT.default), {
            id: "watch-children-option",
            testId: "watch-children-option",
            isSelected: hasAncestorWatchingChildren || isWatchingSpace || isWatchingChildren,
            isDisabled: hasAncestorWatchingChildren || isWatchingSpace,
            onClick: onWatchChildrenChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d49593a2f9070b10$var$i18n.watchChildItems));
    };
    const watchSpaceCheckbox = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lU4RT.default), {
            id: "watch-all-content-option",
            testId: "watch-all-content-option",
            isSelected: isWatchingSpace,
            onClick: onWatchSpaceChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d49593a2f9070b10$var$i18n.watchAllContent));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7DqNt.default), {
        id: "overflow-menu-watch-settings"
    }, hasAncestorWatchingChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d49593a2f9070b10$var$AncestorWatchStatus, null), isFolder ? watchFolderCheckbox() : watchContentCheckbox(), isSpaceOverviewPage && watchBlogpostsCheckbox(), !isFolder && isWatchChildrenRendered && watchChildrenCheckbox(), watchSpaceCheckbox());
};






var $gqsYd = parcelRequire("gqsYd");


var $pskhd = parcelRequire("pskhd");


var $49Q03 = parcelRequire("49Q03");

const $8b864d3fa23503bf$var$i18n = (0, $kSwu1.defineMessages)({
    watchSettings: {
        id: "watch-dialog.overflow-menu.watch-settings",
        defaultMessage: "Watch settings"
    },
    manageWatchers: {
        id: "watch-dialog.overflow-menu.manage-watchers",
        defaultMessage: "Manage watchers"
    },
    watchingIconLabel: {
        id: "watch-dialog.overflow-menu.watching-icon-label",
        defaultMessage: "Watching content"
    },
    notWatchingIconLabel: {
        id: "watch-dialog.overflow-menu.not-watching-icon-label",
        defaultMessage: "Not watching content"
    }
});
var $8b864d3fa23503bf$export$f216106e034bc0b0 = /*#__PURE__*/ function(WatchSettingsRadioOption) {
    WatchSettingsRadioOption["Unwatch"] = "unwatch";
    WatchSettingsRadioOption["ThisItem"] = "this-item";
    WatchSettingsRadioOption["ThisAndNewItems"] = "this-and-new-items";
    WatchSettingsRadioOption["AllContent"] = "all-content";
    return WatchSettingsRadioOption;
}({});
const $8b864d3fa23503bf$export$465e1505ba3dc1c5 = ({ isMenuOpen: isMenuOpen, contentId: contentId, contentType: contentType, spaceId: spaceId = '', spaceKey: spaceKey, setIsMenuOpen: setIsMenuOpen, flags: flags, onMenuClose: onMenuClose, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const updateQueryHandler = (watchTarget, newDataValue)=>{
        const contentData = (0, $l1uFv.readQueryInterop)({
            query: (0, $49Q03.WatchDialogComponentWithWatchChildrenQuery),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "watch-dialog"
        });
        switch(watchTarget){
            case (0, $jle6C.UpdateContentType).CONTENT:
                if (contentData?.singleContent) contentData.singleContent.currentUserIsWatching = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).CHILDREN:
                if (contentData?.singleContent) contentData.singleContent.currentUserIsWatchingChildren = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).SPACE:
                if (contentData?.singleContent?.space) contentData.singleContent.space.currentUser.isWatched = newDataValue;
                break;
            default:
                if (contentData?.singleContent?.space) contentData.singleContent.space.currentUser.isWatchingBlogs = newDataValue;
                break;
        }
        if (contentData) (0, $fEmGS.writeQueryInterop)({
            query: (0, $49Q03.WatchDialogComponentWithWatchChildrenQuery),
            data: contentData,
            __callerPackage__: "watch-dialog"
        });
    };
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const isWatchEnabled = isLicensed || isGuest;
    const { data: watchDialogData, error: watchDialogError, loading: watchDialogDataLoading } = (0, $jMyy4.useQueryInterop)((0, $49Q03.WatchDialogComponentWithWatchChildrenQuery), {
        variables: {
            contentId: contentId
        },
        skip: !isWatchEnabled,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "watch-dialog"
    });
    const { isCurrentUserWatching: isCurrentUserWatching, isWatchingSpace: isWatchingSpace, isWatchingBlogs: isWatchingBlogs, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren } = (0, $pskhd.processWatchData)(watchDialogData);
    const isWatching = isWatchEnabled && (isCurrentUserWatching || isWatchingSpace);
    const { data: watchSettingsTrialDetailsData, error: watchSettingsTrialDetailsError } = (0, $jMyy4.useQueryInterop)((0, $f7631694bda7441a$export$2e2bcd8739ae039), {
        skip: !isWatchEnabled || edition === (0, $gqsYd.CONFLUENCE_EDITION).FREE,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "watch-dialog"
    });
    const handleWatchSettingsItemClick = (0, $cozmU.useCallback)(()=>{
        onClick();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'content-watch-button',
                attributes: {
                    isContentWrapper: true
                },
                source: 'overflowMenu'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const makeHandleManageWatchersClickHandler = (dialogs)=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'ManageWatcherDialogButton',
                    source: 'overflowMenu',
                    attributes: {
                        source: 'v2',
                        isContentWrapper: true,
                        contentType: contentType
                    }
                }
            }).fire();
            dialogs.showDialog((0, $f9HtC.ManageWatcherDialogLoader), {
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey,
                contentType: contentType,
                defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE
            });
            setIsMenuOpen(false);
        };
    };
    const isSpaceAdmin = watchDialogData?.singleContent?.space?.operations?.some((op)=>op?.operation === 'administer') ?? false;
    let inTrial = false;
    if (watchSettingsTrialDetailsError) inTrial = true;
    else {
        const trialEndDate = watchSettingsTrialDetailsData?.license?.trialEndDate;
        if (trialEndDate) {
            const trialDaysLeft = (0, $2Zz3q.getTrialDaysLeftFromTrialEndDate)(trialEndDate) ?? null;
            inTrial = trialDaysLeft !== null && trialDaysLeft > 0;
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "left-start",
        isOpen: isMenuOpen,
        onOpenChange: ({ isOpen: isOpen })=>{
            if (!isOpen) onMenuClose();
        },
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                ...triggerProps,
                ref: triggerRef,
                isDisabled: !isWatchEnabled || watchDialogDataLoading,
                elemBefore: isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($XgBmC))), {
                    label: formatMessage($8b864d3fa23503bf$var$i18n.watchingIconLabel)
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
                    label: formatMessage($8b864d3fa23503bf$var$i18n.notWatchingIconLabel)
                }),
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    size: "small"
                }),
                testId: "nested-watch-menu-trigger",
                onClick: handleWatchSettingsItemClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $8b864d3fa23503bf$var$i18n.watchSettings))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d49593a2f9070b10$export$aa1e7bb13f611ba0), {
        isCurrentUserWatching: isCurrentUserWatching,
        isWatchingSpace: isWatchingSpace,
        isWatchingBlogs: isWatchingBlogs,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren,
        contentId: contentId,
        contentType: contentType,
        spaceId: spaceId,
        updateQueryHandler: updateQueryHandler,
        flags: flags
    }), isSpaceAdmin && edition !== (0, $gqsYd.CONFLUENCE_EDITION).FREE && !inTrial && !watchDialogError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: makeHandleManageWatchersClickHandler(dialogs)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $8b864d3fa23503bf$var$i18n.manageWatchers)))));
};
const $8b864d3fa23503bf$export$f9409fd8f8b5a92d = (0, $7aRa9.withFlags)($8b864d3fa23503bf$export$465e1505ba3dc1c5);


/**
 * @generated SignedSource<<58d2cef38658ff3d348cc525169157d4>>
 * @relayHash b73eeb07332d614a1e170c288004fb18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f2683e6eae220f79d199a910afd2dcf7eb08534396a7873f206554f42cea781
const $1acaf91cfec33c88$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                            "kind": "LinkedField",
                            "name": "currentuser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "FavouritedSummary",
                                    "kind": "LinkedField",
                                    "name": "favourited",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "contentOperations",
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FavouriteMenuItemQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FavouriteMenuItemQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "b73eeb07332d614a1e170c288004fb18",
            "id": "1f2683e6eae220f79d199a910afd2dcf7eb08534396a7873f206554f42cea781",
            "metadata": {},
            "name": "FavouriteMenuItemQuery",
            "operationKind": "query",
            "text": "query FavouriteMenuItemQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
        }
    };
}();
$1acaf91cfec33c88$var$node.hash = "b2cb562e5c9d7e229a13677a47c445f2";
var $1acaf91cfec33c88$export$2e2bcd8739ae039 = $1acaf91cfec33c88$var$node;

































var $77a1U = parcelRequire("77a1U");

var $cf6nm = parcelRequire("cf6nm");

/**
 * @generated SignedSource<<8ce83faee7343fb31f29ec1a2962226d>>
 * @relayHash 87747e14238de77ee6b608c3fa7ceb25
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e83b49a9735e1da791b68dbd15f5e410431ed040eea10f46b8a29d51d7d64974
const $acbeb5139d925032$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                            "kind": "LinkedField",
                            "name": "currentuser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "FavouritedSummary",
                                    "kind": "LinkedField",
                                    "name": "favourited",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "contentOperations",
            "args": v1 /*: any*/ ,
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FavouriteContentShortcutListenerQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FavouriteContentShortcutListenerQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "87747e14238de77ee6b608c3fa7ceb25",
            "id": "e83b49a9735e1da791b68dbd15f5e410431ed040eea10f46b8a29d51d7d64974",
            "metadata": {},
            "name": "FavouriteContentShortcutListenerQuery",
            "operationKind": "query",
            "text": "query FavouriteContentShortcutListenerQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
        }
    };
}();
$acbeb5139d925032$var$node.hash = "6ff7d72d61283f21b554c99c3279a8f9";
var $acbeb5139d925032$export$2e2bcd8739ae039 = $acbeb5139d925032$var$node;




















const $85cfaddd6945fc1f$var$getStarShortcut = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft') return {
            deprecatedAccelerator: undefined,
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT)
        };
        else if (contentMode === 'view') return {
            deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT)
        };
        else return {
            deprecatedAccelerator: undefined,
            accelerator: undefined
        };
    } else // for all other content types, use both keyboard shortcuts
    return {
        deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT)
    };
};
const $85cfaddd6945fc1f$export$380f18fd66f69c3e = (contentType, contentMode)=>{
    if (contentType === 'page' || contentType === 'blogpost') {
        if (contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft' || contentMode === 'view') return 0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT;
        else return null;
    } else return 0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT;
};
const $85cfaddd6945fc1f$export$2846eba8e457bfb = ({ contentId: contentId, contentTitle: contentTitle, contentMode: contentMode, contentType: contentType, source: source = 'FavouriteMoreActionsMenuItem' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator } = $85cfaddd6945fc1f$var$getStarShortcut(contentType, contentMode);
    const FavouriteContentShortcutListenerQuery = (0, $acbeb5139d925032$export$2e2bcd8739ae039);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)(FavouriteContentShortcutListenerQuery, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "favourite-button"
    });
    if (loading || error || !accelerator) return null;
    const isStarred = Boolean(data?.singleContent?.metadata.currentuser?.favourited?.isFavourite);
    const handleShortcut = (toggleStar)=>(e)=>{
            toggleStar(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: true,
                        action: isStarred ? 'unstar' : 'star',
                        isInEditor: contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft'
                    },
                    source: source
                }
            }).fire();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $77a1U.PageStar), {
        contentId: contentId,
        isStarred: isStarred,
        contentTitle: contentTitle,
        shouldShowFlags: true
    }, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: deprecatedAccelerator,
            accelerator: accelerator,
            listener: handleShortcut(toggleStar)
        }));
};


// This component is a dropdown menu item version of the favorite page star button. It is completely standalone and queries for it's own isFavourited data.
// It does not include any shortcut listener and should be used in conjunction with FavouriteContentShortcutListener.tsx if you need to add a listener.
// It is currently used in the page header more actions menu item
const $daed94f8e5673bda$var$FavouriteMenuItemQuery = (0, $1acaf91cfec33c88$export$2e2bcd8739ae039);
const $daed94f8e5673bda$export$ab53347da13f94fa = ({ contentId: contentId, contentTitle: contentTitle, contentMode: contentMode })=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($daed94f8e5673bda$var$FavouriteMenuItemQuery, {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "favourite-button"
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    const isStarred = Boolean(data?.singleContent?.metadata.currentuser?.favourited?.isFavourite);
    const contentType = data?.singleContent?.type;
    const shortcut = (0, $85cfaddd6945fc1f$export$380f18fd66f69c3e)(contentType || '', contentMode);
    const handleClick = (toggleStar)=>(e)=>{
            toggleStar(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: false,
                        action: isStarred ? 'unstar' : 'star',
                        isInEditor: contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft',
                        isContentWrapper: true
                    },
                    source: 'FavouriteMoreActionsMenuItem'
                }
            }).fire();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $77a1U.PageStar), {
        contentId: contentId,
        isStarred: isStarred,
        contentTitle: contentTitle,
        analytics: {
            source: 'FavouriteMoreActionsMenuItem',
            attributes: {
                componentVersion: 'more-actions-menu-item',
                pageType: contentType
            }
        },
        shouldShowFlags: true
    }, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: handleClick(toggleStar),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf6nm.StarIcon), {
                isStarred: isStarred,
                spacing: "none"
            }),
            elemAfter: shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: shortcut
            }),
            isDisabled: !isLoggedIn
        }, isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $daed94f8e5673bda$var$i18n.unstar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $daed94f8e5673bda$var$i18n.star))));
};
const $daed94f8e5673bda$var$i18n = (0, $kSwu1.defineMessages)({
    star: {
        id: "favourite-button.content.star.label",
        defaultMessage: "Star"
    },
    unstar: {
        id: "favourite-button.content.unstar.label",
        defaultMessage: "Unstar"
    }
});















var $iRqYE = parcelRequire("iRqYE");


var $g95v4 = parcelRequire("g95v4");

const $1a937280d497d3e4$export$cbbdc590602afd67 = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const openAgentsAwarenessModal = (0, $g95v4.useOpenAgentsAwarenessModal)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRqYE))), {
            label: ""
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== openAgentsAwarenessModal) {
        t1 = ()=>openAgentsAwarenessModal({
                initialStep: "mcp-setup"
            });
        $[1] = openAgentsAwarenessModal;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "agents-awareness-modal.edit-with-mcp-item.label",
            defaultMessage: "Edit with MCP"
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            testId: "edit-with-mcp-menu-item",
            elemBefore: t0,
            onClick: t1
        }, t2);
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};




var $kPqqM = parcelRequire("kPqqM");
/**
 * @generated SignedSource<<4191c83d97bcf3c010f4c44e5f1df57e>>
 * @relayHash c27dc099805c7eec7a9354a821bd73cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 717eb51b235f5f25635e4ecef7a7a139da3e0a671a31ec57022615806587618b
const $92084701ec630418$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarShortcutListenerIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarShortcutListenerIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c27dc099805c7eec7a9354a821bd73cc",
            "id": "717eb51b235f5f25635e4ecef7a7a139da3e0a671a31ec57022615806587618b",
            "metadata": {},
            "name": "SpaceStarShortcutListenerIsSpaceFavouritedQuery",
            "operationKind": "query",
            "text": "query SpaceStarShortcutListenerIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id,alias,name,key,currentUser{isFavourited}}}"
        }
    };
}();
$92084701ec630418$var$node.hash = "ee6489b807b5c87efd54daae89947f35";
var $92084701ec630418$export$2e2bcd8739ae039 = $92084701ec630418$var$node;















var $f9jv7 = parcelRequire("f9jv7");





var $iCPvv = parcelRequire("iCPvv");




const $e6d97f54b872b96e$var$handleError = (error, createAnalyticsEvent)=>{
    // Temporarily log errors to debug why some are not being marked as handled
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: 'spaceStarShortcutListener',
            source: 'spaceStarShortcutListener',
            attributes: {
                error: JSON.stringify(error),
                isNotFoundError: (0, $f9jv7.isNotFoundError)(error)
            }
        }
    }).fire();
    if ((0, $f9jv7.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
};
const $e6d97f54b872b96e$export$385015a3c6790101 = ({ spaceKey: spaceKey, contentMode: contentMode, source: source = 'FavouriteMoreActionsMenuItem' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: spaceFavouriteStatusData, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $92084701ec630418$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first',
        onError: (error)=>{
            $e6d97f54b872b96e$var$handleError(error, createAnalyticsEvent);
        },
        __callerPackage__: "action-buttons"
    });
    if (loading) return null;
    if (error) {
        $e6d97f54b872b96e$var$handleError(error, createAnalyticsEvent);
        return null;
    }
    const isStarred = spaceFavouriteStatusData?.space?.currentUser?.isFavourited || false;
    const spaceName = spaceFavouriteStatusData?.space?.name || spaceFavouriteStatusData?.space?.alias || spaceFavouriteStatusData?.space?.key || '';
    const spaceId = spaceFavouriteStatusData?.space?.id || '';
    const handleShortcut = (toggleStar)=>(e)=>{
            toggleStar(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'spaceStar',
                    attributes: {
                        triggeredByKeyboardShortcut: true,
                        action: isStarred ? 'unstar' : 'star',
                        isInEditor: contentMode === 'edit'
                    },
                    source: source
                }
            }).fire();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iCPvv.SpaceStar), {
        spaceId: spaceId,
        spaceKey: spaceKey,
        isStarred: isStarred,
        spaceName: spaceName,
        shouldShowFlags: true
    }, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
            listener: handleShortcut(toggleStar)
        }));
};



var $lOeVN = parcelRequire("lOeVN");


var $efvKr = parcelRequire("efvKr");


var $b66o6 = parcelRequire("b66o6");


var $cMvQV = parcelRequire("cMvQV");


var $kM55L = parcelRequire("kM55L");


var $1PC5x = parcelRequire("1PC5x");


var $4vC63 = parcelRequire("4vC63");


var $1TN2N = parcelRequire("1TN2N");


var $1jQpq = parcelRequire("1jQpq");


var $aboIx = parcelRequire("aboIx");


var $jmjWc = parcelRequire("jmjWc");


const $7d3d1e674e88462f$export$c72baf511f2daf8c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Fvd_8",
    name: "LazySmartFolderQuickActionMenuItem",
    loader: async ()=>(await (parcelRequire("hw9ld"))).SmartFolderQuickActionMenuItem
});
$7d3d1e674e88462f$export$c72baf511f2daf8c.displayName = 'lazy(SmartFolderQuickActionMenuItem)';



var $hT3jf = parcelRequire("hT3jf");


var $5wA2k = parcelRequire("5wA2k");


var $lYrp8 = parcelRequire("lYrp8");







/**
 * @generated SignedSource<<a574f92b6a7e6af3ddc43bbb948b7a69>>
 * @relayHash 6a7bfd2b75f9ec03bd1c277b318a767e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 69ac39449190166507f8a0938e118e11a9f304113486744f909250fbd073af3c
const $c77b035615108b26$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "dynamic",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "representation"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useIsPageOrBlogAutoConvertedQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useIsPageOrBlogAutoConvertedQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "6a7bfd2b75f9ec03bd1c277b318a767e",
            "id": "69ac39449190166507f8a0938e118e11a9f304113486744f909250fbd073af3c",
            "metadata": {},
            "name": "useIsPageOrBlogAutoConvertedQuery",
            "operationKind": "query",
            "text": "query useIsPageOrBlogAutoConvertedQuery($contentId:ID,$versionOverride:Int,$status:[String]){content(id:$contentId,version:$versionOverride,status:$status){nodes{id,type,properties(key:\"editor\"){nodes{id,key,value}},operations{operation,targetType},body{dynamic{representation}},metadata{frontend{fabricEditorSupported}}}}}"
        }
    };
}();
$c77b035615108b26$var$node.hash = "69e9e3c602c3d39a798248db917c8256";
var $c77b035615108b26$export$2e2bcd8739ae039 = $c77b035615108b26$var$node;












var $6fil2 = parcelRequire("6fil2");


var $5ZqQS = parcelRequire("5ZqQS");





var $ayQVU = parcelRequire("ayQVU");







const $0633edcc0f21cf62$export$38d9182f14dddb00 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId, contentType: contentType } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6mKj3.expValEquals)("confluence_auto_convert_legacy_draft_fix_fe", "isEnabled", true) ? [
            "draft",
            "current"
        ] : null;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId) {
        t2 = {
            contentId: contentId,
            status: t1
        };
        $[1] = contentId;
        $[2] = t2;
    } else t2 = $[2];
    const t3 = !(contentType === "page" || contentType === "blogpost");
    let t4;
    if ($[3] !== t2 || $[4] !== t3) {
        t4 = {
            variables: t2,
            skip: t3,
            fetchPolicy: (0, $9wGTI.fg)("confluence_frontend_fix_revert_btn_tiny") ? "cache-and-network" : "cache-first"
        };
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const { data: contentPropertiesData, error: error } = (0, $jMyy4.useQueryInterop)((0, $c77b035615108b26$export$2e2bcd8739ae039), {
        ...t4,
        __callerPackage__: "content-types-header"
    });
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
        return false;
    }
    if (contentPropertiesData) {
        const t5 = contentPropertiesData?.content?.nodes?.[0];
        let t6;
        if ($[6] !== t5) {
            t6 = (0, $ayQVU.getAutoConvertionInfo)(t5);
            $[6] = t5;
            $[7] = t6;
        } else t6 = $[7];
        const { isAutoConverted: isAutoConverted } = t6;
        const isNewPage = contentPropertiesData?.content?.nodes?.length === 0;
        return !!isAutoConverted && !isNewPage;
    }
    return false;
};









var $kyKWe = parcelRequire("kyKWe");








var $7rovI = parcelRequire("7rovI");


var $gXrHX = parcelRequire("gXrHX");





var $BCkug = parcelRequire("BCkug");








var $bqMNb = parcelRequire("bqMNb");




const $690df6788a087387$export$d91fa1ff1d654586 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { item: item, contentMode: contentMode, spaceId: spaceId, flags: flags, spaceKey: spaceKey, contentId: contentId, closeParentMenu: closeParentMenu } = t0;
    const { retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, saveDraft: saveDraft } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isAccessLinkRequest = (0, $dnfJM.useIsAccessLinkRequest)();
    const { shareToken: shareToken } = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
    const { exitEditMode: exitEditMode } = (0, $7rovI.useAccessLinkEditMode)();
    let t1;
    if ($[0] !== contentId || $[1] !== exitEditMode || $[2] !== isAccessLinkRequest || $[3] !== push || $[4] !== shareToken || $[5] !== spaceKey) {
        t1 = (forceTransition)=>{
            if (isAccessLinkRequest && shareToken) {
                exitEditMode();
                push((0, $1NBp8.ACCESS_LINK).toUrl({
                    shareToken: shareToken
                }, {
                    query: {
                        [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    }
                }));
                return;
            }
            push((0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            }, forceTransition ? {
                query: {
                    [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                }
            } : undefined));
        };
        $[0] = contentId;
        $[1] = exitEditMode;
        $[2] = isAccessLinkRequest;
        $[3] = push;
        $[4] = shareToken;
        $[5] = spaceKey;
        $[6] = t1;
    } else t1 = $[6];
    const navigateAfterConversion = t1;
    let t2;
    if ($[7] !== contentId || $[8] !== contentMode || $[9] !== flags || $[10] !== navigateAfterConversion || $[11] !== retrieveEditorTitleAndContent || $[12] !== saveDraft || $[13] !== spaceId) {
        t2 = contentMode === "view" ? {
            contentId: contentId,
            spaceId: spaceId,
            isUnpublishedDraft: false,
            flags: flags,
            analyticsSource: "viewPageScreen",
            adfOrigin: "RENDERER",
            onSuccessfulConversion: ()=>navigateAfterConversion(true),
            retrieveEditorTitleAndContent: undefined
        } : {
            contentId: contentId,
            spaceId: spaceId,
            isUnpublishedDraft: contentMode === "draft",
            flags: flags,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            saveDraft: saveDraft,
            analyticsSource: "ellipsisDropdownComponent",
            adfOrigin: "EDITOR",
            onSuccessfulConversion: ()=>navigateAfterConversion(false)
        };
        $[7] = contentId;
        $[8] = contentMode;
        $[9] = flags;
        $[10] = navigateAfterConversion;
        $[11] = retrieveEditorTitleAndContent;
        $[12] = saveDraft;
        $[13] = spaceId;
        $[14] = t2;
    } else t2 = $[14];
    const useSwitchToLivePagesProps = t2;
    const switchToLivePage = (0, $BCkug.useSwitchToLivePage)(useSwitchToLivePagesProps);
    let t3;
    if ($[15] !== closeParentMenu || $[16] !== switchToLivePage) {
        t3 = ()=>{
            closeParentMenu();
            switchToLivePage();
        };
        $[15] = closeParentMenu;
        $[16] = switchToLivePage;
        $[17] = t3;
    } else t3 = $[17];
    let t4;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))), {
            label: ""
        });
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== item.id || $[20] !== item.label || $[21] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: item.id,
            onClick: t3,
            elemBefore: t4
        }, item.label);
        $[19] = item.id;
        $[20] = item.label;
        $[21] = t3;
        $[22] = t5;
    } else t5 = $[22];
    return t5;
};





















var $jLnA6 = parcelRequire("jLnA6");













// this is to keep consistent with ContentTools PopupMenuGroup
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcd7f3eccb1861ca$var$StyledDropdownItemGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $9erVg.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4ouGXIPIoL _1EqgXlOAqP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $bcd7f3eccb1861ca$var$DropdownItemLabelContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $bcd7f3eccb1861ca$var$badgeContainerStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.075'
});
const $bcd7f3eccb1861ca$export$7a3b78bc1d3676d9 = (styleClass)=>{
    return !styleClass?.includes('aui-button') ? styleClass : '';
};
const $bcd7f3eccb1861ca$export$49b1344a56b06112 = (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { label: label, items: items, isNestedMenuOpen: isNestedMenuOpen, onClick: onClick, iconBefore: iconBefore, forgeMenuItems: forgeMenuItems, onMenuClose: onMenuClose, id: id } = t0;
    if (!items.length && !forgeMenuItems?.length) return null;
    let t1;
    if ($[0] !== onMenuClose) {
        t1 = (t2)=>{
            const { isOpen: isOpen } = t2;
            if (!isOpen) onMenuClose();
        };
        $[0] = onMenuClose;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== iconBefore || $[3] !== id || $[4] !== label || $[5] !== onClick) {
        t2 = (t3)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                ...triggerProps,
                ref: triggerRef,
                onClick: onClick,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    size: "small"
                }),
                elemBefore: iconBefore,
                testId: `${id}-button`
            }, label);
        };
        $[2] = iconBefore;
        $[3] = id;
        $[4] = label;
        $[5] = onClick;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== items) {
        t3 = items.map($bcd7f3eccb1861ca$var$_temp);
        $[7] = items;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== forgeMenuItems) {
        t4 = forgeMenuItems && forgeMenuItems.length > 0 && forgeMenuItems.map($bcd7f3eccb1861ca$var$_temp2);
        $[9] = forgeMenuItems;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bcd7f3eccb1861ca$var$StyledDropdownItemGroup, null, t3, t4);
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== isNestedMenuOpen || $[15] !== t1 || $[16] !== t2 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "left-start",
            isOpen: isNestedMenuOpen,
            onOpenChange: t1,
            trigger: t2
        }, t5);
        $[14] = isNestedMenuOpen;
        $[15] = t1;
        $[16] = t2;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
};
function $bcd7f3eccb1861ca$var$_temp(item) {
    if (item.customComponent) return item.customComponent();
    const { id: id_0, url: url, label: itemLabel, badgeLabel: badgeLabel, tooltip: tooltip, onClick: onItemClick, closeParentMenu: closeParentMenu } = item;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: $bcd7f3eccb1861ca$export$7a3b78bc1d3676d9(item?.styleClass),
        key: id_0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        href: url,
        onClick: ()=>{
            onItemClick?.();
            closeParentMenu?.();
        },
        UNSAFE_shouldDisableRouterLink: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bcd7f3eccb1861ca$var$DropdownItemLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, itemLabel || tooltip), badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $bcd7f3eccb1861ca$var$badgeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), null, badgeLabel)))));
}
function $bcd7f3eccb1861ca$var$_temp2(forgeMenuItem) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
        key: forgeMenuItem?.props?.extension?.id,
        module: forgeMenuItem?.props?.extension
    }, forgeMenuItem);
}


















var $hMcNB = parcelRequire("hMcNB");





var $jxqsh = parcelRequire("jxqsh");


var $g9ioO = parcelRequire("g9ioO");





var $jmUhx = parcelRequire("jmUhx");


var $31le2 = parcelRequire("31le2");





var $fHs3z = parcelRequire("fHs3z");





var $c0A7H = parcelRequire("c0A7H");





var $7A1BE = parcelRequire("7A1BE");


var $d4GYd = parcelRequire("d4GYd");


var $iDfTs = parcelRequire("iDfTs");





var $hFGQl = parcelRequire("hFGQl");


var $hL4RO = parcelRequire("hL4RO");


var $jBnsv = parcelRequire("jBnsv");








var $1AbrA = parcelRequire("1AbrA");


var $jcM8h = parcelRequire("jcM8h");


var $l3C2L = parcelRequire("l3C2L");





var $d8J72 = parcelRequire("d8J72");

var $3eMfQ = parcelRequire("3eMfQ");


var $k9WFY = parcelRequire("k9WFY");


var $iVd6X = parcelRequire("iVd6X");







/**
 * Action id constants for the content header's more actions menu.
 */ const $9af26f5142ee161a$export$bcce08436c9de127 = 'action-move-page-dialog-link';
const $9af26f5142ee161a$export$c7733ea6d8e45875 = 'action-move-blogpost-dialog-link';
const $9af26f5142ee161a$export$da4fec526a505196 = 'action-remove-content-link';
const $9af26f5142ee161a$export$94db61d2b880af44 = 'action-copy-page-link';
const $9af26f5142ee161a$export$d81a93c80838b765 = 'action-archive-link';
const $9af26f5142ee161a$export$21b8b89e4603550f = 'action-restore-link';
const $9af26f5142ee161a$export$84c7eab054d974db = 'action-give-feedback-link';
const $9af26f5142ee161a$export$a751f1adb88d1383 = 'view-resolved-comments';
const $9af26f5142ee161a$export$e14cf657321c833b = 'action-view-version-history-link';
const $9af26f5142ee161a$export$fc2e34cd983af5d6 = 'action-view-history-link';
const $9af26f5142ee161a$export$bbe81b5a8b0eaf4 = 'action-export-pdf-link';
const $9af26f5142ee161a$export$5da5719a925f973 = 'action-export-word-link';
const $9af26f5142ee161a$export$1f0e30e52c48f232 = 'action-export-markdown-link';
const $9af26f5142ee161a$export$b1a4c392275ea35a = 'action-templates-and-import';
const $9af26f5142ee161a$export$2728c726be07790 = 'action-templates';
const $9af26f5142ee161a$export$f1ffcc01948271f7 = 'action-import';
const $9af26f5142ee161a$export$5497d83bbd1b1232 = 'action-convert-page-to-blog';
const $9af26f5142ee161a$export$7767afe5b675f4b1 = 'action-convert-page-to-folder';
const $9af26f5142ee161a$export$8ba85686c8897eca = 'action-convert-live-doc-to-page';
const $9af26f5142ee161a$export$a4eecad100747ab0 = 'action-convert-page-to-markdown';
const $9af26f5142ee161a$export$e1530e5397882a1f = 'action-convert-page-to-rich-text';
const $9af26f5142ee161a$export$6aee40c7c2e30c2b = 'action-convert-to-content';
const $9af26f5142ee161a$export$ae5f0093bbf45ce8 = 'action-edit-with-mcp';
const $9af26f5142ee161a$export$f9e89fba7e6b4574 = 'preferences';
const $9af26f5142ee161a$export$d588519b9727f1cc = 'export-file';
const $9af26f5142ee161a$export$f0ae5a9b5b44d373 = 'open-find-replace';
const $9af26f5142ee161a$export$cce5e117e5e43bc = 'whiteboard-import';
const $9af26f5142ee161a$export$240b6ef4a1c531f6 = 'presentation-mode';
const $9af26f5142ee161a$export$10f4bed2ae52719b = 'action-switch-to-live-edit';
const $9af26f5142ee161a$export$c9981a2480d638b0 = 'action-revert-to-previous';
const $9af26f5142ee161a$export$fe2b6e9bf8b31ecc = 'action-revert-editor';
const $9af26f5142ee161a$export$12b5e6890d8e049c = 'fullscreen';
const $9af26f5142ee161a$export$5f2e846fff4ab830 = 'whiteboard-documentation';
const $9af26f5142ee161a$export$d4cf3906d3082596 = 'whiteboard-templates';
const $9af26f5142ee161a$export$348fd9bd77c132d9 = 'action-favourite-content';
const $9af26f5142ee161a$export$35f02acdf766e275 = 'action-favourite-space';
const $9af26f5142ee161a$export$e242b9905c10e726 = 'action-watch-content';
const $9af26f5142ee161a$export$8d78c75e31d09d0d = 'action-smart-folder-sync';
const $9af26f5142ee161a$export$6bb183703c5072f1 = 'ask-to-edit-content';
const $9af26f5142ee161a$export$74317f458aa33c63 = 'action-preview-content';
const $9af26f5142ee161a$export$461acb5c5f9c7b12 = 'action-manage-content';
const $9af26f5142ee161a$export$fe0a3b90b0b6010b = 'action-automations';
const $9af26f5142ee161a$export$52e1dc7e5d9b8b02 = 'action-advanced';
const $9af26f5142ee161a$export$da9876ab77cf10e8 = 'action-view-storage-link';
const $9af26f5142ee161a$export$ecf44b2b0a73d53f = 'action-view-source-link';
const $9af26f5142ee161a$export$2594f905f6c1490e = 'databases-copy-structure';
const $9af26f5142ee161a$export$6563b47d35bee4f1 = 'databases-undo';
const $9af26f5142ee161a$export$fe723f15ba37849b = 'databases-redo';
const $9af26f5142ee161a$export$be7385413e15c3ea = 'databases-templates';
const $9af26f5142ee161a$export$e07ca208ff99048e = 'databases-export';
const $9af26f5142ee161a$export$d7bae9f2073f40be = 'databases-lock-structure';
const $9af26f5142ee161a$export$95f3debc4a615fda = 'databases-get-help';
const $9af26f5142ee161a$export$54ed9c94f2cfe2b6 = 'databases-devtools';
const $9af26f5142ee161a$export$23eaedbb3a44a3b5 = 'action-edit-embed-link';
const $9af26f5142ee161a$export$a6381225def83c4b = 'action-page-permissions-link';
const $9af26f5142ee161a$export$ab4fe2a2881747b5 = 'action-export-content';
const $9af26f5142ee161a$export$c1ca183de464b52d = 'slides-export-to-pdf';
const $9af26f5142ee161a$export$3192aea0628d957a = 'action-convert-content';
const $9af26f5142ee161a$export$654801d4f89a934 = 'action-company-hub-feedback';
const $9af26f5142ee161a$export$43db96fb923dc5c7 = 'action-editor-undo';
const $9af26f5142ee161a$export$4e316098da1efb3e = 'action-editor-redo';
const $9af26f5142ee161a$export$8f2c4b97a6e00f7f = 'action-editor-find-replace';
const $9af26f5142ee161a$export$22a5e799bdd9dd62 = 'action-report-abuse';





















/**
 * Trigger a client-side browser download of a markdown string as a `.md` file.
 * Tries `msSaveOrOpenBlob` → `showSaveFilePicker` → anchor-click. No-ops on SSR.
 */ const $487aedb288980f4f$export$ec71ef93809fd1b1 = (markdown, filename)=>{
    if (typeof document === 'undefined' || typeof URL === 'undefined' || typeof Blob === 'undefined') return;
    const safeFilename = $487aedb288980f4f$export$fa302515f2a866ab(filename);
    const nav = typeof navigator !== 'undefined' ? navigator : undefined;
    if (nav && typeof nav.msSaveOrOpenBlob === 'function') {
        const blob = new Blob([
            markdown
        ], {
            type: 'text/markdown;charset=utf-8'
        });
        nav.msSaveOrOpenBlob(blob, safeFilename);
        return;
    }
    const showSaveFilePicker = typeof window !== 'undefined' ? window.showSaveFilePicker : undefined;
    if (typeof showSaveFilePicker === 'function') {
        (async ()=>{
            try {
                const handle = await showSaveFilePicker({
                    suggestedName: safeFilename,
                    types: [
                        {
                            description: 'Markdown file',
                            accept: {
                                'text/markdown': [
                                    '.md'
                                ]
                            }
                        }
                    ]
                });
                const writable = await handle.createWritable();
                await writable.write(markdown);
                await writable.close();
            } catch (err) {
                // Only fall through to the anchor strategy for real errors;
                // a user-initiated cancel must be a no-op.
                if (!(err instanceof DOMException && err.name === 'AbortError')) $487aedb288980f4f$var$fallbackAnchorDownload(markdown, safeFilename);
            }
        })();
        return;
    }
    $487aedb288980f4f$var$fallbackAnchorDownload(markdown, safeFilename);
};
const $487aedb288980f4f$var$fallbackAnchorDownload = (markdown, safeFilename)=>{
    // `File` carries a `name` field used as the saved filename when the
    // `download` attribute is suppressed. `application/octet-stream` forces
    // the browser to save instead of navigate.
    const file = new File([
        markdown
    ], safeFilename, {
        type: 'application/octet-stream'
    });
    const url = URL.createObjectURL(file);
    // `#<filename>` hash so the URL path itself reads as the intended name
    // when both `download` and `File.name` are ignored.
    const urlWithHint = `${url}#${encodeURIComponent(safeFilename)}`;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const anchor = document.createElement('a');
    anchor.href = urlWithHint;
    anchor.download = safeFilename;
    anchor.target = '_self';
    anchor.rel = '';
    anchor.style.display = 'none';
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.body.appendChild(anchor);
    const clickEvent = new MouseEvent('click', {
        view: typeof window !== 'undefined' ? window : undefined,
        bubbles: true,
        cancelable: true
    });
    anchor.dispatchEvent(clickEvent);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.body.removeChild(anchor);
    setTimeout(()=>URL.revokeObjectURL(url), 0);
};
const $487aedb288980f4f$export$fa302515f2a866ab = (rawTitle)=>{
    const trimmed = (rawTitle || '').trim();
    const fallback = trimmed.length > 0 ? trimmed : 'page';
    const cleaned = fallback// eslint-disable-next-line no-control-regex
    .replace(/[\\/:*?"<>|\u0000-\u001F]/g, '-').replace(/\s+/g, ' ').replace(/-+/g, '-').slice(0, 120)// Re-trim after slice so a truncation cut mid-run doesn't leave a
    // trailing dot/dash/space.
    .replace(/^[.\-\s]+|[.\-\s]+$/g, '');
    const safe = cleaned.length > 0 ? cleaned : 'page';
    return `${safe}.md`;
};


const $ca10db43f6aa5685$var$i18n = (0, $kSwu1.defineMessages)({
    exportMarkdownLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.export.markdown",
        defaultMessage: "Export to Markdown"
    },
    exportMarkdownNewLozenge: {
        id: "content-types-header.ellipsis.open.ellipsis.export.markdown.new-lozenge",
        defaultMessage: "New"
    }
});
// The Confluence v2 REST API serves pages and blogposts from separate
// collections. A blogpost id does not exist under `/pages/{id}` (it 404s), so we
// must pick the collection that matches the content type. Classic pages and live
// docs are both `contentType === 'page'` and use the `pages` collection.
const $ca10db43f6aa5685$var$getMarkdownExportEndpoint = (contentId, contentType)=>{
    const collection = contentType === 'blogpost' ? 'blogposts' : 'pages';
    return `/wiki/api/v2/${collection}/${encodeURIComponent(contentId)}?body-format=markdown`;
};
const $ca10db43f6aa5685$export$75d683b3beaada74 = ({ contentId: contentId, contentType: contentType, contentMode: contentMode, pageTitle: pageTitle, onClickAnalytics: onClickAnalytics, closeParentMenu: closeParentMenu })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isExporting, setIsExporting] = (0, $cozmU.useState)(false);
    const isLiveDoc = contentType === 'page' && contentMode === 'live';
    const fireClickedAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'exportMenuItem',
                actionSubjectId: 'exportMarkdown',
                source: 'overflowMenu',
                attributes: {
                    exportType: 'markdown',
                    contentId: contentId,
                    contentType: contentType,
                    isLiveDoc: isLiveDoc
                }
            }
        }).fire();
    }, [
        contentType,
        createAnalyticsEvent,
        contentId,
        isLiveDoc
    ]);
    const fireResultAnalytics = (0, $cozmU.useCallback)((result, extra)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: result,
                actionSubject: 'exportMenuItem',
                actionSubjectId: 'exportMarkdown',
                source: 'overflowMenu',
                attributes: {
                    exportType: 'markdown',
                    contentId: contentId,
                    contentType: contentType,
                    isLiveDoc: isLiveDoc,
                    ...extra
                }
            }
        }).fire();
    }, [
        contentType,
        createAnalyticsEvent,
        contentId,
        isLiveDoc
    ]);
    const handleClick = (0, $cozmU.useCallback)(async ()=>{
        if (isExporting) return;
        onClickAnalytics?.();
        fireClickedAnalytics();
        setIsExporting(true);
        try {
            // oxlint-disable-next-line eslint-core/no-restricted-syntax
            const response = await fetch($ca10db43f6aa5685$var$getMarkdownExportEndpoint(contentId, contentType), {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    Accept: 'application/json'
                }
            });
            if (!response.ok) {
                fireResultAnalytics('failed', {
                    reason: response.status === 400 ? 'markdown-not-supported' : `http-${response.status}`
                });
                return;
            }
            const data = await response.json();
            const markdown = data?.body?.markdown?.value;
            const resolvedTitle = data?.title || pageTitle || 'page';
            if (typeof markdown !== 'string' || markdown.length === 0) {
                fireResultAnalytics('failed', {
                    reason: 'missing-markdown'
                });
                return;
            }
            const escapedTitle = resolvedTitle.replace(/([\\`*_{}[\]()#+\-.!|>])/g, '\\$1');
            const prelude = `# ${escapedTitle}\n\n`;
            (0, $487aedb288980f4f$export$ec71ef93809fd1b1)(`${prelude}${markdown}`, resolvedTitle);
            fireResultAnalytics('succeeded');
        } catch (error) {
            fireResultAnalytics('failed', {
                reason: 'network-error',
                message: error instanceof Error ? error.message : String(error)
            });
        } finally{
            setIsExporting(false);
            closeParentMenu?.();
        }
    }, [
        fireClickedAnalytics,
        fireResultAnalytics,
        isExporting,
        contentId,
        contentType,
        onClickAnalytics,
        pageTitle,
        closeParentMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: handleClick,
        isDisabled: isExporting,
        testId: "export-markdown-menu-item",
        "aria-label": intl.formatMessage($ca10db43f6aa5685$var$i18n.exportMarkdownLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ca10db43f6aa5685$var$i18n.exportMarkdownLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ca10db43f6aa5685$var$i18n.exportMarkdownNewLozenge))));
};









var $kymtV = parcelRequire("kymtV");

const $f648d1777beb603c$export$febcd4c90af43de9 = ({ contentId: contentId, contentType: contentType, url: url, label: label, onClickAnalytics: onClickAnalytics, closeParentMenu: closeParentMenu })=>{
    // `isCreating` drives the item's disabled state (needs a re-render); `isCreatingRef` is the
    // in-flight guard read inside the click handler, so the handler doesn't depend on the state and
    // isn't recreated on every toggle.
    const [isCreating, setIsCreating] = (0, $cozmU.useState)(false);
    const isCreatingRef = (0, $cozmU.useRef)(false);
    // Shared create → route → open-modal flow (with a real "Try again"), also used by the Cmd/Ctrl+P
    // print shortcut. It owns the create analytics (`started` + `pagePdfExportCreate`), so this menu
    // item only drives the click and disabled state.
    const { startExport: startExport } = (0, $kymtV.useStartPagePdfExport)();
    const handleClick = (0, $cozmU.useCallback)(async (event)=>{
        onClickAnalytics?.();
        event.preventDefault();
        if (isCreatingRef.current) return;
        isCreatingRef.current = true;
        setIsCreating(true);
        try {
            // The shared flow navigates (legacy) or opens the Export modal (V3 / error) with retry,
            // and fires the create analytics itself.
            await startExport({
                contentId: contentId,
                contentType: contentType,
                url: url,
                source: 'menu'
            });
            closeParentMenu?.();
        } finally{
            // Always reset so an unexpected throw can't leave the item permanently disabled.
            isCreatingRef.current = false;
            setIsCreating(false);
        }
    }, [
        onClickAnalytics,
        startExport,
        contentId,
        contentType,
        url,
        closeParentMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        href: url,
        UNSAFE_shouldDisableRouterLink: true,
        isDisabled: isCreating,
        testId: "export-pdf-menu-item",
        onClick: (event_0)=>{
            handleClick(event_0);
        }
    }, label);
};



const $434c765ed6791bfa$export$68013e639efb767f = 'action-apps';
const $434c765ed6791bfa$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    export: {
        id: "content-types-header.ellipsis.open.ellipsis.export",
        defaultMessage: "Export"
    },
    convert: {
        id: "content-types-header.ellipsis.open.ellipsis.convert",
        defaultMessage: "Convert"
    },
    duplicate: {
        id: "content-types-header.ellipsis.open.ellipsis.duplicate",
        defaultMessage: "Duplicate"
    },
    makeACopy: {
        id: "content-types-header.ellipsis.open.ellipsis.makeACopy",
        defaultMessage: "Make a copy"
    },
    duplicateDatabase: {
        id: "content-types-header.ellipsis.open.ellipsis.duplicate.database",
        defaultMessage: "Duplicate database"
    },
    makeACopyOfDatabase: {
        id: "content-types-header.ellipsis.open.ellipsis.makeACopy.database",
        defaultMessage: "Make a copy of database"
    },
    archive: {
        id: "content-types-header.ellipsis.open.ellipsis.archive",
        defaultMessage: "Archive"
    },
    deleteDraftLabel: {
        id: "content-types-header.content-types.more-actions.delete-draft",
        defaultMessage: "Delete draft"
    },
    deleteLabel: {
        id: "content-types-header.content-types.more-actions.delete",
        defaultMessage: "Delete"
    },
    archiveAndDeleteLabel: {
        id: "content-types-header.content-types.more-actions.archive-and-delete",
        defaultMessage: "Archive and delete"
    },
    viewChangesTitle: {
        id: "content-types-header.content-types.view.changes.title",
        defaultMessage: "Latest changes"
    },
    viewChangesLabel: {
        id: "content-types-header.content-types.view.changes.label",
        defaultMessage: "View changes"
    },
    automationsModalTitle: {
        id: "content-types-header.automations.title",
        defaultMessage: "Page automations"
    },
    automationsLabel: {
        id: "content-types-header.automations.label",
        defaultMessage: "Automations"
    },
    advancedLabel: {
        id: "content-types-header.advanced.label",
        defaultMessage: "Advanced details"
    },
    pageAppsLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.page.apps",
        defaultMessage: "Apps"
    }
});
var $434c765ed6791bfa$export$8bf1ff90935c8832 = /*#__PURE__*/ function(NestedMenuTypes) {
    NestedMenuTypes["Export"] = "export";
    NestedMenuTypes["Convert"] = "convert";
    NestedMenuTypes["ConvertTo"] = "convert-to";
    NestedMenuTypes["Archive"] = "archive";
    NestedMenuTypes["Advanced"] = "advanced";
    NestedMenuTypes["Attachments"] = "attachments";
    NestedMenuTypes["Apps"] = "apps";
    NestedMenuTypes["ContentOwnership"] = "content-ownership";
    NestedMenuTypes["MoreSupport"] = "more-support";
    NestedMenuTypes["CopyDatabase"] = "copy-database";
    NestedMenuTypes["Help"] = "help";
    NestedMenuTypes["Watch"] = "watch";
    NestedMenuTypes["TemplatesAndImport"] = "templates-and-import";
    return NestedMenuTypes;
}({});
const $434c765ed6791bfa$var$ConvertMenuItemComponent = ({ webItemsMap: webItemsMap, isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, spaceKey: spaceKey, contentId: contentId, dialogs: dialogs, handleNestedMenuItemClose: handleNestedMenuItemClose, contentMode: contentMode, flags: flags, spaceId: spaceId, closeParentMenu: closeParentMenu, isConvertToFolderHighlighted: isConvertToFolderHighlighted })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const convertItems = [
        (0, $9af26f5142ee161a$export$10f4bed2ae52719b),
        (0, $9af26f5142ee161a$export$7767afe5b675f4b1),
        (0, $9af26f5142ee161a$export$5497d83bbd1b1232)
    ].map((id)=>{
        const item = webItemsMap[id];
        if (id === (0, $9af26f5142ee161a$export$7767afe5b675f4b1) && item) {
            item.url = '';
            item.urlWithoutContextPath = '';
            return {
                ...item,
                customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d8J72.ConvertToFolderItem), {
                        key: item.completeKey,
                        sectionItem: item,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        dialogs: dialogs,
                        shouldHighlight: isConvertToFolderHighlighted,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7A1BE))), {
                            label: ""
                        }),
                        onClick: closeParentMenu
                    })
            };
        } else if (id === (0, $9af26f5142ee161a$export$5497d83bbd1b1232) && item) {
            item.url = '';
            item.urlWithoutContextPath = '';
            const makePublishPageAsBlogDialogOpener = ()=>{
                closeParentMenu();
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'publishPageAsBlog',
                        source: 'contentTypesHeader'
                    }
                }).fire();
                dialogs.showDialog((0, $k9WFY.PublishPageAsBlogDialog), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    source: (0, $iVd6X.PublishPageAsBlogSources).ViewPage
                });
            };
            return {
                ...item,
                customComponent: ()=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eMfQ.LazyContentToolsItem), {
                        key: item.completeKey,
                        ...item,
                        onClick: makePublishPageAsBlogDialogOpener,
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
                            label: ""
                        })
                    });
                }
            };
        } else if (id === (0, $9af26f5142ee161a$export$10f4bed2ae52719b) && item) return {
            ...item,
            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $690df6788a087387$export$d91fa1ff1d654586), {
                    item: item,
                    contentMode: contentMode,
                    spaceId: spaceId,
                    flags: flags,
                    spaceKey: spaceKey,
                    contentId: contentId,
                    closeParentMenu: closeParentMenu
                })
        };
        else return null;
    }).filter((item_0)=>item_0 && item_0.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $434c765ed6791bfa$export$a7357cdd1f0b0168.convert),
        items: convertItems,
        isNestedMenuOpen: isNestedMenuOpen,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
            label: ""
        }),
        key: (0, $9af26f5142ee161a$export$3192aea0628d957a),
        onMenuClose: handleNestedMenuItemClose
    });
};
const $434c765ed6791bfa$export$1a264aaf74bdd787 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { webItemsMap: webItemsMap, nestedPopup: nestedPopup, handleNestedMenuItemClick: handleNestedMenuItemClick, spaceKey: spaceKey, contentId: contentId, handleNestedMenuItemClose: handleNestedMenuItemClose, flags: flags, spaceId: spaceId, contentMode: contentMode, closeParentMenu: closeParentMenu, isConvertToFolderHighlighted: isConvertToFolderHighlighted } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleNestedMenuItemClick) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowExportAndConvert",
                    source: "overflowMenu"
                }
            }).fire();
            handleNestedMenuItemClick("convert");
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleNestedMenuItemClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleConvertMenuItemClick = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== closeParentMenu || $[5] !== contentId || $[6] !== contentMode || $[7] !== flags || $[8] !== handleConvertMenuItemClick || $[9] !== handleNestedMenuItemClose || $[10] !== isConvertToFolderHighlighted || $[11] !== nestedPopup || $[12] !== spaceId || $[13] !== spaceKey || $[14] !== webItemsMap) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t2
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($434c765ed6791bfa$var$ConvertMenuItemComponent, {
                webItemsMap: webItemsMap,
                dialogs: dialogs,
                isNestedMenuOpen: nestedPopup === "convert",
                handleClick: handleConvertMenuItemClick,
                contentId: contentId,
                spaceKey: spaceKey,
                flags: flags,
                spaceId: spaceId,
                handleNestedMenuItemClose: handleNestedMenuItemClose,
                contentMode: contentMode,
                closeParentMenu: closeParentMenu,
                isConvertToFolderHighlighted: isConvertToFolderHighlighted
            }));
        $[4] = closeParentMenu;
        $[5] = contentId;
        $[6] = contentMode;
        $[7] = flags;
        $[8] = handleConvertMenuItemClick;
        $[9] = handleNestedMenuItemClose;
        $[10] = isConvertToFolderHighlighted;
        $[11] = nestedPopup;
        $[12] = spaceId;
        $[13] = spaceKey;
        $[14] = webItemsMap;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
};
const $434c765ed6791bfa$export$7592eae6681a8aa2 = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { items: items, nestedPopup: nestedPopup, handleNestedMenuItemClick: handleNestedMenuItemClick, handleNestedMenuItemClose: handleNestedMenuItemClose } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleNestedMenuItemClick) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowConvertTo",
                    source: "overflowMenu"
                }
            }).fire();
            handleNestedMenuItemClick("convert-to");
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleNestedMenuItemClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleConvertToMenuItemClick = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $434c765ed6791bfa$export$a7357cdd1f0b0168.convert);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
            label: ""
        });
        $[4] = t3;
    } else t3 = $[4];
    const t4 = nestedPopup === "convert-to";
    let t5;
    if ($[5] !== handleConvertToMenuItemClick || $[6] !== handleNestedMenuItemClose || $[7] !== items || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t2,
            items: items,
            iconBefore: t3,
            isNestedMenuOpen: t4,
            onClick: handleConvertToMenuItemClick,
            key: (0, $9af26f5142ee161a$export$6aee40c7c2e30c2b),
            onMenuClose: handleNestedMenuItemClose
        });
        $[5] = handleConvertToMenuItemClick;
        $[6] = handleNestedMenuItemClose;
        $[7] = items;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $434c765ed6791bfa$export$35c6726f59e309e4 = [
    'page',
    'blogpost'
];
const $434c765ed6791bfa$export$e7957cf61244c20e = (contentType)=>!!contentType && $434c765ed6791bfa$export$35c6726f59e309e4.includes(contentType);
const $434c765ed6791bfa$export$fb577cf43b1d490f = (webItemsMap)=>Boolean(webItemsMap[0, $9af26f5142ee161a$export$5da5719a925f973]?.id || webItemsMap[0, $9af26f5142ee161a$export$bbe81b5a8b0eaf4]?.id);
const $434c765ed6791bfa$var$exportTypeByActionId = {
    [(0, $9af26f5142ee161a$export$5da5719a925f973)]: 'word',
    [(0, $9af26f5142ee161a$export$bbe81b5a8b0eaf4)]: 'pdf',
    [(0, $9af26f5142ee161a$export$1f0e30e52c48f232)]: 'markdown'
};
const $434c765ed6791bfa$export$b945ccaa4d42d330 = (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { webItemsMap: webItemsMap, handleNestedMenuItemClick: handleNestedMenuItemClick, nestedPopup: nestedPopup, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu, contentId: contentId, contentType: contentType, contentMode: contentMode, pageTitle: pageTitle, contentStatus: contentStatus } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== webItemsMap) {
        t1 = $434c765ed6791bfa$export$fb577cf43b1d490f(webItemsMap);
        $[0] = webItemsMap;
        $[1] = t1;
    } else t1 = $[1];
    const canExportStandardFormat = t1;
    let t2;
    if ($[2] !== createAnalyticsEvent) {
        t2 = (exportType)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowExport",
                    source: "overflowMenu",
                    ...exportType ? {
                        attributes: {
                            exportType: exportType
                        }
                    } : {}
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    const fireOverflowExportClickedAnalytics = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $9af26f5142ee161a$export$5da5719a925f973),
            (0, $9af26f5142ee161a$export$bbe81b5a8b0eaf4)
        ];
        $[4] = t3;
    } else t3 = $[4];
    let exportItems;
    if ($[5] !== canExportStandardFormat || $[6] !== closeParentMenu || $[7] !== contentId || $[8] !== contentMode || $[9] !== contentStatus || $[10] !== contentType || $[11] !== fireOverflowExportClickedAnalytics || $[12] !== pageTitle || $[13] !== webItemsMap) {
        exportItems = t3.map((id)=>{
            const item = webItemsMap[id];
            const onClickAnalytics = ()=>fireOverflowExportClickedAnalytics($434c765ed6791bfa$var$exportTypeByActionId[id]);
            if (id === (0, $9af26f5142ee161a$export$bbe81b5a8b0eaf4) && item?.id && !!contentId) return {
                ...item,
                closeParentMenu: closeParentMenu,
                customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f648d1777beb603c$export$febcd4c90af43de9), {
                        key: (0, $9af26f5142ee161a$export$bbe81b5a8b0eaf4),
                        contentId: contentId,
                        contentType: contentType,
                        url: item.url,
                        label: item.label,
                        onClickAnalytics: onClickAnalytics,
                        closeParentMenu: closeParentMenu
                    })
            };
            return {
                ...item,
                onClick: onClickAnalytics,
                closeParentMenu: closeParentMenu
            };
        }).filter($434c765ed6791bfa$var$_temp);
        if (canExportStandardFormat && !!contentId && $434c765ed6791bfa$export$e7957cf61244c20e(contentType) && (0, $6mKj3.expValEquals)("confluence_export_markdown", "isEnabled", true)) {
            let t4;
            if ($[15] !== closeParentMenu || $[16] !== contentId || $[17] !== contentMode || $[18] !== contentStatus || $[19] !== contentType || $[20] !== fireOverflowExportClickedAnalytics || $[21] !== pageTitle) {
                t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ca10db43f6aa5685$export$75d683b3beaada74), {
                        key: (0, $9af26f5142ee161a$export$1f0e30e52c48f232),
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode,
                        pageTitle: pageTitle ?? "",
                        contentStatus: contentStatus,
                        onClickAnalytics: ()=>fireOverflowExportClickedAnalytics($434c765ed6791bfa$var$exportTypeByActionId[0, $9af26f5142ee161a$export$1f0e30e52c48f232]),
                        closeParentMenu: closeParentMenu
                    });
                $[15] = closeParentMenu;
                $[16] = contentId;
                $[17] = contentMode;
                $[18] = contentStatus;
                $[19] = contentType;
                $[20] = fireOverflowExportClickedAnalytics;
                $[21] = pageTitle;
                $[22] = t4;
            } else t4 = $[22];
            let t5;
            if ($[23] !== closeParentMenu || $[24] !== t4) {
                t5 = {
                    id: (0, $9af26f5142ee161a$export$1f0e30e52c48f232),
                    label: "",
                    url: "",
                    closeParentMenu: closeParentMenu,
                    customComponent: t4
                };
                $[23] = closeParentMenu;
                $[24] = t4;
                $[25] = t5;
            } else t5 = $[25];
            exportItems.push(t5);
        }
        $[5] = canExportStandardFormat;
        $[6] = closeParentMenu;
        $[7] = contentId;
        $[8] = contentMode;
        $[9] = contentStatus;
        $[10] = contentType;
        $[11] = fireOverflowExportClickedAnalytics;
        $[12] = pageTitle;
        $[13] = webItemsMap;
        $[14] = exportItems;
    } else exportItems = $[14];
    let t4;
    if ($[26] !== fireOverflowExportClickedAnalytics || $[27] !== handleNestedMenuItemClick) {
        t4 = ()=>{
            fireOverflowExportClickedAnalytics();
            handleNestedMenuItemClick("export");
        };
        $[26] = fireOverflowExportClickedAnalytics;
        $[27] = handleNestedMenuItemClick;
        $[28] = t4;
    } else t4 = $[28];
    const handleExportMenuItemClick = t4;
    let t5;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $434c765ed6791bfa$export$a7357cdd1f0b0168.export);
        $[29] = t5;
    } else t5 = $[29];
    let t6;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))), {
            label: ""
        });
        $[30] = t6;
    } else t6 = $[30];
    const t7 = nestedPopup === "export";
    let t8;
    if ($[31] !== exportItems || $[32] !== handleExportMenuItemClick || $[33] !== handleNestedMenuItemClose || $[34] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t5,
            items: exportItems,
            iconBefore: t6,
            isNestedMenuOpen: t7,
            onClick: handleExportMenuItemClick,
            key: (0, $9af26f5142ee161a$export$ab4fe2a2881747b5),
            onMenuClose: handleNestedMenuItemClose
        });
        $[31] = exportItems;
        $[32] = handleExportMenuItemClick;
        $[33] = handleNestedMenuItemClose;
        $[34] = t7;
        $[35] = t8;
    } else t8 = $[35];
    return t8;
};
const $434c765ed6791bfa$export$5ac124715785374c = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onDeleteClick: onDeleteClick, contentMode: contentMode, createAnalyticsEvent: createAnalyticsEvent } = t0;
    const label = contentMode === "draft" ? $434c765ed6791bfa$export$a7357cdd1f0b0168.deleteDraftLabel : $434c765ed6791bfa$export$a7357cdd1f0b0168.deleteLabel;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== createAnalyticsEvent || $[2] !== label || $[3] !== onDeleteClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t1,
            key: `container-${(0, $9af26f5142ee161a$export$da4fec526a505196)}`
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "overflowDelete",
                            source: "overflowMenu"
                        }
                    }).fire();
                    onDeleteClick(dialogs);
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)));
        $[1] = createAnalyticsEvent;
        $[2] = label;
        $[3] = onDeleteClick;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $434c765ed6791bfa$export$f4be76d677f42fda = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onArchiveClick: onArchiveClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onArchiveClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t1,
            key: `container-${(0, $9af26f5142ee161a$export$d81a93c80838b765)}`
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                onClick: ()=>{
                    onArchiveClick(dialogs);
                },
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($31le2))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $434c765ed6791bfa$export$a7357cdd1f0b0168.archive)));
        $[1] = onArchiveClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
const $434c765ed6791bfa$export$a05f0dd30396f811 = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { webItems: webItems, isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, onArchiveClick: onArchiveClick, onDeleteClick: onDeleteClick, contentMode: contentMode, createAnalyticsEvent: createAnalyticsEvent, handleNestedMenuItemClose: handleNestedMenuItemClose } = t0;
    let t1;
    if ($[0] !== contentMode || $[1] !== createAnalyticsEvent || $[2] !== onArchiveClick || $[3] !== onDeleteClick || $[4] !== webItems) {
        let t2;
        if ($[6] !== contentMode || $[7] !== createAnalyticsEvent || $[8] !== onArchiveClick || $[9] !== onDeleteClick) {
            t2 = (item_0)=>{
                if (item_0.id === (0, $9af26f5142ee161a$export$d81a93c80838b765)) return {
                    ...item_0,
                    customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($434c765ed6791bfa$export$f4be76d677f42fda, {
                            onArchiveClick: onArchiveClick
                        })
                };
                else {
                    if (item_0.id === (0, $9af26f5142ee161a$export$da4fec526a505196)) return {
                        ...item_0,
                        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($434c765ed6791bfa$export$5ac124715785374c, {
                                onDeleteClick: onDeleteClick,
                                contentMode: contentMode,
                                createAnalyticsEvent: createAnalyticsEvent
                            })
                    };
                }
                return item_0;
            };
            $[6] = contentMode;
            $[7] = createAnalyticsEvent;
            $[8] = onArchiveClick;
            $[9] = onDeleteClick;
            $[10] = t2;
        } else t2 = $[10];
        t1 = webItems.filter($434c765ed6791bfa$var$_temp2).map(t2);
        $[0] = contentMode;
        $[1] = createAnalyticsEvent;
        $[2] = onArchiveClick;
        $[3] = onDeleteClick;
        $[4] = webItems;
        $[5] = t1;
    } else t1 = $[5];
    const archiveItems = t1;
    let t2;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $434c765ed6791bfa$export$a7357cdd1f0b0168.archiveAndDeleteLabel);
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            label: ""
        });
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== archiveItems || $[14] !== handleClick || $[15] !== handleNestedMenuItemClose || $[16] !== isNestedMenuOpen) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t2,
            items: archiveItems,
            isNestedMenuOpen: isNestedMenuOpen,
            onClick: handleClick,
            iconBefore: t3,
            onMenuClose: handleNestedMenuItemClose
        });
        $[13] = archiveItems;
        $[14] = handleClick;
        $[15] = handleNestedMenuItemClose;
        $[16] = isNestedMenuOpen;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
};
const $434c765ed6791bfa$export$d206439c03b979ee = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { shortcutKeys: shortcutKeys, id: id } = t0;
    let t1;
    if ($[0] !== id || $[1] !== shortcutKeys) {
        let t2;
        if ($[3] !== id) {
            t2 = (key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                    key: `${id}-shortcut-${key}`,
                    shortcut: key
                });
            $[3] = id;
            $[4] = t2;
        } else t2 = $[4];
        t1 = shortcutKeys.map(t2);
        $[0] = id;
        $[1] = shortcutKeys;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $434c765ed6791bfa$export$b605bf507f6a39c = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { item: item, icon: icon, testId: testId } = t0;
    const { id: id, url: url, target: target, onClick: onClick, shortcutText: shortcutText, text: text, showToggle: showToggle, isDisabled: isDisabled } = item;
    let t1;
    if ($[0] !== id || $[1] !== shortcutText || $[2] !== showToggle) {
        t1 = ()=>{
            if (shortcutText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($434c765ed6791bfa$export$d206439c03b979ee, {
                shortcutKeys: shortcutText.split("+"),
                id: id
            });
            else {
                if (showToggle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
                    isChecked: showToggle.isChecked,
                    isDisabled: showToggle.isDisabled
                });
            }
            return null;
        };
        $[0] = id;
        $[1] = shortcutText;
        $[2] = showToggle;
        $[3] = t1;
    } else t1 = $[3];
    const ElementAfter = t1;
    const t2 = icon ?? null;
    let t3;
    if ($[4] !== ElementAfter) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ElementAfter, null);
        $[4] = ElementAfter;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== id || $[7] !== isDisabled || $[8] !== onClick || $[9] !== t2 || $[10] !== t3 || $[11] !== target || $[12] !== testId || $[13] !== text || $[14] !== url) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: t2,
            key: id,
            testId: testId,
            href: url,
            target: target,
            onClick: onClick,
            isDisabled: isDisabled,
            elemAfter: t3
        }, text);
        $[6] = id;
        $[7] = isDisabled;
        $[8] = onClick;
        $[9] = t2;
        $[10] = t3;
        $[11] = target;
        $[12] = testId;
        $[13] = text;
        $[14] = url;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
};
const $434c765ed6791bfa$export$36ee254e582a74c2 = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { setIsCopyContentModalOpen: setIsCopyContentModalOpen, closeParentMenu: closeParentMenu, item: item, showIcon: t1 } = t0;
    const showIcon = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== closeParentMenu || $[1] !== setIsCopyContentModalOpen) {
        t2 = ()=>{
            closeParentMenu();
            setIsCopyContentModalOpen(true);
        };
        $[0] = closeParentMenu;
        $[1] = setIsCopyContentModalOpen;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== showIcon) {
        t3 = showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
            label: ""
        }) : null;
        $[3] = showIcon;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== item.label || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: (0, $9af26f5142ee161a$export$94db61d2b880af44),
            testId: "copy-content-button",
            onClick: t2,
            elemBefore: t3
        }, item.label);
        $[5] = item.label;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
const $434c765ed6791bfa$export$3131530af790ffe2 = ({ isNestedMenuOpen: isNestedMenuOpen, handleClick: handleClick, copyDatabaseItem: copyDatabaseItem, copyStructureItem: copyStructureItem, setIsCopyContentModalOpen: setIsCopyContentModalOpen, contentMode: contentMode, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const copyDatabaseLabel = formatMessage((0, $6mKj3.expValEquals)('make_a_copy_cta', 'cohort', 'test') ? $434c765ed6791bfa$export$a7357cdd1f0b0168.makeACopyOfDatabase : $434c765ed6791bfa$export$a7357cdd1f0b0168.duplicateDatabase);
    const copyOnClick = copyStructureItem.onClick;
    copyStructureItem.onClick = ()=>{
        closeParentMenu();
        copyOnClick?.();
    };
    if (contentMode === 'archived') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($434c765ed6791bfa$export$b605bf507f6a39c, {
        item: copyStructureItem,
        key: copyStructureItem.id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
            label: ""
        })
    });
    const copyStructureItemWithComponent = {
        ...copyStructureItem,
        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($434c765ed6791bfa$export$b605bf507f6a39c, {
                item: copyStructureItem,
                key: copyStructureItem.id
            })
    };
    const copyItems = [
        {
            ...copyDatabaseItem,
            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($434c765ed6791bfa$export$36ee254e582a74c2, {
                    setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                    closeParentMenu: closeParentMenu,
                    item: {
                        ...copyDatabaseItem,
                        label: copyDatabaseLabel
                    },
                    showIcon: false
                })
        },
        copyStructureItemWithComponent
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6mKj3.expValEquals)('make_a_copy_cta', 'cohort', 'test') ? $434c765ed6791bfa$export$a7357cdd1f0b0168.makeACopy : $434c765ed6791bfa$export$a7357cdd1f0b0168.duplicate),
        items: copyItems,
        isNestedMenuOpen: isNestedMenuOpen,
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
            label: ""
        }),
        onMenuClose: handleNestedMenuItemClose
    });
};
const $434c765ed6791bfa$export$f28b24dc0422311f = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, dialogs: dialogs, saveDraft: saveDraft, createAnalyticsEvent: createAnalyticsEvent } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== dialogs || $[3] !== intl || $[4] !== saveDraft) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowViewChanges",
                    source: "overflowMenu"
                }
            }).fire();
            saveDraft?.();
            dialogs.showModal((0, $l3C2L.ViewChangesDialogLoader), {
                contentId: contentId,
                title: intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.viewChangesTitle)
            });
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = dialogs;
        $[3] = intl;
        $[4] = saveDraft;
        $[5] = t1;
    } else t1 = $[5];
    const onClick = t1;
    let t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))), {
            label: ""
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $434c765ed6791bfa$export$a7357cdd1f0b0168.viewChangesLabel);
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    let t4;
    if ($[8] !== onClick) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: "view-changes",
            onClick: onClick,
            elemBefore: t2
        }, t3);
        $[8] = onClick;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
};
const $434c765ed6791bfa$export$2ca3e90bac67fd87 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { item: item, nestedPopup: nestedPopup, setNestedPopup: setNestedPopup, contentId: contentId, setIsMenuOpen: setIsMenuOpen } = t0;
    let t1;
    if ($[0] !== setIsMenuOpen) {
        t1 = ()=>{
            setIsMenuOpen(false);
        };
        $[0] = setIsMenuOpen;
        $[1] = t1;
    } else t1 = $[1];
    const handleMenuClose = t1;
    let t2;
    if ($[2] !== nestedPopup || $[3] !== setNestedPopup) {
        t2 = ()=>{
            if (nestedPopup === "content-ownership") setNestedPopup(undefined);
            else setNestedPopup("content-ownership");
        };
        $[2] = nestedPopup;
        $[3] = setNestedPopup;
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClick = t2;
    let t3;
    if ($[5] !== setNestedPopup) {
        t3 = ()=>{
            setNestedPopup(undefined);
        };
        $[5] = setNestedPopup;
        $[6] = t3;
    } else t3 = $[6];
    const handlePopupClose = t3;
    const t4 = nestedPopup === "content-ownership";
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
            label: ""
        });
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== contentId || $[9] !== handleMenuClose || $[10] !== handleOnClick || $[11] !== handlePopupClose || $[12] !== item.id || $[13] !== item.label || $[14] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jcM8h.ContentOwnerPopupComponent), {
            contentId: contentId,
            itemId: item.id,
            itemLabel: item.label,
            isOpen: t4,
            onClick: handleOnClick,
            onCloseParent: handleMenuClose,
            onClosePopup: handlePopupClose,
            elemBefore: t5
        });
        $[8] = contentId;
        $[9] = handleMenuClose;
        $[10] = handleOnClick;
        $[11] = handlePopupClose;
        $[12] = item.id;
        $[13] = item.label;
        $[14] = t4;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
const $434c765ed6791bfa$export$f26eff3587fe7632 = ({ isAppsRendered: isAppsRendered, spaceKey: spaceKey, contentId: contentId, isMenuOpen: isMenuOpen, nestedPopup: nestedPopup, items: items, handleNestedMenuItemClick: handleNestedMenuItemClick, createAnalyticsEvent: createAnalyticsEvent, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu })=>{
    const pageAppItems = items.filter((item)=>item?.completeKey?.includes((0, $jBnsv.CONNECT_APP_PREFIX_KEY)) && item?.id !== (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) && // MYCL-34: id check before fg() so the gate is only exposed on a match.
        !((0, $hL4RO.isDeprecatedConnectWebItem)(item?.id) && (0, $9wGTI.fg)('twcg-2215-confluence-slack-deprecate-page-notifs'))).map((item)=>{
        item.closeParentMenu = closeParentMenu;
        return item;
    });
    const handleAppsMenuItemClick = ()=>{
        handleNestedMenuItemClick("apps");
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowApps',
                source: 'overflowMenu'
            }
        }).fire();
    };
    // The app's modal returns focus to whatever had focus when it opened. The app's menu item is
    // disabled while the app loads, so that is the body. Close the menu and move focus back to the
    // "More actions" trigger once the modal has finished closing.
    const closeMenuAndRestoreFocus = ()=>{
        handleNestedMenuItemClose();
        closeParentMenu();
        window.setTimeout(()=>{
            if (typeof document !== 'undefined') document.getElementById('more-actions-trigger')?.focus();
        }, 0);
    };
    return {
        name: $434c765ed6791bfa$export$68013e639efb767f,
        shouldRender: isAppsRendered,
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TN2N.LazyForgeContentTools), {
                spaceKey: spaceKey,
                contentId: contentId,
                onLoadComplete: ()=>{},
                isDropdownMenuOpen: isMenuOpen,
                onExtensionClose: closeMenuAndRestoreFocus
            }, (forgeMenuItems)=>pageAppItems.length > 0 || forgeMenuItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $434c765ed6791bfa$export$a7357cdd1f0b0168.pageAppsLabel),
                    items: pageAppItems,
                    isNestedMenuOpen: nestedPopup === "apps",
                    onClick: handleAppsMenuItemClick,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
                        label: ""
                    }),
                    forgeMenuItems: forgeMenuItems,
                    onMenuClose: handleNestedMenuItemClose,
                    id: "third-party"
                }) : null)
    };
};
const $434c765ed6791bfa$export$7e059d95fddc01f4 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, pageTitle: pageTitle } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== createAnalyticsEvent || $[3] !== experienceTracker || $[4] !== intl || $[5] !== pageTitle || $[6] !== spaceKey) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t1
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS)
                    });
                    dialogs.showModal((0, $1AbrA.PageQuickActionAutomationMenu), {
                        pageId: contentId,
                        pageTitle: pageTitle || intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.automationsModalTitle),
                        spaceKey: spaceKey
                    });
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "overflowAutomations",
                            source: "overflowMenu"
                        }
                    }).fire();
                }
            }, intl.formatMessage($434c765ed6791bfa$export$a7357cdd1f0b0168.automationsLabel)));
        $[1] = contentId;
        $[2] = createAnalyticsEvent;
        $[3] = experienceTracker;
        $[4] = intl;
        $[5] = pageTitle;
        $[6] = spaceKey;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $434c765ed6791bfa$export$f404e2d5b48ab522 = (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { webItemsMap: webItemsMap, handleNestedMenuItemClick: handleNestedMenuItemClick, nestedPopup: nestedPopup, handleNestedMenuItemClose: handleNestedMenuItemClose, closeParentMenu: closeParentMenu } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const viewStorageFormatItem = webItemsMap[0, $9af26f5142ee161a$export$da9876ab77cf10e8];
    const viewSourceItem = (0, $9wGTI.fg)("cc-page-experiences-enable-view-source-action-btn") ? webItemsMap[0, $9af26f5142ee161a$export$ecf44b2b0a73d53f] : null;
    let advancedItems;
    if ($[0] !== closeParentMenu || $[1] !== viewSourceItem || $[2] !== viewStorageFormatItem) {
        advancedItems = [];
        if (viewSourceItem) {
            let t1;
            if ($[4] !== closeParentMenu || $[5] !== viewSourceItem) {
                t1 = {
                    ...viewSourceItem,
                    closeParentMenu: closeParentMenu
                };
                $[4] = closeParentMenu;
                $[5] = viewSourceItem;
                $[6] = t1;
            } else t1 = $[6];
            advancedItems.push(t1);
        }
        if (viewStorageFormatItem) {
            let t1;
            if ($[7] !== closeParentMenu || $[8] !== viewStorageFormatItem) {
                t1 = {
                    ...viewStorageFormatItem,
                    closeParentMenu: closeParentMenu
                };
                $[7] = closeParentMenu;
                $[8] = viewStorageFormatItem;
                $[9] = t1;
            } else t1 = $[9];
            advancedItems.push(t1);
        }
        $[0] = closeParentMenu;
        $[1] = viewSourceItem;
        $[2] = viewStorageFormatItem;
        $[3] = advancedItems;
    } else advancedItems = $[3];
    if (advancedItems.length === 0) return null;
    let t1;
    if ($[10] !== createAnalyticsEvent || $[11] !== handleNestedMenuItemClick) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowAdvanced",
                    source: "overflowMenu"
                }
            }).fire();
            handleNestedMenuItemClick("advanced");
        };
        $[10] = createAnalyticsEvent;
        $[11] = handleNestedMenuItemClick;
        $[12] = t1;
    } else t1 = $[12];
    const onClick = t1;
    let t2;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $434c765ed6791bfa$export$a7357cdd1f0b0168.advancedLabel);
        $[13] = t2;
    } else t2 = $[13];
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            label: "",
            size: "small"
        });
        $[14] = t3;
    } else t3 = $[14];
    const t4 = nestedPopup === "advanced";
    let t5;
    if ($[15] !== advancedItems || $[16] !== handleNestedMenuItemClose || $[17] !== onClick || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
            label: t2,
            items: advancedItems,
            iconBefore: t3,
            isNestedMenuOpen: t4,
            onClick: onClick,
            key: (0, $9af26f5142ee161a$export$ab4fe2a2881747b5),
            onMenuClose: handleNestedMenuItemClose
        });
        $[15] = advancedItems;
        $[16] = handleNestedMenuItemClose;
        $[17] = onClick;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
};
function $434c765ed6791bfa$var$_temp(item_0) {
    return item_0.id;
}
function $434c765ed6791bfa$var$_temp2(item) {
    return item.id === (0, $9af26f5142ee161a$export$d81a93c80838b765) || item.id === (0, $9af26f5142ee161a$export$da4fec526a505196);
}

















const $ac5cc0f86197b0c1$export$ea7f8a8a3c6349fc = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { label: label, isLivePage: isLivePage, contentType: contentType, itemId: t1, itemUrl: t2 } = t0;
    const itemId = t1 === undefined ? "" : t1;
    const itemUrl = t2 === undefined ? "" : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
            label: ""
        });
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] !== contentType || $[2] !== createAnalyticsEvent || $[3] !== isLivePage) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "versionHistory",
                    source: "overflowMenu",
                    attributes: {
                        isContentWrapper: true,
                        isNewContentHistory: true,
                        isLivePage: isLivePage,
                        contentType: contentType
                    }
                }
            }).fire();
        };
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = isLivePage;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== itemId || $[6] !== itemUrl || $[7] !== label || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: itemId,
            elemBefore: t3,
            href: itemUrl,
            onClick: t4
        }, label);
        $[5] = itemId;
        $[6] = itemUrl;
        $[7] = label;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};















var $4aRua = parcelRequire("4aRua");








var $57p4j = parcelRequire("57p4j");








var $dmDX7 = parcelRequire("dmDX7");


var $ewVsQ = parcelRequire("ewVsQ");

const $5d3293071a1569ba$var$i18n = (0, $kSwu1.defineMessages)({
    askToEditContentLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit",
        defaultMessage: "Ask to edit"
    },
    askToEditPendingLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit.pending.label",
        defaultMessage: "Requested"
    },
    askToEditPendingRequestExistsFlagTitle: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit.flag.title",
        defaultMessage: "Request pending"
    },
    askToEditPendingRequestExistsFlagDescription: {
        id: "content-types-header.ellipsis.open.ellipsis.ask-to-edit.flag.description",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "You already sent a request. We'll send you an email when it's been approved."
    }
});
const $5d3293071a1569ba$export$84d0de3613f64b9a = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { contentType: contentType, contentId: contentId, flags: flags, triggerAnalyticsEvent: triggerAnalyticsEvent, askToEditKey: askToEditKey } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== flags || $[2] !== triggerAnalyticsEvent) {
        t1 = {
            contentId: contentId,
            flags: flags,
            triggerAnalyticsEvent: triggerAnalyticsEvent
        };
        $[0] = contentId;
        $[1] = flags;
        $[2] = triggerAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const { requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission } = (0, $ewVsQ.useRequestToEditContent)(t1);
    let t2;
    if ($[4] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[4] = contentId;
        $[5] = t2;
    } else t2 = $[5];
    const { pendingRequestExists: pendingRequestExists, isLoadingForFirstTime: pendingRequestCheckLoading } = (0, $dmDX7.usePendingRequestExists)(t2);
    const readyToSendRequest = !hasRequestedEditPermission && !pendingRequestExists && !pendingRequestCheckLoading;
    let t3;
    if ($[6] !== contentId || $[7] !== contentType || $[8] !== createAnalyticsEvent || $[9] !== flags || $[10] !== formatMessage || $[11] !== pendingRequestExists || $[12] !== readyToSendRequest || $[13] !== requestToEditContent) {
        t3 = async ()=>{
            if (readyToSendRequest) {
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "requestAccessButton",
                        source: "moreActionsMenu",
                        attributes: {
                            contentType: contentType,
                            accessType: "edit",
                            contentId: contentId,
                            editDeniedButCanView: true
                        }
                    }
                }).fire();
                await requestToEditContent();
            } else if (pendingRequestExists) flags.showInfoFlag({
                id: "ask-to-edit.ellipsis.pending-edit-request-exists.flag",
                title: formatMessage($5d3293071a1569ba$var$i18n.askToEditPendingRequestExistsFlagTitle),
                description: formatMessage($5d3293071a1569ba$var$i18n.askToEditPendingRequestExistsFlagDescription),
                isAutoDismiss: true
            });
        };
        $[6] = contentId;
        $[7] = contentType;
        $[8] = createAnalyticsEvent;
        $[9] = flags;
        $[10] = formatMessage;
        $[11] = pendingRequestExists;
        $[12] = readyToSendRequest;
        $[13] = requestToEditContent;
        $[14] = t3;
    } else t3 = $[14];
    const handleItemClick = t3;
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: ""
        });
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== hasRequestedEditPermission || $[17] !== pendingRequestExists) {
        t5 = (hasRequestedEditPermission || pendingRequestExists) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            duration: "medium"
        }, $5d3293071a1569ba$var$_temp);
        $[16] = hasRequestedEditPermission;
        $[17] = pendingRequestExists;
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $5d3293071a1569ba$var$i18n.askToEditContentLabel);
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== askToEditKey || $[21] !== handleItemClick || $[22] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: askToEditKey,
            onClick: handleItemClick,
            elemBefore: t4,
            elemAfter: t5
        }, t6));
        $[20] = askToEditKey;
        $[21] = handleItemClick;
        $[22] = t5;
        $[23] = t7;
    } else t7 = $[23];
    return t7;
};
function $5d3293071a1569ba$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $5d3293071a1569ba$var$i18n.askToEditPendingLabel)));
}



const $511857b10ace36ca$var$COMBINED_ACTION_ARCHIVE = 'combined-action-archive';
const $511857b10ace36ca$var$i18n = (0, $kSwu1.defineMessages)({
    triggerLabel: {
        id: "content-types-header.content-types.more-actions.label",
        defaultMessage: "More actions"
    },
    tooltip: {
        id: "content-types-header.content-types.more-actions.disabled-tooltip",
        defaultMessage: "Coming soon"
    },
    templatesImportLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.templates",
        defaultMessage: "Templates and import"
    },
    templatesLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.templates-only",
        defaultMessage: "Templates"
    },
    importLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.import-only",
        defaultMessage: "Import"
    },
    presentLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.present",
        defaultMessage: "Present"
    },
    revertLabel: {
        id: "content-types-header.revert.label",
        defaultMessage: "Revert to previous version"
    },
    revertEditor: {
        id: "content-types-header.revert.editor.label",
        defaultMessage: "Revert to legacy editor"
    },
    help: {
        id: "content-types-header.ellipsis.open.ellipsis.help",
        defaultMessage: "Help"
    },
    previewLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.preview",
        defaultMessage: "Preview"
    },
    manageLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.manage",
        defaultMessage: "Manage"
    },
    versionHistoryLabel: {
        id: "content-types-header.version.history.label",
        defaultMessage: "Version history"
    },
    convertToPage: {
        id: "content-types-header.ellipsis.open.ellipsis.convert-to-page",
        defaultMessage: "Convert to page"
    },
    convertToMarkdown: {
        id: "content-types-header.ellipsis.open.ellipsis.convert-to-markdown",
        defaultMessage: "Convert to markdown"
    },
    convertToRichText: {
        id: "content-types-header.ellipsis.open.ellipsis.convert-to-rich-text",
        defaultMessage: "Convert to rich text"
    },
    companyHubFeedback: {
        id: "content-types-header.ellipsis.open.ellipsis.hub.share-feedback",
        defaultMessage: "Give feedback on Company hub"
    },
    editorFindReplaceLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.editor-find-replace",
        defaultMessage: "Find and replace"
    },
    editorFindLabel: {
        id: "content-types-header.ellipsis.open.ellipsis.editor-find",
        defaultMessage: "Find"
    }
});
const $511857b10ace36ca$var$dropdownMenuContentStyles = (0, $buxP3.xcss)({
    minWidth: '260px'
});
const $511857b10ace36ca$var$dropdownTriggerBoxStyles = (0, $buxP3.xcss)({
    position: 'relative'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
// NOTE: These styles are directly copied from ContentTools.tsx in @confluence/content-tools
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $511857b10ace36ca$var$ResolvedCommentsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $511857b10ace36ca$var$ResolvedCommentsLabelContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2O5VijiZR3 _3YEZNO7dHp _1bHrqEAEMG _0adFHsgVvo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $511857b10ace36ca$var$createActionsMap = (actions)=>{
    const map = {};
    actions?.forEach((action)=>{
        if (action?.id) map[action.id] = action;
    });
    return map;
};
const $511857b10ace36ca$var$useOpenWatchMenuQueryParam = (0, $dPJCf.createSingleQueryParamHook)('openWatchModal');
const $511857b10ace36ca$export$6e6eb6019781c337 = (t0)=>{
    const $ = (0, $bDgLe.c)(408);
    const { moreActions: moreActions, contentId: contentId, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey, allowedFeatures: allowedFeatures, hasArchivePermission: hasArchivePermission, flags: flags, contentData: contentData, readOnly: readOnly, isConvertToFolderHighlighted: t1, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted } = t0;
    const isConvertToFolderHighlighted = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const history = (0, $dPJCf.useHistory)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[0] !== contentId || $[1] !== contentMode || $[2] !== contentType || $[3] !== createAnalyticsEvent || $[4] !== spaceKey) {
        t2 = async (eventName)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: eventName,
                    actionSubject: "askToEditContent",
                    source: "moreActionsMenu",
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        isContentWrapper: true,
                        spaceKey: spaceKey,
                        contentMode: contentMode || "view"
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = contentMode;
        $[2] = contentType;
        $[3] = createAnalyticsEvent;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    const triggerAnalyticsEvent = t2;
    const { saveDraft: saveDraft, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, isContentCreationPanelOpen: isContentCreationPanelOpen, contentCreationPanelMode: contentCreationPanelMode, showRevertDialog: showRevertDialog, onPreviewClicked: onPreviewClicked, hasEditPermission: hasEditPermission, validatePageAndOpenModal: validatePageAndOpenModal, activateFindReplace: editorActivateFindReplace, editorActions: editorActions } = (0, $3o3i5.useEditorObjectHeaderContext)();
    let t3;
    if ($[6] !== contentId || $[7] !== contentType) {
        t3 = {
            contentId: contentId,
            contentType: contentType
        };
        $[6] = contentId;
        $[7] = contentType;
        $[8] = t3;
    } else t3 = $[8];
    const isPageOrBlogAutoConverted = (0, $0633edcc0f21cf62$export$38d9182f14dddb00)(t3);
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            source: "hubEditorEllipsisDropdown",
            type: (0, $hjUDQ.FeedbackType).COMPANY_HUB
        };
        $[9] = t4;
    } else t4 = $[9];
    const openCompanyHubFeedbackCollector = (0, $lOeVN.useFeedbackCollector)(t4);
    let t5;
    if ($[10] !== validatePageAndOpenModal) {
        t5 = validatePageAndOpenModal?.("OverflowMenuConvertToPage");
        $[10] = validatePageAndOpenModal;
        $[11] = t5;
    } else t5 = $[11];
    const publishPage = t5;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [];
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== contentId) {
        t7 = {
            variables: {
                contentId: contentId,
                location: (0, $eSLr0.TOOLS_MENU_CONTAINER),
                locations: t6,
                spaceKey: null,
                version: null
            }
        };
        $[13] = contentId;
        $[14] = t7;
    } else t7 = $[14];
    const [preloadWebItemsQuery, t8] = (0, $lvOsp.useLazyQueryInterop)((0, $iEfsZ.default), {
        ...t7,
        __callerPackage__: "content-types-header"
    });
    const { data: webItemsData, called: isWebItemsQueryCalled, error: error, loading: loading } = t8;
    const [isCopyContentModalOpen, setIsCopyContentModalOpen] = (0, $cozmU.useState)(false);
    const [isMoveContentModalOpen, setIsMoveContentModalOpen] = (0, $cozmU.useState)(false);
    const [isShortcutTriggered, setIsShortcutTriggered] = (0, $cozmU.useState)(false);
    const { isMenuOpen: isMenuOpen, isCloseMenuDisabled: isCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuState)();
    const { setIsMenuOpen: setIsMenuOpen } = (0, $c54hr.useMoreActionsMenuActions)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const isAccessLinkRequest = (0, $dnfJM.useIsAccessLinkRequest)();
    let t9;
    if ($[15] !== setIsMenuOpen) {
        t9 = ()=>{
            setIsMenuOpen(false);
        };
        $[15] = setIsMenuOpen;
        $[16] = t9;
    } else t9 = $[16];
    const handleSmartFolderStopSyncing = t9;
    let t10;
    if ($[17] !== contentId || $[18] !== contentType || $[19] !== createAnalyticsEvent || $[20] !== spaceId) {
        t10 = (actionSubjectId)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "dropdownItem",
                    actionSubjectId: actionSubjectId,
                    source: "moreActions",
                    objectId: contentId,
                    objectType: contentType,
                    containerId: spaceId
                }
            }).fire();
        };
        $[17] = contentId;
        $[18] = contentType;
        $[19] = createAnalyticsEvent;
        $[20] = spaceId;
        $[21] = t10;
    } else t10 = $[21];
    const fireSmartFolderMenuAnalytics = t10;
    const { edition: edition, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    const isAuthenticatedWithoutConfluenceUser = (0, $8Lx5S.useIsAuthenticatedWithoutConfluenceUser)();
    const isFreeUser = edition === (0, $euL71.ConfluenceEdition).FREE;
    const isPremiumUser = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    const isCommentsEnabled = (0, $1b70db1d5649f5f3$export$5dc260e4e702b5d0)(contentType);
    const isVersionHistoryEnabled = (0, $5thep.useIsVersionHistoryEnabled)(contentType);
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const [nestedPopup, setNestedPopup] = (0, $cozmU.useState)(undefined);
    const { showSidePanel: showSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    let isSpaceOverviewPage;
    let t11;
    if ($[22] !== contentMode || $[23] !== contentType) {
        isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
        t11 = (0, $ff966189b275be15$export$a2eada40e8c9a2ed)(contentType, contentMode, isSpaceOverviewPage);
        $[22] = contentMode;
        $[23] = contentType;
        $[24] = isSpaceOverviewPage;
        $[25] = t11;
    } else {
        isSpaceOverviewPage = $[24];
        t11 = $[25];
    }
    const isPresentRendered = t11;
    const isLivePage = contentType === "page" && contentMode === "live";
    let t12;
    if ($[26] !== contentId || $[27] !== editorActions || $[28] !== flags || $[29] !== isLivePage) {
        t12 = {
            contentId: contentId,
            isLivePage: isLivePage,
            editorActions: editorActions,
            flags: flags
        };
        $[26] = contentId;
        $[27] = editorActions;
        $[28] = flags;
        $[29] = isLivePage;
        $[30] = t12;
    } else t12 = $[30];
    const { isMarkdownMode: isMarkdownMode, isUpdating: isMarkdownModeUpdating, convertToMarkdown: convertToMarkdown, convertToRichText: convertToRichText, confirmConvertToMarkdown: confirmConvertToMarkdown, confirmConvertToRichText: confirmConvertToRichText } = (0, $bJrpn.useMarkdownModeActions)(t12);
    const [t13] = (0, $efvKr.useLivePageMode)();
    const { mode: livePageMode } = t13;
    const isLivePageViewOnlyPermissions = isLivePage && !hasEditPermission;
    let t14;
    if ($[31] !== contentData?.operations) {
        t14 = (type)=>contentData?.operations?.some((operation)=>operation?.targetType === type && operation?.operation === "update");
        $[31] = contentData?.operations;
        $[32] = t14;
    } else t14 = $[32];
    const hasUpdateOperation = t14;
    let t15;
    if ($[33] !== hasUpdateOperation) {
        t15 = (type_0)=>!hasUpdateOperation(type_0);
        $[33] = hasUpdateOperation;
        $[34] = t15;
    } else t15 = $[34];
    const isAskToEditEnabled = t15;
    let t16;
    if ($[35] !== contentType || $[36] !== hasUpdateOperation) {
        t16 = contentType === "page" && !hasUpdateOperation(contentType);
        $[35] = contentType;
        $[36] = hasUpdateOperation;
        $[37] = t16;
    } else t16 = $[37];
    const isPageViewOnlyPermissions = t16;
    let t17;
    if ($[38] !== contentType || $[39] !== isAskToEditEnabled) {
        t17 = (0, $1ggpj.isCanvasContentType)(contentType) && isAskToEditEnabled(contentType);
        $[38] = contentType;
        $[39] = isAskToEditEnabled;
        $[40] = t17;
    } else t17 = $[40];
    const isCanvasViewOnlyPermissions = t17;
    const isDatabaseViewOnlyPermissions = contentType === "database" && isAskToEditEnabled(contentType);
    const isBlogViewOnlyPermissions = contentType === "blogpost" && isAskToEditEnabled(contentType);
    const isContentViewOnlyPermissions = isLivePageViewOnlyPermissions || isPageViewOnlyPermissions || isCanvasViewOnlyPermissions || isDatabaseViewOnlyPermissions || isBlogViewOnlyPermissions;
    let t18;
    if ($[41] !== isAccessLinkRequest || $[42] !== isAuthenticatedWithoutConfluenceUser || $[43] !== isContentViewOnlyPermissions || $[44] !== isLoggedIn) {
        t18 = isAccessLinkRequest || !isLoggedIn || !isContentViewOnlyPermissions || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)("cc_perms_ga_access_requests", "isEnabled", true) || isAuthenticatedWithoutConfluenceUser && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("cc_fe_inconsistent_license_warning", "isEnabled", true);
        $[41] = isAccessLinkRequest;
        $[42] = isAuthenticatedWithoutConfluenceUser;
        $[43] = isContentViewOnlyPermissions;
        $[44] = isLoggedIn;
        $[45] = t18;
    } else t18 = $[45];
    let t19;
    if ($[46] !== t18) {
        t19 = {
            skip: t18
        };
        $[46] = t18;
        $[47] = t19;
    } else t19 = $[47];
    const { contentEnabled: contentEnabled, loading: isAccessRequestSettingsLoading } = (0, $kqv9Z.useAccessRequestSettings)(t19);
    const isContentAccessRequestDisabled = contentEnabled === false || isAccessRequestSettingsLoading;
    const contentStatus = contentData?.status || undefined;
    const isArchived = contentData?.status === "archived";
    const isStarringEnabledForContentType = (0, $2cKGu.useIsStarringEnabled)(contentType, contentMode);
    const [t20] = (0, $7J5Uc.useThemingState)();
    const { theme: theme } = t20;
    const openWatchModalQueryParam = Boolean($511857b10ace36ca$var$useOpenWatchMenuQueryParam());
    const { setQueryParams: setQueryParams, push: push } = (0, $dPJCf.useRouteActions)();
    let t21;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = {
            step: (0, $bzwhi.MoreActionsObjectSidebarTourSteps).FIRST
        };
        $[48] = t21;
    } else t21 = $[48];
    const { activeSpotlight: activeSpotlight, resetTour: resetTour } = (0, $bzwhi.useMoreActionsObjectSidebarTour)(t21);
    let t22;
    if ($[49] !== contentData?.operations || $[50] !== contentType) {
        t22 = contentData?.operations?.filter((operation_0)=>operation_0?.targetType === contentType && operation_0?.operation === "read").length;
        $[49] = contentData?.operations;
        $[50] = contentType;
        $[51] = t22;
    } else t22 = $[51];
    const hasReadPermission = Boolean(t22);
    const shouldRenderStarContentMenuItem = isStarringEnabledForContentType && !!allowedFeatures.showFavourite && !isSpaceOverviewPage && hasReadPermission && !isAccessLinkRequest;
    const shouldRenderStarSpaceMenuItem = isSpaceOverviewPage && isLoggedIn;
    let t23;
    if ($[52] !== spaceKey) {
        t23 = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        $[52] = spaceKey;
        $[53] = t23;
    } else t23 = $[53];
    const isCompanyHub = t23;
    let t24;
    if ($[54] !== contentData) {
        t24 = contentData ?? {};
        $[54] = contentData;
        $[55] = t24;
    } else t24 = $[55];
    let t25;
    if ($[56] !== t24) {
        t25 = (0, $hT3jf.isSmartFolder)(t24);
        $[56] = t24;
        $[57] = t25;
    } else t25 = $[57];
    const isSmartFolderContent = t25;
    const t26 = contentData?.properties?.nodes;
    let t27;
    if ($[58] !== t26) {
        t27 = (0, $aboIx.isDevDocsOwnedFolder)({
            propertyCollections: [
                t26
            ]
        });
        $[58] = t26;
        $[59] = t27;
    } else t27 = $[59];
    const isDevDocsOwnedContent = t27;
    const t28 = !isSmartFolderContent;
    let t29;
    if ($[60] !== t28) {
        t29 = {
            skip: t28
        };
        $[60] = t28;
        $[61] = t29;
    } else t29 = $[61];
    const { isSmartFoldersEnabledForMilestone: isSmartFoldersM1Enabled, loading: isSmartFoldersLoading } = (0, $lYrp8.useIsSmartFoldersEnabledForMilestone)(spaceKey, 1, t29);
    const t30 = !isSmartFolderContent;
    let t31;
    if ($[62] !== t30) {
        t31 = {
            skip: t30
        };
        $[62] = t30;
        $[63] = t31;
    } else t31 = $[63];
    const { isSmartFoldersEnabledForMilestone: isSmartFoldersM2Enabled, loading: isSmartFoldersM2Loading } = (0, $lYrp8.useIsSmartFoldersEnabledForMilestone)(spaceKey, 2, t31);
    const t32 = !isSmartFolderContent;
    let t33;
    if ($[64] !== t32) {
        t33 = {
            skip: t32
        };
        $[64] = t32;
        $[65] = t33;
    } else t33 = $[65];
    const smartFolderConnectedSource = (0, $5wA2k.useSmartFolderQuickActionSource)(contentId, contentData?.properties?.nodes, t33);
    let t34;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = [
            (0, $aYZaZ.Buttons).DELETE_DRAFT,
            (0, $aYZaZ.Buttons).MANAGE,
            (0, $aYZaZ.Buttons).RESOLVED_COMMENTS,
            (0, $aYZaZ.Buttons).VIEW_CHANGES
        ];
        $[66] = t34;
    } else t34 = $[66];
    const companyHubEllipsisButtons = t34;
    let t35;
    if ($[67] !== isCompanyHub) {
        const allowedEllipsisButtons = isCompanyHub ? companyHubEllipsisButtons : [
            (0, $aYZaZ.Buttons).PUBLISH_WITHOUT_NOTIFY,
            (0, $aYZaZ.Buttons).DELETE_DRAFT,
            (0, $aYZaZ.Buttons).EDIT_LABELS,
            (0, $aYZaZ.Buttons).MOVE_PAGE,
            (0, $aYZaZ.Buttons).PREVIEW,
            (0, $aYZaZ.Buttons).RESOLVED_COMMENTS,
            (0, $aYZaZ.Buttons).TEMPLATE_BROWSER,
            (0, $aYZaZ.Buttons).VIEW_CHANGES,
            (0, $aYZaZ.Buttons).SWITCH_TO_LIVE_EDIT,
            (0, $aYZaZ.Buttons).CLASSIFY_CONTENT
        ];
        t35 = (menuItem)=>allowedEllipsisButtons?.includes(menuItem) ?? true;
        $[67] = isCompanyHub;
        $[68] = t35;
    } else t35 = $[68];
    const isAllowed = t35;
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    let t36;
    if ($[69] !== contentMode || $[70] !== contentType || $[71] !== isLivePageViewOnlyPermissions) {
        t36 = (0, $ff966189b275be15$export$37d144a1b557c80d)(contentType, contentMode) && !isLivePageViewOnlyPermissions;
        $[69] = contentMode;
        $[70] = contentType;
        $[71] = isLivePageViewOnlyPermissions;
        $[72] = t36;
    } else t36 = $[72];
    const isConvertToPageEligible = t36;
    let t37;
    if ($[73] !== contentMode || $[74] !== contentType || $[75] !== isLivePageViewOnlyPermissions || $[76] !== isMarkdownMode) {
        t37 = !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$d01b7f6c0ae49b6b)(contentType, contentMode, isMarkdownMode);
        $[73] = contentMode;
        $[74] = contentType;
        $[75] = isLivePageViewOnlyPermissions;
        $[76] = isMarkdownMode;
        $[77] = t37;
    } else t37 = $[77];
    const isConvertToMarkdownShortcutEligible = t37;
    let t38;
    if ($[78] !== contentMode || $[79] !== contentType || $[80] !== isLivePageViewOnlyPermissions || $[81] !== isMarkdownMode) {
        t38 = !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$22cead55e1c779de)(contentType, contentMode, isMarkdownMode);
        $[78] = contentMode;
        $[79] = contentType;
        $[80] = isLivePageViewOnlyPermissions;
        $[81] = isMarkdownMode;
        $[82] = t38;
    } else t38 = $[82];
    const isConvertToRichTextShortcutEligible = t38;
    const isMarkdownToggleShortcutEnabled = isConvertToMarkdownShortcutEligible || isConvertToRichTextShortcutEligible;
    let t39;
    if ($[83] !== convertToMarkdown || $[84] !== convertToRichText || $[85] !== isConvertToMarkdownShortcutEligible || $[86] !== isConvertToRichTextShortcutEligible || $[87] !== isMarkdownModeUpdating) {
        t39 = ()=>{
            if (isMarkdownModeUpdating) return;
            if (isConvertToRichTextShortcutEligible) convertToRichText();
            else if (isConvertToMarkdownShortcutEligible) convertToMarkdown();
        };
        $[83] = convertToMarkdown;
        $[84] = convertToRichText;
        $[85] = isConvertToMarkdownShortcutEligible;
        $[86] = isConvertToRichTextShortcutEligible;
        $[87] = isMarkdownModeUpdating;
        $[88] = t39;
    } else t39 = $[88];
    const handleToggleMarkdownModeShortcut = t39;
    let t40;
    let t41;
    if ($[89] !== isConvertToFolderHighlighted || $[90] !== setIsMenuOpen) {
        t40 = ()=>{
            if (isConvertToFolderHighlighted) {
                setIsMenuOpen(isConvertToFolderHighlighted);
                setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Convert);
            }
        };
        t41 = [
            isConvertToFolderHighlighted,
            setIsMenuOpen
        ];
        $[89] = isConvertToFolderHighlighted;
        $[90] = setIsMenuOpen;
        $[91] = t40;
        $[92] = t41;
    } else {
        t40 = $[91];
        t41 = $[92];
    }
    (0, $cozmU.useEffect)(t40, t41);
    let t42;
    if ($[93] !== allowedFeatures.showWatchDialog || $[94] !== contentMode || $[95] !== contentType || $[96] !== loading || $[97] !== openWatchModalQueryParam || $[98] !== setIsMenuOpen || $[99] !== setQueryParams) {
        t42 = ()=>{
            if (openWatchModalQueryParam && contentType && contentMode && !loading) {
                if ((0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && !!allowedFeatures.showWatchDialog) {
                    setIsMenuOpen(true);
                    setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch);
                }
                setQueryParams({
                    openWatchModal: null
                });
            }
        };
        $[93] = allowedFeatures.showWatchDialog;
        $[94] = contentMode;
        $[95] = contentType;
        $[96] = loading;
        $[97] = openWatchModalQueryParam;
        $[98] = setIsMenuOpen;
        $[99] = setQueryParams;
        $[100] = t42;
    } else t42 = $[100];
    let t43;
    if ($[101] !== allowedFeatures || $[102] !== contentMode || $[103] !== contentType || $[104] !== loading || $[105] !== openWatchModalQueryParam || $[106] !== setIsMenuOpen || $[107] !== setQueryParams) {
        t43 = [
            openWatchModalQueryParam,
            setQueryParams,
            contentType,
            contentMode,
            loading,
            allowedFeatures,
            setIsMenuOpen
        ];
        $[101] = allowedFeatures;
        $[102] = contentMode;
        $[103] = contentType;
        $[104] = loading;
        $[105] = openWatchModalQueryParam;
        $[106] = setIsMenuOpen;
        $[107] = setQueryParams;
        $[108] = t43;
    } else t43 = $[108];
    (0, $cozmU.useEffect)(t42, t43);
    let t44;
    if ($[109] !== isShortcutTriggered || $[110] !== loading || $[111] !== webItemsData?.webItemSections) {
        t44 = ()=>{
            if (isShortcutTriggered && !loading) {
                if (webItemsData?.webItemSections?.some($511857b10ace36ca$var$_temp)) {
                    (0, $4GDP8.openMoreActionsMenuClick)();
                    (0, $4GDP8.simulateItemClick)((0, $9af26f5142ee161a$export$240b6ef4a1c531f6));
                }
                setIsShortcutTriggered(false);
            }
        };
        $[109] = isShortcutTriggered;
        $[110] = loading;
        $[111] = webItemsData?.webItemSections;
        $[112] = t44;
    } else t44 = $[112];
    let t45;
    if ($[113] !== isShortcutTriggered || $[114] !== loading || $[115] !== webItemsData) {
        t45 = [
            isShortcutTriggered,
            webItemsData,
            loading
        ];
        $[113] = isShortcutTriggered;
        $[114] = loading;
        $[115] = webItemsData;
        $[116] = t45;
    } else t45 = $[116];
    (0, $cozmU.useEffect)(t44, t45);
    let t46;
    if ($[117] !== activeSpotlight || $[118] !== contentId || $[119] !== contentType || $[120] !== createAnalyticsEvent || $[121] !== isCloseMenuDisabled || $[122] !== resetTour || $[123] !== setIsConvertToFolderHighlighted || $[124] !== setIsMenuOpen || $[125] !== spaceId) {
        t46 = (t47)=>{
            const { isOpen: isOpen } = t47;
            if (!isOpen && isCloseMenuDisabled) return;
            if (activeSpotlight) return;
            setIsMenuOpen(isOpen);
            if (!isOpen) {
                resetTour();
                setNestedPopup(undefined);
                setIsConvertToFolderHighlighted?.(false);
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contentTypeHeaderMoreActions",
                    containerType: "space",
                    containerId: spaceId,
                    objectId: contentId,
                    source: "contentTypesHeader",
                    attributes: {
                        isContentWrapper: true,
                        contentType: contentType
                    }
                }
            }).fire();
        };
        $[117] = activeSpotlight;
        $[118] = contentId;
        $[119] = contentType;
        $[120] = createAnalyticsEvent;
        $[121] = isCloseMenuDisabled;
        $[122] = resetTour;
        $[123] = setIsConvertToFolderHighlighted;
        $[124] = setIsMenuOpen;
        $[125] = spaceId;
        $[126] = t46;
    } else t46 = $[126];
    const handleOpenChange = t46;
    let t47;
    if ($[127] !== isWebItemsQueryCalled || $[128] !== preloadWebItemsQuery) {
        t47 = ()=>{
            if (isWebItemsQueryCalled) return;
            preloadWebItemsQuery();
        };
        $[127] = isWebItemsQueryCalled;
        $[128] = preloadWebItemsQuery;
        $[129] = t47;
    } else t47 = $[129];
    const preloadWebItems = t47;
    let t48;
    if ($[130] !== nestedPopup) {
        t48 = (nestedMenuType)=>{
            if (nestedPopup === nestedMenuType) setNestedPopup(undefined);
            else setNestedPopup(nestedMenuType);
        };
        $[130] = nestedPopup;
        $[131] = t48;
    } else t48 = $[131];
    const handleNestedMenuItemClick = t48;
    let t49;
    if ($[132] === Symbol.for("react.memo_cache_sentinel")) {
        t49 = ()=>{
            setNestedPopup(undefined);
        };
        $[132] = t49;
    } else t49 = $[132];
    const handleNestedMenuItemClose = t49;
    let t50;
    if ($[133] !== contentId || $[134] !== contentType || $[135] !== experienceTracker || $[136] !== isSmartFolderContent || $[137] !== isSmartFoldersM2Enabled || $[138] !== isSmartFoldersM2Loading || $[139] !== setIsMenuOpen) {
        t50 = (dialogs)=>{
            experienceTracker.start({
                name: (0, $irVI7.DELETE_PAGE_EXPERIENCE)
            });
            dialogs.showModal((0, $6ykQV.DeleteNestedPagesActionLoader), {
                contentId: contentId,
                source: "contentTypesHeader",
                shouldRedirectOnSuccess: true,
                contentType: contentType,
                shouldShowSmartFolderNestedDelete: isSmartFolderContent && !isSmartFoldersM2Loading && isSmartFoldersM2Enabled
            });
            setIsMenuOpen(false);
        };
        $[133] = contentId;
        $[134] = contentType;
        $[135] = experienceTracker;
        $[136] = isSmartFolderContent;
        $[137] = isSmartFoldersM2Enabled;
        $[138] = isSmartFoldersM2Loading;
        $[139] = setIsMenuOpen;
        $[140] = t50;
    } else t50 = $[140];
    const onDeleteClick = t50;
    let t51;
    if ($[141] !== contentId || $[142] !== spaceKey) {
        t51 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bHd1w.MovePageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                onClose: ()=>setIsMoveContentModalOpen(false),
                onCloseComplete: ()=>setIsMoveContentModalOpen(false),
                referrer: "content-types-header"
            });
        $[141] = contentId;
        $[142] = spaceKey;
        $[143] = t51;
    } else t51 = $[143];
    const renderMoveContentModal = t51;
    let t52;
    if ($[144] !== contentId || $[145] !== contentMode || $[146] !== experienceTracker || $[147] !== spaceKey) {
        t52 = (dialogs_0)=>{
            experienceTracker.start({
                name: (0, $irVI7.MOVE_PAGE_DIALOG_LOAD_EXPERIENCE)
            });
            dialogs_0.showDialog((0, $bHd1w.MovePageDialog), {
                spaceKey: spaceKey,
                contentId: contentId,
                referrer: "view-page-actions-menu",
                isMovingDraftVersion: contentMode === "edit",
                isUnpublishedDraft: contentMode === "draft"
            });
        };
        $[144] = contentId;
        $[145] = contentMode;
        $[146] = experienceTracker;
        $[147] = spaceKey;
        $[148] = t52;
    } else t52 = $[148];
    const renderMovePageModal = t52;
    let t53;
    if ($[149] !== contentId || $[150] !== contentMode || $[151] !== spaceKey) {
        t53 = (dialogs_1)=>{
            dialogs_1.showModal((0, $78wUU.MoveBlogModalLoader), {
                currentSpaceKey: spaceKey,
                blogPostId: contentId,
                isEditMode: contentMode === "edit",
                isUnpublishedDraft: contentMode === "draft"
            });
        };
        $[149] = contentId;
        $[150] = contentMode;
        $[151] = spaceKey;
        $[152] = t53;
    } else t53 = $[152];
    const renderMoveBlogModal = t53;
    let t54;
    if ($[153] !== contentId || $[154] !== spaceKey) {
        t54 = ()=>(0, $6mKj3.expVal)("confluence_modernized_copy_dialog", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3J7TU.CopyPageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                onClose: async ()=>setIsCopyContentModalOpen(false)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5FwhF.CopyPageTreeDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                onClose: async ()=>setIsCopyContentModalOpen(false)
            });
        $[153] = contentId;
        $[154] = spaceKey;
        $[155] = t54;
    } else t54 = $[155];
    const renderCopyContentModal = t54;
    let t55;
    if ($[156] !== confirmConvertToMarkdown || $[157] !== confirmConvertToRichText) {
        t55 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b730a79dde962810$export$7a57ac10272e035f), {
                onConfirmToMarkdown: confirmConvertToMarkdown,
                onConfirmToRichText: confirmConvertToRichText
            });
        $[156] = confirmConvertToMarkdown;
        $[157] = confirmConvertToRichText;
        $[158] = t55;
    } else t55 = $[158];
    const renderConvertMarkdownModeDialog = t55;
    let t56;
    if ($[159] !== contentId || $[160] !== experienceTracker || $[161] !== isFreeUser || $[162] !== isSmartFolderContent || $[163] !== isSmartFoldersM2Enabled || $[164] !== isSmartFoldersM2Loading || $[165] !== setIsMenuOpen) {
        t56 = (dialogs_2)=>{
            if (isFreeUser) dialogs_2.showDialog((0, $k22lL.ArchiveUpsellDialog));
            else {
                experienceTracker.start({
                    name: (0, $irVI7.ARCHIVE_PAGES_EXPERIENCE)
                });
                dialogs_2.showDialog((0, $2WH1B.ArchivePagesLoader), {
                    contentId: contentId,
                    source: "contentTypesHeader",
                    shouldShowSmartFolderNestedArchive: isSmartFolderContent && !isSmartFoldersM2Loading && isSmartFoldersM2Enabled
                });
            }
            setIsMenuOpen(false);
        };
        $[159] = contentId;
        $[160] = experienceTracker;
        $[161] = isFreeUser;
        $[162] = isSmartFolderContent;
        $[163] = isSmartFoldersM2Enabled;
        $[164] = isSmartFoldersM2Loading;
        $[165] = setIsMenuOpen;
        $[166] = t56;
    } else t56 = $[166];
    const onArchiveClick = t56;
    let t57;
    if ($[167] !== contentId || $[168] !== contentType || $[169] !== createAnalyticsEvent || $[170] !== showSidePanel || $[171] !== trackExperience) {
        t57 = ()=>{
            trackExperience({
                contentType: contentType,
                experience: "sidePanel",
                task: "start"
            });
            showSidePanel();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "versionHistory",
                    source: "moreActionsMenu",
                    objectId: contentId,
                    objectType: contentType,
                    attributes: {
                        isContentWrapper: true
                    }
                }
            }).fire();
        };
        $[167] = contentId;
        $[168] = contentType;
        $[169] = createAnalyticsEvent;
        $[170] = showSidePanel;
        $[171] = trackExperience;
        $[172] = t57;
    } else t57 = $[172];
    const handleViewVersionHistory = t57;
    let t58;
    if ($[173] !== createAnalyticsEvent || $[174] !== saveDraft || $[175] !== showRevertDialog) {
        t58 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowRevert",
                    source: "overflowMenu"
                }
            }).fire();
            saveDraft?.({
                isOnClose: false
            });
            showRevertDialog?.();
        };
        $[173] = createAnalyticsEvent;
        $[174] = saveDraft;
        $[175] = showRevertDialog;
        $[176] = t58;
    } else t58 = $[176];
    const onRevertClick = t58;
    let t59;
    if ($[177] !== contentId || $[178] !== contentStatus || $[179] !== contentType || $[180] !== createAnalyticsEvent || $[181] !== push || $[182] !== saveDraft || $[183] !== spaceKey) {
        t59 = (dialogs_3)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "overflowRevertToLegacyEditor",
                    source: "overflowMenu"
                }
            }).fire();
            saveDraft?.({
                isOnClose: false
            });
            dialogs_3.showDialog((0, $b66o6.RevertEditorDialog), {
                contentId: contentId,
                onPageRevert: ()=>(0, $d8oE8.onClickPageRevert)(push, contentType, spaceKey, contentId, (0, $6mKj3.expValEquals)("confluence_auto_convert_legacy_draft_fix_fe", "isEnabled", true) ? contentStatus : undefined)
            });
        };
        $[177] = contentId;
        $[178] = contentStatus;
        $[179] = contentType;
        $[180] = createAnalyticsEvent;
        $[181] = push;
        $[182] = saveDraft;
        $[183] = spaceKey;
        $[184] = t59;
    } else t59 = $[184];
    const onRevertToLegacyEditorClick = t59;
    const onFeedbackClick = $511857b10ace36ca$var$_temp2;
    let t60;
    if ($[185] !== commentService || $[186] !== contentId) {
        t60 = (dialogs_5, context)=>{
            dialogs_5.showDialog((0, $6eFi0.ResolvedInlineCommentsDialogLoader), {
                contentId: contentId,
                context: context,
                onReopenResolvedCommentHandler: (commentIds)=>{
                    commentService.onReopenResolvedComment(commentIds);
                }
            });
        };
        $[185] = commentService;
        $[186] = contentId;
        $[187] = t60;
    } else t60 = $[187];
    const makeInlineCommentsDialogOpener = t60;
    let t61;
    if ($[188] !== contentId || $[189] !== createAnalyticsEvent || $[190] !== experienceTracker || $[191] !== spaceId || $[192] !== theme) {
        t61 = (enterPresenterMode)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "present",
                        source: "moreActions",
                        objectId: contentId,
                        containerId: spaceId,
                        attributes: {
                            currentThemePreference: theme,
                            OStheme: (0, $5yVAS.getSystemPreferredColorScheme)()
                        }
                    }
                }).fire();
                experienceTracker.start({
                    name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
                });
                enterPresenterMode();
            };
        $[188] = contentId;
        $[189] = createAnalyticsEvent;
        $[190] = experienceTracker;
        $[191] = spaceId;
        $[192] = theme;
        $[193] = t61;
    } else t61 = $[193];
    const makePresenterModeOpener = t61;
    let t62;
    if ($[194] !== contentId || $[195] !== contentType || $[196] !== createAnalyticsEvent) {
        t62 = (onPreviewClicked_0)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "previewPage",
                        source: "moreActions",
                        objectId: contentId,
                        objectType: contentType
                    }
                }).fire();
                onPreviewClicked_0(false);
            };
        $[194] = contentId;
        $[195] = contentType;
        $[196] = createAnalyticsEvent;
        $[197] = t62;
    } else t62 = $[197];
    const makePreviewContentHandler = t62;
    let t63;
    if ($[198] !== contentId) {
        t63 = (dialogs_6)=>()=>{
                dialogs_6.showModal((0, $1PC5x.LinkToThisPageDialog), {
                    contentId: contentId
                });
            };
        $[198] = contentId;
        $[199] = t63;
    } else t63 = $[199];
    const openLinkToThisPageDialog = t63;
    let t64;
    if ($[200] !== allowedFeatures.showWatchDialog || $[201] !== contentData?.properties?.nodes || $[202] !== contentData?.title || $[203] !== contentId || $[204] !== contentMode || $[205] !== contentType || $[206] !== fireSmartFolderMenuAnalytics || $[207] !== flags || $[208] !== handleNestedMenuItemClick || $[209] !== handleSmartFolderStopSyncing || $[210] !== hasEditPermission || $[211] !== history || $[212] !== isAccessLinkRequest || $[213] !== isArchived || $[214] !== isAuthenticatedWithoutConfluenceUser || $[215] !== isCompanyHub || $[216] !== isContentAccessRequestDisabled || $[217] !== isContentViewOnlyPermissions || $[218] !== isDevDocsOwnedContent || $[219] !== isLoggedIn || $[220] !== isPresentRendered || $[221] !== isSmartFolderContent || $[222] !== isSmartFoldersLoading || $[223] !== isSmartFoldersM1Enabled || $[224] !== makePresenterModeOpener || $[225] !== makePreviewContentHandler || $[226] !== nestedPopup || $[227] !== onPreviewClicked || $[228] !== setIsMenuOpen || $[229] !== shouldRenderStarContentMenuItem || $[230] !== shouldRenderStarSpaceMenuItem || $[231] !== smartFolderConnectedSource || $[232] !== spaceId || $[233] !== spaceKey || $[234] !== triggerAnalyticsEvent) {
        t64 = (t65)=>{
            const { webItemsMap: webItemsMap, customActionsMap: customActionsMap } = t65;
            const primaryActionsItems = [
                {
                    name: (0, $9af26f5142ee161a$export$35f02acdf766e275),
                    shouldRender: shouldRenderStarSpaceMenuItem,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kPqqM.SpaceStarMenuItemWithQuery), {
                            spaceKey: spaceKey
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$348fd9bd77c132d9),
                    shouldRender: shouldRenderStarContentMenuItem && !isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $daed94f8e5673bda$export$ab53347da13f94fa), {
                            contentId: contentId,
                            contentTitle: contentData?.title || "",
                            contentMode: contentMode || ""
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$8d78c75e31d09d0d),
                    shouldRender: isSmartFolderContent && !isDevDocsOwnedContent && !isSmartFoldersLoading && isSmartFoldersM1Enabled,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d3d1e674e88462f$export$c72baf511f2daf8c), {
                            appName: smartFolderConnectedSource.appName,
                            folderId: contentId,
                            fireAnalytics: fireSmartFolderMenuAnalytics,
                            onConfirmStopSyncing: handleSmartFolderStopSyncing,
                            compact: false,
                            properties: contentData?.properties?.nodes,
                            provider: smartFolderConnectedSource.provider
                        }))
                },
                {
                    name: (0, $9af26f5142ee161a$export$e242b9905c10e726),
                    shouldRender: (0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && !!allowedFeatures.showWatchDialog && !isCompanyHub && (contentType !== "folder" || (0, $6mKj3.expValEquals)("support_watching_of_parent_folders", "isEnabled", true)),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b864d3fa23503bf$export$f9409fd8f8b5a92d), {
                            isMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch,
                            contentId: contentId,
                            contentType: contentType,
                            spaceId: spaceId,
                            spaceKey: spaceKey,
                            setIsMenuOpen: setIsMenuOpen,
                            onMenuClose: handleNestedMenuItemClose,
                            onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch)
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$6bb183703c5072f1),
                    shouldRender: !isAccessLinkRequest && isLoggedIn && !isArchived && isContentViewOnlyPermissions && !isContentAccessRequestDisabled && !(isAuthenticatedWithoutConfluenceUser && (0, $6mKj3.expValEquals)("cc_fe_inconsistent_license_warning", "isEnabled", true)),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d3293071a1569ba$export$84d0de3613f64b9a), {
                            contentType: contentType,
                            contentId: contentId,
                            flags: flags,
                            triggerAnalyticsEvent: triggerAnalyticsEvent,
                            askToEditKey: (0, $9af26f5142ee161a$export$6bb183703c5072f1)
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$74317f458aa33c63),
                    shouldRender: (0, $ff966189b275be15$export$74e87e549c7a0f96)(contentType, contentMode) && !isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                            key: (0, $9af26f5142ee161a$export$74317f458aa33c63),
                            onClick: makePreviewContentHandler(onPreviewClicked),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4HbMh))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: (0, $9af26f5142ee161a$export$74317f458aa33c63),
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).PREVIEW
                                ]
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.previewLabel))
                },
                {
                    name: (0, $9af26f5142ee161a$export$461acb5c5f9c7b12),
                    shouldRender: isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                            key: (0, $9af26f5142ee161a$export$461acb5c5f9c7b12),
                            onClick: ()=>history?.push((0, $1NBp8.COMPANY_HUB_SETTINGS).toUrl(), {
                                    from: (0, $1NBp8.COMPANY_HUB_EDIT).name
                                }),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($11OF7))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.manageLabel))
                },
                {
                    name: (0, $9af26f5142ee161a$export$12b5e6890d8e049c),
                    shouldRender: !!customActionsMap[0, $9af26f5142ee161a$export$12b5e6890d8e049c],
                    component: ()=>{
                        const item = customActionsMap[0, $9af26f5142ee161a$export$12b5e6890d8e049c];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item,
                            key: item.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2x0Nk))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$f9e89fba7e6b4574),
                    shouldRender: (0, $ff966189b275be15$export$4a2abd609e31ae47)(contentType) && !!customActionsMap[0, $9af26f5142ee161a$export$f9e89fba7e6b4574],
                    component: ()=>{
                        const item_0 = customActionsMap[0, $9af26f5142ee161a$export$f9e89fba7e6b4574];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_0,
                            key: item_0.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$240b6ef4a1c531f6),
                    shouldRender: isPresentRendered && !!webItemsMap[0, $9af26f5142ee161a$export$240b6ef4a1c531f6],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                            attribution: (0, $3IBnw.Attribution).COMMENTS,
                            key: webItemsMap[0, $9af26f5142ee161a$export$240b6ef4a1c531f6].completeKey
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5KL6w.LazyPresenterModeContextConsumer), {
                            key: `presenter-mode-menu-item-${webItemsMap[0, $9af26f5142ee161a$export$240b6ef4a1c531f6].completeKey}`
                        }, (enterPresenterMode_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                id: (0, $9af26f5142ee161a$export$240b6ef4a1c531f6),
                                key: (0, $9af26f5142ee161a$export$240b6ef4a1c531f6),
                                onClick: makePresenterModeOpener(enterPresenterMode_0),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6omt0))), {
                                    label: ""
                                }),
                                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                                    shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT)
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.presentLabel))))
                },
                {
                    name: "viewEditToggle",
                    shouldShowSeparator: false,
                    shouldRender: Boolean(contentMode === "live" && hasEditPermission),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gDbO8.LivePagesModeChanger), {
                            contentId: contentId,
                            flags: flags,
                            analyticsSource: "livePagesEllipsisDropdown",
                            elemAfter: (0, $434c765ed6791bfa$export$d206439c03b979ee)
                        })
                }
            ];
            const actionsToRender = primaryActionsItems.filter($511857b10ace36ca$var$_temp3);
            return {
                key: "primary-actions",
                items: actionsToRender
            };
        };
        $[200] = allowedFeatures.showWatchDialog;
        $[201] = contentData?.properties?.nodes;
        $[202] = contentData?.title;
        $[203] = contentId;
        $[204] = contentMode;
        $[205] = contentType;
        $[206] = fireSmartFolderMenuAnalytics;
        $[207] = flags;
        $[208] = handleNestedMenuItemClick;
        $[209] = handleSmartFolderStopSyncing;
        $[210] = hasEditPermission;
        $[211] = history;
        $[212] = isAccessLinkRequest;
        $[213] = isArchived;
        $[214] = isAuthenticatedWithoutConfluenceUser;
        $[215] = isCompanyHub;
        $[216] = isContentAccessRequestDisabled;
        $[217] = isContentViewOnlyPermissions;
        $[218] = isDevDocsOwnedContent;
        $[219] = isLoggedIn;
        $[220] = isPresentRendered;
        $[221] = isSmartFolderContent;
        $[222] = isSmartFoldersLoading;
        $[223] = isSmartFoldersM1Enabled;
        $[224] = makePresenterModeOpener;
        $[225] = makePreviewContentHandler;
        $[226] = nestedPopup;
        $[227] = onPreviewClicked;
        $[228] = setIsMenuOpen;
        $[229] = shouldRenderStarContentMenuItem;
        $[230] = shouldRenderStarSpaceMenuItem;
        $[231] = smartFolderConnectedSource;
        $[232] = spaceId;
        $[233] = spaceKey;
        $[234] = triggerAnalyticsEvent;
        $[235] = t64;
    } else t64 = $[235];
    const primaryActionData = t64;
    let t65;
    if ($[236] !== allowedFeatures.showArchive || $[237] !== allowedFeatures.showCopy || $[238] !== allowedFeatures.showMove || $[239] !== contentCreationPanelMode || $[240] !== contentData?.title || $[241] !== contentId || $[242] !== contentMode || $[243] !== contentStatus || $[244] !== contentType || $[245] !== convertToMarkdown || $[246] !== convertToRichText || $[247] !== createAnalyticsEvent || $[248] !== flags || $[249] !== handleNestedMenuItemClick || $[250] !== hasArchivePermission || $[251] !== intl || $[252] !== isAccessLinkRequest || $[253] !== isCompanyHub || $[254] !== isContentCreationPanelOpen || $[255] !== isConvertToFolderHighlighted || $[256] !== isConvertToMarkdownShortcutEligible || $[257] !== isConvertToPageEligible || $[258] !== isConvertToRichTextShortcutEligible || $[259] !== isFreeUser || $[260] !== isLivePageViewOnlyPermissions || $[261] !== isMarkdownModeUpdating || $[262] !== isModernEmbeddedConfluence || $[263] !== isSmartFolderContent || $[264] !== isSpaceOverviewPage || $[265] !== nestedPopup || $[266] !== onArchiveClick || $[267] !== onClickOpenContentCreationPanel || $[268] !== onDeleteClick || $[269] !== publishPage || $[270] !== readOnly || $[271] !== renderMoveBlogModal || $[272] !== renderMovePageModal || $[273] !== setIsMenuOpen || $[274] !== spaceId || $[275] !== spaceKey) {
        t65 = (t66)=>{
            const { webItems: webItems, webItemsMap: webItemsMap_0, customActionsMap: customActionsMap_0 } = t66;
            const hasArchive = !isCompanyHub && ((0, $ff966189b275be15$export$32820bf57e654cf8)(contentType, contentMode) || isSmartFolderContent) && (hasArchivePermission || isFreeUser) && allowedFeatures.showArchive && !!webItemsMap_0[0, $9af26f5142ee161a$export$d81a93c80838b765];
            const hasDelete = !!webItemsMap_0[0, $9af26f5142ee161a$export$da4fec526a505196];
            const modifyActionsToRender = [
                {
                    name: (0, $9af26f5142ee161a$export$21b8b89e4603550f),
                    shouldRender: !!webItemsMap_0[0, $9af26f5142ee161a$export$21b8b89e4603550f],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${(0, $9af26f5142ee161a$export$21b8b89e4603550f)}`
                        }, (dialogs_7)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                key: (0, $9af26f5142ee161a$export$21b8b89e4603550f),
                                onClick: ()=>{
                                    createAnalyticsEvent({
                                        type: "sendUIEvent",
                                        data: {
                                            action: "clicked",
                                            actionSubject: "button",
                                            actionSubjectId: "overflowRestore",
                                            source: "overflowMenu",
                                            attributes: {
                                                isContentWrapper: true
                                            }
                                        }
                                    }).fire();
                                    dialogs_7.showModal((0, $1Zthr.UnarchivePagesDialogLoader), {
                                        contentId: contentId,
                                        source: "contentTypesHeader"
                                    });
                                },
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqeQP))), {
                                    label: ""
                                })
                            }, webItemsMap_0[0, $9af26f5142ee161a$export$21b8b89e4603550f].label))
                },
                {
                    name: (0, $9af26f5142ee161a$export$94db61d2b880af44),
                    shouldRender: allowedFeatures.showCopy && (0, $ff966189b275be15$export$a130e0ea03d42b0b)(contentType, contentMode) && (!!webItemsMap_0[0, $9af26f5142ee161a$export$94db61d2b880af44] || !!customActionsMap_0[0, $9af26f5142ee161a$export$2594f905f6c1490e]),
                    component: ()=>{
                        (0, $6mKj3.manuallyLogExpExposure)("make_a_copy_cta");
                        if (customActionsMap_0[0, $9af26f5142ee161a$export$2594f905f6c1490e]) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$3131530af790ffe2), {
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).CopyDatabase,
                            handleClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).CopyDatabase),
                            copyDatabaseItem: webItemsMap_0[0, $9af26f5142ee161a$export$94db61d2b880af44],
                            copyStructureItem: customActionsMap_0[0, $9af26f5142ee161a$export$2594f905f6c1490e],
                            setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                            contentMode: contentMode,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        });
                        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$36ee254e582a74c2), {
                            setIsCopyContentModalOpen: setIsCopyContentModalOpen,
                            closeParentMenu: ()=>setIsMenuOpen(false),
                            item: webItemsMap_0[0, $9af26f5142ee161a$export$94db61d2b880af44]
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$bcce08436c9de127),
                    shouldRender: !isAccessLinkRequest && !isLivePageViewOnlyPermissions && allowedFeatures.showMove && !isCompanyHub && (0, $ff966189b275be15$export$dec488a51a9b97f0)(contentType, contentMode) && !!webItemsMap_0[0, $9af26f5142ee161a$export$bcce08436c9de127],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${(0, $9af26f5142ee161a$export$bcce08436c9de127)}`
                        }, (dialogs_8)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                key: (0, $9af26f5142ee161a$export$bcce08436c9de127),
                                onClick: ()=>renderMovePageModal(dialogs_8),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
                                    label: ""
                                })
                            }, webItemsMap_0[0, $9af26f5142ee161a$export$bcce08436c9de127].label))
                },
                {
                    name: (0, $9af26f5142ee161a$export$c7733ea6d8e45875),
                    shouldRender: allowedFeatures.showMove && (0, $ff966189b275be15$export$dec488a51a9b97f0)(contentType, contentMode) && !!webItemsMap_0[0, $9af26f5142ee161a$export$c7733ea6d8e45875],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${(0, $9af26f5142ee161a$export$c7733ea6d8e45875)}`
                        }, (dialogs_9)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                key: (0, $9af26f5142ee161a$export$c7733ea6d8e45875),
                                onClick: ()=>renderMoveBlogModal(dialogs_9),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
                                    label: ""
                                })
                            }, webItemsMap_0[0, $9af26f5142ee161a$export$c7733ea6d8e45875].label))
                },
                {
                    name: (0, $9af26f5142ee161a$export$b1a4c392275ea35a),
                    shouldRender: (!(0, $6mKj3.expVal)("platform_editor_blocks_conf", "isEnabled", false) || contentType !== "page") && (0, $ff966189b275be15$export$f7bde71715697ce0)(contentType, contentMode, readOnly) && !isContentCreationPanelOpen && !isLivePageViewOnlyPermissions && (!(0, $1ggpj.isCanvasContentType)(contentType) || !!customActionsMap_0[0, $9af26f5142ee161a$export$d4cf3906d3082596] || !!customActionsMap_0[0, $9af26f5142ee161a$export$cce5e117e5e43bc]),
                    component: ()=>{
                        if (customActionsMap_0[0, $9af26f5142ee161a$export$be7385413e15c3ea]) {
                            customActionsMap_0[0, $9af26f5142ee161a$export$be7385413e15c3ea].text = intl.formatMessage($511857b10ace36ca$var$i18n.templatesImportLabel);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                                item: customActionsMap_0[0, $9af26f5142ee161a$export$be7385413e15c3ea],
                                key: (0, $9af26f5142ee161a$export$be7385413e15c3ea),
                                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))), {
                                    label: ""
                                })
                            });
                        } else {
                            if (customActionsMap_0[0, $9af26f5142ee161a$export$d4cf3906d3082596] || customActionsMap_0[0, $9af26f5142ee161a$export$cce5e117e5e43bc]) {
                                const nestedItems = [];
                                const createNestedItem = (actionKey)=>{
                                    const action = customActionsMap_0[actionKey];
                                    if (action) nestedItems.push({
                                        ...action,
                                        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                                                item: action,
                                                key: action.id
                                            })
                                    });
                                };
                                createNestedItem((0, $9af26f5142ee161a$export$d4cf3906d3082596));
                                createNestedItem((0, $9af26f5142ee161a$export$cce5e117e5e43bc));
                                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.templatesImportLabel),
                                    isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).TemplatesAndImport,
                                    onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).TemplatesAndImport),
                                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))), {
                                        label: ""
                                    }),
                                    items: nestedItems,
                                    onMenuClose: handleNestedMenuItemClose
                                });
                            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                key: (0, $9af26f5142ee161a$export$b1a4c392275ea35a),
                                onClick: ()=>onClickOpenContentCreationPanel?.(),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))), {
                                    label: ""
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.templatesImportLabel));
                        }
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$2728c726be07790),
                    shouldRender: contentType === "page" && (0, $ff966189b275be15$export$f7bde71715697ce0)(contentType, contentMode, readOnly) && !isLivePageViewOnlyPermissions && (!isContentCreationPanelOpen || contentCreationPanelMode === (0, $lJDEI.PANEL_MODE_IMPORT)) && (0, $6mKj3.expVal)("platform_editor_blocks_conf", "isEnabled", false),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                            key: (0, $9af26f5142ee161a$export$2728c726be07790),
                            onClick: ()=>onClickOpenContentCreationPanel?.((0, $lJDEI.PANEL_MODE_TEMPLATES)),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ivert))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.templatesLabel))
                },
                {
                    name: (0, $9af26f5142ee161a$export$f1ffcc01948271f7),
                    shouldRender: !isAccessLinkRequest && contentType === "page" && !isModernEmbeddedConfluence && (0, $ff966189b275be15$export$f7bde71715697ce0)(contentType, contentMode, readOnly) && !isLivePageViewOnlyPermissions && (!isContentCreationPanelOpen || contentCreationPanelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES)) && (0, $6mKj3.expVal)("platform_editor_blocks_conf", "isEnabled", false),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                            key: (0, $9af26f5142ee161a$export$f1ffcc01948271f7),
                            onClick: ()=>onClickOpenContentCreationPanel?.((0, $lJDEI.PANEL_MODE_IMPORT)),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.importLabel))
                },
                {
                    name: (0, $9af26f5142ee161a$export$10f4bed2ae52719b),
                    shouldRender: (0, $ff966189b275be15$export$d790dfbcfcf44b71)(contentType, contentMode) && !!webItemsMap_0[0, $9af26f5142ee161a$export$10f4bed2ae52719b],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $690df6788a087387$export$d91fa1ff1d654586), {
                            item: webItemsMap_0[0, $9af26f5142ee161a$export$10f4bed2ae52719b],
                            contentMode: contentMode,
                            flags: flags,
                            spaceId: spaceId,
                            spaceKey: spaceKey,
                            contentId: contentId,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$8ba85686c8897eca),
                    shouldRender: isConvertToPageEligible && !(0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                            key: (0, $9af26f5142ee161a$export$8ba85686c8897eca),
                            onClick: publishPage,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.convertToPage))
                },
                {
                    name: (0, $9af26f5142ee161a$export$6aee40c7c2e30c2b),
                    shouldRender: (isConvertToPageEligible || isConvertToMarkdownShortcutEligible || isConvertToRichTextShortcutEligible) && (0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true),
                    component: ()=>{
                        const convertToItems = [];
                        if (isConvertToPageEligible) convertToItems.push({
                            id: (0, $9af26f5142ee161a$export$8ba85686c8897eca),
                            label: "",
                            url: "",
                            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                    key: (0, $9af26f5142ee161a$export$8ba85686c8897eca),
                                    onClick: ()=>{
                                        setIsMenuOpen(false);
                                        publishPage?.();
                                    },
                                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
                                        label: ""
                                    })
                                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.convertToPage))
                        });
                        if (isConvertToMarkdownShortcutEligible) convertToItems.push({
                            id: (0, $9af26f5142ee161a$export$a4eecad100747ab0),
                            label: "",
                            url: "",
                            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                    key: (0, $9af26f5142ee161a$export$a4eecad100747ab0),
                                    onClick: ()=>{
                                        setIsMenuOpen(false);
                                        convertToMarkdown();
                                    },
                                    isDisabled: isMarkdownModeUpdating,
                                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2jY8x))), {
                                        label: ""
                                    }),
                                    elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                        id: (0, $9af26f5142ee161a$export$a4eecad100747ab0),
                                        shortcutKeys: [
                                            (0, $gnkil.UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT)
                                        ]
                                    })
                                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.convertToMarkdown))
                        });
                        if (isConvertToRichTextShortcutEligible) convertToItems.push({
                            id: (0, $9af26f5142ee161a$export$e1530e5397882a1f),
                            label: "",
                            url: "",
                            customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                    key: (0, $9af26f5142ee161a$export$e1530e5397882a1f),
                                    onClick: ()=>{
                                        setIsMenuOpen(false);
                                        convertToRichText();
                                    },
                                    isDisabled: isMarkdownModeUpdating,
                                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))), {
                                        label: ""
                                    }),
                                    elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                        id: (0, $9af26f5142ee161a$export$e1530e5397882a1f),
                                        shortcutKeys: [
                                            (0, $gnkil.UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT)
                                        ]
                                    })
                                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.convertToRichText))
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$7592eae6681a8aa2), {
                            items: convertToItems,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            handleNestedMenuItemClose: handleNestedMenuItemClose
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$3192aea0628d957a),
                    shouldRender: (0, $ff966189b275be15$export$78b7a39935e0bb86)(contentType, contentMode, isSpaceOverviewPage) && (!!webItemsMap_0[0, $9af26f5142ee161a$export$5497d83bbd1b1232] || !!webItemsMap_0[0, $9af26f5142ee161a$export$7767afe5b675f4b1] || !!webItemsMap_0[0, $9af26f5142ee161a$export$10f4bed2ae52719b]),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$1a264aaf74bdd787), {
                            webItemsMap: webItemsMap_0,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            spaceKey: spaceKey,
                            contentId: contentId,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            flags: flags,
                            spaceId: spaceId,
                            contentMode: contentMode,
                            closeParentMenu: ()=>setIsMenuOpen(false),
                            isConvertToFolderHighlighted: isConvertToFolderHighlighted
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$ab4fe2a2881747b5),
                    shouldRender: (0, $ff966189b275be15$export$58a134bd2769b459)(contentType, contentMode) && (0, $434c765ed6791bfa$export$fb577cf43b1d490f)(webItemsMap_0),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b945ccaa4d42d330), {
                            webItemsMap: webItemsMap_0,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            closeParentMenu: ()=>setIsMenuOpen(false),
                            contentId: contentId,
                            contentType: contentType,
                            contentMode: contentMode,
                            pageTitle: contentData?.title || "",
                            contentStatus: contentStatus
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$c1ca183de464b52d),
                    shouldRender: contentType === "slide" && (0, $9wGTI.fg)("cc-mui-slides-export") && !!customActionsMap_0[0, $9af26f5142ee161a$export$c1ca183de464b52d],
                    component: ()=>{
                        const item_2 = customActionsMap_0[0, $9af26f5142ee161a$export$c1ca183de464b52d];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_2,
                            key: item_2.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))), {
                                label: ""
                            }),
                            testId: "slides-export-to-pdf-button"
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$d588519b9727f1cc),
                    shouldRender: !!customActionsMap_0[0, $9af26f5142ee161a$export$d588519b9727f1cc],
                    component: ()=>{
                        const item_3 = customActionsMap_0[0, $9af26f5142ee161a$export$d588519b9727f1cc];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_3,
                            key: item_3.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
                                label: ""
                            }),
                            testId: "whiteboard-export-button"
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$f0ae5a9b5b44d373),
                    shouldRender: !!customActionsMap_0[0, $9af26f5142ee161a$export$f0ae5a9b5b44d373],
                    component: ()=>{
                        const item_4 = customActionsMap_0[0, $9af26f5142ee161a$export$f0ae5a9b5b44d373];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_4,
                            key: item_4.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$e07ca208ff99048e),
                    shouldRender: !!customActionsMap_0[0, $9af26f5142ee161a$export$e07ca208ff99048e],
                    component: ()=>{
                        const item_5 = customActionsMap_0[0, $9af26f5142ee161a$export$e07ca208ff99048e];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_5,
                            key: item_5.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
                                label: ""
                            }),
                            testId: "database-export-button"
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$d81a93c80838b765),
                    shouldRender: hasArchive && !hasDelete,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$f4be76d677f42fda), {
                            onArchiveClick: onArchiveClick
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$da4fec526a505196),
                    shouldRender: hasDelete && !hasArchive,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$5ac124715785374c), {
                            contentMode: contentMode,
                            onDeleteClick: onDeleteClick,
                            createAnalyticsEvent: createAnalyticsEvent
                        })
                },
                {
                    name: $511857b10ace36ca$var$COMBINED_ACTION_ARCHIVE,
                    shouldRender: hasArchive && hasDelete,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$a05f0dd30396f811), {
                            webItems: webItems,
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Archive,
                            handleClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Archive),
                            onArchiveClick: onArchiveClick,
                            onDeleteClick: onDeleteClick,
                            contentMode: contentMode,
                            createAnalyticsEvent: createAnalyticsEvent,
                            handleNestedMenuItemClose: handleNestedMenuItemClose
                        })
                }
            ];
            const actionsToRender_0 = modifyActionsToRender.filter($511857b10ace36ca$var$_temp4);
            return {
                key: "modify-actions",
                items: actionsToRender_0
            };
        };
        $[236] = allowedFeatures.showArchive;
        $[237] = allowedFeatures.showCopy;
        $[238] = allowedFeatures.showMove;
        $[239] = contentCreationPanelMode;
        $[240] = contentData?.title;
        $[241] = contentId;
        $[242] = contentMode;
        $[243] = contentStatus;
        $[244] = contentType;
        $[245] = convertToMarkdown;
        $[246] = convertToRichText;
        $[247] = createAnalyticsEvent;
        $[248] = flags;
        $[249] = handleNestedMenuItemClick;
        $[250] = hasArchivePermission;
        $[251] = intl;
        $[252] = isAccessLinkRequest;
        $[253] = isCompanyHub;
        $[254] = isContentCreationPanelOpen;
        $[255] = isConvertToFolderHighlighted;
        $[256] = isConvertToMarkdownShortcutEligible;
        $[257] = isConvertToPageEligible;
        $[258] = isConvertToRichTextShortcutEligible;
        $[259] = isFreeUser;
        $[260] = isLivePageViewOnlyPermissions;
        $[261] = isMarkdownModeUpdating;
        $[262] = isModernEmbeddedConfluence;
        $[263] = isSmartFolderContent;
        $[264] = isSpaceOverviewPage;
        $[265] = nestedPopup;
        $[266] = onArchiveClick;
        $[267] = onClickOpenContentCreationPanel;
        $[268] = onDeleteClick;
        $[269] = publishPage;
        $[270] = readOnly;
        $[271] = renderMoveBlogModal;
        $[272] = renderMovePageModal;
        $[273] = setIsMenuOpen;
        $[274] = spaceId;
        $[275] = spaceKey;
        $[276] = t65;
    } else t65 = $[276];
    const modifyActionData = t65;
    let t66;
    if ($[277] !== contentMode) {
        t66 = (customActionsMap_1)=>[
                {
                    name: (0, $9af26f5142ee161a$export$6563b47d35bee4f1),
                    shouldRender: !!customActionsMap_1[0, $9af26f5142ee161a$export$6563b47d35bee4f1] && contentMode !== "archived",
                    component: ()=>{
                        const item_7 = customActionsMap_1[0, $9af26f5142ee161a$export$6563b47d35bee4f1];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_7,
                            key: item_7.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$fe723f15ba37849b),
                    shouldRender: !!customActionsMap_1[0, $9af26f5142ee161a$export$fe723f15ba37849b] && contentMode !== "archived",
                    component: ()=>{
                        const item_8 = customActionsMap_1[0, $9af26f5142ee161a$export$fe723f15ba37849b];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_8,
                            key: item_8.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAKDg))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$d7bae9f2073f40be),
                    shouldRender: !!customActionsMap_1[0, $9af26f5142ee161a$export$d7bae9f2073f40be],
                    component: ()=>{
                        const item_9 = customActionsMap_1[0, $9af26f5142ee161a$export$d7bae9f2073f40be];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_9,
                            key: item_9.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
                                label: ""
                            })
                        });
                    }
                }
            ];
        $[277] = contentMode;
        $[278] = t66;
    } else t66 = $[278];
    const getDatabaseActionItems = t66;
    let t67;
    if ($[279] !== contentData?.operations || $[280] !== contentData?.title || $[281] !== contentId || $[282] !== contentMode || $[283] !== contentType || $[284] !== createAnalyticsEvent || $[285] !== experienceTracker || $[286] !== handleNestedMenuItemClick || $[287] !== handleViewVersionHistory || $[288] !== intl || $[289] !== isAccessLinkRequest || $[290] !== isAllowed || $[291] !== isCommentsEnabled || $[292] !== isLivePage || $[293] !== isLivePageViewOnlyPermissions || $[294] !== isLoggedIn || $[295] !== isMenuOpen || $[296] !== isPageOrBlogAutoConverted || $[297] !== isPremiumUser || $[298] !== isSpaceOverviewPage || $[299] !== isVersionHistoryEnabled || $[300] !== makeInlineCommentsDialogOpener || $[301] !== nestedPopup || $[302] !== onRevertClick || $[303] !== onRevertToLegacyEditorClick || $[304] !== saveDraft || $[305] !== setIsMenuOpen || $[306] !== spaceKey) {
        t67 = (t68)=>{
            const { webItemsMap: webItemsMap_1, customActionsMap: customActionsMap_2, webItems: webItems_0 } = t68;
            const hasEditPermissionRevertToLegacyEditor = contentData?.operations?.some((operation_1)=>operation_1?.targetType === contentType && operation_1?.operation === "update");
            const secondaryActionItems = [
                {
                    name: (0, $aYZaZ.Buttons).VIEW_CHANGES,
                    shouldRender: !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$caca47bf68c8998)(contentType, contentMode) && isAllowed((0, $aYZaZ.Buttons).VIEW_CHANGES),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: (0, $aYZaZ.Buttons).VIEW_CHANGES
                        }, (dialogs_10)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$f28b24dc0422311f), {
                                contentId: contentId,
                                dialogs: dialogs_10,
                                saveDraft: saveDraft,
                                createAnalyticsEvent: createAnalyticsEvent
                            }))
                },
                {
                    name: (0, $9af26f5142ee161a$export$c9981a2480d638b0),
                    shouldRender: (0, $ff966189b275be15$export$d0c33a26470e0efe)(contentType, contentMode),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                            key: (0, $9af26f5142ee161a$export$c9981a2480d638b0),
                            onClick: onRevertClick,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.revertLabel))
                },
                {
                    name: (0, $9af26f5142ee161a$export$a751f1adb88d1383),
                    shouldRender: isCommentsEnabled && !!webItemsMap_1[0, $9af26f5142ee161a$export$a751f1adb88d1383],
                    component: ()=>{
                        const item_10 = webItemsMap_1[0, $9af26f5142ee161a$export$a751f1adb88d1383];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ],
                            key: `container-${item_10.id}`
                        }, (dialogs_11)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                key: item_10.id,
                                onClick: ()=>{
                                    if ((0, $1ggpj.isCanvasContentType)(contentType) || contentType === "database") makeInlineCommentsDialogOpener(dialogs_11, contentType);
                                },
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                                    label: ""
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$ResolvedCommentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$ResolvedCommentsLabelContainer, null, item_10.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BVDK.ResolvedInlineCommentsCounterLoader), {
                                contentId: contentId
                            }))));
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$e14cf657321c833b),
                    shouldRender: isVersionHistoryEnabled && !!webItemsMap_1[0, $9af26f5142ee161a$export$e14cf657321c833b],
                    component: ()=>{
                        const item_11 = webItemsMap_1[0, $9af26f5142ee161a$export$e14cf657321c833b];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                            key: item_11.id,
                            onClick: handleViewVersionHistory,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.versionHistoryLabel));
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$fc2e34cd983af5d6),
                    shouldRender: !isAccessLinkRequest && (0, $ff966189b275be15$export$458bbd6d88041c9d)(contentType, contentMode) && !!webItemsMap_1[0, $9af26f5142ee161a$export$fc2e34cd983af5d6],
                    component: ()=>{
                        const item_12 = webItemsMap_1[0, $9af26f5142ee161a$export$fc2e34cd983af5d6];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac5cc0f86197b0c1$export$ea7f8a8a3c6349fc), {
                            itemId: item_12?.id,
                            itemUrl: item_12?.url,
                            label: intl.formatMessage($511857b10ace36ca$var$i18n.versionHistoryLabel),
                            isLivePage: isLivePage,
                            contentType: contentType
                        });
                    }
                },
                {
                    name: (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID),
                    shouldRender: !isLivePageViewOnlyPermissions && (0, $ff966189b275be15$export$11233ac17765daec)(contentType) && !!webItemsMap_1[0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$2ca3e90bac67fd87), {
                            key: (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID),
                            item: webItemsMap_1[0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID],
                            nestedPopup: nestedPopup,
                            setNestedPopup: setNestedPopup,
                            contentId: contentId,
                            setIsMenuOpen: setIsMenuOpen
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$fe0a3b90b0b6010b),
                    shouldRender: isPremiumUser && isLoggedIn && (0, $ff966189b275be15$export$bb21210c1c36f22a)(contentType, contentMode, isSpaceOverviewPage),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$7e059d95fddc01f4), {
                            experienceTracker: experienceTracker,
                            contentId: contentId,
                            spaceKey: spaceKey,
                            pageTitle: contentData?.title || ""
                        })
                },
                {
                    name: (0, $9af26f5142ee161a$export$fe2b6e9bf8b31ecc),
                    shouldRender: (0, $6mKj3.expVal)("confluence_tinymce_deprecation_phase", "value", 0) < 3 && hasEditPermissionRevertToLegacyEditor && (0, $ff966189b275be15$export$493ddb7a4c710fed)(contentType, contentMode, isAllowed((0, $aYZaZ.Buttons).DELETE_DRAFT), (0, $6mKj3.expValEquals)("confluence_auto_convert_legacy_draft_fix_fe", "isEnabled", true)) && isPageOrBlogAutoConverted,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                            attribution: (0, $3IBnw.Attribution).CC_EDITOR_AI,
                            key: "revert-to-legacy-editor-menu-item"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ]
                        }, (dialogs_12)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                key: (0, $9af26f5142ee161a$export$c9981a2480d638b0),
                                onClick: ()=>onRevertToLegacyEditorClick(dialogs_12),
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
                                    label: ""
                                })
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.revertEditor))))
                },
                {
                    name: (0, $9af26f5142ee161a$export$52e1dc7e5d9b8b02),
                    shouldRender: !isAccessLinkRequest && (0, $ff966189b275be15$export$49f8860e43af4419)(contentType, contentMode),
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$f404e2d5b48ab522), {
                            webItemsMap: webItemsMap_1,
                            handleNestedMenuItemClick: handleNestedMenuItemClick,
                            nestedPopup: nestedPopup,
                            handleNestedMenuItemClose: handleNestedMenuItemClose,
                            closeParentMenu: ()=>setIsMenuOpen(false)
                        })
                },
                (0, $434c765ed6791bfa$export$f26eff3587fe7632)({
                    isAppsRendered: !isAccessLinkRequest && (0, $ff966189b275be15$export$8623af461a2f6a54)(contentType, contentMode),
                    spaceKey: spaceKey,
                    contentId: contentId,
                    isMenuOpen: isMenuOpen,
                    handleNestedMenuItemClick: handleNestedMenuItemClick,
                    nestedPopup: nestedPopup,
                    items: webItems_0,
                    createAnalyticsEvent: createAnalyticsEvent,
                    handleNestedMenuItemClose: handleNestedMenuItemClose,
                    closeParentMenu: ()=>setIsMenuOpen(false)
                }),
                {
                    name: (0, $9af26f5142ee161a$export$23eaedbb3a44a3b5),
                    shouldRender: !!customActionsMap_2[0, $9af26f5142ee161a$export$23eaedbb3a44a3b5],
                    component: ()=>{
                        const item_13 = customActionsMap_2[0, $9af26f5142ee161a$export$23eaedbb3a44a3b5];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_13,
                            key: item_13.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                                label: ""
                            })
                        });
                    }
                }
            ];
            const actionsToRender_1 = secondaryActionItems.filter($511857b10ace36ca$var$_temp5);
            return {
                key: "secondary-actions",
                items: actionsToRender_1
            };
        };
        $[279] = contentData?.operations;
        $[280] = contentData?.title;
        $[281] = contentId;
        $[282] = contentMode;
        $[283] = contentType;
        $[284] = createAnalyticsEvent;
        $[285] = experienceTracker;
        $[286] = handleNestedMenuItemClick;
        $[287] = handleViewVersionHistory;
        $[288] = intl;
        $[289] = isAccessLinkRequest;
        $[290] = isAllowed;
        $[291] = isCommentsEnabled;
        $[292] = isLivePage;
        $[293] = isLivePageViewOnlyPermissions;
        $[294] = isLoggedIn;
        $[295] = isMenuOpen;
        $[296] = isPageOrBlogAutoConverted;
        $[297] = isPremiumUser;
        $[298] = isSpaceOverviewPage;
        $[299] = isVersionHistoryEnabled;
        $[300] = makeInlineCommentsDialogOpener;
        $[301] = nestedPopup;
        $[302] = onRevertClick;
        $[303] = onRevertToLegacyEditorClick;
        $[304] = saveDraft;
        $[305] = setIsMenuOpen;
        $[306] = spaceKey;
        $[307] = t67;
    } else t67 = $[307];
    const secondaryActionData = t67;
    let t68;
    if ($[308] !== getDatabaseActionItems) {
        t68 = (t69)=>{
            const { customActionsMap: customActionsMap_3 } = t69;
            const databaseActionItems = getDatabaseActionItems(customActionsMap_3);
            const actionsToRender_2 = databaseActionItems.filter($511857b10ace36ca$var$_temp6);
            return {
                key: "database-actions",
                items: actionsToRender_2
            };
        };
        $[308] = getDatabaseActionItems;
        $[309] = t68;
    } else t68 = $[309];
    const databaseActionData = t68;
    let t69;
    if ($[310] !== contentMode || $[311] !== contentType || $[312] !== editorActivateFindReplace || $[313] !== hasEditPermission || $[314] !== hasUpdateOperation || $[315] !== isAIEarlyAccessEnabled || $[316] !== isAdminHubAIEnabled || $[317] !== livePageMode) {
        t69 = ()=>{
            const isFindOnlyInLiveView = contentMode === "live" && livePageMode === "view" && (0, $2pQiO.UNSAFE_expValNoExposure)("platform_editor_collapsible_headings", "isEnabled", false);
            const editorActionItems = [
                {
                    name: (0, $9af26f5142ee161a$export$8f2c4b97a6e00f7f),
                    shouldRender: (0, $ff966189b275be15$export$71ad62dbe8638043)(contentType, contentMode, hasEditPermission, livePageMode) && !!editorActivateFindReplace,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                            key: (0, $9af26f5142ee161a$export$8f2c4b97a6e00f7f),
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                                label: ""
                            }),
                            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$d206439c03b979ee), {
                                id: (0, $9af26f5142ee161a$export$8f2c4b97a6e00f7f),
                                shortcutKeys: [
                                    (0, $gnkil.EDITOR2_SHORTCUTS).FIND_REPLACE
                                ]
                            }),
                            onClick: async ()=>{
                                editorActivateFindReplace?.();
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isFindOnlyInLiveView ? $511857b10ace36ca$var$i18n.editorFindLabel : $511857b10ace36ca$var$i18n.editorFindReplaceLabel))
                },
                {
                    name: (0, $9af26f5142ee161a$export$ae5f0093bbf45ce8),
                    shouldRender: isAdminHubAIEnabled && isAIEarlyAccessEnabled && (contentType === "page" || contentType === "blogpost") && (contentMode === "view" || contentMode === "live" || contentMode === "edit") && Boolean(hasUpdateOperation(contentType)) && (0, $9wGTI.fg)("post-office_enable_edit-with-mcp-discovery"),
                    component: $511857b10ace36ca$var$_temp7
                }
            ];
            const actionsToRender_3 = editorActionItems.filter($511857b10ace36ca$var$_temp8);
            return {
                key: "editor-actions",
                items: actionsToRender_3
            };
        };
        $[310] = contentMode;
        $[311] = contentType;
        $[312] = editorActivateFindReplace;
        $[313] = hasEditPermission;
        $[314] = hasUpdateOperation;
        $[315] = isAIEarlyAccessEnabled;
        $[316] = isAdminHubAIEnabled;
        $[317] = livePageMode;
        $[318] = t69;
    } else t69 = $[318];
    const editorActionData = t69;
    let t70;
    if ($[319] !== contentType || $[320] !== handleNestedMenuItemClick || $[321] !== intl || $[322] !== isCompanyHub || $[323] !== nestedPopup || $[324] !== openCompanyHubFeedbackCollector) {
        t70 = (t71)=>{
            const { webItemsMap: webItemsMap_2, customActionsMap: customActionsMap_4, actions: actions } = t71;
            const additionalActionItems = [
                {
                    name: (0, $9af26f5142ee161a$export$84c7eab054d974db),
                    shouldRender: (0, $ff966189b275be15$export$46e46e0c15d57a1)(contentType) && !!webItemsMap_2[0, $9af26f5142ee161a$export$84c7eab054d974db],
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                            to: [
                                (0, $kRW4Y.DialogsStateContainer)
                            ]
                        }, (dialogs_13)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                                key: (0, $9af26f5142ee161a$export$84c7eab054d974db),
                                onClick: ()=>{
                                    onFeedbackClick(dialogs_13, contentType);
                                },
                                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f3HCt))), {
                                    label: ""
                                })
                            }, webItemsMap_2[0, $9af26f5142ee161a$export$84c7eab054d974db].label))
                },
                {
                    name: (0, $9af26f5142ee161a$export$5f2e846fff4ab830),
                    shouldRender: (0, $ff966189b275be15$export$1711931c27adfab0)(contentType) && !!customActionsMap_4[0, $9af26f5142ee161a$export$5f2e846fff4ab830],
                    component: ()=>{
                        const items = actions.flat().map($511857b10ace36ca$var$_temp9);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcd7f3eccb1861ca$export$49b1344a56b06112), {
                            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.help),
                            isNestedMenuOpen: nestedPopup === (0, $434c765ed6791bfa$export$8bf1ff90935c8832).Help,
                            onClick: ()=>handleNestedMenuItemClick((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Help),
                            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
                                label: ""
                            }),
                            items: items,
                            onMenuClose: handleNestedMenuItemClose
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$95f3debc4a615fda),
                    shouldRender: (0, $ff966189b275be15$export$1711931c27adfab0)(contentType) && !!customActionsMap_4[0, $9af26f5142ee161a$export$95f3debc4a615fda],
                    component: ()=>{
                        customActionsMap_4[0, $9af26f5142ee161a$export$95f3debc4a615fda].text = intl.formatMessage($511857b10ace36ca$var$i18n.help);
                        const item_17 = customActionsMap_4[0, $9af26f5142ee161a$export$95f3debc4a615fda];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_17,
                            key: item_17.id,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
                                label: ""
                            })
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$54ed9c94f2cfe2b6),
                    shouldRender: !!customActionsMap_4[0, $9af26f5142ee161a$export$54ed9c94f2cfe2b6],
                    component: ()=>{
                        const item_18 = customActionsMap_4[0, $9af26f5142ee161a$export$54ed9c94f2cfe2b6];
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                            item: item_18,
                            key: item_18.id
                        });
                    }
                },
                {
                    name: (0, $9af26f5142ee161a$export$654801d4f89a934),
                    shouldRender: isCompanyHub,
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                            key: (0, $9af26f5142ee161a$export$654801d4f89a934),
                            onClick: openCompanyHubFeedbackCollector,
                            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f3HCt))), {
                                label: ""
                            })
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.companyHubFeedback))
                }
            ];
            const actionsToRender_4 = additionalActionItems.filter($511857b10ace36ca$var$_temp0);
            return {
                key: "additional-items",
                items: actionsToRender_4
            };
        };
        $[319] = contentType;
        $[320] = handleNestedMenuItemClick;
        $[321] = intl;
        $[322] = isCompanyHub;
        $[323] = nestedPopup;
        $[324] = openCompanyHubFeedbackCollector;
        $[325] = t70;
    } else t70 = $[325];
    const feedbackActionData = t70;
    let t71;
    if ($[326] !== contentId || $[327] !== contentType || $[328] !== createAnalyticsEvent || $[329] !== spaceId) {
        t71 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "reportAbuse",
                    source: "moreActionsMenu",
                    objectId: contentId,
                    objectType: contentType,
                    containerId: spaceId
                }
            }).fire();
        };
        $[326] = contentId;
        $[327] = contentType;
        $[328] = createAnalyticsEvent;
        $[329] = spaceId;
        $[330] = t71;
    } else t71 = $[330];
    const onReportAbuseClick = t71;
    let t72;
    if ($[331] !== contentId || $[332] !== contentType || $[333] !== onReportAbuseClick) {
        t72 = ()=>({
                key: "report-abuse",
                items: [
                    {
                        name: (0, $9af26f5142ee161a$export$22a5e799bdd9dd62),
                        shouldRender: true,
                        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $871972f40e17ae63$export$fe18dbd7a0492bf0), {
                                contentId: contentId,
                                contentType: contentType,
                                onClick: onReportAbuseClick
                            })
                    }
                ]
            });
        $[331] = contentId;
        $[332] = contentType;
        $[333] = onReportAbuseClick;
        $[334] = t72;
    } else t72 = $[334];
    const reportAbuseActionData = t72;
    let t73;
    if ($[335] !== databaseActionData || $[336] !== editorActionData || $[337] !== feedbackActionData || $[338] !== modifyActionData || $[339] !== moreActions?.items || $[340] !== primaryActionData || $[341] !== reportAbuseActionData || $[342] !== secondaryActionData) {
        t73 = (t74)=>{
            const { webItems: webItems_1 } = t74;
            const webItemsMap_3 = $511857b10ace36ca$var$createActionsMap(webItems_1);
            const customActionsToRender = moreActions?.items?.flat() ?? [];
            const customActionsMap_5 = $511857b10ace36ca$var$createActionsMap(customActionsToRender);
            const [, , , feedbackCustomActions] = moreActions?.items ?? [];
            const actionGroupsToRender = [];
            const primaryActionGroup = primaryActionData({
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5
            });
            if (primaryActionGroup.items.length > 0) actionGroupsToRender.push(primaryActionGroup);
            const editorActionGroup = editorActionData();
            if (editorActionGroup.items.length > 0) actionGroupsToRender.push(editorActionGroup);
            const databaseActionGroup = databaseActionData({
                customActionsMap: customActionsMap_5
            });
            if (databaseActionGroup.items.length > 0) actionGroupsToRender.push(databaseActionGroup);
            const secondaryActionGroup = secondaryActionData({
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5,
                webItems: webItems_1
            });
            if (secondaryActionGroup.items.length > 0) actionGroupsToRender.push(secondaryActionGroup);
            const modifyActionGroup = modifyActionData({
                webItems: webItems_1,
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5
            });
            if (modifyActionGroup.items.length > 0) actionGroupsToRender.push(modifyActionGroup);
            const feedbackActionGroup = feedbackActionData({
                webItemsMap: webItemsMap_3,
                customActionsMap: customActionsMap_5,
                actions: feedbackCustomActions ?? []
            });
            if (feedbackActionGroup.items.length > 0) actionGroupsToRender.push(feedbackActionGroup);
            actionGroupsToRender.push(reportAbuseActionData());
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $511857b10ace36ca$var$dropdownMenuContentStyles
            }, actionGroupsToRender.map($511857b10ace36ca$var$_temp10)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.CONTENT_OVERFLOW_MENU)
            }));
        };
        $[335] = databaseActionData;
        $[336] = editorActionData;
        $[337] = feedbackActionData;
        $[338] = modifyActionData;
        $[339] = moreActions?.items;
        $[340] = primaryActionData;
        $[341] = reportAbuseActionData;
        $[342] = secondaryActionData;
        $[343] = t73;
    } else t73 = $[343];
    const renderActions = t73;
    let t74;
    if ($[344] === Symbol.for("react.memo_cache_sentinel")) {
        t74 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_OVERFLOW_MENU)
        });
        $[344] = t74;
    } else t74 = $[344];
    let t75;
    if ($[345] !== error) {
        t75 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.CONTENT_OVERFLOW_MENU),
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }));
        $[345] = error;
        $[346] = t75;
    } else t75 = $[346];
    let t76;
    if ($[347] !== isLivePage || $[348] !== isPresentRendered || $[349] !== isWebItemsQueryCalled || $[350] !== preloadWebItems) {
        t76 = isPresentRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: !isLivePage ? (0, $gnkil.PRESENTATION_MODE_SHORTCUT) : undefined,
            accelerator: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_PRESENTATION_MODE_SHORTCUT),
            listener: ()=>{
                if (!isWebItemsQueryCalled) preloadWebItems();
                setIsShortcutTriggered(true);
            }
        });
        $[347] = isLivePage;
        $[348] = isPresentRendered;
        $[349] = isWebItemsQueryCalled;
        $[350] = preloadWebItems;
        $[351] = t76;
    } else t76 = $[351];
    let t77;
    if ($[352] !== handleToggleMarkdownModeShortcut || $[353] !== isMarkdownToggleShortcutEnabled) {
        t77 = isMarkdownToggleShortcutEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT),
            listener: handleToggleMarkdownModeShortcut
        });
        $[352] = handleToggleMarkdownModeShortcut;
        $[353] = isMarkdownToggleShortcutEnabled;
        $[354] = t77;
    } else t77 = $[354];
    let t78;
    if ($[355] !== contentData?.title || $[356] !== contentId || $[357] !== contentMode || $[358] !== contentType || $[359] !== shouldRenderStarContentMenuItem) {
        t78 = shouldRenderStarContentMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $85cfaddd6945fc1f$export$2846eba8e457bfb), {
            contentId: contentId,
            contentTitle: contentData?.title || "",
            contentMode: contentMode,
            contentType: contentType
        });
        $[355] = contentData?.title;
        $[356] = contentId;
        $[357] = contentMode;
        $[358] = contentType;
        $[359] = shouldRenderStarContentMenuItem;
        $[360] = t78;
    } else t78 = $[360];
    let t79;
    if ($[361] !== contentMode || $[362] !== shouldRenderStarSpaceMenuItem || $[363] !== spaceKey) {
        t79 = shouldRenderStarSpaceMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6d97f54b872b96e$export$385015a3c6790101), {
            spaceKey: spaceKey,
            contentMode: contentMode
        });
        $[361] = contentMode;
        $[362] = shouldRenderStarSpaceMenuItem;
        $[363] = spaceKey;
        $[364] = t79;
    } else t79 = $[364];
    let t80;
    if ($[365] !== contentId || $[366] !== contentMode || $[367] !== contentType || $[368] !== isMenuOpen || $[369] !== setIsMenuOpen) {
        t80 = (0, $ff966189b275be15$export$3d371a49efa2fa0a)(contentType, contentMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3krUE.LazyWatchSettingsOverflowMenuShortcut), {
            contentId: contentId,
            contentType: contentType,
            openWatchSettingsMenu: ()=>{
                if (!isMenuOpen) setIsMenuOpen(true);
                setNestedPopup((0, $434c765ed6791bfa$export$8bf1ff90935c8832).Watch);
            }
        });
        $[365] = contentId;
        $[366] = contentMode;
        $[367] = contentType;
        $[368] = isMenuOpen;
        $[369] = setIsMenuOpen;
        $[370] = t80;
    } else t80 = $[370];
    let t81;
    if ($[371] === Symbol.for("react.memo_cache_sentinel")) {
        t81 = [
            (0, $kRW4Y.DialogsStateContainer)
        ];
        $[371] = t81;
    } else t81 = $[371];
    let t82;
    if ($[372] !== contentId || $[373] !== contentMode || $[374] !== isMenuOpen || $[375] !== livePageMode || $[376] !== openLinkToThisPageDialog || $[377] !== spaceKey) {
        t82 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t81
        }, (dialogs_14)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
                deprecatedAccelerator: contentMode === "view" || contentMode === "live" && livePageMode === "view" ? (0, $gnkil.LINK_TO_THIS_PAGE_SHORTCUT) : undefined,
                accelerator: (0, $gnkil.UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT),
                listener: openLinkToThisPageDialog(dialogs_14)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TN2N.LazyForgeContentTools), {
                spaceKey: spaceKey,
                contentId: contentId,
                onLoadComplete: $511857b10ace36ca$var$_temp11,
                isDropdownMenuOpen: isMenuOpen,
                lazyLoaderPlaceholderComponent: ""
            }, $511857b10ace36ca$var$_temp13)));
        $[372] = contentId;
        $[373] = contentMode;
        $[374] = isMenuOpen;
        $[375] = livePageMode;
        $[376] = openLinkToThisPageDialog;
        $[377] = spaceKey;
        $[378] = t82;
    } else t82 = $[378];
    let t83;
    if ($[379] !== activeSpotlight || $[380] !== contentId || $[381] !== handleOpenChange || $[382] !== isMenuOpen || $[383] !== isModernEmbeddedConfluence || $[384] !== loading || $[385] !== preloadWebItems || $[386] !== renderActions) {
        t83 = !isModernEmbeddedConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            onMouseEnter: preloadWebItems
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            shouldRenderToParent: (0, $9wGTI.fg)("a11y-fixes-october-2026"),
            strategy: (0, $9wGTI.fg)("a11y-fixes-october-2026") ? "absolute" : undefined,
            isOpen: isMenuOpen,
            onOpenChange: handleOpenChange,
            trigger: $511857b10ace36ca$var$_temp14,
            placement: "bottom-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            "data-testid": "web-actions-test",
            contentId: contentId,
            location: (0, $eSLr0.TOOLS_MENU_CONTAINER),
            fetchPolicy: "cache-and-network",
            renderWhenLoading: true
        }, (t84)=>{
            const { webItems: webItems_2 } = t84;
            if (loading || !webItems_2 || webItems_2.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownMenuContentSkeleton, null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderActions({
                webItems: webItems_2
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, activeSpotlight));
        })));
        $[379] = activeSpotlight;
        $[380] = contentId;
        $[381] = handleOpenChange;
        $[382] = isMenuOpen;
        $[383] = isModernEmbeddedConfluence;
        $[384] = loading;
        $[385] = preloadWebItems;
        $[386] = renderActions;
        $[387] = t83;
    } else t83 = $[387];
    let t84;
    if ($[388] !== isCopyContentModalOpen || $[389] !== renderCopyContentModal) {
        t84 = isCopyContentModalOpen && renderCopyContentModal();
        $[388] = isCopyContentModalOpen;
        $[389] = renderCopyContentModal;
        $[390] = t84;
    } else t84 = $[390];
    let t85;
    if ($[391] !== isMoveContentModalOpen || $[392] !== renderMoveContentModal) {
        t85 = isMoveContentModalOpen && renderMoveContentModal();
        $[391] = isMoveContentModalOpen;
        $[392] = renderMoveContentModal;
        $[393] = t85;
    } else t85 = $[393];
    let t86;
    if ($[394] !== renderConvertMarkdownModeDialog) {
        t86 = (0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true) && renderConvertMarkdownModeDialog();
        $[394] = renderConvertMarkdownModeDialog;
        $[395] = t86;
    } else t86 = $[395];
    let t87;
    if ($[396] !== t75 || $[397] !== t76 || $[398] !== t77 || $[399] !== t78 || $[400] !== t79 || $[401] !== t80 || $[402] !== t82 || $[403] !== t83 || $[404] !== t84 || $[405] !== t85 || $[406] !== t86) {
        t87 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t74, t75, t76, t77, t78, t79, t80, t82, t83, t84, t85, t86);
        $[396] = t75;
        $[397] = t76;
        $[398] = t77;
        $[399] = t78;
        $[400] = t79;
        $[401] = t80;
        $[402] = t82;
        $[403] = t83;
        $[404] = t84;
        $[405] = t85;
        $[406] = t86;
        $[407] = t87;
    } else t87 = $[407];
    return t87;
};
const $511857b10ace36ca$var$DropdownMenuTrigger = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { triggerProps: triggerProps } = t0;
    let props;
    let triggerRef;
    if ($[0] !== triggerProps) {
        ({ triggerRef: triggerRef, ...props } = triggerProps);
        $[0] = triggerProps;
        $[1] = props;
        $[2] = triggerRef;
    } else {
        props = $[1];
        triggerRef = $[2];
    }
    const buttonRef = (0, $cozmU.useRef)(null);
    const intl = (0, $kSwu1.useIntl)();
    const { isPresenterModeActive: isPresenterModeActive, hasEnteredPresentMode: hasEnteredPresentMode } = (0, $5KL6w.usePresenterModeContext)();
    const [t1] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t1;
    const isNetworkDisabled = isCollabOffline;
    let t2;
    let t3;
    if ($[3] !== hasEnteredPresentMode || $[4] !== isPresenterModeActive) {
        t2 = ()=>{
            if (!isPresenterModeActive && hasEnteredPresentMode && buttonRef?.current) buttonRef.current?.focus();
        };
        t3 = [
            isPresenterModeActive,
            hasEnteredPresentMode
        ];
        $[3] = hasEnteredPresentMode;
        $[4] = isPresenterModeActive;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $511857b10ace36ca$var$i18n.triggerLabel);
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== intl) {
        t5 = intl.formatMessage($511857b10ace36ca$var$i18n.triggerLabel);
        $[8] = intl;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== triggerRef) {
        t6 = (0, $4nIKB.mergeRefs)([
            triggerRef,
            buttonRef
        ]);
        $[10] = triggerRef;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== isNetworkDisabled || $[13] !== props || $[14] !== t5 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $511857b10ace36ca$var$dropdownTriggerBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "bottom",
            content: t4
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ...props,
            label: t5,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
            ref: t6,
            appearance: "subtle",
            id: "more-actions-trigger",
            interactionName: "more-actions-overflow-menu",
            isDisabled: isNetworkDisabled
        })));
        $[12] = isNetworkDisabled;
        $[13] = props;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
};
const $511857b10ace36ca$var$DropdownMenuContentSkeleton = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "more-actions-overflow-menu-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownItemSkeleton, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $511857b10ace36ca$var$DropdownItemSkeleton = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            isShimmering: true,
            borderRadius: 0,
            width: 200,
            height: 20
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $511857b10ace36ca$var$_temp(section) {
    return section?.items?.length && section?.items[0]?.id === (0, $9af26f5142ee161a$export$240b6ef4a1c531f6);
}
function $511857b10ace36ca$var$_temp2(dialogs_4, contentTypeForFeedback) {
    dialogs_4.showModal((0, $dcvq8.GlobalFeedbackCollector), {
        feedbackSource: (0, $1ggpj.CONTENT_TYPE_FEEDBACK_SOURCE)[contentTypeForFeedback],
        showTypeField: true,
        contentType: contentTypeForFeedback
    });
}
function $511857b10ace36ca$var$_temp3(item_1) {
    return item_1.shouldRender;
}
function $511857b10ace36ca$var$_temp4(item_6) {
    return item_6.shouldRender;
}
function $511857b10ace36ca$var$_temp5(item_14) {
    return item_14.shouldRender;
}
function $511857b10ace36ca$var$_temp6(item_15) {
    return item_15.shouldRender;
}
function $511857b10ace36ca$var$_temp7() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a937280d497d3e4$export$cbbdc590602afd67), null);
}
function $511857b10ace36ca$var$_temp8(item_16) {
    return item_16.shouldRender;
}
function $511857b10ace36ca$var$_temp9(action_0) {
    return {
        ...action_0,
        customComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $434c765ed6791bfa$export$b605bf507f6a39c), {
                item: action_0,
                key: action_0.id
            })
    };
}
function $511857b10ace36ca$var$_temp0(item_19) {
    return item_19.shouldRender;
}
function $511857b10ace36ca$var$_temp1(item_20) {
    return item_20.component();
}
function $511857b10ace36ca$var$_temp10(actionGroup, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        hasSeparator: index > 0,
        key: actionGroup.key
    }, actionGroup.items.map($511857b10ace36ca$var$_temp1));
}
function $511857b10ace36ca$var$_temp11() {}
function $511857b10ace36ca$var$_temp12(forgeMenuItem) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
        key: forgeMenuItem?.props?.extension?.id,
        module: forgeMenuItem?.props?.extension,
        action: ()=>{
            (0, $4GDP8.openForgeAppFromSubmenu)({
                parentmenuId: "#more-actions-trigger",
                submenuId: "[data-testid='third-party-button']",
                forgeItemId: forgeMenuItem?.props?.extension?.id
            });
        }
    });
}
function $511857b10ace36ca$var$_temp13(forgeMenuItems) {
    return forgeMenuItems.length > 0 && forgeMenuItems.map($511857b10ace36ca$var$_temp12);
}
function $511857b10ace36ca$var$_temp14(triggerProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($511857b10ace36ca$var$DropdownMenuTrigger, {
        triggerProps: triggerProps
    });
}





















var $fZ6J4 = parcelRequire("fZ6J4");





var $k7ow8 = parcelRequire("k7ow8");

const $93fa65fd07bdcd80$var$PRESENT_SHORTCUT = 'mod+option+r';
const $93fa65fd07bdcd80$var$tooltipTriggerWrapperStyles = null;
const $93fa65fd07bdcd80$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "content-types-header.content-types.present-slides-button.label",
        defaultMessage: "Present"
    }
});
const $93fa65fd07bdcd80$export$a2bc87848a8a0a89 = ()=>{
    const $ = (0, $bDgLe.c)(15);
    const intl = (0, $kSwu1.useIntl)();
    const [isAvailable, setIsAvailable] = (0, $cozmU.useState)((0, $k7ow8.contentPresentationService).isAvailable);
    const [isPresentSlidesEnabled, setIsPresentSlidesEnabled] = (0, $cozmU.useState)((0, $k7ow8.contentPresentationService).isPresentSlidesEnabled);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            shortcut: $93fa65fd07bdcd80$var$PRESENT_SHORTCUT
        };
        $[0] = t0;
    } else t0 = $[0];
    const shortcutStrings = (0, $4tOXV.useShortcutStrings)(t0);
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>(0, $k7ow8.contentPresentationService).onAvailabilityChange(setIsAvailable);
        t2 = [];
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>(0, $k7ow8.contentPresentationService).onPresentSlidesEnabledChange(setIsPresentSlidesEnabled);
        t4 = [];
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!isAvailable) return null;
    let t5;
    if ($[5] !== intl) {
        t5 = intl.formatMessage($93fa65fd07bdcd80$var$i18n.label);
        $[5] = intl;
        $[6] = t5;
    } else t5 = $[6];
    const label = t5;
    const t6 = !isPresentSlidesEnabled;
    let t7;
    if ($[7] !== label || $[8] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))),
            isDisabled: t6,
            onClick: $93fa65fd07bdcd80$var$_temp
        }, label);
        $[7] = label;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    const button = t7;
    let t8;
    if ($[10] !== button || $[11] !== isPresentSlidesEnabled || $[12] !== label || $[13] !== shortcutStrings) {
        t8 = isPresentSlidesEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: label,
            shortcut: shortcutStrings
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbvbI6"
            ])
        }, button)) : button;
        $[10] = button;
        $[11] = isPresentSlidesEnabled;
        $[12] = label;
        $[13] = shortcutStrings;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
};
function $93fa65fd07bdcd80$var$_temp() {
    return (0, $k7ow8.contentPresentationService).startPresent();
}









var $bLtXM = parcelRequire("bLtXM");

const $6967e8de26962a4d$export$99c2b779aa4e8b8b = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { collaborators: collaborators, contentId: contentId, contentType: contentType, contentMode: contentMode, isViewMode: isViewMode, children: children } = t0;
    const t1 = contentMode === "view" ? "viewPageScreen" : "editPageScreen";
    let t2;
    if ($[0] !== children || $[1] !== collaborators || $[2] !== contentId || $[3] !== contentType || $[4] !== isViewMode || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bLtXM.ContentHeaderPresence), {
            collaborators: collaborators,
            contentId: contentId,
            contentType: contentType,
            isViewMode: isViewMode,
            analyticSource: t1
        }, children);
        $[0] = children;
        $[1] = collaborators;
        $[2] = contentId;
        $[3] = contentType;
        $[4] = isViewMode;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};





/**
 * @generated SignedSource<<fdd9b11fbfdc3e33a05d8b1881a06b3b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $826269c7e8f31d2c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "EditorCloseButtonGetDraftParentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            }
        ],
        "type": "Content"
    };
}();
$826269c7e8f31d2c$var$node.hash = "2b05313527c3eb54a3e1e06657506abb";
var $826269c7e8f31d2c$export$2e2bcd8739ae039 = $826269c7e8f31d2c$var$node;


















var $hYoU4 = parcelRequire("hYoU4");


var $5M5fB = parcelRequire("5M5fB");


var $1ch0f = parcelRequire("1ch0f");


var $2unW6 = parcelRequire("2unW6");


var $lu0E4 = parcelRequire("lu0E4");


var $5rEAe = parcelRequire("5rEAe");


var $3mmDo = parcelRequire("3mmDo");


var $atF9V = parcelRequire("atF9V");


var $lHzSp = parcelRequire("lHzSp");


var $ivb8S = parcelRequire("ivb8S");


var $5cryL = parcelRequire("5cryL");





var $jacyh = parcelRequire("jacyh");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $ecUYt = parcelRequire("ecUYt");


var $fFmJj = parcelRequire("fFmJj");










const $1d832c644d7a0658$var$i18n = (0, $kSwu1.defineMessages)({
    closeButtonText: {
        id: "content-types-header.close.name",
        defaultMessage: "Close"
    },
    closeButtonPublishTooltip: {
        id: "content-types-header.editor.close.publish.tooltip",
        defaultMessage: "Saves changes without publishing"
    },
    closeButtonUpdateTooltip: {
        id: "content-types-header.editor.close.update.tooltip",
        defaultMessage: "Saves changes without updating"
    },
    discardOnCloseButtonTooltip: {
        id: "content-types-header.editor.discard.close.tooltip",
        defaultMessage: "Discard empty draft"
    }
});
const $1d832c644d7a0658$export$f7109619a5e9e0d6 = 'next-FullPageEditorComponent';
const $1d832c644d7a0658$export$f64ffceb1bd6299f = (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    const { contentType: contentType, contentId: contentId, spaceKey: spaceKey, pageTreeStateUpdater: pageTreeStateUpdater, areMainButtonsDisabled: t1, isUnpublishedDraft: t2 } = t0;
    const areMainButtonsDisabled = t1 === undefined ? false : t1;
    const isUnpublishedDraft = t2 === undefined ? false : t2;
    const intl = (0, $kSwu1.useIntl)();
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { saveDraft: saveDraft, navigateOnClose: navigateOnClose, triggerAnalyticsEvent: triggerAnalyticsEvent, version: version, editorActions: editorActions, title: title } = (0, $3o3i5.useEditorObjectHeaderContext)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fragmentSpec: (0, $826269c7e8f31d2c$export$2e2bcd8739ae039)
        };
        $[0] = t3;
    } else t3 = $[0];
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        ...t3,
        __callerPackage__: "content-types-header"
    });
    const [t4] = (0, $hYoU4.useNativeCollabState)();
    const { collabEditProvider: collabEditProvider } = t4;
    const { isSingleUserSession: isSingleUserSession } = (0, $5M5fB.usePresence)(collabEditProvider);
    const { hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState, emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription } = (0, $lHzSp.useEmojiTitleCoverPictureAndContentState)();
    const { hasRestrictions: hasRestrictions } = (0, $atF9V.useRestrictions)();
    const hasLabels = (0, $2unW6.useLabels)(contentId);
    const hasTitle = Boolean(title);
    let t5;
    if ($[1] !== editorActions) {
        t5 = editorActions.isDocumentEmpty();
        $[1] = editorActions;
        $[2] = t5;
    } else t5 = $[2];
    const hasBody = !t5;
    let t6;
    if ($[3] !== hasBody || $[4] !== hasContentState || $[5] !== hasCoverPicture || $[6] !== hasEmoji || $[7] !== hasLabels || $[8] !== hasRestrictions || $[9] !== hasTitle || $[10] !== isSingleUserSession || $[11] !== isUnpublishedDraft) {
        t6 = {
            isUnpublishedDraft: isUnpublishedDraft,
            isSingleUserSession: isSingleUserSession,
            hasTitle: hasTitle,
            hasBody: hasBody,
            hasEmoji: hasEmoji,
            hasCoverPicture: hasCoverPicture,
            hasContentState: hasContentState,
            hasRestrictions: hasRestrictions,
            hasLabels: hasLabels
        };
        $[3] = hasBody;
        $[4] = hasContentState;
        $[5] = hasCoverPicture;
        $[6] = hasEmoji;
        $[7] = hasLabels;
        $[8] = hasRestrictions;
        $[9] = hasTitle;
        $[10] = isSingleUserSession;
        $[11] = isUnpublishedDraft;
        $[12] = t6;
    } else t6 = $[12];
    const discardDraftOnClose = (0, $3mmDo.useWillDeleteBlankDraftOnClose)(t6);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS));
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== version) {
        t8 = !(0, $9wGTI.fg)("cc_onboarding_experience") || version !== 1;
        $[14] = version;
        $[15] = t8;
    } else t8 = $[15];
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(t7, t8);
    let t9;
    if ($[16] !== onboardingStateData) {
        t9 = (0, $ivb8S.deserializeState)(onboardingStateData);
        $[16] = onboardingStateData;
        $[17] = t9;
    } else t9 = $[17];
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, recentSpotlightCompleted: recentSpotlightCompleted } = t9;
    const shouldShowRecentSpotlight = !onboardingStateLoading && editorOnboardingEligiblity && !recentSpotlightCompleted;
    let t10;
    if ($[18] !== contentId || $[19] !== contentType || $[20] !== createAnalyticsEvent || $[21] !== discardDraftOnClose || $[22] !== forceRefetchBlogTree || $[23] !== navigateOnClose || $[24] !== pageTreeStateUpdater || $[25] !== readFragmentInterop || $[26] !== saveDraft || $[27] !== setOnboardingState || $[28] !== shouldShowRecentSpotlight || $[29] !== triggerAnalyticsEvent) {
        t10 = async ()=>{
            if (contentType === "page") (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.EDITOR_CLOSE_BUTTON_CLICK));
            if (shouldShowRecentSpotlight) setOnboardingState({
                key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_OPEN,
                value: "true"
            });
            if (discardDraftOnClose) {
                triggerAnalyticsEvent("close", {
                    discarded: true
                });
                (0, $1ch0f.deleteDraft)({
                    contentId: contentId,
                    deleteOnlyIfBlank: true
                }).then(async (t11)=>{
                    const { data: data } = t11;
                    if (contentType === "blogpost") forceRefetchBlogTree();
                    triggerAnalyticsEvent("draftDiscarded", {
                        wasDeleted: !!data?.deleteContent?.wasDeleted
                    });
                    const parentId = await (0, $5rEAe.getParentOfDraft)(contentId, readFragmentInterop);
                    if (parentId) pageTreeStateUpdater.setForceFetchPageId(parentId);
                    else createAnalyticsEvent({
                        type: "sendOperationalEvent",
                        data: {
                            action: "notFound",
                            actionSubject: "discardedDraftParent",
                            objectType: contentType,
                            objectId: contentId
                        }
                    }).fire();
                });
                navigateOnClose({
                    isDiscarding: true
                });
            } else {
                triggerAnalyticsEvent("close");
                saveDraft({
                    isOnClose: true
                }).then(()=>navigateOnClose());
            }
        };
        $[18] = contentId;
        $[19] = contentType;
        $[20] = createAnalyticsEvent;
        $[21] = discardDraftOnClose;
        $[22] = forceRefetchBlogTree;
        $[23] = navigateOnClose;
        $[24] = pageTreeStateUpdater;
        $[25] = readFragmentInterop;
        $[26] = saveDraft;
        $[27] = setOnboardingState;
        $[28] = shouldShowRecentSpotlight;
        $[29] = triggerAnalyticsEvent;
        $[30] = t10;
    } else t10 = $[30];
    const onClose = t10;
    let t11;
    if ($[31] !== areMainButtonsDisabled || $[32] !== discardDraftOnClose || $[33] !== intl || $[34] !== isUnpublishedDraft) {
        t11 = ()=>{
            if (areMainButtonsDisabled) return;
            else {
                if (discardDraftOnClose) return intl.formatMessage($1d832c644d7a0658$var$i18n.discardOnCloseButtonTooltip);
                else {
                    if (isUnpublishedDraft) return intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonPublishTooltip);
                    else return intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonUpdateTooltip);
                }
            }
        };
        $[31] = areMainButtonsDisabled;
        $[32] = discardDraftOnClose;
        $[33] = intl;
        $[34] = isUnpublishedDraft;
        $[35] = t11;
    } else t11 = $[35];
    const getCloseButtonTooltip = t11;
    let t12;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $6mKj3.expValEquals)("cc_editor_two_stage_hydration_removal", "editorCloseButton", true);
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== getCloseButtonTooltip) {
        t13 = getCloseButtonTooltip();
        $[37] = getCloseButtonTooltip;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== intl) {
        t14 = intl.formatMessage($1d832c644d7a0658$var$i18n.closeButtonText);
        $[39] = intl;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== areMainButtonsDisabled || $[42] !== onClose || $[43] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            id: "close-button",
            appearance: "subtle",
            onClick: onClose,
            isDisabled: areMainButtonsDisabled,
            testId: "close-button"
        }, t14);
        $[41] = areMainButtonsDisabled;
        $[42] = onClose;
        $[43] = t14;
        $[44] = t15;
    } else t15 = $[44];
    let t16;
    if ($[45] !== t13 || $[46] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t13
        }, t15);
        $[45] = t13;
        $[46] = t15;
        $[47] = t16;
    } else t16 = $[47];
    let t17;
    if ($[48] !== contentId || $[49] !== contentType || $[50] !== isUnpublishedDraft || $[51] !== spaceKey || $[52] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dA1Sn.TwoStageHydration), {
            name: "close-button",
            enabled: !t12
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lu0E4.PreloadButtonWrapper), {
            isPublish: false,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }, t16));
        $[48] = contentId;
        $[49] = contentType;
        $[50] = isUnpublishedDraft;
        $[51] = spaceKey;
        $[52] = t16;
        $[53] = t17;
    } else t17 = $[53];
    let t18;
    if ($[54] !== emojiCoverPictureAndContentStateSubscription || $[55] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, emojiCoverPictureAndContentStateSubscription, t17);
        $[54] = emojiCoverPictureAndContentStateSubscription;
        $[55] = t17;
        $[56] = t18;
    } else t18 = $[56];
    return t18;
};
const $1d832c644d7a0658$export$e392907f0931982f = (0, $ecUYt.withPageTreeStateUpdater)($1d832c644d7a0658$export$f64ffceb1bd6299f);





















var $iXzFq = parcelRequire("iXzFq");



















var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");








var $55fM8 = parcelRequire("55fM8");





var $kh0hi = parcelRequire("kh0hi");








var $1KOhB = parcelRequire("1KOhB");








var $jlIaF = parcelRequire("jlIaF");


var $8lYIw = parcelRequire("8lYIw");





var $kDhla = parcelRequire("kDhla");











var $1P7Cq = parcelRequire("1P7Cq");


var $5G6sa = parcelRequire("5G6sa");


var $3jwuS = parcelRequire("3jwuS");














const $f294e68c8b2b1e6c$var$i18n = (0, $kSwu1.defineMessages)({
    saved: {
        id: "content-types-header.last-edited.saved",
        defaultMessage: "Saved"
    },
    shortJustNow: {
        id: "content-types-header.last-edited.shortJustNow",
        defaultMessage: "just now"
    },
    shortXMinutesAgo: {
        id: "content-types-header.last-edited.shortXMinutesAgo",
        defaultMessage: "{timeAgo}m ago"
    },
    shortXHoursAgo: {
        id: "content-types-header.last-edited.shortXHoursAgo",
        defaultMessage: "{timeAgo}h ago"
    },
    shortXDaysAgo: {
        id: "content-types-header.last-edited.shortXDaysAgo",
        defaultMessage: "{timeAgo}d ago"
    },
    tooltipFullDate: {
        id: "content-types-header.last-edited.tooltipFullDate",
        defaultMessage: "{date} at {time}"
    },
    tooltipDate: {
        id: "content-types-header.last-edited.tooltipDate",
        // oxlint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{date}"
    },
    edited: {
        id: "content-types-header.last-edited.edited",
        defaultMessage: "Edited {timestamp}"
    },
    published: {
        id: "content-types-header.last-edited.published",
        defaultMessage: "Published {timestamp}"
    },
    updated: {
        id: "content-types-header.last-edited.updated",
        defaultMessage: "Updated {timestamp}"
    },
    editedOn: {
        id: "content-types-header.last-edited.editedOn",
        defaultMessage: "Edited by {contributor} on {timestamp}"
    },
    publishedOn: {
        id: "content-types-header.last-edited.publishedOn",
        defaultMessage: "Published by {contributor} on {timestamp}"
    },
    updatedOn: {
        id: "content-types-header.last-edited.updatedOn",
        defaultMessage: "Updated by {contributor} on {timestamp}"
    }
});
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_SECONDS = 1000;
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_MINUTES = 60000;
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR = 3600000;
const $f294e68c8b2b1e6c$var$MILLISECONDS_TO_DAY = 86400000;
/**
 * Formats full server date in shortened form ('MMM DD') if in the same calendar year, otherwise uses long form ('MMM DD, YYYY)
 */ const $f294e68c8b2b1e6c$var$formatfriendlyWhen = (friendlyWhen)=>{
    const now = new Date();
    const currentYear = now.getUTCFullYear();
    if (friendlyWhen.includes(currentYear.toString())) {
        // We expect that full server date (version.friendlyWhen) is of the format 'MMM DD, YYYY' (Jan 01, 2025) format for US_en
        // If it is not in this format depending on localization, we take the entire date
        const splitDate = friendlyWhen.split(',');
        return splitDate.length === 2 ? splitDate[0] : friendlyWhen;
    }
    return friendlyWhen;
};
const $f294e68c8b2b1e6c$export$f87e4558f7028ac3 = (lastEditedTime, friendlyWhen, isEditMode, formatMessage, renderServerPlaceholder)=>{
    let headerTimestamp;
    const timeNow = new Date();
    let currentTimestamp;
    if (renderServerPlaceholder && window.__SSR_CURRENT_DATE__) currentTimestamp = window.__SSR_CURRENT_DATE__;
    else currentTimestamp = timeNow.getTime();
    const timeDifference = currentTimestamp - lastEditedTime.getTime();
    let isSavedIndicator = false;
    if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_SECONDS < 60) {
        if (isEditMode) {
            headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.saved);
            isSavedIndicator = true;
        } else headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortJustNow);
    } else if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_MINUTES < 60) {
        const minutes = Math.floor(timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_MINUTES);
        headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortXMinutesAgo, {
            timeAgo: minutes
        });
    } else if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR < 24) {
        const hours = Math.floor(timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR);
        headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortXHoursAgo, {
            timeAgo: hours
        });
    } else if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR < 48) {
        const days = Math.floor(timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_DAY);
        headerTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.shortXDaysAgo, {
            timeAgo: days
        });
    } else // After 48 hours, include date in format MMM DD (shortened month 'Jan', for US_en) from server
    headerTimestamp = $f294e68c8b2b1e6c$var$formatfriendlyWhen(friendlyWhen);
    return {
        headerTimestamp: headerTimestamp,
        isSavedIndicator: isSavedIndicator
    };
};
const $f294e68c8b2b1e6c$export$442a454d04f6993d = (lastEditedTime, friendlyWhen, formatMessage, formatTime, formatDate, timeZone, renderServerPlaceholder)=>{
    let tooltipTimestamp;
    const timeNow = new Date();
    let currentTimestamp;
    if (renderServerPlaceholder && window.__SSR_CURRENT_DATE__) currentTimestamp = window.__SSR_CURRENT_DATE__;
    else currentTimestamp = timeNow.getTime();
    const timeDifference = currentTimestamp - lastEditedTime.getTime();
    // Format client timestamp for use when < 48 hours in the past
    const monthAndDay = formatDate(lastEditedTime, {
        month: 'short',
        day: 'numeric',
        timeZone: timeZone
    });
    const formattedTime = formatTime(lastEditedTime, {
        hour: 'numeric',
        minute: 'numeric',
        timeZone: timeZone
    });
    if (timeDifference / $f294e68c8b2b1e6c$var$MILLISECONDS_TO_HOUR < 48) tooltipTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.tooltipFullDate, {
        date: monthAndDay,
        time: formattedTime
    });
    else // Use server friendlyWhen here because we want it to match the header timestamp
    tooltipTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.tooltipDate, {
        date: friendlyWhen
    });
    return tooltipTimestamp;
};
const $f294e68c8b2b1e6c$var$focusBorderStyles = (0, $buxP3.xcss)({
    ':focus-visible': {
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineColor: 'color.border.focused',
        outlineOffset: 'space.025'
    }
});
const $f294e68c8b2b1e6c$export$736471da038a469 = ({ localizedHeaderTimestamp: localizedHeaderTimestamp, isSavedIndicator: isSavedIndicator, hasVersionHistory: hasVersionHistory, isPageOrBlog: isPageOrBlog, isEditMode: isEditMode, versionNumber: versionNumber, createChangeLink: createChangeLink, formatMessage: formatMessage })=>{
    if (isSavedIndicator) return hasVersionHistory ? createChangeLink(localizedHeaderTimestamp) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        tabIndex: 0,
        role: "tooltip",
        xcss: $f294e68c8b2b1e6c$var$focusBorderStyles
    }, localizedHeaderTimestamp);
    let headerMessage;
    if (isPageOrBlog) {
        let formattedTimestamp;
        if (isEditMode) formattedTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.edited, {
            timestamp: localizedHeaderTimestamp
        });
        else formattedTimestamp = versionNumber > 1 ? formatMessage($f294e68c8b2b1e6c$var$i18n.updated, {
            timestamp: localizedHeaderTimestamp
        }) : formatMessage($f294e68c8b2b1e6c$var$i18n.published, {
            timestamp: localizedHeaderTimestamp
        });
        headerMessage = hasVersionHistory ? createChangeLink(formattedTimestamp) : formattedTimestamp;
    } else {
        const formattedTimestamp = formatMessage($f294e68c8b2b1e6c$var$i18n.edited, {
            timestamp: localizedHeaderTimestamp
        });
        headerMessage = hasVersionHistory ? createChangeLink(formattedTimestamp) : formattedTimestamp;
    }
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(headerMessage)) return headerMessage;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        tabIndex: 0,
        role: "tooltip",
        xcss: $f294e68c8b2b1e6c$var$focusBorderStyles
    }, headerMessage);
};
const $f294e68c8b2b1e6c$export$c5802041e21f264 = ({ localizedTooltipTimestamp: localizedTooltipTimestamp, isEditMode: isEditMode, isPageOrBlog: isPageOrBlog, versionNumber: versionNumber, fullName: fullName, formatMessage: formatMessage })=>{
    let tooltipMessage;
    if (isPageOrBlog) {
        if (isEditMode) tooltipMessage = formatMessage($f294e68c8b2b1e6c$var$i18n.editedOn, {
            timestamp: localizedTooltipTimestamp,
            contributor: fullName
        });
        else tooltipMessage = versionNumber > 1 ? formatMessage($f294e68c8b2b1e6c$var$i18n.updatedOn, {
            timestamp: localizedTooltipTimestamp,
            contributor: fullName
        }) : formatMessage($f294e68c8b2b1e6c$var$i18n.publishedOn, {
            timestamp: localizedTooltipTimestamp,
            contributor: fullName
        });
    } else tooltipMessage = formatMessage($f294e68c8b2b1e6c$var$i18n.editedOn, {
        timestamp: localizedTooltipTimestamp,
        contributor: fullName
    });
    return tooltipMessage;
};


const $f00826a51c2021a6$var$lastEditedStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtle',
    alignItems: 'center',
    flexDirection: 'row',
    padding: 'space.050',
    textWrap: 'nowrap'
});
const $f00826a51c2021a6$var$linkStyles = {
    color: "var(--ds-text-subtle, #505258)"
};
const $f00826a51c2021a6$var$disabledLinkStyles = {
    ...$f00826a51c2021a6$var$linkStyles,
    pointerEvents: 'none',
    cursor: 'default'
};
const $f00826a51c2021a6$var$pressableStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtle',
    font: 'font.body',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $f00826a51c2021a6$export$2fd1e1faefc578c4 = ({ contentId: contentId, version: version, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey })=>{
    const { showSidePanel: showSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { formatMessage: formatMessage, formatTime: formatTime, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const previousRemoteChangeTimeRef = (0, $cozmU.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $cozmU.useRef)(undefined);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const contentIdRef = (0, $cozmU.useRef)(contentId);
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)();
    const isNetworkDisabled = isCollabOffline;
    const { setWasTransitionedFromEditor: setWasTransitionedFromEditor } = (0, $5G6sa.useNewContentHistoryActions)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Debounce to avoid rapid calls and prevent performance lag
    const debouncedSetRecentVersion = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            updateTimestampCache({
                contentId: contentIdRef.current // we need to use a ref for contentId so that the debounced timer doesn't reset every rerender
            });
        }, 3000), // eslint-disable-next-line react-hooks/exhaustive-deps
    [] // intentionally do not add dependencies so that the debounce timer is not reset on every rerender
    );
    // Update time stamp to "Just now" on page edit and live page edit
    (0, $1KOhB.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            debouncedSetRecentVersion();
        }
    });
    (0, $cozmU.useEffect)(()=>{
        contentIdRef.current = contentId;
    }, [
        contentId
    ]);
    // Cancel any pending timers on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            debouncedSetRecentVersion.cancel();
        };
    }, [
        debouncedSetRecentVersion
    ]);
    const fireOnClickAnalyticsEvent = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'objectHeader',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lastEditedTimestamp',
                attributes: {
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentType,
        contentMode
    ]);
    const handleLinkClick = (0, $cozmU.useCallback)(()=>{
        // Track when user navigates from editor to version history so we can redirect back to editor on back click
        // Only track for non-live pages when in edit mode since lives pages use the view page route
        const isEditMode = contentMode === 'edit';
        if (!isLivePage && isEditMode) setWasTransitionedFromEditor(true);
        fireOnClickAnalyticsEvent();
    }, [
        isLivePage,
        contentMode,
        setWasTransitionedFromEditor,
        fireOnClickAnalyticsEvent
    ]);
    const createEditorChangeLink = (formattedMessage)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isNetworkDisabled ? $f00826a51c2021a6$var$disabledLinkStyles : $f00826a51c2021a6$var$linkStyles,
            href: `${(0, $jlIaF.CONTEXT_PATH)}/spaces/${spaceKey}/history/${contentId}`,
            onClick: isNetworkDisabled ? undefined : handleLinkClick
        }, formattedMessage);
    };
    const handleContentTypesLinkClick = ()=>{
        showSidePanel();
        fireOnClickAnalyticsEvent();
    };
    const createContentTypesChangeLink = (formattedMessage)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: $f00826a51c2021a6$var$pressableStyles,
            backgroundColor: "color.background.neutral.subtle",
            onClick: handleContentTypesLinkClick
        }, formattedMessage);
    };
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const lastEditedHeaderResult = (0, $cozmU.useMemo)(()=>{
        const lastEditedTime = new Date(version.when);
        const isEditMode = !(contentMode === 'view' || contentMode === 'archived');
        const { headerTimestamp: headerTimestamp, isSavedIndicator: isSavedIndicator } = (0, $f294e68c8b2b1e6c$export$f87e4558f7028ac3)(lastEditedTime, version.friendlyWhen, isEditMode, formatMessage, renderServerPlaceholder);
        return {
            headerTimestamp: headerTimestamp,
            isSavedIndicator: isSavedIndicator
        };
    }, [
        version.when,
        version.friendlyWhen,
        contentMode,
        formatMessage,
        renderServerPlaceholder
    ]);
    const lastEditedTooltipResult = (0, $cozmU.useMemo)(()=>{
        const lastEditedTime = new Date(version.when);
        return (0, $f294e68c8b2b1e6c$export$442a454d04f6993d)(lastEditedTime, version.friendlyWhen, formatMessage, formatTime, formatDate, timeZone, renderServerPlaceholder);
    }, [
        version.when,
        version.friendlyWhen,
        formatMessage,
        formatTime,
        formatDate,
        timeZone,
        renderServerPlaceholder
    ]);
    /**
   * Formats header timestamp as well as tooltip timestamp
   */ const formatTimestamps = ()=>{
        let headerMessage;
        let tooltipMessage;
        const isEditMode = !(contentMode === 'view' || contentMode === 'archived');
        const { headerTimestamp: headerTimestamp, isSavedIndicator: isSavedIndicator } = lastEditedHeaderResult;
        const tooltipTimestamp = lastEditedTooltipResult;
        const isPageOrBlog = contentType === 'page' || contentType === 'blogpost';
        if (isPageOrBlog) {
            const hasEditorVersionHistory = !!spaceKey && contentMode !== 'draft';
            headerMessage = (0, $f294e68c8b2b1e6c$export$736471da038a469)({
                localizedHeaderTimestamp: headerTimestamp,
                isSavedIndicator: isSavedIndicator,
                hasVersionHistory: hasEditorVersionHistory,
                isPageOrBlog: isPageOrBlog,
                isEditMode: isEditMode,
                versionNumber: version.number,
                createChangeLink: createEditorChangeLink,
                formatMessage: formatMessage
            });
            tooltipMessage = (0, $f294e68c8b2b1e6c$export$c5802041e21f264)({
                localizedTooltipTimestamp: tooltipTimestamp,
                isEditMode: isEditMode,
                isPageOrBlog: isPageOrBlog,
                versionNumber: version.number,
                fullName: version.by.fullName,
                formatMessage: formatMessage
            });
        } else if ((0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database') {
            const hasContentTypesVersionHistory = !version.contentTypeModified;
            headerMessage = (0, $f294e68c8b2b1e6c$export$736471da038a469)({
                localizedHeaderTimestamp: headerTimestamp,
                isSavedIndicator: isSavedIndicator,
                hasVersionHistory: hasContentTypesVersionHistory,
                isPageOrBlog: isPageOrBlog,
                isEditMode: isEditMode,
                versionNumber: version.number,
                createChangeLink: createContentTypesChangeLink,
                formatMessage: formatMessage
            });
            tooltipMessage = (0, $f294e68c8b2b1e6c$export$c5802041e21f264)({
                localizedTooltipTimestamp: tooltipTimestamp,
                isEditMode: isEditMode,
                isPageOrBlog: isPageOrBlog,
                versionNumber: version.number,
                fullName: version.by.fullName,
                formatMessage: formatMessage
            });
        } else {
            headerMessage = null;
            tooltipMessage = null;
        }
        return {
            headerMessage: headerMessage,
            tooltipMessage: tooltipMessage
        };
    };
    // Ensures that timestamp will only display when most accurate timestamp is available
    if (contentMode === 'edit' && !version.when) return null;
    const { headerMessage: formattedHeaderMessage, tooltipMessage: formattedTooltipMessage } = formatTimestamps();
    // Only show tooltip if header timestamp is not full format > 2 days
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $f00826a51c2021a6$var$lastEditedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        component: (0, $778018eca844ead1$export$7574cd0e3a4be128),
        content: formattedTooltipMessage,
        delay: 0
    }, formattedHeaderMessage));
};


const $71eaeeab7c35a8b6$var$unpublishedChangesTextStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest'
});
const $71eaeeab7c35a8b6$var$unpublishedChangesLinkStyles = null; // this component is copied from content-header PageMetadataBanner.jsx to avoid circular dependency
const $71eaeeab7c35a8b6$export$87049fd2bc239211 = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { contentId: contentId, contentType: contentType, contentMode: contentMode, spaceKey: spaceKey, version: version, hasEditPermission: hasEditPermission } = t0;
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] !== getQueryParams) {
        const queryParams = getQueryParams();
        t1 = (0, $c3Qwv.getSingleParamInt)(queryParams, "versionOverride", null);
        $[0] = getQueryParams;
        $[1] = t1;
    } else t1 = $[1];
    const versionOverride = t1;
    let t2;
    if ($[2] !== contentId || $[3] !== contentMode || $[4] !== contentType || $[5] !== hasEditPermission || $[6] !== spaceKey || $[7] !== version) {
        t2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f00826a51c2021a6$export$2fd1e1faefc578c4), {
                contentId: contentId,
                version: version,
                contentType: contentType,
                contentMode: contentMode,
                spaceKey: spaceKey,
                hasEditPermission: hasEditPermission
            });
        $[2] = contentId;
        $[3] = contentMode;
        $[4] = contentType;
        $[5] = hasEditPermission;
        $[6] = spaceKey;
        $[7] = version;
        $[8] = t2;
    } else t2 = $[8];
    const renderLastEdited = t2;
    if (!(contentMode === "view" && (contentType === "page" || contentType === "blogpost"))) {
        let t3;
        if ($[9] !== renderLastEdited) {
            t3 = renderLastEdited();
            $[9] = renderLastEdited;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
        });
        $[11] = t3;
    } else t3 = $[11];
    const t4 = versionOverride || undefined;
    let t5;
    if ($[12] !== contentId || $[13] !== contentType || $[14] !== hasEditPermission || $[15] !== renderLastEdited || $[16] !== spaceKey) {
        t5 = (t6)=>{
            const { webItems: webItems } = t6;
            let unpublishedChangesItem = null;
            const editUrl = (0, $iXzFq.getUrlForContentType)({
                contentType: contentType,
                contentId: contentId,
                spaceKey: spaceKey,
                redirectToEditor: true
            });
            if (webItems.some($71eaeeab7c35a8b6$var$_temp)) unpublishedChangesItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $71eaeeab7c35a8b6$var$unpublishedChangesTextStyles
            }, hasEditPermission && editUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                href: editUrl,
                "data-testid": "unpublished-changes-edit-link",
                className: (0, $hekY6.default)([
                    "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzKGUX _2nTuUYKGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $71eaeeab7c35a8b6$var$i18n.unpublishedChanges)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $71eaeeab7c35a8b6$var$i18n.unpublishedChanges));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
            }), unpublishedChangesItem || renderLastEdited());
        };
        $[12] = contentId;
        $[13] = contentType;
        $[14] = hasEditPermission;
        $[15] = renderLastEdited;
        $[16] = spaceKey;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== contentId || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            tagName: "span",
            location: (0, $eSLr0.PAGE_METADATA_BANNER),
            contentId: contentId,
            version: t4
        }, t5));
        $[18] = contentId;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
};
const $71eaeeab7c35a8b6$var$i18n = (0, $kSwu1.defineMessages)({
    unpublishedChanges: {
        id: "content-types-header.object-header-items.unpublished-changes.link.text",
        defaultMessage: "Unpublished changes"
    }
});
function $71eaeeab7c35a8b6$var$_temp(item) {
    return item.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID);
}









var $gabmL = parcelRequire("gabmL");







const $85c7900526df4a2e$export$b0a1564bba9108e3 = (contentId, contentMode)=>{
    const $ = (0, $bDgLe.c)(16);
    const isEditorMode = contentMode === "draft" || contentMode === "edit" || contentMode === "live";
    const t0 = !isEditorMode;
    let t1;
    if ($[0] !== contentId || $[1] !== t0) {
        t1 = {
            pageId: contentId,
            fetchPolicy: "cache-and-network",
            skip: t0
        };
        $[0] = contentId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const publicLinkData = (0, $gabmL.usePublicLinkPageDataProvider)(t1);
    let t2;
    let t3;
    if ($[3] !== isEditorMode || $[4] !== publicLinkData.errors) {
        t2 = ()=>{
            if (!isEditorMode) return;
            for (const error of publicLinkData.errors)(0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            isEditorMode,
            publicLinkData.errors
        ];
        $[3] = isEditorMode;
        $[4] = publicLinkData.errors;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const { isPublishingContent: isPublishingContent, userOffline: userOffline, forceDisabled: forceDisabled, editorTitle: editorTitle, collabLimitReached: collabLimitReached } = (0, $3o3i5.useEditorObjectHeaderContext)();
    if (!isEditorMode) {
        let t4;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                shouldDisableEditorButtons: false,
                isPublishDisabledForPublishModal: false,
                isPublishDisabled: false,
                pageIsExternallyShared: false
            };
            $[7] = t4;
        } else t4 = $[7];
        return t4;
    }
    const publicLinkDataIsLoading = publicLinkData.isLoading;
    const pageIsExternallyShared = !publicLinkData.isLoading && publicLinkData.isPublicLinkFullyEnabled;
    const shouldDisableActions = isPublishingContent || userOffline || !!forceDisabled;
    const shouldDisableEditorButtons = shouldDisableActions || publicLinkDataIsLoading;
    let t4;
    if ($[8] !== editorTitle) {
        t4 = !editorTitle || !editorTitle.trim();
        $[8] = editorTitle;
        $[9] = t4;
    } else t4 = $[9];
    const isEditorTitleEmpty = t4;
    const isPublishDisabledForPublishModal = shouldDisableActions || Boolean(collabLimitReached);
    const isPublishDisabled = isEditorTitleEmpty || isPublishDisabledForPublishModal;
    let t5;
    if ($[10] !== isPublishDisabled || $[11] !== isPublishDisabledForPublishModal || $[12] !== pageIsExternallyShared || $[13] !== shouldDisableActions || $[14] !== shouldDisableEditorButtons) {
        t5 = {
            shouldDisableEditorButtons: shouldDisableEditorButtons,
            isPublishDisabledForPublishModal: isPublishDisabledForPublishModal,
            isPublishDisabled: isPublishDisabled,
            isCloseButtonDisabled: shouldDisableActions,
            pageIsExternallyShared: pageIsExternallyShared
        };
        $[10] = isPublishDisabled;
        $[11] = isPublishDisabledForPublishModal;
        $[12] = pageIsExternallyShared;
        $[13] = shouldDisableActions;
        $[14] = shouldDisableEditorButtons;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};





const $0ecb1ba642d20f26$export$b5190710ae2f673b = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { contentData: contentData, useDraftVersion: useDraftVersion } = t0;
    let t1;
    bb0: {
        if (useDraftVersion) {
            const t2 = contentData?.draftVersion?.contentTypeModified ?? false;
            const t3 = contentData?.draftVersion?.number ?? 1;
            const t4 = contentData?.draftVersion?.when ?? "";
            const t5 = contentData?.draftVersion?.friendlyWhen ?? "";
            const t6 = contentData?.draftVersion?.by?.displayName ?? "";
            let t7;
            if ($[0] !== t6) {
                t7 = {
                    fullName: t6
                };
                $[0] = t6;
                $[1] = t7;
            } else t7 = $[1];
            let t8;
            if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5 || $[6] !== t7) {
                t8 = {
                    contentTypeModified: t2,
                    number: t3,
                    when: t4,
                    friendlyWhen: t5,
                    by: t7
                };
                $[2] = t2;
                $[3] = t3;
                $[4] = t4;
                $[5] = t5;
                $[6] = t7;
                $[7] = t8;
            } else t8 = $[7];
            t1 = t8;
            break bb0;
        }
        const t2 = contentData?.version?.contentTypeModified ?? false;
        const t3 = contentData?.version?.number ?? 1;
        const t4 = contentData?.version?.when ?? "";
        const t5 = contentData?.version?.friendlyWhen ?? "";
        const t6 = contentData?.version?.by?.displayName ?? "";
        let t7;
        if ($[8] !== t6) {
            t7 = {
                fullName: t6
            };
            $[8] = t6;
            $[9] = t7;
        } else t7 = $[9];
        let t8;
        if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t7) {
            t8 = {
                contentTypeModified: t2,
                number: t3,
                when: t4,
                friendlyWhen: t5,
                by: t7
            };
            $[10] = t2;
            $[11] = t3;
            $[12] = t4;
            $[13] = t5;
            $[14] = t7;
            $[15] = t8;
        } else t8 = $[15];
        t1 = t8;
    }
    const version = t1;
    return version;
};





/**
 * @generated SignedSource<<80f10004d4062a12fdb863ba549764dc>>
 * @relayHash 59f0519f908a00783bb64023ad19fee7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cefa642b8002fbccab8533b25b71da09e9d6f25c52e47c7333d1337fc0256f4b
const $f0f4daa1977f21aa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluencePrivacyMode",
            "kind": "LinkedField",
            "name": "confluence_isPrivacyModeEnabled",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPrivacyModeEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsPrivacyModeEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsPrivacyModeEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "59f0519f908a00783bb64023ad19fee7",
            "id": "cefa642b8002fbccab8533b25b71da09e9d6f25c52e47c7333d1337fc0256f4b",
            "metadata": {},
            "name": "useIsPrivacyModeEnabledQuery",
            "operationKind": "query",
            "text": "query useIsPrivacyModeEnabledQuery($cloudId:ID!){confluence_isPrivacyModeEnabled(cloudId:$cloudId){isPrivacyModeEnabled}}"
        }
    };
}();
$f0f4daa1977f21aa$var$node.hash = "974739f746f3758748387ad8be18ef42";
var $f0f4daa1977f21aa$export$2e2bcd8739ae039 = $f0f4daa1977f21aa$var$node;

















const $bd64585724dda192$export$4aac5356fb0022cd = ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== edition) {
        t1 = !(0, $9wGTI.fg)("ccir_privacy_mode") || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || Boolean(undefined);
        $[2] = edition;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $f0f4daa1977f21aa$export$2e2bcd8739ae039), {
        ...t2,
        __callerPackage__: "content-types-header"
    });
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    return data?.confluence_isPrivacyModeEnabled?.isPrivacyModeEnabled ?? false;
};


'use no memo';
const $2c279a34b2a89086$export$2ed55bc7ce9c518 = ({ contentId: contentId, contentType: contentType, contentMode: contentMode, contentActions: contentActions, handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight, allowedFeatures: allowedFeatures, contentData: contentData, editContentFragmentRef: editContentFragmentRef, renderCopyLink: renderCopyLink, renderShare: renderShare, isSpaceOverviewPage: isSpaceOverviewPage, readOnly: readOnly, isConvertToFolderHighlighted: isConvertToFolderHighlighted = false, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage })=>{
    const isExternal = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const { isAnonymous: isAnonymous } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { loomExternalOpenRoute: loomExternalOpenRoute } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { isPublishingContent: isPublishingContent, onClickPublish: onClickPublish, editorTitle: editorTitle, saveDraft: saveDraft, isUnpublishedDraft: isUnpublishedDraft, shouldRenderPreview: shouldRenderPreview, onPreviewClicked: onPreviewClicked, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, viewMode: viewMode, onHoverPublish: onHoverPublish, checkIfConditionPreventingPublish: checkIfConditionPreventingPublish } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const { isPublishDisabledForPublishModal: isPublishDisabledForPublishModal, isPublishDisabled: isPublishDisabled, isCloseButtonDisabled: isCloseButtonDisabled } = (0, $85c7900526df4a2e$export$b0a1564bba9108e3)(contentId, contentMode);
    const isClassicEdit = (contentType === 'page' || contentType === 'blogpost') && (contentMode === 'draft' || contentMode === 'edit');
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(contentData?.space?.key);
    const isClassificationEnabled = (0, $66bd5ba8343e39f0$export$48cea123122bbc52)(contentData?.type ?? '');
    const isArchived = contentData?.status === 'archived';
    const version = (0, $0ecb1ba642d20f26$export$b5190710ae2f673b)({
        contentData: contentData,
        useDraftVersion: isClassicEdit
    });
    const isPrivacyModeEnabled = (0, $bd64585724dda192$export$4aac5356fb0022cd)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const computedReadOnly = readOnly || isExternal || !contentData?.operations?.some((operation)=>operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation?.targetType) && operation?.operation === 'update');
    const isClassificationAllowedInMoreActions = !computedReadOnly && isClassificationEnabled;
    const moreActionsAllowedFeatures = isClassificationAllowedInMoreActions ? {
        ...allowedFeatures,
        showClassificationMenuAction: true
    } : allowedFeatures;
    const hasArchivePermission = contentData?.operations?.some((operation_0)=>{
        return operation_0?.targetType === contentType && operation_0?.operation === 'archive';
    });
    const isPreviewPanelTestEnabled = (0, $1xpoY.default).getString('confluence_page_preview_panel_testing', '') !== '';
    const isCanvasPresenceEnabled = !isMobileApp && contentMode !== 'archived' && ((0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database');
    const isPagePresenceEnabled = [
        'page',
        'blogpost'
    ].includes(contentType) && contentMode !== 'archived';
    const isFolderPresenceEnabled = contentType === 'folder' && contentMode !== 'archived';
    const isAgentPresenceSupportedContent = [
        'page',
        'blogpost'
    ].includes(contentType) && contentMode !== 'archived';
    const isAgentPresenceEnabled = isAgentPresenceSupportedContent && (contentMode === 'live' || contentMode === 'edit' || contentMode === 'draft');
    const isMovedAgentPresenceEnabled = isAgentPresenceSupportedContent && (0, $9wGTI.fg)('platform_move_presence_agents');
    const shouldRenderPresence = allowedFeatures.showPresence !== false && (isPagePresenceEnabled || isCanvasPresenceEnabled || isFolderPresenceEnabled) && !isPrivacyModeEnabled;
    if (isVersionHistoryPage) // don't show any header items or overflow items for version history page as they are irrelevant
    return [];
    if (isAttachmentsPage) // don't show any header items or overflow items for attachments page as they are irrelevant
    return [];
    const currentUserHasEditPermission = contentData?.operations?.some((operation_1)=>{
        return operation_1?.targetType === contentType && operation_1?.operation === 'update';
    });
    return [
        {
            name: 'lastEdited',
            shouldShowSeparator: false,
            shouldRender: allowedFeatures.showLastEdited !== false && contentType !== 'embed' && (contentType !== 'folder' || isFolderPresenceEnabled) && (contentType === 'database' || !isSpaceOverviewPage),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $71eaeeab7c35a8b6$export$87049fd2bc239211), {
                contentId: contentId,
                version: version,
                contentType: contentType,
                contentMode: contentMode,
                spaceKey: contentData?.space?.key ?? '',
                hasEditPermission: currentUserHasEditPermission ?? false
            }))
        },
        {
            name: 'aiAgentPresence',
            shouldShowSeparator: false,
            shouldRender: isAgentPresenceEnabled && !isMovedAgentPresenceEnabled,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ug2F.AgentPresenceLoader), null)
        },
        {
            name: 'presence',
            shouldShowSeparator: isCompanyHub,
            shouldRender: shouldRenderPresence || isMovedAgentPresenceEnabled,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldRenderPresence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6967e8de26962a4d$export$99c2b779aa4e8b8b), {
                collaborators: contentActions?.collaborators,
                contentId: contentId,
                contentType: contentType,
                contentMode: contentMode,
                isViewMode: viewMode
            }, isMovedAgentPresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ug2F.AgentPresenceLoader), {
                isNestedInPresenceAvatarGroup: true
            }) : undefined) : isMovedAgentPresenceEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ug2F.AgentPresenceLoader), null))
        },
        {
            name: 'preview',
            shouldShowSeparator: false,
            shouldRender: isCompanyHub,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4HbMh))),
                appearance: "subtle",
                label: "",
                onClick: onPreviewClicked
            }))
        },
        {
            name: 'presentSlides',
            shouldShowSeparator: false,
            shouldRender: contentType === 'slide',
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $93fa65fd07bdcd80$export$a2bc87848a8a0a89), null)
        },
        {
            name: 'mainActions',
            // this only handles showing external link for embed object header
            shouldShowSeparator: false,
            shouldRender: !!contentActions?.mainActions && !!allowedFeatures.showMainActions,
            children: !!contentActions?.mainActions && !!allowedFeatures.showMainActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $48a5da156a2c7b78$export$a37ba60443eae06e), {
                mainActions: contentActions.mainActions.mainActions
            })) : null
        },
        {
            name: 'editIcon',
            shouldShowSeparator: false,
            shouldRender: (contentType === 'page' || contentType === 'blogpost') && contentMode === 'view',
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iAOfI.EditContentButton), {
                contentId: contentId,
                contentFragmentRef: editContentFragmentRef
            }))
        },
        {
            name: 'previewPanelTest',
            shouldShowSeparator: false,
            shouldRender: isPreviewPanelTestEnabled,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0f9c0b3d7e5360a3$export$7c95b5e4cc9d3256), null)
        },
        {
            name: 'update',
            shouldShowSeparator: false,
            shouldRender: isClassicEdit,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dA1Sn.TwoStageHydration), {
                name: "update-split-button",
                // cc_editor_two_stage_hydration_removal - When cleaning up this experiment, also remove the related TwoStageHydration component
                enabled: !(0, $6mKj3.expValEquals)('cc_editor_two_stage_hydration_removal', 'useHeaderItems', true),
                ssrPlaceholder: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jeQ9x.PublishButtonWithMoreOptions), {
                    onClickPublish: onClickPublish,
                    onHoverPublish: onHoverPublish,
                    publishButtonDisabled: isPublishDisabledForPublishModal ?? isPublishDisabled,
                    title: editorTitle,
                    onClickPreview: onPreviewClicked,
                    userViewingPreview: shouldRenderPreview,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    isUnpublishedDraft: isUnpublishedDraft,
                    flags: flags,
                    saveDraft: saveDraft,
                    contentType: contentType,
                    savingInProgress: isPublishingContent,
                    shouldShowWorldIcon: false,
                    shouldShowFooterButtons: true,
                    checkIfConditionPreventingPublish: checkIfConditionPreventingPublish
                }))))
        },
        {
            name: 'close',
            shouldShowSeparator: false,
            shouldRender: contentMode === 'draft' || contentMode === 'edit',
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d832c644d7a0658$export$e392907f0931982f), {
                contentType: contentType,
                contentId: contentId,
                spaceKey: contentData?.space?.key ?? '',
                areMainButtonsDisabled: !!isCloseButtonDisabled,
                isUnpublishedDraft: contentMode === 'draft'
            }))
        },
        {
            name: 'share',
            shouldShowSeparator: false,
            shouldRender: !isAnonymous && !isArchived && !!allowedFeatures.showShare && !isCompanyHub,
            children: renderShare()
        },
        {
            name: 'loomExternalOpen',
            shouldShowSeparator: false,
            shouldRender: !!loomExternalOpenRoute,
            children: loomExternalOpenRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bjZbA.LoomExternalOpenButton), null) : null
        },
        {
            name: 'contentRestrictions',
            shouldShowSeparator: false,
            shouldRender: !isAnonymous && !!allowedFeatures.showContentRestrictions && isArchived,
            children: renderShare({
                isNotifyDisabled: true
            })
        },
        {
            name: 'copy',
            shouldShowSeparator: false,
            shouldRender: isArchived,
            children: renderCopyLink() ?? null
        },
        {
            name: 'moreActions',
            shouldShowSeparator: false,
            shouldRenderInContainer: false,
            shouldRender: !!allowedFeatures.showMoreActions,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $511857b10ace36ca$export$6e6eb6019781c337), {
                    moreActions: contentActions?.moreActions,
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    spaceKey: contentData?.space?.key ?? '',
                    allowedFeatures: moreActionsAllowedFeatures,
                    hasArchivePermission: hasArchivePermission,
                    handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
                    flags: flags_0,
                    contentData: contentData,
                    readOnly: computedReadOnly,
                    isConvertToFolderHighlighted: isConvertToFolderHighlighted,
                    setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted
                }))))
        }
    ];
};



















var $5Vf1r = parcelRequire("5Vf1r");








var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $d8c6dd08bfe3a65f$var$getIsSideNavCollapsed = ()=>{
    const sideNavCollapsedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? 'expanded';
    return sideNavCollapsedValue === 'collapsed';
};
const $d8c6dd08bfe3a65f$export$49b33b1785ffa4cd = (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { contentType: contentType, isSpaceOverviewPage: isSpaceOverviewPage, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage, isArchived: isArchived, isEditorToolbarShown: isEditorToolbarShown, isTitleFullyVisible: isTitleFullyVisible, isLegacyObjectSidebarShown: isLegacyObjectSidebarShown, contentId: contentId, contentTypesHeaderDataLoading: contentTypesHeaderDataLoading } = t0;
    const hasMounted = (0, $cozmU.useRef)(false);
    const shouldListenForTitleVisibilityChanges = (contentType === "blogpost" || contentType === "page" || contentType === "folder") && !isSpaceOverviewPage && !isArchived && !isEditorToolbarShown && !isVersionHistoryPage && !isAttachmentsPage;
    const checkAndSetDisplayAttribute = $d8c6dd08bfe3a65f$var$_temp;
    const checkAndSetStyle = $d8c6dd08bfe3a65f$var$_temp2;
    let t1;
    if ($[0] !== contentTypesHeaderDataLoading || $[1] !== isAttachmentsPage || $[2] !== isEditorToolbarShown || $[3] !== isLegacyObjectSidebarShown || $[4] !== isSpaceOverviewPage || $[5] !== isTitleFullyVisible || $[6] !== isVersionHistoryPage || $[7] !== shouldListenForTitleVisibilityChanges) {
        t1 = ()=>{
            const toggleSpaceNameBreadcrumbListener = ()=>{
                const separator = document.getElementById("breadcrumbs-separator");
                const spaceName = document.getElementById("breadcrumbs-space-name");
                const chevron = document.getElementById("breadcrumbs-dropdown-chevron-button");
                const contentTitle = document.getElementById("breadcrumbs-content-title");
                const showOnlyContentTitle = ()=>{
                    checkAndSetDisplayAttribute(separator, "none");
                    checkAndSetDisplayAttribute(spaceName, "none");
                    checkAndSetDisplayAttribute(chevron, "block");
                    checkAndSetStyle(contentTitle, "opacity", "1");
                    checkAndSetStyle(contentTitle, "maxWidth", "800px");
                };
                const showOnlySpaceName = ()=>{
                    checkAndSetDisplayAttribute(separator, "none");
                    checkAndSetDisplayAttribute(spaceName, "inline");
                    checkAndSetDisplayAttribute(chevron, "block");
                    checkAndSetStyle(contentTitle, "opacity", "0");
                    checkAndSetStyle(contentTitle, "maxWidth", "0px");
                };
                const showFullBreadcrumbs = ()=>{
                    checkAndSetDisplayAttribute(separator, "inline");
                    checkAndSetDisplayAttribute(spaceName, "inline");
                    checkAndSetDisplayAttribute(chevron, "block");
                    checkAndSetStyle(contentTitle, "opacity", "1");
                    checkAndSetStyle(contentTitle, "maxWidth", "800px");
                };
                const hideEntireBreadcrumbs = ()=>{
                    checkAndSetDisplayAttribute(separator, "none");
                    checkAndSetDisplayAttribute(spaceName, "none");
                    checkAndSetDisplayAttribute(chevron, "none");
                    checkAndSetStyle(contentTitle, "opacity", "0");
                    checkAndSetStyle(contentTitle, "maxWidth", "0px");
                };
                if (!isEditorToolbarShown) checkAndSetStyle(contentTitle, "transition", "opacity 100ms linear");
                if (!isSpaceOverviewPage && !isVersionHistoryPage && !isAttachmentsPage) {
                    if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) {
                        if (shouldListenForTitleVisibilityChanges) {
                            if (isTitleFullyVisible) showOnlySpaceName();
                            else if (contentTypesHeaderDataLoading) hideEntireBreadcrumbs();
                            else showFullBreadcrumbs();
                        } else {
                            if (isEditorToolbarShown) showFullBreadcrumbs();
                            checkAndSetDisplayAttribute(separator, "inline");
                            checkAndSetDisplayAttribute(spaceName, "inline");
                        }
                    } else if (shouldListenForTitleVisibilityChanges) {
                        if (isTitleFullyVisible) {
                            if (isLegacyObjectSidebarShown) showOnlyContentTitle();
                            else hideEntireBreadcrumbs();
                        } else if (contentTypesHeaderDataLoading) hideEntireBreadcrumbs();
                        else showOnlyContentTitle();
                    } else {
                        if (isEditorToolbarShown) showOnlyContentTitle();
                        checkAndSetDisplayAttribute(separator, "none");
                        checkAndSetDisplayAttribute(spaceName, "none");
                    }
                }
            };
            window.addEventListener("resize", toggleSpaceNameBreadcrumbListener);
            if (!hasMounted.current) hasMounted.current = true;
            else toggleSpaceNameBreadcrumbListener();
            return ()=>{
                window.removeEventListener("resize", toggleSpaceNameBreadcrumbListener);
            };
        };
        $[0] = contentTypesHeaderDataLoading;
        $[1] = isAttachmentsPage;
        $[2] = isEditorToolbarShown;
        $[3] = isLegacyObjectSidebarShown;
        $[4] = isSpaceOverviewPage;
        $[5] = isTitleFullyVisible;
        $[6] = isVersionHistoryPage;
        $[7] = shouldListenForTitleVisibilityChanges;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== contentId || $[10] !== contentTypesHeaderDataLoading || $[11] !== isAttachmentsPage || $[12] !== isEditorToolbarShown || $[13] !== isLegacyObjectSidebarShown || $[14] !== isSpaceOverviewPage || $[15] !== isTitleFullyVisible || $[16] !== isVersionHistoryPage || $[17] !== shouldListenForTitleVisibilityChanges) {
        t2 = [
            isLegacyObjectSidebarShown,
            shouldListenForTitleVisibilityChanges,
            isSpaceOverviewPage,
            isVersionHistoryPage,
            isAttachmentsPage,
            contentId,
            isTitleFullyVisible,
            isEditorToolbarShown,
            contentTypesHeaderDataLoading
        ];
        $[9] = contentId;
        $[10] = contentTypesHeaderDataLoading;
        $[11] = isAttachmentsPage;
        $[12] = isEditorToolbarShown;
        $[13] = isLegacyObjectSidebarShown;
        $[14] = isSpaceOverviewPage;
        $[15] = isTitleFullyVisible;
        $[16] = isVersionHistoryPage;
        $[17] = shouldListenForTitleVisibilityChanges;
        $[18] = t2;
    } else t2 = $[18];
    (0, $cozmU.useEffect)(t1, t2);
    if (!isVersionHistoryPage && !isAttachmentsPage) {
        if ((contentType === "blogpost" || contentType === "page" || contentType === "folder") && !isSpaceOverviewPage && !isArchived) {
            if (contentTypesHeaderDataLoading && !isTitleFullyVisible) return (0, $5Vf1r.BREADCRUMBS_MODES).HIDDEN;
            if (isEditorToolbarShown) {
                if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
                else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
            } else if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) {
                if (isTitleFullyVisible) return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_SPACE_NAME;
                else return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
            } else {
                if (isTitleFullyVisible) {
                    if (isLegacyObjectSidebarShown) return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
                    return (0, $5Vf1r.BREADCRUMBS_MODES).HIDDEN;
                } else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
            }
        } else if (contentType === "database" || (0, $1ggpj.isCanvasContentType)(contentType) || contentType === "embed") {
            if ($d8c6dd08bfe3a65f$var$getIsSideNavCollapsed()) return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
            else return (0, $5Vf1r.BREADCRUMBS_MODES).ONLY_CONTENT_TITLE;
        }
    }
    return (0, $5Vf1r.BREADCRUMBS_MODES).FULL;
};
function $d8c6dd08bfe3a65f$var$_temp(element, displayProperty) {
    if (!element) return;
    if ((0, $6mKj3.expValEquals)("platform_editor_reduce_forced_layout", "isEnabled", true)) {
        if (element.style.display !== displayProperty) element.setAttribute("style", `display: ${displayProperty};`);
        return;
    }
    if (window.getComputedStyle(element).getPropertyValue("display") !== displayProperty) element.setAttribute("style", `display: ${displayProperty};`);
}
function $d8c6dd08bfe3a65f$var$_temp2(element_0, property, value) {
    if (element_0 && element_0?.style?.[property] !== value) element_0.style[property] = value;
}



var $lEVfb = parcelRequire("lEVfb");










const $9234e6aea1a8bf8e$export$3a542eb6901fb0e2 = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, objectHeaderRef: objectHeaderRef, shouldUseProgressiveHeader: shouldUseProgressiveHeader } = t0;
    const [isIntersecting, setIsIntersecting] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== objectHeaderRef) {
        t1 = ()=>{
            if (objectHeaderRef?.current) {
                const title = document.getElementById("content-title-id") || document.getElementById("editor-title-id");
                if (title) {
                    const titleRect = title.getBoundingClientRect();
                    const headerRect = objectHeaderRef.current.getBoundingClientRect();
                    setIsIntersecting(titleRect.top < headerRect.bottom);
                }
            }
        };
        $[0] = objectHeaderRef;
        $[1] = t1;
    } else t1 = $[1];
    const checkIntersection = t1;
    let t2;
    if ($[2] !== checkIntersection || $[3] !== shouldUseProgressiveHeader) {
        t2 = ()=>{
            if (shouldUseProgressiveHeader) {
                if (!window.__SSR_RENDERED__ || !(0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) checkIntersection();
                window.addEventListener("scroll", checkIntersection, true);
                window.addEventListener("resize", checkIntersection);
            }
            return ()=>{
                window.removeEventListener("scroll", checkIntersection, true);
                window.removeEventListener("resize", checkIntersection);
            };
        };
        $[2] = checkIntersection;
        $[3] = shouldUseProgressiveHeader;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== checkIntersection || $[6] !== contentId || $[7] !== objectHeaderRef || $[8] !== shouldUseProgressiveHeader) {
        t3 = [
            contentId,
            objectHeaderRef,
            checkIntersection,
            shouldUseProgressiveHeader
        ];
        $[5] = checkIntersection;
        $[6] = contentId;
        $[7] = objectHeaderRef;
        $[8] = shouldUseProgressiveHeader;
        $[9] = t3;
    } else t3 = $[9];
    (0, $cozmU.useEffect)(t2, t3);
    return isIntersecting;
};


const $4e15ea858159a232$export$b109b4315ce03d6c = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { contentType: contentType, contentMode: contentMode, isSpaceOverviewPage: isSpaceOverviewPage, isVersionHistoryPage: isVersionHistoryPage, isAttachmentsPage: isAttachmentsPage, isArchived: isArchived, isLegacyObjectSidebarShown: isLegacyObjectSidebarShown, contentTypesHeaderDataLoading: contentTypesHeaderDataLoading, objectHeaderRef: objectHeaderRef, contentId: contentId } = t0;
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode, isEditMode: isLiveEditMode } = t1;
    const t2 = !isLiveEditMode;
    let t3;
    if ($[0] !== t2) {
        t3 = {
            defaultDockedAtTop: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)(t3);
    const isPageOrBlog = contentType === "page" || contentType === "blogpost";
    const isViewOrViewLiveMode = contentMode === "view" || isLiveViewMode;
    const isInEditor = contentMode === "draft" || contentMode === "edit" || isLiveEditMode;
    const isEditorToolbarShown = isInEditor && isEditorToolbarDockedAtTop;
    const shouldUseProgressiveHeader = isPageOrBlog && isViewOrViewLiveMode || isInEditor && !isEditorToolbarShown || isVersionHistoryPage || isAttachmentsPage || contentType === "folder";
    let t4;
    if ($[2] !== contentId || $[3] !== objectHeaderRef || $[4] !== shouldUseProgressiveHeader) {
        t4 = {
            contentId: contentId,
            objectHeaderRef: objectHeaderRef,
            shouldUseProgressiveHeader: shouldUseProgressiveHeader
        };
        $[2] = contentId;
        $[3] = objectHeaderRef;
        $[4] = shouldUseProgressiveHeader;
        $[5] = t4;
    } else t4 = $[5];
    const isTitleIntersectingWithHeader = (0, $9234e6aea1a8bf8e$export$3a542eb6901fb0e2)(t4);
    const t5 = !isTitleIntersectingWithHeader;
    let t6;
    if ($[6] !== contentId || $[7] !== contentType || $[8] !== contentTypesHeaderDataLoading || $[9] !== isArchived || $[10] !== isAttachmentsPage || $[11] !== isEditorToolbarShown || $[12] !== isLegacyObjectSidebarShown || $[13] !== isSpaceOverviewPage || $[14] !== isVersionHistoryPage || $[15] !== t5) {
        t6 = {
            isVersionHistoryPage: isVersionHistoryPage,
            isAttachmentsPage: isAttachmentsPage,
            contentType: contentType,
            isSpaceOverviewPage: isSpaceOverviewPage,
            isArchived: isArchived,
            isEditorToolbarShown: isEditorToolbarShown,
            isTitleFullyVisible: t5,
            isLegacyObjectSidebarShown: isLegacyObjectSidebarShown,
            contentId: contentId,
            contentTypesHeaderDataLoading: contentTypesHeaderDataLoading
        };
        $[6] = contentId;
        $[7] = contentType;
        $[8] = contentTypesHeaderDataLoading;
        $[9] = isArchived;
        $[10] = isAttachmentsPage;
        $[11] = isEditorToolbarShown;
        $[12] = isLegacyObjectSidebarShown;
        $[13] = isSpaceOverviewPage;
        $[14] = isVersionHistoryPage;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    const breadcrumbsDisplayMode = (0, $d8c6dd08bfe3a65f$export$49b33b1785ffa4cd)(t6);
    let isBorderlessHeader = !isSpaceOverviewPage && !isTitleIntersectingWithHeader && !isLegacyObjectSidebarShown && !isEditorToolbarShown || contentTypesHeaderDataLoading && isTitleIntersectingWithHeader;
    let t7;
    if ($[17] !== breadcrumbsDisplayMode || $[18] !== isBorderlessHeader || $[19] !== isEditorToolbarShown || $[20] !== isTitleIntersectingWithHeader || $[21] !== shouldUseProgressiveHeader) {
        t7 = {
            breadcrumbsDisplayMode: breadcrumbsDisplayMode,
            isBorderlessHeader: isBorderlessHeader,
            isEditorToolbarShown: isEditorToolbarShown,
            isTitleIntersectingWithHeader: isTitleIntersectingWithHeader,
            shouldUseProgressiveHeader: shouldUseProgressiveHeader
        };
        $[17] = breadcrumbsDisplayMode;
        $[18] = isBorderlessHeader;
        $[19] = isEditorToolbarShown;
        $[20] = isTitleIntersectingWithHeader;
        $[21] = shouldUseProgressiveHeader;
        $[22] = t7;
    } else t7 = $[22];
    return t7;
};





/**
 * @generated SignedSource<<308d8ea762a7fa250bd925d50e81cd4f>>
 * @relayHash 3b98665a502cac11f0f0e17a07349edb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd2c3ff0e434e977560973adbde3b7cc5f31ab2753416516ff2b5dee879618fd
const $7f834dc00463a9eb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentTitleUpdated",
                    "kind": "LinkedField",
                    "name": "contentTitleUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentTitle"
                        },
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTypesTitleSubscription",
            "selections": v2 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTypesTitleSubscription",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "3b98665a502cac11f0f0e17a07349edb",
            "id": "fd2c3ff0e434e977560973adbde3b7cc5f31ab2753416516ff2b5dee879618fd",
            "metadata": {},
            "name": "ContentTypesTitleSubscription",
            "operationKind": "subscription",
            "text": "subscription ContentTypesTitleSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,__typename,_deltas,contentTitleUpdated{contentTitle,__typename}}}"
        }
    };
}();
$7f834dc00463a9eb$var$node.hash = "ec5cbfcceb83c8c688c2eb6a721f9544";
var $7f834dc00463a9eb$export$2e2bcd8739ae039 = $7f834dc00463a9eb$var$node;






var $fD0Uz = parcelRequire("fD0Uz");


var $3vc4U = parcelRequire("3vc4U");





var $fJlJm = parcelRequire("fJlJm");











var $aMcHK = parcelRequire("aMcHK");





var $d9tcB = parcelRequire("d9tcB");

const $dfe2d565e9152de8$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined'
];
const $dfe2d565e9152de8$export$76c04e45533062c9 = (response, onDataReceived)=>{
    const payload = response?.subscriptionData?.data?.confluence_onContentModified;
    const _deltas = payload?._deltas;
    if (!payload || !Array.isArray(_deltas)) return;
    if (_deltas?.length === 0 || _deltas.indexOf('contentTitleUpdated') === -1) return;
    const { contentTitleUpdated: contentTitleUpdated } = payload;
    const title = contentTitleUpdated?.contentTitle;
    onDataReceived(title);
};
const $dfe2d565e9152de8$export$33a5663c83a12152 = (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { contentType: contentType, contentId: contentId, onDataReceived: onDataReceived, skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== contentId || $[1] !== contentType) {
        t2 = {
            contentType: contentType,
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = t2;
    } else t2 = $[2];
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onSubscriptionData } = (0, $3vc4U.useSubscriptionValues)(t2);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    let t3;
    if ($[3] !== id) {
        t3 = {
            id: id
        };
        $[3] = id;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== extensions || $[6] !== id || $[7] !== onDataReceived || $[8] !== onSubscriptionComplete || $[9] !== onSubscriptionData || $[10] !== skip || $[11] !== skipSubscriptionForAnonUsers || $[12] !== t3) {
        t4 = {
            variables: t3,
            extensions: extensions,
            onSubscriptionComplete: onSubscriptionComplete,
            onSubscriptionData (response) {
                $dfe2d565e9152de8$export$76c04e45533062c9(response, onDataReceived);
                onSubscriptionData(response);
            },
            skip: skip || !id || skipSubscriptionForAnonUsers,
            interopApolloAggClient: true
        };
        $[5] = extensions;
        $[6] = id;
        $[7] = onDataReceived;
        $[8] = onSubscriptionComplete;
        $[9] = onSubscriptionData;
        $[10] = skip;
        $[11] = skipSubscriptionForAnonUsers;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $7f834dc00463a9eb$export$2e2bcd8739ae039), {
        ...t4,
        __callerPackage__: "content-types-header"
    });
    let t5;
    let t6;
    if ($[14] !== contentId || $[15] !== contentType || $[16] !== error) {
        t5 = ()=>{
            if (error) {
                const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
                const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean("confluence_html_error_catching", false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
                const isIgnoredError = $dfe2d565e9152de8$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
                const statusCode = (0, $aMcHK.getStatusCode)(error) || error?.errors?.[0]?.extensions?.statusCode;
                if (statusCode !== 403 && !isIgnoredError) {
                    const e = new Error(`Subscription Error - ContentTypesTitleSubscription:${errorMessage}`);
                    (0, $fJlJm.setContentErrorAttributes)(e, {
                        objectId: contentId,
                        objectType: contentType
                    });
                    (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                    });
                }
                (0, $7Sm4c.markErrorAsHandled)(error);
            }
        };
        t6 = [
            error,
            contentId,
            contentType
        ];
        $[14] = contentId;
        $[15] = contentType;
        $[16] = error;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $cozmU.useEffect)(t5, t6);
    return null;
};












var $4ez2K = parcelRequire("4ez2K");





var $2JKSZ = parcelRequire("2JKSZ");


var $knzfV = parcelRequire("knzfV");


var $bFMG7 = parcelRequire("bFMG7");





var $hl0fg = parcelRequire("hl0fg");





var $1u6lx = parcelRequire("1u6lx");

const $5b06a9a89418566a$export$4ad2c8d6c7cae594 = 1000;
const $5b06a9a89418566a$export$9dbd9e1965ba2157 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    t0 === undefined || t0;
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const isIconOnly = windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594;
    return isIconOnly || renderServerPlaceholder ? (0, $1u6lx.TagButtonUIVariant).iconOnly : (0, $1u6lx.TagButtonUIVariant).default;
} : (_args = {})=>{
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const isIconOnly = windowWidth < $5b06a9a89418566a$export$4ad2c8d6c7cae594;
    // window is not availble in SSR so we need to need to render
    // the icon only while hydrating
    return isIconOnly || renderServerPlaceholder ? (0, $1u6lx.TagButtonUIVariant).iconOnly : (0, $1u6lx.TagButtonUIVariant).default;
};








/**
 * @generated SignedSource<<6639f45c4cc2dc293fb2949dbea5270a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4dfd3aefd5b50ce2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentBasicInfoFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$4dfd3aefd5b50ce2$var$node.hash = "c75429b09fee9e0b10f7ca8e827e75a3";
var $4dfd3aefd5b50ce2$export$2e2bcd8739ae039 = $4dfd3aefd5b50ce2$var$node;











const $b19fb0df3b9373e6$export$26aebb14cb61773d = (0, $3u0dr.isReactCompilerActiveV2)() ? (fragmentNode, fragmentRef)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== fragmentNode) {
        t0 = {
            fragmentSpec: fragmentNode
        };
        $[0] = fragmentNode;
        $[1] = t0;
    } else t0 = $[1];
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)(t0);
    const t1 = `${fragmentRef?.__typename}:${fragmentRef?.id}`;
    let t2;
    if ($[2] !== readFragmentInterop || $[3] !== t1) {
        t2 = readFragmentInterop({
            id: t1
        });
        $[2] = readFragmentInterop;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (fragmentNode, fragmentRef)=>{
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: fragmentNode
    });
    return readFragmentInterop({
        id: `${fragmentRef?.__typename}:${fragmentRef?.id}`
    });
};


const $da1026f8e09cf81c$export$d21a46dab87be04 = (contentBasicInfoRef, externalShareContent)=>{
    if (externalShareContent) return {
        id: externalShareContent.id,
        title: externalShareContent.title,
        type: externalShareContent.type,
        subType: externalShareContent.subType ?? null,
        status: externalShareContent.status
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b19fb0df3b9373e6$export$26aebb14cb61773d)((0, $4dfd3aefd5b50ce2$export$2e2bcd8739ae039), contentBasicInfoRef);
};


/**
 * @generated SignedSource<<4fb507ec69be37d77b3bfb8228936a85>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $428aade5a3e8b849$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentSpaceFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "alias"
        }
    ],
    "type": "Space"
};
$428aade5a3e8b849$var$node.hash = "5e7d3791ffec068935e152aaea16d3a4";
var $428aade5a3e8b849$export$2e2bcd8739ae039 = $428aade5a3e8b849$var$node;



const $437d3186ffdaf7cd$export$64efb28d9ab6d8a8 = (contentSpaceRef, externalShareContent)=>{
    if (externalShareContent?.space) return {
        id: externalShareContent.space.id,
        name: externalShareContent.space.name,
        key: externalShareContent.space.key,
        alias: externalShareContent.space.alias
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b19fb0df3b9373e6$export$26aebb14cb61773d)((0, $428aade5a3e8b849$export$2e2bcd8739ae039), contentSpaceRef);
};



// duplicated from ContentHeader
const $580936b329b9c958$var$ContentClassificationTagLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ifxj2",
    name: 'ContentClassificationTag',
    loader: async ()=>(await (parcelRequire("ds2ZC"))).ContentClassificationTag
});
const $580936b329b9c958$export$68383d0b588bf7b6 = ({ contentId: contentId, contentData: contentData, contentBasicInfoRef: contentBasicInfoRef, contentSpaceRef: contentSpaceRef, contentStatusContext: contentStatusContext, contentType: contentType, readOnly: readOnly, isSpaceOverviewPage: isSpaceOverviewPage, isObjectHeader: isObjectHeader })=>{
    let spaceKey, contentBasicInfo;
    if (contentBasicInfoRef && contentSpaceRef) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        contentBasicInfo = (0, $da1026f8e09cf81c$export$d21a46dab87be04)(contentBasicInfoRef);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        spaceKey = (0, $437d3186ffdaf7cd$export$64efb28d9ab6d8a8)(contentSpaceRef)?.key ?? '';
    } else {
        contentBasicInfo = contentData;
        spaceKey = contentData?.space?.key ?? '';
    }
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: spaceKey,
        contentStatusContext: contentStatusContext,
        shouldReadFromQueries: true
    });
    const isClassificationEnabled = contentClassificationMetadata?.featureEnabled ?? false;
    const classificationTagUiVariant = (0, $5b06a9a89418566a$export$9dbd9e1965ba2157)({
        contentTitle: contentBasicInfo?.title ?? '',
        classificationName: contentClassificationMetadata.classification?.name
    });
    if (((0, $1ggpj.isCanvasContentType)(contentType.type) || contentType.type === 'database' || contentType.type === 'embed' || !isObjectHeader) && // from renderOriginalHeader in ContentTypesHeader
    isClassificationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        testId: "content-types-header-classification"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2JKSZ.ContentTypeClassification), {
        variant: classificationTagUiVariant,
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType.type,
        contentClassificationMetadata: contentClassificationMetadata,
        readOnly: readOnly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knzfV.ClassificationEditModal), {
        contentId: contentId,
        spaceKey: spaceKey,
        contentClassificationMetadata: contentClassificationMetadata
    }));
    else if (contentType.mode === 'live' || contentType.mode === 'draft' || contentType.mode === 'edit') return null;
    else if (isSpaceOverviewPage) // we want to render the classification tag in the header for space overview pages
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "content-classification-tag"
    }, (0, $6mKj3.expValEquals)('dlp_auto_classifications_enabled', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2JKSZ.ContentTypeClassification), {
        variant: classificationTagUiVariant,
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType.type || null,
        contentClassificationMetadata: contentClassificationMetadata,
        readOnly: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($580936b329b9c958$var$ContentClassificationTagLoader, {
        contentId: contentId,
        contentType: contentType.type || null,
        contentClassificationMetadata: contentClassificationMetadata,
        isEditMode: false
    }));
    return null;
};


/**
 * @generated SignedSource<<d1072dc3f12c562d90c5b4f55b9b3274>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cda1bfac0303ae7e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "contentTypeModified"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "kind": "ScalarField",
            "name": "friendlyWhen"
        },
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "catchTo": "RESULT"
        },
        "name": "EditorContentTypesHeader_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "alias"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "subType"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "alias": "smartFolderProperties",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "smartFolderProperties"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"smartFolderProperties\"])"
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": v2 /*: any*/ 
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": v2 /*: any*/ 
            }
        ],
        "type": "Content"
    };
}();
$cda1bfac0303ae7e$var$node.hash = "72cb906a7a76ba0d112b9fe4c62e5c80";
var $cda1bfac0303ae7e$export$2e2bcd8739ae039 = $cda1bfac0303ae7e$var$node;


const $670e6d8ba843e357$export$8d80f480f5f7c5a0 = (0, $cda1bfac0303ae7e$export$2e2bcd8739ae039);


const $985b9df8a4afde11$var$asContentTypesHeaderQueryNode = (contentData)=>{
    if (!contentData) return contentData;
    if ('smartFolderProperties' in contentData) return {
        ...contentData,
        properties: contentData.smartFolderProperties
    };
    return contentData;
};
const $985b9df8a4afde11$export$9ea3622300cd40d2 = (0, $8ed80225f5935c72$export$2e2bcd8739ae039);
const $985b9df8a4afde11$export$e5688214a1861822 = {
    database: (0, $5qUgM.DATABASE_HEADER_SEGMENT_METRIC),
    embed: (0, $5qUgM.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC),
    whiteboard: (0, $5qUgM.WHITEBOARD_HEADER_SEGMENT_METRIC)
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$ContentActionContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showSeparator: showSeparator, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.showSeparator && "_0YfYpCOeNX _1gPMHuRsfN _0GBAIrogpp _47eTBtey7F",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
$985b9df8a4afde11$var$ContentActionContainer.displayName = 'ContentActionContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $985b9df8a4afde11$var$ArchiveBannerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFullWidth: isFullWidth, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _1pp6NdIZbP",
            __cmplp.isFullWidth ? "_2XghbEg3tj" : "_2XghbE4kLL _1EqgXlfqQP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
$985b9df8a4afde11$var$ArchiveBannerContainer.displayName = 'ArchiveBannerContainer';
const $985b9df8a4afde11$var$flexNavigationContainerStylesOld = (0, $buxP3.xcss)({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxSizing: 'border-box',
    justifyContent: 'space-between'
});
const $985b9df8a4afde11$var$flexNavigationContainerStyles = (0, $buxP3.xcss)({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxSizing: 'border-box',
    justifyContent: 'space-between'
});
const $985b9df8a4afde11$var$objectHeaderFlexNavigationContainerStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.0',
    paddingRight: 'space.0',
    overflow: 'hidden'
});
const $985b9df8a4afde11$var$floatingHeaderContainerStyles = (0, $buxP3.xcss)({
    marginTop: 'space.100',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    height: '58px'
});
const $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles = (0, $buxP3.xcss)({
    gap: 'space.075',
    alignItems: 'center',
    minWidth: '176px'
}); // Transition matches the one `useBreadcrumbsDisplayMode` applies to `#breadcrumbs-content-title`.
const $985b9df8a4afde11$var$contentTitleStyles = (0, $buxP3.xcss)({
    minWidth: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    transition: 'opacity 100ms linear'
});
const $985b9df8a4afde11$var$contentTitleVisibleStyles = (0, $buxP3.xcss)({
    opacity: 1
});
const $985b9df8a4afde11$var$contentTitleHiddenStyles = (0, $buxP3.xcss)({
    opacity: 0,
    pointerEvents: 'none'
});
const $985b9df8a4afde11$var$objectHeaderStyles = (0, $buxP3.xcss)({
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'elevation.surface',
    height: '56px',
    zIndex: 'layer'
});
const $985b9df8a4afde11$var$objectHeaderSpotlightZIndexOverride = (0, $buxP3.xcss)({
    zIndex: 'spotlight'
}); // If the object header's size changes, make sure to update the height constant
// FIXED_OBJECT_HEADER_SSR_HEIGHT in contentTypesHeaderConstants.ts
const $985b9df8a4afde11$var$fixedBorderHeaderContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.150',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $985b9df8a4afde11$var$borderHeaderFadeInStyles = (0, $buxP3.xcss)({
    transition: 'border-bottom 100ms linear'
});
const $985b9df8a4afde11$var$fixedBorderlessHeaderContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.150',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-inverse, #FFFFFF)"}`
});
const $985b9df8a4afde11$var$floatingBlockHeaderStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.xlarge',
    padding: 'space.100',
    backgroundColor: 'elevation.surface',
    height: '56px',
    pointerEvents: 'auto',
    minWidth: '176px'
});
const $985b9df8a4afde11$var$objectHeaderActionsContainerStyles = (0, $buxP3.xcss)({
    flexShrink: 0,
    paddingRight: 'space.075'
});
const $985b9df8a4afde11$var$inlineRenameMarginStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.negative.075'
});
const $985b9df8a4afde11$var$inlineRenameOverflowStyles = (0, $buxP3.xcss)({
    overflow: 'hidden'
});
const $985b9df8a4afde11$var$mobileAppWhiteboardStyles = (0, $buxP3.xcss)({
    pointerEvents: 'none',
    userSelect: 'none',
    touchAction: 'none'
});
const $985b9df8a4afde11$var$skeletonBreadcrumbsStyles = (0, $buxP3.xcss)({
    height: '20px',
    width: '200px'
});
const $985b9df8a4afde11$var$skeletonTitleStyles = (0, $buxP3.xcss)({
    height: '24px',
    width: '300px'
});
const $985b9df8a4afde11$var$skeletonActionSmallStyles = (0, $buxP3.xcss)({
    height: '32px',
    width: '80px'
});
const $985b9df8a4afde11$var$skeletonActionLargeStyles = (0, $buxP3.xcss)({
    height: '32px',
    width: '100px'
});
const $985b9df8a4afde11$var$getShareAction = (mode)=>mode === (0, $cD1qu.PageMode).EDIT ? (0, $cD1qu.PageMode).EDIT : (0, $cD1qu.PageMode).VIEW;
const $985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { shouldShowEmojiTitle: shouldShowEmojiTitle, contentId: contentId, readOnly: readOnly, contentType: contentType, title: title, isMarkdownMode: t1, spaceName: spaceName, onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler, showInlineRename: t2 } = t0;
    const isMarkdownMode = t1 === undefined ? false : t1;
    const showInlineRename = t2 === undefined ? true : t2;
    const { isEditing: isEditing, setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub, updateCache: updateCache } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title);
    const onDataReceivedRef = (0, $cozmU.useRef)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (newTitle)=>onDataReceivedRef?.current?.(newTitle);
        $[0] = t3;
    } else t3 = $[0];
    const stableOnDataReceived = t3;
    if (!showInlineRename) return null;
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            $985b9df8a4afde11$var$inlineRenameMarginStyles,
            $985b9df8a4afde11$var$inlineRenameOverflowStyles
        ];
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            (0, $7xVCs.PageTreeStateUpdater)
        ];
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== contentId || $[4] !== contentType || $[5] !== isEditing || $[6] !== isMarkdownMode || $[7] !== onCloseTitleSpotlight || $[8] !== readOnly || $[9] !== registerShowTitleSpotlightHandler || $[10] !== setUpdatedTitleFromPubsub || $[11] !== shouldShowEmojiTitle || $[12] !== spaceName || $[13] !== title || $[14] !== updateCache) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            gap: "space.075",
            alignItems: "center",
            testId: "inline-rename-breadcrumb-title",
            xcss: t4
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t5
        }, (pageStateUpdater)=>{
            const updateContentTree = ()=>{
                pageStateUpdater.setForceFetchPageId(contentId);
            };
            const onDataReceived = (newTitle_0)=>{
                if (!isEditing) {
                    updateCache(newTitle_0);
                    updateContentTree();
                    setUpdatedTitleFromPubsub(undefined);
                } else setUpdatedTitleFromPubsub(newTitle_0);
            };
            onDataReceivedRef.current = onDataReceived;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                space: "space.0",
                alignBlock: "center",
                xcss: $985b9df8a4afde11$var$inlineRenameOverflowStyles
            }, shouldShowEmojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z0fF.EmojiTitleSelection), {
                "data-testid": "emoji-title-selection",
                contentId: contentId,
                isTitleDisabled: false,
                isTitleCenterAligned: true,
                hasCoverPicture: false,
                isReadOnly: readOnly,
                contentType: contentType,
                updateContentTree: updateContentTree
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $778018eca844ead1$export$42d61ec2afde455f), {
                title: title ?? "",
                contentId: contentId,
                spaceName: spaceName ?? "",
                readOnly: readOnly,
                key: title,
                updateContentTree: updateContentTree,
                contentType: contentType ?? "",
                isMarkdownMode: isMarkdownMode,
                onCloseTitleSpotlight: onCloseTitleSpotlight,
                registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dfe2d565e9152de8$export$33a5663c83a12152), {
                contentId: contentId,
                contentType: contentType,
                onDataReceived: stableOnDataReceived,
                skip: !(0, $9wGTI.fg)("cc_fps_migration_content-title") || ![
                    "DUAL",
                    "GRAPHQL"
                ].includes((0, $1xpoY.default).getString("confluence-migrate-fps-to-graphql-subscription", ""))
            }));
        }));
        $[3] = contentId;
        $[4] = contentType;
        $[5] = isEditing;
        $[6] = isMarkdownMode;
        $[7] = onCloseTitleSpotlight;
        $[8] = readOnly;
        $[9] = registerShowTitleSpotlightHandler;
        $[10] = setUpdatedTitleFromPubsub;
        $[11] = shouldShowEmojiTitle;
        $[12] = spaceName;
        $[13] = title;
        $[14] = updateCache;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
$985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb.displayName = 'ContentTypesInlineRenameBreadcrumb';
const $985b9df8a4afde11$var$ContentTypesHeaderInnerContent = ({ contentData: contentData, contentTypesHeaderDataLoading: contentTypesHeaderDataLoading = false, ContentTypesHeaderQueryError: ContentTypesHeaderQueryError, contentId: contentId, contentActions: contentActions, isFloating: isFloating = false, allowedFeatures: allowedFeatures = (0, $4cb3eaaf01c9d693$export$dce52735e291d3da), onCloseTitleSpotlight: onCloseTitleSpotlight, registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler, onHeightChange: onHeightChange, handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight, onShareClick: onShareClick, onCopyLinkClick: onCopyLinkClick, editContentFragmentRef: editContentFragmentRef, shareContentFragmentRef: shareContentFragmentRef, publicLinkPage: publicLinkPage, isSpaceOverviewPage: isSpaceOverviewPage = false, isConvertToFolderHighlighted: isConvertToFolderHighlighted = false, setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted, whiteboardAIAgentService: whiteboardAIAgentService, viewOnlyBadge: viewOnlyBadge })=>{
    const { shareButton: accessLinkShareButton, title: accessLinkTitle } = (0, $cozmU.useContext)((0, $4Wxqa.AccessLinkHeaderReplacementsContext));
    const isAccessLinkViewer = (0, $dnfJM.useIsAccessLinkRequest)();
    const isExternal = (0, $jjv3l.useIsRestrictedExternalShareRequest)(); // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { bannerHeight: headerHeight, setBannerElement: setHeaderHeightElement } = (0, $bvJwp.useResizeBanner)(isSSR);
    const objectHeaderRef = (0, $cozmU.useRef)(null); // If accessing these values outside of editor sessions, they will be default values
    const { editorTitle: editorTitle, shouldRenderPreview: shouldRenderPreview } = (0, $3o3i5.useEditorObjectHeaderContext)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { approvalRequest: approvalRequest, isContentApprovalsEnabled: isContentApprovalsEnabled, isRequiredApproversActive: isRequiredApproversActive } = (0, $laFNM.useApprovals)();
    const panel = (0, $aWwYt.usePanel)();
    const isLegacyObjectSidebarShown = isObjectSidebarShown && !((0, $9wGTI.fg)('ads-panel-system-confluence-object-sidebar') && (0, $jvYFk.isMigratedToPanelSystem)(panel?.id));
    const isVersionHistoryPage = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.CONTENT_HISTORY).name
    });
    const isAttachmentsPage = (0, $dPJCf.useRouteName)({
        selector: (routeName_0)=>routeName_0 === (0, $1NBp8.ATTACHMENTS_PAGE).name
    }); // Automation manual trigger modal listening for query param
    (0, $hQBR9.useAutomationUrlParamTrigger)((0, $9wGTI.fg)('a4c-enable-automation-url-trigger'));
    (0, $cozmU.useEffect)(()=>{
        onHeightChange?.(headerHeight);
    }, [
        headerHeight,
        onHeightChange
    ]);
    const contentTypesHeaderQueryNode = $985b9df8a4afde11$var$asContentTypesHeaderQueryNode(contentData);
    const contentSpace = contentTypesHeaderQueryNode?.space;
    const contentBasicInfo = contentTypesHeaderQueryNode;
    const spaceKey = contentSpace?.key || ''; // Different pieces of content can have different modes, which need to be reflected in this header.
    // Eg, pages & blogposts can be 'draft', 'archived', 'view', 'edit', or 'live' (or 'embedded', or 'legacy'!)
    const rawContentType = contentBasicInfo?.type ?? undefined; // ShareButton's shareContentType prop doesn't like null values
    const isArchived = contentBasicInfo?.status === 'archived';
    const isDraft = contentBasicInfo?.status === 'draft';
    const isViewEditOrLive = (0, $aSsfA.useGetPageMode)(); // we use subType value directly for live pages bc when a user is not on the live page route,
    // the live docs sweet state store is not populated and useIsCurrentPageLive in useGetPageMode returns false
    const subType = contentBasicInfo?.subType;
    const contentType = (0, $cozmU.useMemo)(()=>({
            type: rawContentType,
            mode: (0, $cuWTe.getContentMode)(rawContentType, isArchived, isDraft, subType === 'live' ? subType : isViewEditOrLive)
        }), [
        rawContentType,
        isArchived,
        isDraft,
        subType,
        isViewEditOrLive
    ]);
    const hasActiveApprovalReview = Boolean(approvalRequest?.review) && approvalRequest?.review?.reviewStatus !== 'CANCELED';
    const approvalsPaneContentStatus = isDraft ? (0, $1vpkQ.APPROVALS_PANE_DRAFT_CONTENT_STATUS) : (0, $1vpkQ.APPROVALS_PANE_CURRENT_CONTENT_STATUS);
    const handleSuccessfulShareWithApprovalIntent = (0, $cozmU.useCallback)((intent)=>{
        (0, $1vpkQ.openApprovalsPaneForContext)({
            contentId: contentId,
            contentStatus: approvalsPaneContentStatus,
            initialApprovers: intent.approvers,
            entryPoint: 'shareDialog',
            rightSidebarContext: rightSidebarContext
        });
    }, [
        approvalsPaneContentStatus,
        contentId,
        rightSidebarContext
    ]);
    const isEditPage = (0, $cozmU.useMemo)(()=>contentType.mode === 'live' || contentType.mode === 'draft' || contentType.mode === 'edit', [
        contentType.mode
    ]);
    const { shouldDisableEditorButtons: shouldDisableEditorButtons } = (0, $85c7900526df4a2e$export$b0a1564bba9108e3)(contentId, contentType.mode);
    const isUnpublishedDraft = contentType.mode === 'draft';
    const isRecapSpotlightEligible = (0, $l7iY7.useRecapSpotlightEligibility)(isUnpublishedDraft);
    let contentStatusContext;
    if (contentType.mode === 'live') contentStatusContext = 'current-and-draft';
    else if (contentType.mode === 'edit' || contentType.mode === 'draft') contentStatusContext = 'draft-only';
    else contentStatusContext = 'current-only';
    const { breadcrumbsDisplayMode: breadcrumbsDisplayMode, isBorderlessHeader: isBorderlessHeader, isEditorToolbarShown: isEditorToolbarShown, isTitleIntersectingWithHeader: isTitleIntersectingWithHeader, shouldUseProgressiveHeader: shouldUseProgressiveHeader } = (0, $4e15ea858159a232$export$b109b4315ce03d6c)({
        contentType: contentType.type,
        contentMode: contentType.mode || '',
        isSpaceOverviewPage: isSpaceOverviewPage,
        isVersionHistoryPage: isVersionHistoryPage,
        isAttachmentsPage: isAttachmentsPage,
        isArchived: isArchived,
        isLegacyObjectSidebarShown: isLegacyObjectSidebarShown,
        contentTypesHeaderDataLoading: contentTypesHeaderDataLoading,
        objectHeaderRef: objectHeaderRef,
        contentId: contentId
    }); // When the progressive reveal is off no scroll signal ever arrives, so waiting for it would
    // hide the title permanently. Show it outright instead.
    const isContentTitleVisible = isTitleIntersectingWithHeader || !shouldUseProgressiveHeader;
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isMobileAppWhiteboard = isMobileApp && contentType.type === 'whiteboard';
    const operations = contentData?.operations;
    const isReadOnlyDueToContext = isMobileAppWhiteboard || isExternal;
    const hasUpdatePermission = operations?.some((operation)=>operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation?.targetType) && operation?.operation === 'update');
    const readOnly = isReadOnlyDueToContext || !hasUpdatePermission;
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const shouldShowEmojiTitle = (0, $99t4P.isEmojiTitleEnabled)(contentType.type); // Whiteboard and Database's archive banner renders in its own shell to account for a pinned solid header and a side panel
    // Similarly, pages and blogposts manage their own archive banner
    const showArchiveBanner = contentType.type === 'embed';
    const hasFullWidthBanner = contentType.type === 'embed';
    const accessLinkResolvedFeatures = (0, $52743c6077a5aa9d$export$994d93100c71c210)({
        allowedFeatures: allowedFeatures,
        hasAccessLinkTitle: Boolean(accessLinkTitle),
        isAccessLinkViewer: isAccessLinkViewer
    });
    const { showBreadcrumbs: breadcrumbsIsAllowedFeature, showInlineRename: inlineRenameIsAllowedFeature = true, showReplacementAccessLinkTitle: accessLinkTitleIsAllowedFeature = true } = accessLinkResolvedFeatures;
    const shouldShowAccessLinkTitleInBreadcrumbs = accessLinkTitleIsAllowedFeature && Boolean(accessLinkTitle);
    const showInlineRename = contentType.type !== 'page' && contentType.type !== 'blogpost' && inlineRenameIsAllowedFeature;
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(contentType.type === 'page' ? contentId : undefined);
    const isLivePageInMarkdownMode = contentType.type === 'page' && contentType.mode === 'live' && isMarkdownMode;
    const shouldShowInlineRenameInBreadcrumbs = inlineRenameIsAllowedFeature && (showInlineRename || isLivePageInMarkdownMode);
    const canUpdatePageTitleInMarkdownMode = !!operations?.some((operation_0)=>operation_0?.targetType === 'page' && operation_0?.operation === 'update');
    const inlineRenameReadOnly = isLivePageInMarkdownMode ? !canUpdatePageTitleInMarkdownMode || isReadOnlyDueToContext : readOnly;
    const renderCopyLink = ()=>{
        if (Object.values((0, $18vK6.SUPPORTED_CONTENT_TYPES)).includes(contentType.type)) return(// onClickCapture on a role="presentation" span intercepts copy-link clicks for
        // callers that need to observe them, without making the wrapper itself interactive.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            role: "presentation",
            onClickCapture: onCopyLinkClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPoXA.CopyLinkButtonLoader), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType.type,
            source: "contentHeader",
            /**
                                                                                                                            * All currently-supported content types currently treats both viewing and
                                                                                                                            * editing the same. To avoid issues, we'll refer to viewing to maintain
                                                                                                                            * consistency, as using 'edit' would generate a different URL.
                                                                                                                            */ pageMode: "view"
        })));
    };
    const renderShare = (opts)=>{
        // `ShareAndRestrictButton` renders permanently disabled for a token-only viewer, whose
        // permissions query never resolves.
        if (isAccessLinkViewer && accessLinkShareButton) return(// onClickCapture on a role="presentation" span intercepts share clicks for
        // callers that need to observe them, without making the wrapper itself interactive.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            role: "presentation",
            onClickCapture: onShareClick
        }, accessLinkShareButton));
        return(// onClickCapture on a role="presentation" span intercepts share clicks for
        // callers that need to observe them, without making the wrapper itself interactive.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            role: "presentation",
            onClickCapture: onShareClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
            contentId: contentId,
            contentFragmentRef: shareContentFragmentRef,
            publicLinkPage: publicLinkPage,
            contentType: contentType.type,
            shareeAction: $985b9df8a4afde11$var$getShareAction(isViewEditOrLive),
            source: "contentHeader",
            isUnpublishedDraft: contentType.mode === 'draft',
            contentSubType: contentType.mode === 'live' ? 'live' : undefined,
            isNotifyDisabled: opts?.isNotifyDisabled,
            isApprovalHandoffEnabled: contentType.type === 'page' && contentType.mode !== 'live' && isContentApprovalsEnabled && !hasActiveApprovalReview && !isRequiredApproversActive && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            onSuccessfulShareWithApprovalIntent: handleSuccessfulShareWithApprovalIntent
        })));
    };
    const wrappedRenderShare = (opts_0)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), null, renderShare(opts_0)));
    }; // The primary reason for this structure is to support programmatic control of when a separator should render
    const headerItems = (0, $2c279a34b2a89086$export$2ed55bc7ce9c518)({
        contentId: contentId,
        contentType: contentType.type,
        contentMode: contentType.mode,
        contentActions: contentActions,
        handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
        allowedFeatures: accessLinkResolvedFeatures,
        contentData: contentTypesHeaderQueryNode,
        editContentFragmentRef: editContentFragmentRef,
        renderCopyLink: renderCopyLink,
        renderShare: wrappedRenderShare,
        isSpaceOverviewPage: isSpaceOverviewPage,
        readOnly: readOnly,
        isConvertToFolderHighlighted: isConvertToFolderHighlighted,
        setIsConvertToFolderHighlighted: setIsConvertToFolderHighlighted,
        whiteboardAIAgentService: whiteboardAIAgentService,
        isVersionHistoryPage: isVersionHistoryPage,
        isAttachmentsPage: isAttachmentsPage
    });
    const renderActionContainers = ()=>{
        const contentToRender = headerItems.filter((contentActions_0)=>contentActions_0.shouldRender);
        return contentToRender.map((contentAction, index)=>{
            const { name: name, shouldShowSeparator: shouldShowSeparator, children: children, shouldRenderInContainer: shouldRenderInContainer = true } = contentAction;
            const isLastEntry = index + 1 === contentToRender.length;
            const showSeparator = isLastEntry ? false : shouldShowSeparator;
            const testIdName = `${name}-action-container-${showSeparator ? 'with-separator' : 'without-separator'}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                key: name
            }, shouldRenderInContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentActionContainer, {
                "data-testid": testIdName,
                showSeparator: showSeparator,
                "data-vc": testIdName
            }, children) : children);
        });
    };
    const hasActionsToRender = ()=>{
        return headerItems.some((contentAction_0)=>contentAction_0.shouldRender);
    };
    const renderObjectHeader = ()=>{
        if (shouldRenderPreview) return null;
        const isFloatingBlockHeader = (0, $1ggpj.isCanvasContentType)(contentType.type); // Return link for Version History or Attachments breadcrumbs
        const contentLink = contentId && contentType.type && (isVersionHistoryPage || isAttachmentsPage) ? (0, $hzkzq.buildContentPath)({
            contentId: contentId,
            contentType: contentType.type === 'space' ? 'page' : contentType.type,
            isSpaceOverview: isSpaceOverviewPage,
            spaceKey: spaceKey
        }) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: [
                $985b9df8a4afde11$var$objectHeaderStyles,
                isRecapSpotlightEligible && $985b9df8a4afde11$var$objectHeaderSpotlightZIndexOverride,
                isFloatingBlockHeader && $985b9df8a4afde11$var$floatingHeaderContainerStyles,
                !isFloatingBlockHeader && isBorderlessHeader && $985b9df8a4afde11$var$fixedBorderlessHeaderContainerStyles,
                !isFloatingBlockHeader && !isBorderlessHeader && $985b9df8a4afde11$var$fixedBorderHeaderContainerStyles,
                !isEditorToolbarShown && $985b9df8a4afde11$var$borderHeaderFadeInStyles,
                isMobileAppWhiteboard && $985b9df8a4afde11$var$mobileAppWhiteboardStyles
            ],
            ref: objectHeaderRef,
            id: "object-header-container-id",
            testId: "object-header-container",
            "data-vc": "object-header-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: [
                $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles,
                isFloatingBlockHeader && $985b9df8a4afde11$var$floatingBlockHeaderStyles
            ]
        }, breadcrumbsIsAllowedFeature && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c44703207686ef4$export$8bb26699ba16d6a3), {
            contentId: contentId,
            // the alias because that is used in the route URL so SSR will pick that up as the
            // space key and use it in the preloading cache for the space detail query.  If we
            // use the true (UUID) space key here in the request, the SSR cache will not find it
            // in the cache and we won't see the breadcrumbs in the SSR'ed version of the header
            spaceKey: contentSpace?.alias ?? contentSpace?.key ?? '',
            contentTitle: (0, $71c531080fb6afdc$export$753f77420b5437b9)({
                isSpaceOverviewPage: isSpaceOverviewPage,
                contentMode: contentType.mode,
                editorTitle: editorTitle,
                contentTitle: contentBasicInfo?.title
            }),
            showInlineRename: shouldShowInlineRenameInBreadcrumbs,
            shouldDisableMoveButton: shouldDisableEditorButtons,
            displayMode: breadcrumbsDisplayMode,
            contentLink: contentLink,
            contentType: contentType.type,
            subType: contentType.mode === 'live' ? 'live' : undefined
        }), shouldShowAccessLinkTitleInBreadcrumbs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: [
                $985b9df8a4afde11$var$contentTitleStyles,
                isContentTitleVisible ? $985b9df8a4afde11$var$contentTitleVisibleStyles : $985b9df8a4afde11$var$contentTitleHiddenStyles
            ],
            testId: "header-content-title"
        }, accessLinkTitle), shouldShowInlineRenameInBreadcrumbs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentTypesInlineRenameBreadcrumb, {
            contentId: contentId,
            readOnly: inlineRenameReadOnly,
            contentType: contentType.type,
            spaceName: contentSpace?.name,
            title: contentBasicInfo?.title,
            isMarkdownMode: isMarkdownMode,
            shouldShowEmojiTitle: shouldShowEmojiTitle,
            onCloseTitleSpotlight: onCloseTitleSpotlight,
            registerShowTitleSpotlightHandler: registerShowTitleSpotlightHandler
        }), viewOnlyBadge, !isEditPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $580936b329b9c958$export$68383d0b588bf7b6), {
            contentStatusContext: contentStatusContext,
            contentData: contentTypesHeaderQueryNode,
            contentId: contentId,
            contentType: contentType,
            readOnly: readOnly,
            isSpaceOverviewPage: isSpaceOverviewPage,
            isObjectHeader: true
        })), !isMobile && !isMobileApp && hasActionsToRender() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.075",
            alignBlock: "center",
            alignInline: "end",
            xcss: [
                $985b9df8a4afde11$var$objectHeaderActionsContainerStyles,
                isFloatingBlockHeader && $985b9df8a4afde11$var$floatingBlockHeaderStyles
            ],
            testId: "object-header-actions-container"
        }, renderActionContainers())));
    };
    const segmentMetric = $985b9df8a4afde11$export$e5688214a1861822[contentType.type];
    const headerComponents = renderObjectHeader(); // We moved the classification modal context provider to the fullpageeditor component level for page editor to be able to use it
    // in the page editor byline. We need to conditionally render it here for the other content types.
    const ConditionalClassificationProvider = contentType.mode === 'live' || contentType.mode === 'draft' || contentType.mode === 'edit' ? (0, $cozmU.Fragment) : (0, $40pD8.ClassificationModalContextProvider);
    const hasPointerEvents = !(0, $1ggpj.isCanvasContentType)(contentType.type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC)
    }), segmentMetric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: segmentMetric
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lyx2E.ContentTypesHeaderContainer), {
        isFloating: isFloating,
        ref: setHeaderHeightElement,
        hasPointerEvents: hasPointerEvents,
        key: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            (0, $6mKj3.isExperimentEnabled)('platform_editor_fix_ssr_vr_mismatch') ? $985b9df8a4afde11$var$flexNavigationContainerStyles : $985b9df8a4afde11$var$flexNavigationContainerStylesOld,
            $985b9df8a4afde11$var$objectHeaderFlexNavigationContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ConditionalClassificationProvider, null, headerComponents)), showArchiveBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ArchiveBannerContainer, {
        isFullWidth: hasFullWidthBanner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deZfn.ArchivedPageBanner), {
        contentId: contentId,
        marginStyle: "none"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        attributes: {
            contentId: contentId,
            contentType: contentType.type
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE),
        attributes: {
            contentId: contentId,
            contentType: contentType.type,
            contentMode: contentType.mode
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC),
        customData: {
            contentType: contentType.type,
            contentMode: contentType.mode
        }
    }), ContentTypesHeaderQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: ContentTypesHeaderQueryError
    }));
};
$985b9df8a4afde11$var$ContentTypesHeaderInnerContent.displayName = 'ContentTypesHeaderInnerContent';
const $985b9df8a4afde11$var$ContentTypesHeaderInnerFromFragment = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let contentFragmentRef;
    let props;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = contentFragmentRef;
        $[2] = props;
    } else {
        contentFragmentRef = $[1];
        props = $[2];
    }
    const contentFragmentData = (0, $6SsN4.useFragment)($985b9df8a4afde11$export$9ea3622300cd40d2, contentFragmentRef);
    let t1;
    if ($[3] !== contentFragmentData || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInnerContent, {
            ...props,
            contentData: contentFragmentData
        });
        $[3] = contentFragmentData;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
$985b9df8a4afde11$var$ContentTypesHeaderInnerFromFragment.displayName = 'ContentTypesHeaderInnerFromFragment';
const $985b9df8a4afde11$var$ContentTypesHeaderInnerFromEditorFragment = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let editorContentFragmentRef;
    let props;
    if ($[0] !== t0) {
        ({ editorContentFragmentRef: editorContentFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = editorContentFragmentRef;
        $[2] = props;
    } else {
        editorContentFragmentRef = $[1];
        props = $[2];
    }
    const result = (0, $6SsN4.useFragment)((0, $670e6d8ba843e357$export$8d80f480f5f7c5a0), editorContentFragmentRef);
    let t1;
    if ($[3] !== result) {
        t1 = result && !result.ok ? new Error("EditorContentTypesHeader_content field error", {
            cause: result.errors
        }) : undefined;
        $[3] = result;
        $[4] = t1;
    } else t1 = $[4];
    const error = t1;
    const t2 = result?.ok ? result.value : null;
    let t3;
    if ($[5] !== error || $[6] !== props || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInnerContent, {
            ...props,
            contentData: t2,
            ContentTypesHeaderQueryError: error
        });
        $[5] = error;
        $[6] = props;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
};
const $985b9df8a4afde11$var$ContentTypesHeaderInnerFromQuery = (props)=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] !== props.contentId) {
        t0 = {
            variables: {
                contentId: props.contentId
            },
            fetchPolicy: "cache-and-network"
        };
        $[0] = props.contentId;
        $[1] = t0;
    } else t0 = $[1];
    const result = (0, $jMyy4.useQueryInterop)((0, $568fA.default), {
        ...t0,
        __callerPackage__: "content-types-header"
    });
    const t1 = result?.data?.content?.nodes?.[0];
    const t2 = result?.loading;
    const t3 = result?.error;
    let t4;
    if ($[2] !== props || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInnerContent, {
            ...props,
            contentData: t1,
            contentTypesHeaderDataLoading: t2,
            ContentTypesHeaderQueryError: t3
        });
        $[2] = props;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};
$985b9df8a4afde11$var$ContentTypesHeaderInnerFromQuery.displayName = 'ContentTypesHeaderInnerFromQuery';
const $985b9df8a4afde11$var$ContentTypesHeaderInner = (props)=>{
    const $ = (0, $bDgLe.c)(8);
    if (props.externalShareContent) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInnerContent, {
                ...props,
                contentData: props.externalShareContent
            });
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    if (props.editorContentFragmentRef !== undefined) {
        let t0;
        if ($[2] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInnerFromEditorFragment, {
                ...props,
                editorContentFragmentRef: props.editorContentFragmentRef
            });
            $[2] = props;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    }
    if (props.contentFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_obj_header_frag_dedup") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t0;
        if ($[4] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInnerFromFragment, {
                ...props,
                contentFragmentRef: props.contentFragmentRef
            });
            $[4] = props;
            $[5] = t0;
        } else t0 = $[5];
        return t0;
    }
    let t0;
    if ($[6] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInnerFromQuery, props);
        $[6] = props;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
};
$985b9df8a4afde11$var$ContentTypesHeaderInner.displayName = 'ContentTypesHeaderInner';
const $985b9df8a4afde11$export$f6490cc19c07c23d = ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $985b9df8a4afde11$var$objectHeaderBreadcrumbsAndMetadataStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $985b9df8a4afde11$var$skeletonBreadcrumbsStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $985b9df8a4afde11$var$skeletonTitleStyles
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lyx2E.ContentTypesHeaderContainer), {
            isFloating: false,
            hasPointerEvents: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: (0, $6mKj3.isExperimentEnabled)("platform_editor_fix_ssr_vr_mismatch") ? $985b9df8a4afde11$var$flexNavigationContainerStyles : $985b9df8a4afde11$var$flexNavigationContainerStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $985b9df8a4afde11$var$objectHeaderStyles
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.075",
            alignBlock: "center",
            alignInline: "end",
            xcss: $985b9df8a4afde11$var$objectHeaderActionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $985b9df8a4afde11$var$skeletonActionSmallStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $985b9df8a4afde11$var$skeletonActionLargeStyles
        })))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $985b9df8a4afde11$export$e3980b758fe4ea84 = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$export$f6490cc19c07c23d, null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-types-header",
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($985b9df8a4afde11$var$ContentTypesHeaderInner, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
$985b9df8a4afde11$export$e3980b758fe4ea84.displayName = 'ContentTypesHeader';
module.exports["ContentTypesHeader"] = $985b9df8a4afde11$export$e3980b758fe4ea84;

});

parcelRegister("bvJwp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $357714bfdc877a0f$export$75b569184a0dd765 = (isSSR)=>{
    const [bannerHeight, setBannerHeight] = (0, $cozmU.useState)(0);
    const [bannerElement, setBannerElement] = (0, $cozmU.useState)(null);
    const resizeObserver = (0, $cozmU.useMemo)(()=>{
        if (!isSSR) return new ResizeObserver((entries)=>{
            for (const entry of entries)setBannerHeight(entry.borderBoxSize[0].blockSize);
        });
    }, [
        isSSR
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (bannerElement && resizeObserver) {
            resizeObserver.observe(bannerElement);
            return ()=>resizeObserver.unobserve(bannerElement);
        } else setBannerHeight(0);
    }, [
        bannerElement,
        resizeObserver
    ]);
    return {
        setBannerElement: setBannerElement,
        bannerHeight: bannerHeight,
        setBannerHeight: setBannerHeight
    };
};
module.exports["useResizeBanner"] = $357714bfdc877a0f$export$75b569184a0dd765;

});

parcelRegister("hQBR9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aF6s = parcelRequire("8aF6s");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $jmjWc = parcelRequire("jmjWc");


const $89f8907be2f15304$var$PageUrlAutomationMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "KurQn",
    name: "PageUrlAutomationMenu",
    loader: async ()=>(await (parcelRequire("gcKEc"))).PageUrlAutomationMenu
});
const $89f8907be2f15304$var$useRunAutomationIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('runAutomationId');
const $89f8907be2f15304$export$88bb754436f46ef4 = (featureGateEnabled = true)=>{
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    // These return 'undefined' from within modals for some reason, so have to get them here instead of inside PageUrlAutomationMenu
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    // Need to get this here to know if we should call showModal() or not
    const runAutomationIdQueryParam = $89f8907be2f15304$var$useRunAutomationIdQueryParam();
    const [isFirstLoad, setIsFirstLoad] = (0, $cozmU.useState)(true);
    const shouldShowModal = featureGateEnabled && runAutomationIdQueryParam && spaceKey && contentId && isFirstLoad;
    (0, $cozmU.useEffect)(()=>{
        if (shouldShowModal) {
            // We only want show the modal once on page load
            setIsFirstLoad(false);
            showModal($89f8907be2f15304$var$PageUrlAutomationMenu, {
                spaceKey: spaceKey,
                pageId: contentId,
                preselectedRuleId: runAutomationIdQueryParam
            });
        }
    }, [
        spaceKey,
        contentId,
        shouldShowModal,
        runAutomationIdQueryParam,
        showModal
    ]);
};
module.exports["useAutomationUrlParamTrigger"] = $89f8907be2f15304$export$88bb754436f46ef4;

});

parcelRegister("gcKEc", function(module, exports) {

let $bcc1f38172333756$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bcc1f38172333756$var$load("gC8Nc").then(()=>parcelRequire('dsFIi'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("aCrkK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");

const $91a763c2849bb3c4$var$experienceMap = {
    whiteboard: {
        restoreModal: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    },
    slide: {
        restoreModal: (0, $irVI7.SLIDE_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.SLIDE_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.SLIDE_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    },
    database: {
        restoreModal: (0, $irVI7.DATABASE_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.DATABASE_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.DATABASE_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    }
};
const $91a763c2849bb3c4$export$9560419a530f63b5 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const trackExperience = ({ contentType: contentType, experience: experience, task: task })=>{
        if (!contentType || !experience || !task) return;
        if (contentType === 'whiteboard' || contentType === 'database' || contentType === 'slide') {
            const experienceName = $91a763c2849bb3c4$var$experienceMap[contentType]?.[experience];
            if (experienceName) {
                if (task === 'start') experienceTracker.start({
                    name: experienceName
                });
                else experienceTracker.succeed({
                    name: experienceName
                });
            }
        }
    };
    return {
        trackExperience: trackExperience
    };
};
module.exports["useVersionHistoryExperienceTracking"] = $91a763c2849bb3c4$export$9560419a530f63b5;

});

parcelRegister("5thep", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $d81f7457a684c10d$export$c72df13ba879849e = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
module.exports["useIsVersionHistoryEnabled"] = $d81f7457a684c10d$export$c72df13ba879849e;

});

parcelRegister("hw9ld", function(module, exports) {

let $cc0cabc7b09af911$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cc0cabc7b09af911$var$load("6wr18"),
    $cc0cabc7b09af911$var$load("fVspZ"),
    $cc0cabc7b09af911$var$load("ffEVr"),
    $cc0cabc7b09af911$var$load("4NeBP")
]).then(()=>parcelRequire('cVRP5'));

});

parcelRegister("ewVsQ", function(module, exports) {
/**
 * @generated SignedSource<<ba24157d94e05467bed3ecf2964d0637>>
 * @relayHash 105992711dc201bcdc02eab95a31be75
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 581380d480b1c1aef14b326950f927e04ff260333f2aa183ddfcaf75fa5bb07c
const $bc3babc53c1d16f7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestPageAccessInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "requestPageAccessInput",
                    "variableName": "requestPageAccessInput"
                }
            ],
            "concreteType": "RequestPageAccessPayload",
            "kind": "LinkedField",
            "name": "requestPageAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRequestToEditContentRequestPageAccessMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRequestToEditContentRequestPageAccessMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "105992711dc201bcdc02eab95a31be75",
            "id": "581380d480b1c1aef14b326950f927e04ff260333f2aa183ddfcaf75fa5bb07c",
            "metadata": {},
            "name": "useRequestToEditContentRequestPageAccessMutation",
            "operationKind": "mutation",
            "text": "mutation useRequestToEditContentRequestPageAccessMutation($requestPageAccessInput:RequestPageAccessInput!){requestPageAccess(requestPageAccessInput:$requestPageAccessInput){displayName}}"
        }
    };
}();
$bc3babc53c1d16f7$var$node.hash = "5e921684206067f4b8976995c29ac184";
var $bc3babc53c1d16f7$export$2e2bcd8739ae039 = $bc3babc53c1d16f7$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $308Wd = parcelRequire("308Wd");




const $b8ad22721a0e1a1a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    requestToEdit: {
        defaultMessage: "Request to edit",
        id: "no-permission.request.to.edit.button.label"
    },
    editRequestSent: {
        defaultMessage: "Request sent",
        id: "no-permission.edit.request.sent.button.label"
    },
    notSentFlagTitle: {
        defaultMessage: "Your request wasn\u2019t sent",
        id: "no-permission.request.to.edit.not.sent.flag.title"
    },
    notSentFlagDescription: {
        defaultMessage: "We ran into a problem submitting your edit request. Try again or contact your admin.",
        id: "no-permission.request.to.edit.not.sent.flag.description"
    },
    requestSentFlagTitle: {
        defaultMessage: "Request to edit sent",
        id: "no-permission.request.to.edit.request.sent.flag.title"
    },
    requestSentFlagShortTitle: {
        defaultMessage: "Request sent",
        id: "no-permission.request.to.edit.request.sent.flag.short.title"
    },
    requestSentFlagDescription: {
        defaultMessage: "We've asked the owner to give you edit access. You'll be notified once the request is approved.",
        id: "no-permission.request.to.edit.request.sent.flag.description"
    },
    requestSentFlagAction: {
        defaultMessage: "Got it",
        id: "no-permission.request.to.edit.request.sent.flag.action"
    }
});


const $820cfbe605341dee$var$useRequestToEditContentRequestPageAccessMutation = (0, $bc3babc53c1d16f7$export$2e2bcd8739ae039);
const $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID = 'request-to-edit-sent';
const $820cfbe605341dee$export$c3a30e09778accb4 = ({ contentId: contentId, flags: flags, triggerAnalyticsEvent: triggerAnalyticsEvent })=>{
    const [requestSent, setRequestSent] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    const showRequestToEditFailedFlag = (0, $cozmU.useCallback)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('content.request.to.edit.failed');
        if (!flags) return;
        flags.showWarningFlag({
            title: intl.formatMessage((0, $b8ad22721a0e1a1a$export$defe85febe8b728c).notSentFlagTitle),
            description: intl.formatMessage((0, $b8ad22721a0e1a1a$export$defe85febe8b728c).notSentFlagDescription),
            appearance: 'warning',
            isAutoDismiss: true
        });
    }, [
        flags,
        intl,
        triggerAnalyticsEvent
    ]);
    const showRequestToEditSentFlag = (0, $cozmU.useCallback)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('content.request.to.edit.success');
        if (!flags) return;
        flags.showSuccessFlag({
            id: $820cfbe605341dee$var$REQUEST_SENT_FLAG_ID,
            title: intl.formatMessage((0, $b8ad22721a0e1a1a$export$defe85febe8b728c).requestSentFlagShortTitle),
            description: intl.formatMessage((0, $b8ad22721a0e1a1a$export$defe85febe8b728c).requestSentFlagDescription),
            isAutoDismiss: true
        });
    }, [
        flags,
        intl,
        triggerAnalyticsEvent
    ]);
    const handleRequestComplete = (result)=>{
        if (result?.requestPageAccess) {
            setRequestSent(true);
            showRequestToEditSentFlag();
        } else {
            showRequestToEditFailedFlag();
            setRequestSent(false);
        }
    };
    const handleRequestError = ()=>{
        showRequestToEditFailedFlag();
        setRequestSent(false);
    };
    const [requestToEditContent, { loading: loading }] = (0, $308Wd.useMutationInterop)($820cfbe605341dee$var$useRequestToEditContentRequestPageAccessMutation, {
        variables: {
            requestPageAccessInput: {
                pageId: contentId || '',
                accessType: 'EDIT'
            }
        },
        onCompleted: handleRequestComplete,
        onError: handleRequestError,
        __callerPackage__: "no-permission"
    });
    return {
        requestToEditContent: requestToEditContent,
        loading: loading,
        hasRequestedEditPermission: requestSent
    };
};
module.exports["useRequestToEditContent"] = $820cfbe605341dee$export$c3a30e09778accb4;

});

parcelRegister("k7ow8", function(module, exports) {
/**
 * A simple pub/sub service that allows the Slides iframe to register
 * a "start present" handler, and the Confluence header Present button
 * to invoke it.
 */ class $7a993192edcdefb2$export$9d138f5693eb2588 {
    /**
   * Register a handler that starts presentation mode.
   * Called by the content iframe in the Confluence header
   *
   * @returns An unsubscribe function to remove the handler.
   */ onStartPresent(cb) {
        this.handler = cb;
        this.presentSlidesEnabled = true;
        this.notifyAvailabilityListeners(true);
        this.notifyPresentSlidesEnabledListeners();
        return ()=>{
            if (this.handler === cb) {
                this.handler = null;
                this.presentSlidesEnabled = true;
                this.notifyAvailabilityListeners(false);
                this.notifyPresentSlidesEnabledListeners();
            }
        };
    }
    /**
   * Lets the slides iframe enable or disable the shell Present control while the
   * handler stays registered (for example while a prompt slide is active).
   */ setPresentSlidesEnabled(enabled) {
        if (this.presentSlidesEnabled === enabled) return;
        this.presentSlidesEnabled = enabled;
        this.notifyPresentSlidesEnabledListeners();
    }
    /**
   * Whether the header Present control should accept interaction. Only meaningful
   * when {@link isAvailable} is true.
   */ get isPresentSlidesEnabled() {
        return this.presentSlidesEnabled;
    }
    /**
   * Trigger presentation mode. Called by the Confluence header Present button.
   * Invokes the handler registered by the content iframe.
   */ startPresent() {
        if (!this.presentSlidesEnabled) return;
        this.handler?.();
    }
    /**
   * Returns whether a presentation handler is currently registered.
   */ get isAvailable() {
        return this.handler !== null;
    }
    /**
   * Subscribe to availability changes. Called by UI components
   * to reactively show/hide the Present button.
   *
   * @returns An unsubscribe function.
   */ onAvailabilityChange(cb) {
        this.availabilityListeners.add(cb);
        return ()=>{
            this.availabilityListeners.delete(cb);
        };
    }
    /**
   * Subscribe to changes for whether the Present button should be interactive.
   *
   * @returns An unsubscribe function.
   */ onPresentSlidesEnabledChange(cb) {
        this.presentSlidesEnabledListeners.add(cb);
        return ()=>{
            this.presentSlidesEnabledListeners.delete(cb);
        };
    }
    notifyAvailabilityListeners(isAvailable) {
        this.availabilityListeners.forEach((listener)=>listener(isAvailable));
    }
    notifyPresentSlidesEnabledListeners() {
        this.presentSlidesEnabledListeners.forEach((listener)=>listener(this.presentSlidesEnabled));
    }
    dispose() {
        this.handler = null;
        this.presentSlidesEnabled = true;
        this.availabilityListeners.clear();
        this.presentSlidesEnabledListeners.clear();
    }
    constructor(){
        this.handler = null;
        this.availabilityListeners = new Set();
        this.presentSlidesEnabled = true;
        this.presentSlidesEnabledListeners = new Set();
    }
}
const $7a993192edcdefb2$export$438a272138917510 = new $7a993192edcdefb2$export$9d138f5693eb2588();
module.exports["contentPresentationService"] = $7a993192edcdefb2$export$438a272138917510;

});

parcelRegister("bLtXM", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<cb7667edd50494d20618281ed074fa57>>
 * @relayHash beefa4502029b9edf583f29096ec6d94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59253e139e4d9f22296c7edc1165a5ca96d099ffa2525bc52eb27ea54676e3f6
const $1fb504ddbdec34a4$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ContentHeaderPresenceUserQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ContentHeaderPresenceUserQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "beefa4502029b9edf583f29096ec6d94",
            "id": "59253e139e4d9f22296c7edc1165a5ca96d099ffa2525bc52eb27ea54676e3f6",
            "metadata": {},
            "name": "ContentHeaderPresenceUserQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceUserQuery{user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$1fb504ddbdec34a4$var$node.hash = "0834d99c9aa942b8576e3c3061916b0b";
var $1fb504ddbdec34a4$export$2e2bcd8739ae039 = $1fb504ddbdec34a4$var$node;



var $axutP = parcelRequire("axutP");

/**
 * @generated SignedSource<<99804e32e8201ea2d886cb460e5b6384>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a79f006c4ab82603$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ContentHeaderPresence_contentSetting",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isEnabledOnContentView"
        }
    ],
    "type": "ConfluenceTeamPresence"
};
$a79f006c4ab82603$var$node.hash = "303742832bfb08703ddffbad402ced83";
var $a79f006c4ab82603$export$2e2bcd8739ae039 = $a79f006c4ab82603$var$node;



var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $jmjWc = parcelRequire("jmjWc");


var $jMyy4 = parcelRequire("jMyy4");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $3jwuS = parcelRequire("3jwuS");


var $2VZOl = parcelRequire("2VZOl");


var $de2j9 = parcelRequire("de2j9");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $cLo2u = parcelRequire("cLo2u");


var $7Sm4c = parcelRequire("7Sm4c");


var $efvKr = parcelRequire("efvKr");


var $lkApp = parcelRequire("lkApp");


var $9VtwR = parcelRequire("9VtwR");


var $0ejZ8 = parcelRequire("0ejZ8");


const $1e82291b1be231ce$var$PagePresence = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6Cexk",
    name: "PagePresence",
    loader: async ()=>(await (parcelRequire("iRG2A"))).PagePresence
});

const $1e82291b1be231ce$var$CanvasPresence = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TGyYR",
    name: "CanvasPresence",
    loader: async ()=>(await (parcelRequire("62pee"))).CanvasPresence
});
const $1e82291b1be231ce$export$8a8310ae40120280 = (0, $a79f006c4ab82603$export$2e2bcd8739ae039);
const $1e82291b1be231ce$var$ContentHeaderPresenceContentSettingsQuery = (0, $axutP.default);
const $1e82291b1be231ce$var$createDefaultParticipant = ({ presenceId: presenceId, activity: activity, user: user, isGuest: isGuest })=>{
    if (!user) return undefined;
    const sessions = {
        [(0, $9VtwR.CURRENT_USER_DUMMY_SESSION_ID)]: {
            activity: activity
        }
    };
    const usablePresenceId = user?.id ?? presenceId;
    return {
        id: usablePresenceId,
        userId: user?.id ?? 'unidentified',
        presenceId: usablePresenceId,
        name: user?.displayName ?? '',
        src: user?.photos?.[0]?.value ?? '',
        isCurrentUser: true,
        isGuest: isGuest,
        sessions: sessions
    };
};
const $1e82291b1be231ce$var$UFO_SEGMENT_NAME = 'content-header-presence';
const $1e82291b1be231ce$export$a8d99186a74b60f6 = ({ collaborators: collaborators, contentId: contentId, contentType: contentType, isViewMode: isViewMode, analyticSource: analyticSource, children: children })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const isEditPage = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { fetchAnonymousAsset: fetchAnonymousAsset } = (0, $0ejZ8.useAnonymousAsset)();
    const isCanvasType = contentType === 'whiteboard' || contentType === 'database' || contentType === 'slide';
    const { data: userData, error: userQueryError } = (0, $jMyy4.useQueryInterop)((0, $1fb504ddbdec34a4$export$2e2bcd8739ae039), {
        __callerPackage__: "team-presence"
    });
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $cozmU.useRef)(presenceId);
    let contentMode = 'view';
    if (isLivePage) contentMode = 'live';
    else if (isEditPage) contentMode = 'edit';
    const activity = contentMode === 'edit' || contentMode === 'live' && (isLiveEditMode || !isViewMode) ? 'editor' : 'viewer';
    const { data: settingData, error: settingsQueryError } = (0, $jMyy4.useQueryInterop)($1e82291b1be231ce$var$ContentHeaderPresenceContentSettingsQuery, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: isCanvasType || contentMode !== 'view',
        __callerPackage__: "team-presence"
    });
    const error = userQueryError || settingsQueryError;
    const isSettingEnabledOnView = (0, $cozmU.useCallback)(()=>{
        return isCanvasType || settingData?.confluence_teamPresenceContentSetting?.isEnabledOnContentView === true;
    }, [
        isCanvasType,
        settingData
    ]);
    const handleError = (err)=>{
        experienceTracker.fail({
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
            error: err
        });
        (0, $7Sm4c.markErrorAsHandled)(err);
        return null;
    };
    if (!contentType) return null;
    if (error) handleError(error);
    if (contentMode === 'view' && !isSettingEnabledOnView()) {
        experienceTracker.abort({
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
            reason: `Real-time visibility is disabled on view mode`
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lkApp.PresenceStoreContainer), {
        participant: $1e82291b1be231ce$var$createDefaultParticipant({
            presenceId: presenceIdRef.current,
            activity: activity,
            user: userData?.user,
            isGuest: isGuest
        }),
        fetchAnonymousAsset: fetchAnonymousAsset,
        onError: handleError
    }, isCanvasType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1e82291b1be231ce$var$CanvasPresence, {
        collaborators: collaborators,
        contentId: contentId,
        contentType: contentType,
        analyticSource: analyticSource
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1e82291b1be231ce$var$PagePresence, {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        activity: activity,
        analyticSource: analyticSource
    }, children));
};
const $1e82291b1be231ce$export$52baa28b583c9835 = (props)=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1e82291b1be231ce$export$a8d99186a74b60f6, props);
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props.contentId || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).COLLABORATION_PRESENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: $1e82291b1be231ce$var$UFO_SEGMENT_NAME
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
            scope: props.contentId
        }, t0, t1)));
        $[3] = props.contentId;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
module.exports["ContentHeaderPresence"] = $1e82291b1be231ce$export$52baa28b583c9835;

});

parcelRegister("lkApp", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");


var $6e6qw = parcelRequire("6e6qw");


var $9VtwR = parcelRequire("9VtwR");

// yes, all this is hella messy right now, will be refactoring and moving out of a store
const $2960af57d9597263$var$PresenceStore = (0, $8s9DV.createStore)({
    initialState: {
        participants: new Map(),
        telepointers: new Map()
    },
    actions: {
        add: (participant)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                // can't be null in confluence, ultimately is the userId for logged in users and presenceId for anonymous
                const { presenceId: id } = participant;
                const currentParticipants = new Map(participants);
                if (id) {
                    const previousParticipant = currentParticipants.get(id);
                    const entry = {
                        id: id,
                        userId: participant.userId,
                        presenceId: participant.presenceId,
                        name: participant.name,
                        isGuest: participant.isGuest,
                        isCurrentUser: Boolean(previousParticipant?.isCurrentUser),
                        src: participant.avatar,
                        sessions: {
                            ...previousParticipant?.sessions,
                            [participant.sessionId]: {
                                activity: participant.presenceActivity ?? 'viewer'
                            }
                        }
                    };
                    currentParticipants.set(id, entry);
                    setState({
                        participants: currentParticipants
                    });
                } else // eslint-disable-next-line no-console
                console.error("presenceId is null for participant when it shouldn't be for ", participant);
            },
        remove: (sessionId)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                const currentParticipants = new Map(participants);
                const participant = (0, $9VtwR.getCurrentUserFromMap)(participants, sessionId);
                if (participant) {
                    if (Object.keys(participant.sessions).length === 1) {
                        currentParticipants.delete(participant.id);
                        setState({
                            participants: currentParticipants
                        });
                    } else {
                        delete participant.sessions[sessionId];
                        currentParticipants.set(participant.id, participant);
                        setState({
                            participants: currentParticipants
                        });
                    }
                } else // eslint-disable-next-line no-console
                console.error('Could not remove participant with sessionId of ', sessionId);
            },
        addTelepointerData: (data)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const participant = (0, $9VtwR.getCurrentUserFromMap)(state.participants, data.sessionId);
                if (// Don't track the telepointer data for the current user
                participant?.isCurrentUser) return;
                const telepointers = new Map(state.telepointers);
                telepointers.set(data.sessionId, {
                    ...data,
                    timestamp: Date.now()
                });
                setState({
                    telepointers: telepointers
                });
            }
    },
    name: 'PresenceStore'
});
const $2960af57d9597263$export$7033f12ef2e1cbf5 = (0, $kBr4q.createHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$afdb9ee4b69111fa = (0, $kBr4q.createActionsHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$23e4fe06e7659b53 = (0, $kBr4q.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: (state)=>state.participants
});
const $2960af57d9597263$export$d8ba5bfd88808651 = (state, props)=>{
    const { participants: participants } = state;
    const currentUser = (0, $9VtwR.getCurrentUserFromMap)(participants, props.sessionId);
    const participantValues = [
        ...participants.values()
    ].filter((p)=>p.presenceId !== currentUser?.presenceId);
    if (currentUser) participantValues.unshift(currentUser);
    return participantValues.map((participant)=>{
        const isAnonymous = participant.userId === (0, $9VtwR.UNIDENTIFIED);
        // When the user is anonymous, we attempt to use the localized name from the anonymous asset or a default name
        const name = isAnonymous ? participant.name || props.anonymousName : participant.name;
        return {
            ...participant,
            participantColor: isAnonymous ? (0, $6e6qw.getParticipantColor)(participant.id).color.backgroundColor : undefined,
            isCurrentUser: participant.isCurrentUser || participant.id === currentUser?.id,
            name: name,
            activity: participant.isCurrentUser && currentUser ? (0, $9VtwR.getActivityToDisplay)(participant.sessions, props.sessionId, props.activity) : (0, $9VtwR.getActivityToDisplay)(participant.sessions)
        };
    });
};
const $2960af57d9597263$export$5a5a291828ecb5e4 = (0, $kBr4q.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$d8ba5bfd88808651
});
const $2960af57d9597263$export$172cef4c4690b3ab = (state, sessions)=>Object.keys(sessions).map((sId)=>state.telepointers.get(sId)).filter((tData)=>!!tData).sort((a, b)=>b?.timestamp - a?.timestamp)?.[0];
const $2960af57d9597263$export$f1a08937c1f9340b = (0, $kBr4q.createHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$172cef4c4690b3ab
});
const $2960af57d9597263$export$f642eede20cf74c0 = (0, $j8on0.createContainer)($2960af57d9597263$var$PresenceStore, {
    onInit: ()=>({ setState: setState }, { participant: participant, fetchAnonymousAsset: fetchAnonymousAsset, onError: onError })=>{
            if (participant) {
                const defaultParticipants = new Map();
                if (participant.userId === (0, $9VtwR.UNIDENTIFIED)) fetchAnonymousAsset(participant.presenceId).then((asset)=>{
                    defaultParticipants.set(participant.id, {
                        ...participant,
                        src: asset?.src || participant.src,
                        name: asset?.name || participant.name
                    });
                }).catch(onError).finally(()=>{
                    setState({
                        participants: defaultParticipants
                    });
                });
                else {
                    defaultParticipants.set(participant.id, {
                        ...participant
                    });
                    setState({
                        participants: defaultParticipants
                    });
                }
            } else setState({
                participants: new Map()
            });
        }
});
module.exports["usePresenceStore"] = $2960af57d9597263$export$7033f12ef2e1cbf5;
module.exports["usePresenceStoreActions"] = $2960af57d9597263$export$afdb9ee4b69111fa;
module.exports["useParticipants"] = $2960af57d9597263$export$23e4fe06e7659b53;
module.exports["useTransformedParticipants"] = $2960af57d9597263$export$5a5a291828ecb5e4;
module.exports["getActiveTelepointerBySessions"] = $2960af57d9597263$export$172cef4c4690b3ab;
module.exports["useActiveTelepointerBySessions"] = $2960af57d9597263$export$f1a08937c1f9340b;
module.exports["PresenceStoreContainer"] = $2960af57d9597263$export$f642eede20cf74c0;

});

parcelRegister("9VtwR", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $7Y8M5 = parcelRequire("7Y8M5");


var $6e6qw = parcelRequire("6e6qw");


var $9wGTI = parcelRequire("9wGTI");

const $6bda54ffb0f4283a$var$presencePrefix = '/ncs-presence';
const $6bda54ffb0f4283a$export$2fbd87a2176aa7cf = (id)=>{
    if (!id) // Slot 0 is red, which reads as deleted. Gray is the established colour for an
    // unidentified participant, and avoids colliding with the current user's blue.
    return (0, $7Y8M5.participantColors)[(0, $9wGTI.fg)('confluence_ncs_step_diffing_version_history') ? 9 : 0];
    return (0, $6e6qw.getParticipantColor)(id).color;
};
const $6bda54ffb0f4283a$export$fecb54e21647ae4f = ()=>{
    return {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    };
};
const $6bda54ffb0f4283a$export$a8078789f7ade13a = (participants, sessionId)=>{
    if (sessionId) return [
        ...participants.values()
    ].find((p)=>p.sessions[sessionId]);
};
const $6bda54ffb0f4283a$export$8c4801f1df434a3 = (sessionData, currentUserSessionId, defaultActivity)=>{
    if (currentUserSessionId) return sessionData[currentUserSessionId]?.activity ?? defaultActivity ?? 'viewer';
    else {
        const hasEditor = Object.keys(sessionData).find((sessionId)=>sessionData[sessionId]?.activity === 'editor');
        return hasEditor ? 'editor' : 'viewer';
    }
};
const $6bda54ffb0f4283a$export$cd367e77e21c7f3d = ()=>{
    const route = 'collab-presence-confluence';
    if (window.location.hostname === 'localhost' && true) {
        const host = window.__backendOriginHost;
        return `https://${host}/${route}`;
    }
    return `${window.location.origin}/${route}`;
};
const $6bda54ffb0f4283a$export$324e5039614a122a = (cloudId, activationId)=>{
    return `${$6bda54ffb0f4283a$var$presencePrefix}/${cloudId}/${activationId}/confluence`;
};
const $6bda54ffb0f4283a$var$presenceCanvasContentTypes = [
    'database',
    'whiteboard',
    'slide'
];
const $6bda54ffb0f4283a$export$ea7ca1acbbc07168 = (contentType)=>$6bda54ffb0f4283a$var$presenceCanvasContentTypes.includes(contentType);
const $6bda54ffb0f4283a$export$73e42e5abf6898ab = ()=>`presence-${(0, $9HkI0.v4)()}`;
const $6bda54ffb0f4283a$export$dd4b75f1a6268a6b = 4;
const $6bda54ffb0f4283a$export$a9b806721f7a3927 = 'dummy-session-id';
const $6bda54ffb0f4283a$export$72a96dbd0b162542 = 'unidentified';
module.exports["getParticipantColors"] = $6bda54ffb0f4283a$export$2fbd87a2176aa7cf;
module.exports["getCurrentUserColors"] = $6bda54ffb0f4283a$export$fecb54e21647ae4f;
module.exports["getCurrentUserFromMap"] = $6bda54ffb0f4283a$export$a8078789f7ade13a;
module.exports["getActivityToDisplay"] = $6bda54ffb0f4283a$export$8c4801f1df434a3;
module.exports["getPresenceServiceUrl"] = $6bda54ffb0f4283a$export$cd367e77e21c7f3d;
module.exports["getPresenceServicePath"] = $6bda54ffb0f4283a$export$324e5039614a122a;
module.exports["isCanvasContentType"] = $6bda54ffb0f4283a$export$ea7ca1acbbc07168;
module.exports["getPresenceClientId"] = $6bda54ffb0f4283a$export$73e42e5abf6898ab;
module.exports["MAX_GROUP_SIZE"] = $6bda54ffb0f4283a$export$dd4b75f1a6268a6b;
module.exports["CURRENT_USER_DUMMY_SESSION_ID"] = $6bda54ffb0f4283a$export$a9b806721f7a3927;
module.exports["UNIDENTIFIED"] = $6bda54ffb0f4283a$export$72a96dbd0b162542;

});

parcelRegister("0ejZ8", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6e6qw = parcelRequire("6e6qw");


var $bNhgs = parcelRequire("bNhgs");


var $9VtwR = parcelRequire("9VtwR");

const $fd1de2fc32fd6664$export$ed360de126596689 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    const fetchAnonymousAsset = $fd1de2fc32fd6664$var$_temp;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            fetchAnonymousAsset: fetchAnonymousAsset
        };
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $fd1de2fc32fd6664$var$_temp(presenceId) {
    const hashCode = presenceId ? (0, $6e6qw.getHashCode)(presenceId) : 0;
    const primaryIndex = hashCode;
    const svgBackgroundColor = (0, $9VtwR.getParticipantColors)(presenceId).svgBackgroundColor;
    return (0, $bNhgs.getAnonymousAvatarWithStyling)({
        styleProperties: {
            "background-color": svgBackgroundColor
        },
        index: primaryIndex
    });
}
module.exports["useAnonymousAsset"] = $fd1de2fc32fd6664$export$ed360de126596689;

});

parcelRegister("iRG2A", function(module, exports) {

let $dbbdc9a968cabf7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dbbdc9a968cabf7d$var$load("02yT2"),
    $dbbdc9a968cabf7d$var$load("cN2rp"),
    $dbbdc9a968cabf7d$var$load("k8tdD"),
    $dbbdc9a968cabf7d$var$load("e5UdI"),
    $dbbdc9a968cabf7d$var$load("6S5sb"),
    $dbbdc9a968cabf7d$var$load("Wr56p"),
    $dbbdc9a968cabf7d$var$load("hufzp"),
    $dbbdc9a968cabf7d$var$load("7qCqs"),
    $dbbdc9a968cabf7d$var$load("6TqFw"),
    $dbbdc9a968cabf7d$var$load("7sjI9"),
    $dbbdc9a968cabf7d$var$load("7EorR"),
    $dbbdc9a968cabf7d$var$load("jqoep"),
    $dbbdc9a968cabf7d$var$load("aTrJR")
]).then(()=>parcelRequire('gLdsO'));

});

parcelRegister("62pee", function(module, exports) {

let $46567fd2ac3d2d40$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $46567fd2ac3d2d40$var$load("cN2rp"),
    $46567fd2ac3d2d40$var$load("k8tdD"),
    $46567fd2ac3d2d40$var$load("e5UdI"),
    $46567fd2ac3d2d40$var$load("Wr56p"),
    $46567fd2ac3d2d40$var$load("hufzp"),
    $46567fd2ac3d2d40$var$load("7qCqs"),
    $46567fd2ac3d2d40$var$load("7EorR"),
    $46567fd2ac3d2d40$var$load("jqoep"),
    $46567fd2ac3d2d40$var$load("VXbA1"),
    $46567fd2ac3d2d40$var$load("b1YSZ")
]).then(()=>parcelRequire('lx2Vu'));

});

parcelRegister("ds2ZC", function(module, exports) {

let $9cb036305994698d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9cb036305994698d$var$load("5odbj"),
    $9cb036305994698d$var$load("frTOf")
]).then(()=>parcelRequire('8taxc'));

});

parcelRegister("iqeQP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c33c49386fab22e088fef79f72c28139>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6962ccec450c123$var$_react = $d6962ccec450c123$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d6962ccec450c123$var$_iconNew = $d6962ccec450c123$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d6962ccec450c123$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Wrench".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/wrench
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d6962ccec450c123$var$WrenchIcon = (props)=>/*#__PURE__*/ $d6962ccec450c123$var$_react.default.createElement($d6962ccec450c123$var$_iconNew.default, Object.assign({
        name: "WrenchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.5 1.5a4 4 0 0 0-3.614 5.718.75.75 0 0 1-.146.853l-4.95 4.95a.841.841 0 0 0 1.189 1.19l4.95-4.95a.75.75 0 0 1 .853-.147 4 4 0 0 0 5.667-4.252L12.03 7.28a.75.75 0 0 1-1.06 0L8.72 5.03a.75.75 0 0 1 0-1.06l2.419-2.42a4 4 0 0 0-.639-.05M5 5.5A5.5 5.5 0 0 1 12.863.532a.75.75 0 0 1 .208 1.208L10.31 4.5l1.19 1.19 2.76-2.76a.75.75 0 0 1 1.208.207 5.5 5.5 0 0 1-6.832 7.539L4.038 15.27a2.34 2.34 0 1 1-3.31-3.31l4.595-4.596A5.5 5.5 0 0 1 5 5.5" clip-rule="evenodd"/>`
    }, props));
$d6962ccec450c123$var$WrenchIcon.displayName = 'WrenchIcon';
var $d6962ccec450c123$var$_default = module.exports.default = $d6962ccec450c123$var$WrenchIcon;

});


//# sourceMappingURL=FullPageEditorComponent.95f3aaf2.js.map
